import './index.scss';
const SportsBettingRules = () => {
	return (
		<div className="sportsBettingRules">
			<div className="content">
				<div className="title">ESTRELABET — REGRAS ESPORTIVAS E EXPLICAÇÕES DE MERCADOS</div>
				{/* Regras Gerais */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Regras Gerais
					</summary>
					<div className="textItem">
						<p className="pH2">REGRAS GERAIS</p>
						<p>{`1.1 O resultado de um mercado é liquidado assim que este for determinado.`}</p>
						<p>{`Caso um mercado futuro (outright market) de longo ou curto prazo seja decidido por meio de anúncio oficial, a EstrelaBet reserva-se o direito de anular quaisquer apostas efetuadas após a publicação do resultado.`}</p>
						<p>{`Caso uma partida não seja concluída (devido a condições meteorológicas, número insuficiente de jogadores, etc.) e eventualmente seja decidida pelo árbitro e/ou anúncio oficial, a EstrelaBet reserva-se o direito de liquidar em conformidade quaisquer apostas feitas após o anúncio do oficial.`}</p>
						<p>{`Caso o anúncio seja feito mais de 48 horas após o final da partida e quaisquer apostas não decididas já tenham sido tratadas como não decididas e, portanto, anuladas, a liquidação será mantida.`}</p>
						<p>{`Quaisquer mercados especiais de jogadores estão excluídos da regra acima.`}</p>
						<p>{`Se um mercado não for estabelecido no início do jogo, a EstrelaBet liquidará o resultado do jogo assim que a duração normal (tempo regular) da partida for concluída, salvo indicado de outra forma na descrição do mercado no site. Ou seja, todas as apostas serão resolvidas considerando o tempo regulamentar, a menos que esteja especificado um período diferente na descrição do mercado.`}</p>
						<p>{`Exemplo: O mercado vencedor da partida 1X2 de um evento é determinado após o término da duração normal (tempo regular) do evento. O vencedor da partida 1x2 no futebol é determinado após os 90 minutos, incluindo quaisquer minutos extras chamados pelo árbitro da partida como "duração normal".`}</p>
						<p>{`No caso de um evento ser levado a tempo extra (quando o tempo regular não decide o vencedor), todos os mercados que estão sujeitos a "incluir tempo extra" são pagos após a conclusão da hora extra. Quaisquer pênaltis (ou outro decisor) que possam ocorrer não são levados em consideração, a menos que claramente declarado no mercado.`}</p>
						<p>{`Eventos não iniciados a tempo por qualquer motivo ou mesmo adiados podem ser mantidos abertos e todas as apostas permanecem válidas se as atividades começarem dentro das próximas 48 horas do horário oficial de início. Em qualquer outro caso, a EstrelaBet reserva-se, a seu critério, o direito de anular todas as apostas de tais eventos adiados e reembolsar as apostas aos clientes.`}</p>
						<p>{`Em eventos abandonados após seu horário de início e continuados pela organização dentro de 48 horas a partir do horário oficial de início, a EstrelaBet se reserva o direito de manter todas as apostas válidas e liquidar de acordo com este resultado.`}</p>
						<p>{`Em eventos abandonados após o horário de início e não sendo continuados pela organização dentro de 48 horas, a EstrelaBet liquidará todos os mercados determinados decididos no campo e anulará o restante devolvendo as apostas aos clientes. No entanto, em casos como esse, a EstrelaBet reserva-se, a seu critério, o direito de anular todas as apostas dos eventos abandonados e reembolsar as apostas aos clientes.`}</p>
						<p>{`Na regra geral acima há exceções como em:`}</p>
						<p>{`Os jogos de tênis serão mantidos abertos com todas as apostas válidas até que os oficiais ou o órgão organizador declarem um vencedor. Nesses casos, a regra das 48 horas não é válida. No entanto, e em caso de desistência do jogador (lesão, doença ou circunstância pessoal), decisão de adulto, vitória fácil, desqualificação ou abandono, todos os mercados determinados no campo são liquidados em conformidade e todo o resto indecisos declarado nulo e sem validade. Para evitar dúvidas, se um tenista se retirar antes do último ponto concluído, o mercado vencedor da partida é anulado, mas todos os mercados relacionados a sets ou jogos específicos que são determinados são liquidados de acordo.`}</p>
						<p>{`Jogos de esportes americanos, como NFL, MLB, NHL e NBA (MLS não está incluído nesta regra), que não começam ou começam e são abandonados e não retomados no mesmo dia no fuso horário local a partir do horário de início anunciado, terão todas as apostas não decididas anulada`}</p>
						<p>{`(por exemplo, se uma partida de futebol americano for abandonada no segundo tempo, os mercados do primeiro tempo serão liquidados normalmente`}</p>
						<p>{`(por exemplo, na demonstração acima, os mercados do segundo tempo não decididos serão anulados e as apostas serão reembolsadas aos clientes`}</p>
						<p>{`No caso de eventos da NFL (ou outro futebol americano) abandonados ou adiados, todos os mercados serão considerados nulos, a menos que a partida continue na mesma programação semanal da NFL (ou outro futebol americano) (quinta a quarta, horário local do estádio`}</p>
						<p>{`Liga da MLB para Beisebol: Moneyline (Mercado do Vencedor) é considerado decidido se os oficiais da liga considerarem o jogo como finalizado e s`}</p>
						<p>{`pelo menos 5 entradas são concluídas;`}</p>
						<p>{`OU`}</p>
						<p>{`4.5 turnos são completados e o time da casa (ou o segundo rebatedor) está na frent`}</p>
						<p>{`Em todos os outros casos, as apostas na Moneyline são anulada`}</p>
						<p>{`Para evitar dúvidas, as apostas em todos os outros mercados (por exemplo, Totais, Spread etc) serão válidas, a menos que já tenham sido decididas, e se:`}</p>
						<p>{`pelo menos 9 entradas são concluídas;`}</p>
						<p>{`OU`}</p>
						<p>{`8,5 turnos são completados e o time da casa (ou o segundo rebatedor) está na frente.`}</p>
						<p>{`Em todos os outros casos, as apostas são consideradas nulas. No caso de uma Regra de misericórdia ser chamada, todas as apostas serão válidas no placar daquele momento.`}</p>
						<p>{`Liga da MLB para Beisebol: todas as Linhas de Arremessador (Mercados PL para Moneyline, Spread e Totais) são anuladas em caso de mudança no arremessador inicial listado. As apostas feitas nos mercados da linha de arremessadores incluirão a indicação (PL) dentro do boletim de apostas e nas páginas de histórico de apostas. Caso o indicador (PL) não esteja visível dentro do boletim de apostas, a aposta é feita na Linha de Ação e será liquidada de acordo. As linhas de ação são determinadas com base no resultado do evento, independentemente de quaisquer alterações de arremessador. Quaisquer novas linhas de arremessadores oferecidas seguirão as regras acima. As linhas de ação estão seguindo as regras gerais com as exceções referentes à MLB, conforme acima.`}</p>
						<p>{`No Beisebol e no caso de um jogo de 7 entradas, as apostas em todos os mercados serão válidas, a menos que já decidido, se:`}</p>
						<p>{`pelo menos 7 entradas são concluídas;`}</p>
						<p>{`OU`}</p>
						<p>{`6,5 entradas são concluídas e o time da casa (ou o segundo rebatedor) está na frente.`}</p>
						<p>{`Exceção é a Moneyline (Vencedor da Partida) que é considerada decidida se:`}</p>
						<p>{`pelo menos 5 entradas são concluídas;`}</p>
						<p>{`OU`}</p>
						<p>{`4.5 entradas são concluídas e o time da casa (ou o segundo rebatedor) está na frente.`}</p>
						<p>{`Em todos os outros casos, as apostas na Moneyline são consideradas nulas.`}</p>
						<p>{`1.2 A EstrelaBet reserva-se o direito de não aceitar a totalidade ou parte de uma aposta sem fornecer uma razão ao cliente. Se uma aposta não for aceita, as apostas do cliente serão reembolsadas.`}</p>
						<p>{`1.3 Antes do início de um evento, a EstrelaBet reserva-se, a seu critério, o direito de anular ou cancelar parte ou a totalidade de uma aposta, mesmo após a sua aceitação, sem fornecer qualquer motivo ao cliente.`}</p>
						<p>{`Após o início de um evento, a EstrelaBet reserva-se o direito de anular ou cancelar parte ou a totalidade de uma aposta, mesmo após a sua aceitação e mesmo após a sua liquidação, se houver um motivo válido para isso, como:`}</p>
						<p>{`erro na redação (erro palpável) do evento ou das probabilidades, ou hora de início.`}</p>
						<p>{`o cliente tenta contornar os limites da EstrelaBet (pagamento potencial) e gerenciamento de risco, fazendo várias apostas idênticas ou semelhantes ou abrindo várias contas.`}</p>
						<p>{`o cliente está se beneficiando de qualquer anúncio público ou informação secreta a que tenha acesso e que determine o resultado da aposta.`}</p>
						<p>{`o cliente combinou apostas relacionadas.`}</p>
						<p>{`o cliente está participando ativamente do evento, como jogadores, árbitros, dirigentes ou tem relacionamentos diretos ou indiretos com os participantes dos eventos.`}</p>
						<p>{`a EstrelaBet sofre um erro técnico oferecendo odds ou eventos errados.`}</p>
						<p>{`qualquer outro motivo válido devidamente comunicado ao cliente mediante solicitação.`}</p>
						<p>{`1.4 Os ganhos máximos por boletim de aposta poderão ser limitados a critério da EstrelaBet.`}</p>
						<p>{`1.5 A EstrelaBet reserva-se o direito de cancelar todas as apostas de um evento, caso haja alguma alteração no local do evento.`}</p>
						<p>{`1.6 A EstrelaBet se reserva o direito de cancelar todas as apostas se houver mudanças radicais nas circunstâncias de um evento, como a duração do jogo, a distância de uma corrida, a velocidade ou o número de períodos, etc.`}</p>
						<p>{`1.7 Caso a EstrelaBet suspeite que um evento de apostas esportivas seja fraudulento ou com grande probabilidade de ser corrigido, de modo que o resultado seja conhecido previamente por determinados indivíduos, a EstrelaBet reserva-se o direito de:`}</p>
						<ul>
							<li>manter os boletins de apostas específicos pendentes;</li>
							<li>
								informar os órgãos e autoridades reguladoras relevantes (ESSA, Sportradar,
								Federações), depende de qual órgão ou autoridade sob a qual a EstrelaBet é
								regulamentada e com a qual está cooperando;
							</li>
							<li>
								aguardar até que um veredicto desses órgãos ou autoridades seja enviado como
								feedback;
							</li>
							<li>
								liquidar ou anular a aposta após o veredicto dos órgãos ou autoridades competentes.
							</li>
						</ul>
						<p>{`1.8 Caso e durante o processo de efetivação da aposta, o sistema seja tecnicamente interrompido por qualquer motivo, a EstrelaBet seguirá as verificações padrão, como disponibilidade de fundos, correção de preço, etc. e se reserva o direito de aceitar ou rejeitar a aposta de acordo. Nesse caso, o cliente precisa fazer o login assim que o sistema estiver disponível e visitar sua página de histórico de apostas para confirmar se a aposta foi aceita ou não.`}</p>
						<p>{`1.9 Qualquer decisão tomada pelo Árbitro Assistente de Vídeo (VAR) que entre em conflito com a decisão original sancionada pelos árbitros em campo (incluindo não decisões como permitir que o jogo continue antes de revisar o vídeo), alterando assim o estado entendido da partida em o momento da efetivação da aposta, fará com que todas as apostas feitas no período de tempo entre a ocorrência real do incidente original e a decisão final do árbitro sobre o incidente sejam consideradas nulas, a menos que as probabilidades oferecidas na oferta de aposta específica não sejam afetadas pelo uso do VAR ou já foram contabilizados nas cotas oferecidas no momento da aceitação da aposta. A liquidação de todas as outras ofertas de apostas não relacionadas, incluindo aquelas determinadas por qualquer jogada entre o momento do incidente original e a decisão após a revisão do VAR, que não são influenciadas/alteradas pela decisão do VAR, será mantida.`}</p>
						<p>{`Para fins resultantes, as revisões do VAR devem ser consideradas como tendo ocorrido no momento do incidente original para o qual o VAR seria eventualmente usado, mesmo que o jogo não tenha sido imediatamente interrompido. A EstrelaBet reserva-se o direito de reverter quaisquer ofertas previamente liquidadas quando a liquidação se tornar imprecisa após a decisão final do árbitro, desde que tal decisão seja tomada e comunicada antes da conclusão da partida e/ou do prazo listado.`}</p>
						<p>{`1.10 Para fins de experiência do usuário e para um melhor resultado visual, a EstrelaBet está aplicando truncamento de dois dígitos decimais nas probabilidades visíveis na tela. Os cálculos das probabilidades totais são feitos usando um arredondamento do sexto dígito decimal, enquanto o valor do ganho total é sempre truncado para o segundo dígito decimal. Qualquer diferença observada é apenas um produto das regras de arredondamento aqui explicadas.`}</p>
						<p>{`1.11 O prazo máximo entre a liquidação de um boletim de apostas e um potencial reassentamento é de 30 dias.`}</p>
						<p>{`1.12 A duração dos Amistosos de Futebol pode não ser padrão (2x45) ou pode ser modificada durante a partida.`}</p>
						<p>{`Para mercados AO VIVO, em caso de formato inicial incorreto e/ou as equipes ou árbitro decidirem alterar o formato durante o jogo espontaneamente e sem aviso prévio, a EstrelaBet se reserva o direito de anular parcialmente/totalmente as apostas.`}</p>
						<p>{`Para apostas ao vivo e pré-jogo, aplicam-se as seguintes regras, caso de uma partida termine antes dos 90 minutos:`}</p>
						<p>{`Se a partida for terminada pelo árbitro no minuto 79:00 ou depois, todos os mercados são liquidados de acordo com o resultado do FT (tempo regulamentar). Se a partida for encerrada pelo árbitro em 78:59 ou antes, todos os mercados não decididos serão resolvidos anulados.`}</p>
						<p>{`Em partidas que são ABANDONADAS/INTERROMPIDAS devido a outros motivos (tumultos de fãs, desentendimento entre jogadores, lesões graves, mau tempo, falha no holofote, apagão etc), todos os mercados não decididos serão anulados.`}</p>
						<p>{`Formatos de partidas aceitos`}</p>
						<p>{`Jogos pré-jogo com duração entre 45 e 120 minutos.`}</p>
						<p>{`Partidas ao vivo com duração de até 90 minutos. Os possíveis formatos aceitos são 2x25, 2x30, 2x35, 2x40, 2x45, 3x30.`}</p>
						<p>{`Para partidas com duração menor que 45 minutos ou maior que 120 minutos, todos os mercados pré-jogo serão anulados. Em todos os outros casos, as apostas permanecerão normalmente.`}</p>
						<p>{`Para o formato 3x30 (ou outros formatos possíveis com 3 ou mais intervalos), a duração do intervalo será calculada como ''Duração total da partida / 2''.`}</p>
						<p>{`A EstrelaBet não se responsabiliza por alterações inesperadas de formatos e eventuais liquidações relevantes com base em nossas regras, o risco é do cliente e está incluso na aceitação dos T&C durante o cadastro.`}</p>
						<p>{`1.13 Os mercados futuros de longo prazo (Outright) estão sujeitos à regra "Jogar ou pagar (Play-or-Pay)". De acordo com a regra Play-or-Pay, as apostas nos participantes de um mercado Outright permanecerão normalmente, mesmo que a equipe/participante do jogador listado não tenha podido participar da competição, independentemente do motivo (portanto, liquidado como perdida). A regra acima será válida para todos os mercados definitivos (Vencedor, Top3, Top5, etc.) referentes a uma lista de participantes numa competição.`}</p>
						<p>{`Os mercados H2H (cabeça a cabeça) estão excluídos, portanto, se algum dos participantes listados não participar da competição, os mercados H2H em que ele / ela estiver envolvido, serão declarados nulos. A mesma liquidação será aplicada em mercados relacionados com o desempenho individual de uma equipa ou participante (ex. mercados de classificação). No caso de um participante ser substituído por outro participante da mesma equipe, a liquidação dos mercados da equipe (H2H, classificação, etc.) será mantida, enquanto os mercados individuais do participante serão anulados`}</p>
						<p className="pH3">2. Explicação dos Tipos de Apostas Específicos</p>
						<p>{`Marcadores: Primeiro, Último, Marcador a Qualquer Momento`}</p>
						<p>{`As apostas aplicam-se apenas ao tempo regulamentar. Gols contra (com base na autoridade oficial) são omitidos ou contam como "sem marcador" se o jogo tiver apenas "gols contra"`}</p>
						<p>{`Aposta no Primeiro Marcador será NULA se um jogador nunca jogar ou entrar em campo após o primeiro gol do jogo ter sido marcado, exceto no caso de um gol contra, que é ignorado`}</p>
						<p>{`As apostas no último goleador serão anuladas se um jogador não jogar. A pontuação do jogador se aplica a qualquer jogador, independentemente da hora em que ele entrou no jogo`}</p>
						<p>{`Apostas no Marcar a qualquer momento, aplicam-se a qualquer jogador envolvido no jogo, independentemente do horário em que ele entra no jogo. As apostas no Marcar a qualquer momento serão anuladas se o jogador escolhido nunca jogar`}</p>
						<p>{`No caso de um jogo ser abandonado mas houver pelo menos um marcador, as apostas no primeiro marcador são válidas e as apostas no último marcador são anuladas. Sempre que o mercado de Goleadores para este jogador for definido como vencedor, as apostas em outros jogadores serão anuladas`}</p>
						<p>{`As regras acima são válidas para os mercados 'Primeiro/Marcar a qualquer momento e 1X2' e 'Primeiro/Marcar a qualquer momento e Resultado Correto'`}</p>
						<p className="pH2">O resultado de um mercado é liquidado uma vez determinado</p>
						<p>{`Quaisquer mercados relacionados com a qualificação de uma equipe (por exemplo, Para Qualificar, Método de Vitória, etc.) através de um torneio específico (partidas da Copa, partidas do Playoff etc) serão considerados nulos caso a partida seja adiada ou abandonada e a partida não seja remarcada para ser disputada em 48 horas. Caso haja 2 etapas, apenas os mercados colocados no(s) evento(s) adiado(s) serão anulados. Quaisquer apostas relacionadas com qualificações feitas em outrights de curto ou longo prazo permanecerão válidas até serem decididas, independentemente do adiamento/abandono dos eventos`}</p>
						<p>{`As partidas da copa de basquete ou playoff, etc., decididas em melhor de 2 partidas com pontos agregados, se enquadram em regras de liquidação específicas. No caso de empate na primeira partida, nenhuma prorrogação será disputada e o mercado vencedor (incluindo prorrogação) será considerado nulo, enquanto os demais mercados serão liquidados normalmente de acordo com o resultado. O pagamento seria o mesmo se a segunda partida fosse empatada, enquanto houvesse um vencedor na primeira partida. Em relação aos casos em que as pontuações vencedoras estão empatadas após o segundo jogo (por exemplo, a Equipe A vence o primeiro jogo com uma pontuação de 75-70 e a Equipe B vence o segundo jogo com uma pontuação de 85-80), a liquidação será feita em todos os mercados em base ao resultado do tempo regular e o resultado da prorrogação serão ignorado`}</p>
						<p>{`3.1.5 Liquidação das apostas`}</p>
						<p>{`Para fins de liquidação de apostas, serão usadas as estatísticas da entidade oficial organizadora do campeonato/partida. Caso não exista nenhuma entidade oficial/órgão regulador da partida, e/ou as estatísticas oficiais da partida não estejam disponíveis e/ou haja evidências ou indicações específicas de que essas estatísticas não estão corretas, as apostas serão liquidadas de acordo com as estatísticas da **** ou dos nossos provedores oficiais de dados. Se as estatísticas da *****  ou dos nossos provedores de dados oficiais não estiverem disponíveis por qualquer motivo, serão usados fontes de dados independentes para liquidação das apostas.No que diz respeito aos mercados de estatísticas de futebol e os campeonatos nas quais a Opta está fazendo a coleta de dados, a liquidação será determinada com base nos dados fornecidos pela Opta e de acordo com as suas estatísticas. Para efeitos de liquidação, os mercados de Escanteios e/ou Cartões não serão determinados com base nos dados fornecidos pela Opta. Se, por qualquer motivo, a Opta não cobrir nenhuma das estatísticas, as estatísticas do órgão oficial da liga/partida serão usadas para fins de liquidação de apostas. No caso de não existir nenhum órgão oficial da liga/partida e/ou estatísticas do órgão oficial não estarem disponíveis, as apostas serão liquidadas de acordo com as estatísticas de outros provedores de dados oficiais que colaboram conosco. Caso as estatísticas de outros provedores de dados oficiais não estejam disponíveis por qualquer motivo, fontes de dados independentes serão usadas para a liquidação da aposta.`}</p>
						<p>{`Parte mais produtiva equipe - indica qual o tempo da partida a equipe selecionada fará mais gols.`}</p>
						<p>{`Parte mais produtiva - indica qual o tempo da partida será feito mais gols.`}</p>
						<p>{`Jogador Total de chutes: O total de chutes do jogador é o número total de chutes no alvo, chutes fora do alvo e chutes bloqueados marcados por um jogador específico.`}</p>
					</div>
				</details>
				{/* Automobilismo */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 33 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<g clip-path="url(#clip0_515_371)">
								{' '}
								<path
									d="M31.2417 14.5675C30.8717 13.2575 30.3517 11.9575 29.7017 10.7275C27.6617 6.8475 24.2717 3.5575 19.6617 2.1275C14.4017 0.4975 10.1817 0.6875 6.94173 2.3575C3.70173 4.0275 1.82173 6.9775 0.871734 10.0775C-0.0882661 13.1675 -0.178266 16.5575 0.241734 19.4675C0.641734 22.2775 1.59173 25.0575 3.13173 26.6175C3.42173 26.9175 3.81173 27.1175 4.22173 27.1875L26.4417 30.9675C27.1117 31.0775 27.7917 30.8475 28.2517 30.3475C30.1317 28.3075 31.2517 25.7775 31.7317 23.0875C32.2317 20.2875 32.0317 17.3275 31.2417 14.5675ZM7.21173 11.1575L6.98173 12.2075C6.86173 12.7475 6.33173 13.0875 5.79173 12.9775C5.25173 12.8575 4.91173 12.3275 5.02173 11.7875L5.25173 10.7375C6.08173 6.8875 9.78173 4.3675 13.6717 5.0175C14.2117 5.1075 14.5817 5.6275 14.4917 6.1675C14.4017 6.7075 13.8817 7.0775 13.3417 6.9875C10.5117 6.5175 7.81173 8.3575 7.21173 11.1575ZM28.7017 22.6075L19.4117 21.1275C17.0217 20.7375 15.0517 19.0575 14.2817 16.7675L13.2717 13.7775C13.2717 13.7775 13.2717 13.7475 13.2717 13.7375C13.2017 13.4875 13.2517 13.2175 13.4117 13.0175C13.5417 12.8575 13.7317 12.7575 13.9317 12.7275L26.8717 11.0875L27.5617 10.9975C29.6517 14.5875 30.4517 18.9175 29.7517 22.7775L28.6917 22.6075H28.7017Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
							</g>{' '}
							<defs>
								{' '}
								<clipPath id="clip0_515_371">
									{' '}
									<rect
										data-darkreader-inline-fill=""
										fill="white"
										height="28"
										style={{ fill: '#FFFFFF' }}
										transform="translate(0.00317383)"
										width="28"
									>
										{' '}
									</rect>{' '}
								</clipPath>{' '}
							</defs>{' '}
						</svg>
						Automobilismo
					</summary>
					<div className="textItem">
						<p>{`O resultado de uma aposta em um evento de Fórmula 1/Nascar/Indy Car/Rally é baseado nos primeiros resultados oficiais publicados. As decisões tomadas pela federação oficial (incluindo, mas não se limitando à FIA) e que afetem ou alterem o resultado alcançado no campo de corrida não serão levadas em consideração.`}</p>
						<p>{`Toda corrida começa com a volta de aquecimento. Se o piloto que o usuário selecionou não estiver no grid de largada para a volta de aquecimento, ou pronto para começar a corrida do pit lane, a aposta será anulada e a aposta será reembolsada. Se não houver um resultado oficial declarado, todas as apostas nessa corrida serão anuladas.`}</p>
						<p className="pH2">Mercados de automobilismo:</p>
						<p>{`Vencedor (Corrida): Você prevê que o piloto selecionado será o vencedor da corrida.`}</p>
						<p>{`Construtor Vencedor (Corrida): Você tem que prever a qual equipe o piloto vencedor pertence.`}</p>
						<p>{`Margem Vencedora (Corrida): Você deve prever qual equipe/piloto vencerá a corrida com a margem aplicada.`}</p>
						<p>{`Vencedor do Grupo (Corrida): Você prevê que o piloto selecionado será o vencedor do grupo selecionado durante a corrida.`}</p>
						<p>{`Top 3 (Race): Você tem que prever que o piloto selecionado chegará ao pódio.`}</p>
						<p>{`Top 6 (Race): Você deve prever que o piloto selecionado terminará a corrida dentro das primeiras seis posições. Para ser considerado vencedor, o piloto deve completar pelo menos 90% das voltas completadas pelo vencedor arredondado para o número inteiro de voltas mais próximas.`}</p>
						<p>{`Top 10 (Corrida): Você deve prever que o piloto selecionado terminará a Corrida dentro das dez primeiras posições. Para ser considerado vencedor, o piloto deve completar pelo menos 90% das voltas completadas pelo vencedor arredondado para o número inteiro de voltas mais próximas.`}</p>
						<p>{`H2H (Race): Você deve prever qual dos dois pilotos especificados na aposta alcançará a melhor posição na corrida. Caso estes pilotos abandonem ou sejam desqualificados na mesma volta, esta tipologia de aposta será considerada nula. Se um ou mais pilotos listados na aposta não puderem participar da corrida, esta tipologia de aposta será considerada nula. (A saber: H2H significa head to head, o que pode ser traduzido como "cabeça a cabeça", o que indica comparação entre dois adversários)`}</p>
						<p>{`Finalização de Pontos de Ambos os Carros: Você deve prever se ambos os carros da equipe selecionada terminarão a Corrida dentro das dez primeiras posições.`}</p>
						<p>{`Ambos os carros classificados: Você deve prever se ambos os carros da equipe selecionada serão classificados ou não de acordo com o relatório oficial da federação (incluindo, mas não limitado à FIA).`}</p>
						<p>{`Qualquer piloto para vencer a corrida, pole position e volta mais rápida: Isso também é chamado de Hat-trick e você deve prever qual piloto vencerá a corrida, a pole position e a volta mais rápida.`}</p>
						<p>{`Primeiro piloto a fazer um pit stop: Você prevê qual piloto fará o primeiro pit stop durante a corrida.`}</p>
						<p>{`Posição de Grid do Vencedor: Você prevê a posição de largada no grid de largada do piloto vencedor da corrida.`}</p>
						<p>{`Nacionalidade Vencedora: Você prevê a nacionalidade do vencedor da corrida.`}</p>
						<p>{`Piloto Classificado/Não Classificado: Você deve prever se o piloto será classificado ou não de acordo com o relatório oficial da federação (incluindo mas não limitado à FIA), publicado após a corrida principal. Para ser considerado classificado, o piloto deve completar pelo menos 90% das voltas completadas pelo vencedor arredondado para o número inteiro de voltas mais próximas.`}</p>
						<p>{`Número de Pilotos Classificados: Você deve prever quantos carros/pilotos serão classificados de acordo com o relatório oficial da federação (incluindo mas não limitado à FIA) publicado após a corrida principal.`}</p>
						<p>{`Volta mais rápida: Você deve prever qual piloto fará a volta mais rápida durante a corrida principal do Grande Prêmio.`}</p>
						<p>{`Desistência do Primeiro Piloto: Você tem que prever qual piloto vai abandonar primeiro a corrida principal do Grande Prêmio. Um motorista desqualificado ou que tenha sofrido um acidente é considerado desclassificado. Se dois ou mais pilotos se retirarem durante a mesma volta serão considerados iguais, independentemente da ordem em que se retiraram.`}</p>
						<p>{`Primeiro abandono de construtor: Você tem que prever qual equipe vai se retirar primeiro durante a corrida principal do Grande Prêmio. Um motorista desqualificado ou que tenha sofrido um acidente é considerado aposentado. Se dois ou mais pilotos se retirarem durante a mesma volta serão considerados iguais, independentemente da ordem em que se retiraram.`}</p>
						<p>{`Safety Car: Você deve prever se o safety car sairá na pista durante a corrida.`}</p>
						<p>{`Virtual Safety Car: Você tem que prever se o Virtual Safety Car sairá na pista durante a corrida.`}</p>
						<p>{`Vencedor (Pole): Você prevê que o piloto selecionado alcançará a melhor posição durante a sessão de qualificação.`}</p>
						<p>{`Pódio (Pole): Você prevê que o piloto selecionado concluirá a sessão de qualificação na primeira, segunda ou terceira posição.`}</p>
						<p>{`H2H (Pole): Você tem que prever qual dos dois pilotos especificados na aposta alcançará a melhor posição na sessão de qualificação. (A saber: H2H significa head to head, o que pode ser traduzido como "cabeça a cabeça", o que indica comparação entre dois adversários)`}</p>
						<p>{`Margem de Vitória (Pole): Você tem que prever qual equipe/piloto vai ganhar a pole com a margem aplicada.`}</p>
						<p>{`Vencedor do Grupo (Pole): Você prevê que o piloto selecionado será o vencedor do grupo selecionado durante a sessão do Pole.`}</p>
						<p>{`Vencedor (Treino): Você prevê que o piloto selecionado alcançará a melhor posição durante a sessão de treinos.`}</p>
						<p>{`Pódio (Treino): Você prevê que o piloto selecionado concluirá a sessão de treinos na primeira, segunda ou terceira posição.`}</p>
						<p>{`H2H (Treino): Você deve prever qual dos dois pilotos especificados na aposta alcançará a melhor posição na sessão de treinos. (A saber: H2H significa head to head, o que pode ser traduzido como "cabeça a cabeça", o que indica comparação entre dois adversários)`}</p>
						<p>{`Margem Vencedora (Treino): Você deve prever qual equipe/piloto vencerá o Treino com a margem aplicada.`}</p>
						<p>{`Vencedor do Campeonato (Pilotos e Construtores): Este tipo de mercado será liquidado com base no total de pontos alcançados pelos pilotos, imediatamente após a cerimônia de apresentação do pódio do último Grande Prêmio da temporada.`}</p>
						<p>{`Confronto Direto entre Pilotos/Equipe do Campeonato (Geral): Você prevê qual piloto/equipe definirá a melhor colocação no Campeonato de Pilotos atual. Se ambos os pilotos/equipes alcançarem os mesmos pontos na temporada, o vencedor será declarado com os mesmos critérios usados pela federação oficial (incluindo, mas não limitado à FIA); o que significa que apenas as melhores colocações nas temporadas serão consideradas para determinar o vencedor.`}</p>
					</div>
				</details>
				{/* Badminton */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Badminton
					</summary>
					<div className="textItem">
						<p>{`No caso de uma partida não ser finalizada, todos os mercados indecisos são considerados nulos. Se um jogador/equipe se retirar, todos os mercados indecisos são considerados nulos.`}</p>
						<p className="pH2">Mercados Principais</p>
						<p>{`Vencedor (1x2': Mercado de apostas que consiste em prever o vencedor da partida independente'ente da margem de pontos.`}</p>
						<p>{`Resultado Correto: Você deve prever o resultado correto da partida em termos de sets ganhos por cada jogador. Se um jogador se retirar durante a partida, todas as apostas não decididas serão consideradas nulas.`}</p>
						<p>{`Ponto Handicap: Você tem que prever o vencedor de toda a partida (em pontos ganhos) somando ou subtraindo o spread indicado ao resultado da partida (em pontos)`}</p>
						<p>{`Total de Pontos: Consiste em prever se o total de pontos marcados por ambas as equipes será maior ou menor que o número dado no mercado de apostas escolhido.`}</p>
						<p>{`X° jogo - Vencedor: Prever o vencedor no jogo mencionado.`}</p>
						<p>{`X° jogo - Total de Pontos: Prever se o total de pontos acumulados por ambas as equipes em um determinado jogo será superior ou inferior a um determinado número no mercado.`}</p>
						<p>{`X° jogo - Handicap de Pontos: Você tem que prever o vencedor do jogo mencionado (em pontos ganhos) somando ou subtraindo o spread indicado ao resultado da partida (em pontos).`}</p>
						<p>{`X° jogo - par/ímpar: Prever se o total de pontos acumulados por ambas as equipes no jogo em questão será um número par ou ímpar.`}</p>
						<p>{`X° jogo - corrida para X pontos: Você tem que prever qual time alcançará X pontos primeiro para o jogo mencionado.`}</p>
						<p>{`X° jogo - N° ponto: Você tem que prever qual time ganhará o N° point para o jogo mencionado.`}</p>
						<p className="pH2">Mercado Outright:</p>
						<p>{`Vencedor: Você deve prever o vencedor de um determinado torneio de acordo com o ranking oficial da competição.`}</p>
					</div>
				</details>
				{/* Bandy  */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Bandy
					</summary>
					<div className="textItem">
						<p className="pH2">Principais Mercados </p>
						<p>{`Mercado 1X2: Você tem que prever o resultado do tempo regulamentar da partida inteira. Existem 3 resultados possíveis: 1 (o time da casa ganha), X (os times vão empatar), 2 (o time visitante ganha).`}</p>
						<p>{`Total (mais/menos): Você deve prever se o número total de gols marcados durante o tempo regulamentar da partida inteira será acima ou abaixo da linha indicada.`}</p>
						<p className="pH2">Outrights</p>
						<p>{`Vencedor: Você deve prever o vencedor de um determinado torneio de acordo com o ranking oficial da competição.`}</p>
						<p>{``}</p>
						<p>{``}</p>
						<p>{``}</p>
						<p>{``}</p>
					</div>
				</details>
				{/* Basquete  */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 33 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<g clip-path="url(#clip0_414_465)">
								{' '}
								<path
									d="M19.9269 20.5054C20.2266 19.9044 20.5264 19.2032 20.8261 18.4018C16.2299 17.0996 14.931 11.59 13.8319 6.98208C13.2324 4.27741 12.5329 1.47256 11.4338 0.671174C9.03579 1.47256 6.63775 2.77481 4.73931 4.77827C4.1398 5.37931 3.64021 5.98035 3.14062 6.68156C7.23726 11.4899 12.9326 16.9994 19.9269 20.5054Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M17.7287 24.0115C18.1283 23.5106 18.528 22.9096 18.9277 22.3086C11.8335 18.7023 6.13816 13.293 1.9416 8.48468C0.143073 11.6902 -0.356517 15.4968 0.242991 19.0029C2.44119 20.7058 4.63939 21.5072 8.03661 21.9079C12.2332 22.3086 15.4305 23.0098 17.7287 24.0115Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M21.4256 16.4985C22.5247 12.5918 22.9244 7.68329 22.225 1.27221C19.5272 0.0701348 16.5296 -0.230384 13.632 0.170308C14.6312 1.6729 15.2307 3.97689 15.7303 6.48121C16.8294 10.989 17.9285 15.597 21.4256 16.4985Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M23.5239 16.799C26.3216 16.799 29.2193 15.597 30.6181 9.68675C29.8188 7.88364 28.7197 6.28087 27.3208 4.77827C26.4215 3.87671 25.4224 3.07533 24.4232 2.47429C24.9228 8.28433 24.5231 12.9925 23.5239 16.799Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M19.6271 24.9131C20.6263 25.5141 21.4256 26.3155 21.9252 27.1169C22.8245 28.5193 22.6247 29.9217 22.4248 30.8233C24.2233 30.0219 25.822 28.92 27.3208 27.5176C27.9203 26.9165 28.32 26.4157 28.8196 25.7145C26.0219 25.2136 23.3241 24.312 20.8261 23.2101C20.4265 23.8112 20.0268 24.4122 19.6271 24.9131Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M31.7172 12.8923C30.1185 16.799 27.4207 18.7023 23.5239 18.7023H22.9244C22.6247 19.7041 22.225 20.5055 21.8253 21.407C24.2233 22.4087 26.7213 23.3103 29.4191 23.711C29.7188 23.8112 29.9187 23.8112 30.0186 23.8112C31.8171 20.5055 32.4166 16.5987 31.7172 12.8923Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M20.3265 30.8233C20.5264 30.2222 20.926 29.2205 20.2266 28.1186C19.9269 27.6177 19.3274 27.0167 18.3282 26.4157C16.3298 28.6195 14.2315 30.2222 12.1333 31.5245C14.7311 32.2257 17.5288 32.1255 20.1267 31.4243C20.1267 31.3241 20.2266 31.0236 20.3265 30.8233Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M16.4297 25.6143C14.5313 24.9131 11.8335 24.312 7.93669 23.8112C5.13898 23.5106 3.0407 22.9096 1.14225 21.8077C1.9416 23.8112 3.14062 25.7145 4.73931 27.3172C6.23808 28.8198 7.93669 29.9217 9.73522 30.7231C11.8335 29.4209 14.2315 27.8181 16.4297 25.6143Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
							</g>{' '}
							<defs>
								{' '}
								<clipPath id="clip0_414_465">
									{' '}
									<rect
										data-darkreader-inline-fill=""
										fill="white"
										height="28"
										style={{ fill: '#FFFFFF' }}
										transform="translate(0.00317383)"
										width="28"
									>
										{' '}
									</rect>{' '}
								</clipPath>{' '}
							</defs>{' '}
						</svg>
						Basquete
					</summary>
					<div className="textItem">
						<p className="pH2">Principais mercados</p>
						<p>
							Equipe da casa/fora vencerá todas as quartas: Você deve prever se o time da casa ou o
							time visitante vencerá todas as quartas.
						</p>
						<p>
							Qualquer equipe vencerá todas as quartas de final: Você deve prever se haverá uma
							equipe que vencerá todas as quartas.
						</p>
						<p>
							Equipe que vencerá todas as quartas: Você deve prever qual equipe vencerá todas as
							quartas.
						</p>
						<p>
							Total do quarto com a maior pontuação: você deve prever qual quarto terá o maior total
							de pontos marcados em um jogo.
						</p>
						<p>
							Total do quarto com a menor pontuação: você deve prever qual quarto terá o menor total
							de pontos marcados em um jogo.
						</p>
						<p>
							Equipe da casa/fora vencerá os dois tempos: Você deve prever se o time da casa ou o
							time visitante vencerá os dois tempos.
						</p>
						<p>
							Qualquer equipe pode vencer os dois tempos: Você deve prever se haverá uma equipe que
							vencerá os dois tempos.
						</p>
						<p>
							Equipe que vencerá os dois tempos: É preciso prever qual equipe fará mais pontos que a
							outra tanto no primeiro tempo (que inclui o primeiro e o segundo quartos) quanto no
							segundo tempo (que inclui o terceiro e o quarto quartos).
						</p>
						<p>
							Alguns dos mercados listados abaixo podem aparecer em E-Basketball (as mesmas regras
							se aplicam)
						</p>
						<p>
							Money Line (Vencedor) (inclui tempo extra): Preveja o vencedor da partida,
							independentemente da margem de pontos. Este mercado incluirá tempo extra.
						</p>
						<p>
							Total (mais/menos) (inclui tempo extra): Consiste em prever se o total de pontos
							marcados por ambas as equipes será maior ou menor que a linha dada no mercado de
							apostas escolhido. Por exemplo: Acima de 215,5 - Abaixo de 215,5. Este mercado inclui
							tempo extra.
						</p>
						<p>
							Handicap (spread) (inclui tempo extra): Você tem que prever o vencedor da partida
							inteira adicionando ou subtraindo o spread indicado ao resultado da partida. Este
							mercado inclui tempo extra.
						</p>
						<p>
							Total de pontos por equipe (casa - visitante) (inclui tempo extra): Consiste em prever
							se o total de pontos marcados pela equipe da casa ou visitante será maior ou menor que
							a linha dada no mercado de apostas escolhido. Por exemplo: Acima de 215,5 - Abaixo de
							215,5. Este mercado incluirá tempo extra.
						</p>
						<p>
							Par/ímpar (1º tempo ou 2º tempo) (inclui tempo extra): Aqui você prevê se o resultado
							do 1º tempo ou do 2º tempo será um número par ou ímpar. Este mercado incluirá tempo
							extra.
						</p>
						<p>
							Vencedor da partida 1X2: Preveja se o vencedor será o time da casa ou visitante com a
							opção de selecionar também o empate. Nenhuma hora extra está incluída.
						</p>
						<p>
							Intervalo/fim de jogo: Prevê qual time vencerá no primeiro tempo e no final da
							partida.
						</p>
						<p>
							Intervalo de Pontos: Este mercado de apostas consiste em prever um intervalo dentro do
							qual ficará o total de pontos do evento, ou seja, se você selecionar o intervalo
							(151-160) o total de pontos marcados neste evento não pode sair deste intervalo.
						</p>
						<p>
							Vencedor + Totais: Este mercado de apostas combina dois mercados de apostas principais
							onde você deve prever quem vencerá a partida e quantos pontos totais (mais/menos)
							serão marcados na partida.
						</p>
						<p>
							Ponto X (incluindo prorrogação): Você deve prever qual time marcará o ponto X durante
							a partida, incluindo a prorrogação.
						</p>
						<p>
							Corrida para x pontos: Este mercado consiste em prever qual das duas equipes chegará
							primeiro ao ponto que determina o mercado. Por exemplo: Qual equipe alcançará 50
							pontos primeiro.
						</p>
						<p>
							Margem de Vitória: Mercado de apostas que prevê a diferença que uma equipe terá do seu
							adversário no final do jogo, por exemplo, a equipe da casa por 1-5 pontos.
						</p>
						<p>
							Prorrogação sim/não - irá para prorrogação: Aposta que prevê se o evento terá
							prorrogação ou não.
						</p>
						<p>
							Total (mais-exatamente-menos) - 3 possibilidades: Mercado de apostas que dá ao jogador
							a oportunidade de escolher entre 3 possibilidades diferentes, como mais/menos X número
							de pontos ou número exato de X pontos.
						</p>
						<p>
							Qualquer equipe total de pontos consecutivos máximos (mais/menos): Você precisa prever
							se alguma equipe alcançará mais ou menos do que os pontos consecutivos dados em
							qualquer ponto da partida.
						</p>
						<p>
							Total de pontos consecutivos em casa/fora (mais/menos): Você precisa prever se a
							equipe da casa ou visitante alcançará mais ou menos do que os pontos consecutivos
							dados em qualquer ponto da partida.
						</p>
						<p>
							Qualquer time para liderar por X: Você precisa prever se algum time vai liderar por x
							pontos em qualquer ponto da partida.
						</p>
						<p>
							Equipe da casa/fora lidera por X: Você precisa prever se a equipe da casa ou visitante
							vai liderar por x pontos em qualquer ponto da partida.
						</p>
						<p>
							Tipo de pontuação X ponto (incl. prorrogação): Este mercado consiste em prever o tipo
							de pontuação X ponto durante a partida: 6 são os resultados oferecidos:
						</p>
						<p>competidor1 pontuação de 1 ponto</p>
						<p>competidor1 pontuação de 2 pontos</p>
						<p>competidor1 pontuação de 3 pontos</p>
						<p>competidor2 pontuação de 1 ponto</p>
						<p>competidor2 pontuação de 2 pontos</p>
						<p>competidor2 pontuação de 3 pontos</p>
						<p>
							Qual equipe ganhará o pulo da bola: Você deve prever qual equipe ganhará o jump ball.
						</p>
						<p>
							Margem de vitória de qualquer equipe (incluindo o tempo extra): você deve prever se
							alguma equipe vencerá com as margens dadas (incluindo o tempo extra).
						</p>
						<p>Xº tempo limite: Você deve prever qual equipe pedirá o Xº tempo limite</p>
						<p>Xº lance livre marcado: Você deve prever se o Xº lance livre será marcado ou não.</p>
						<p>
							Dupla do primeiro ponto/vencedor (incluindo OT): Você deve prever qual equipe marcará
							o primeiro ponto e qual equipe vencerá a partida (incluindo OT).
						</p>
						<p>
							Tempo do primeiro ponto (segundos decorridos): Você deve prever se o primeiro ponto
							será marcado depois ou antes do período de tempo determinado.
						</p>
						<p>
							Método de pontuação da primeira cesta: Você deve prever o método de pontuação da
							primeira cesta
						</p>
						<p>
							Resultado da primeira posse de bola: Você deve prever o resultado da primeira posse de
							bola.
						</p>
						<p>
							Total de arremessos de três pontos marcados da partida: Consiste em prever pelo menos
							quantos arremessos de três pontos serão realizados e marcados durante a partida,
							apenas no tempo padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Total de arremessos de três pontos marcados pela equipe - Equipe da casa/visitante:
							Consiste em prever pelo menos quantos arremessos de três pontos a equipe da
							casa/visitante irá registrar, apenas no tempo padrão, a menos que o mercado
							especifique (Inc OT).
						</p>
						<p>
							Equipe com mais três pontos marcados: Consiste em prever qual equipe terá mais três
							pontos marcados durante a partida, apenas no tempo padrão, a menos que o mercado
							especifique (Inc OT).
						</p>
						<p>
							Total de Rebotes da Partida: Consiste em prever pelo menos quantos rebotes ocorrerão
							durante a partida, apenas no tempo padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Total de Ressaltos da Equipe - Equipe da Casa/Visitante: Consiste em prever pelo menos
							quantos rebotes a equipe da casa/visitante irá registrar, apenas no tempo padrão, a
							menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Equipe com mais rebotes: Consiste em prever qual equipe registrará mais rebotes,
							apenas no tempo padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Total de assistências da partida: Consiste em prever pelo menos quantas assistências
							ocorrerão durante a partida, apenas no tempo padrão, a menos que o mercado especifique
							(Inc OT).
						</p>
						<p>
							Total de Assistências da Equipe - Equipe da Casa/Visitante: Consiste em prever pelo
							menos quantas assistências a equipe da casa/visitante irá registrar, apenas no tempo
							padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Equipe com mais assistências: Consiste em prever qual equipe registrará mais
							assistências, apenas no tempo padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Match Total Steals: Consiste em prever pelo menos quantos roubos ocorrerão durante a
							partida, apenas no tempo padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Total de Roubos da Equipe - Equipe da Casa/Visitante: Consiste em prever pelo menos
							quantos roubos de bola a equipe da casa/visitante irá registrar, apenas no tempo
							padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Equipe com mais roubos: Consiste em prever qual equipe registrará mais roubos, apenas
							no tempo padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Match Total Blocks: Consiste em prever pelo menos quantos bloqueios ocorrerão durante
							a partida, apenas no tempo padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Total de Bloqueios da Equipe - Time da Casa/Visitante: Consiste em prever pelo menos
							quantos bloqueios o time da casa/visitante irá registrar, apenas no tempo padrão, a
							menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Equipe com mais bloqueios: Consiste em prever qual equipe registrará mais bloqueios,
							apenas no tempo padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Match Total Turnovers: Consiste em prever pelo menos quantos turnovers ocorrerão
							durante a partida, apenas no tempo padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Total de Turnovers da Equipe - Equipe da Casa/Visitante: Consiste em prever pelo menos
							quantas viradas a equipe da casa/visitante irá registrar, apenas no tempo padrão, a
							menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Equipe com mais giros: Consiste em prever qual time registrará mais giros, apenas no
							tempo padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Total de Faltas Cometidas na Partida: Consiste em prever pelo menos quantas faltas
							ocorrerão durante a partida, apenas no tempo padrão, a menos que o mercado especifique
							(Inc OT).
						</p>
						<p>
							Total de Faltas Cometidas pela Equipe - Equipe da Casa/Visitante: Consiste em prever
							pelo menos quantas faltas a equipe da casa/visitante irá registrar, apenas no tempo
							padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Equipe com mais faltas cometidas: Consiste em prever qual equipe irá registrar mais
							faltas, apenas no tempo padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Total de lances livres marcados da partida: Consiste em prever pelo menos quantos
							lances livres serão tentados durante a partida, apenas no tempo padrão, a menos que o
							mercado especifique (Inc OT).
						</p>
						<p>
							Total de lances livres marcados da partida - Equipe da casa/Visitante: Consiste em
							prever pelo menos quantos lances livres a equipe da casa/visitante irá registrar,
							apenas no tempo padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Equipe com mais lances livres marcados: Consiste em prever qual equipe registrará mais
							lances livres, apenas no tempo padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Total de arremessos de dois pontos marcados da partida: Consiste em prever pelo menos
							quantos arremessos de dois pontos ocorrerão durante a partida, apenas no tempo padrão,
							a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Total da partida de arremessos de dois pontos marcados - time da casa/visitante:
							Consiste em prever pelo menos quantos arremessos de dois pontos o time da
							casa/visitante irá registrar, apenas no tempo padrão, a menos que o mercado
							especifique (Inc OT).
						</p>
						<p>
							Equipe com mais arremessos de dois pontos marcados: Consiste em prever qual equipe
							registrará mais arremessos de dois pontos, apenas no tempo padrão, a menos que o
							mercado especifique (Inc OT).
						</p>
						<p>
							Total de lances livres tentados: Consiste em prever pelo menos quantos lances livres
							serão tentados durante a partida, apenas no tempo padrão, a menos que o mercado
							especifique (Inc OT).
						</p>
						<p>
							Total de lances livres tentados - Equipe da casa/visitante: Consiste em prever pelo
							menos quantos arremessos a equipe da casa/visitante tentará, apenas no tempo padrão, a
							menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Equipe com mais lances livres tentados: Consiste em prever qual time tentará mais
							lances livres, apenas no tempo padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Total de arremessos de três pontos tentados: Consiste em prever pelo menos quantos
							arremessos de três pontos serão tentados durante a partida, apenas no tempo padrão, a
							menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Total da partida Tentativas de arremessos de três pontos - Time da casa/Visitante:
							Consiste em prever pelo menos quantos arremessos de três pontos o time da
							casa/visitante tentará, apenas no tempo padrão, a menos que o mercado especifique (Inc
							OT).
						</p>
						<p>
							Equipe com mais arremessos de três pontos tentados: Consiste em prever qual time
							tentará mais arremessos de três pontos, apenas no tempo padrão, a menos que o mercado
							especifique (Inc OT).
						</p>
						<p>
							Total de arremessos de dois pontos tentados: Consiste em prever pelo menos quantos
							arremessos de dois pontos serão tentados durante a partida, apenas no tempo padrão, a
							menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Total da partida Tentativas de arremessos de dois pontos - Time da casa/visitante:
							Consiste em prever pelo menos quantos arremessos de dois pontos o time da
							casa/visitante tentará, apenas no tempo padrão, a menos que o mercado especifique (Inc
							OT).
						</p>
						<p>
							Equipe com mais tentativas de arremessos de dois pontos: Consiste em prever qual
							equipe tentará mais arremessos de dois pontos, apenas no tempo padrão, a menos que o
							mercado especifique (Inc OT).
						</p>
						<p>
							Total de Rebotes Ofensivos da Partida: Consiste em prever pelo menos quantos rebotes
							ofensivos totais ocorrerão durante a partida, apenas no tempo padrão, a menos que o
							mercado especifique (Inc OT).
						</p>
						<p>
							Total de Ressaltos Ofensivos da Partida - Equipe da Casa/Visitante: Consiste em prever
							pelo menos quantos rebotes ofensivos totais a equipe da casa/visitante registrará,
							apenas no tempo padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Equipe com mais rebotes ofensivos: Consiste em prever qual equipe registrará mais
							rebotes ofensivos, apenas no tempo padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Total de Rebotes Defensivos da Partida: Consiste em prever pelo menos quantos rebotes
							defensivos totais ocorrerão durante a partida, apenas no tempo padrão, a menos que o
							mercado especifique (Inc OT).
						</p>
						<p>
							Total de Ressaltos Defensivos da Partida - Time da Casa/Visitante: Consiste em prever
							pelo menos quantos rebotes defensivos totais o time da casa/visitante registrará,
							apenas no tempo padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Equipe com mais rebotes defensivos: Consiste em prever qual equipe registrará mais
							rebotes defensivos, apenas no tempo padrão, a menos que o mercado especifique (Inc
							OT).
						</p>
						<p>
							Vencedor (incl. prorrogação) e ambas as equipes marcarão X pontos: Você deve prever o
							resultado da partida e se ambas as equipes marcarão ou não X pontos.
						</p>
						<p>
							Zº quarto, ambas as equipes marcarão X pontos: Você deve prever se ambas as equipes
							marcarão ou não X pontos durante o Zº quarto.
						</p>
						<p className="pH2">Mercados do 1º tempo</p>
						<p>
							1º tempo - empate anula aposta: Você tem que prever o vencedor do 1º tempo, se o tempo
							terminar empatado todas as apostas serão anuladas, se o tempo estiver incompleto este
							mercado será anulado.
						</p>
						<p>
							1º tempo - Handicap: Você tem que prever o vencedor do 1º tempo somando ou subtraindo
							o spread indicado ao resultado do tempo, se o tempo estiver incompleto este mercado
							será anulado.
						</p>
						<p>
							1º tempo - Total (Abaixo/Mais): Você tem que prever se o número total de pontos
							marcados durante o 1º tempo será acima ou abaixo da linha dada, se o tempo estiver
							incompleto este mercado será anulado.
						</p>
						<p>
							1º tempo - Total de casa/fora (abaixo/acima): Você tem que prever se o número total de
							pontos marcados pela equipe nomeada (casa ou visitante) durante o 1º tempo será acima
							ou abaixo da linha dada, se a metade estiver incompleta, este mercado será anulado.
						</p>
						<p>
							1º tempo - 1x2: Aposte no vencedor do 1º tempo, com a opção de sorteio disponível
							também.
						</p>
						<p>
							1º tempo par/ímpar: Você tem que prever se o número total de pontos marcados no 1º
							tempo será par ou ímpar, se o tempo estiver incompleto este mercado será anulado.
						</p>
						<p className="pH2">Mercados do 2º tempo</p>
						<p>
							2º tempo - empate anula aposta: Você tem que prever o vencedor do 2º tempo (não
							incluindo tempo extra, salvo indicação em contrário), se o tempo terminar empatado,
							todas as apostas serão anuladas para este mercado, se o tempo for incompleto este
							mercado será anulado.
						</p>
						<p>
							2º tempo - Handicap: Você tem que prever o vencedor do 2º tempo (não incluindo tempo
							extra salvo indicação em contrário) adicionando ou subtraindo o spread indicado ao
							resultado do tempo, se o tempo estiver incompleto este mercado será anulado.
						</p>
						<p>
							2ª parte - 1x2: Aposte no vencedor da 2ª parte (não inclui prolongamento salvo
							indicação em contrário), com a opção de empate disponível também.
						</p>
						<p>
							2º tempo - par/ímpar: Você tem que prever se o número total de pontos marcados no 2º
							tempo (não incluindo tempo extra, salvo indicação em contrário) será par ou ímpar, se
							o tempo estiver incompleto, este mercado será anulado.
						</p>
						<p>
							Potenciais tempos extras serão contados para o 2º tempo em mercados que incluam tempos
							extras
						</p>
						<p>Mercados do quarto</p>
						<p>
							1º-2º-3º-4º quarto: Os mercados de apostas do quarto permitem que o jogador aposte no
							resultado final de cada um dos quartos.
						</p>
						<p>Vencedor do quarto: Aposte no vencedor do quarto.</p>
						<p>
							Quarto 1x2: Você tem que prever o resultado de um determinado quarto, as seleções são
							1-o time da casa, 2-o time visitante e X-empate. Se o quarto estiver incompleto, este
							mercado será anulado.
						</p>
						<p>
							Quarto empate anula aposta: Você tem que prever o vencedor de um determinado quarto,
							se o quarto terminar empatado todas as apostas serão anuladas para este mercado, se o
							quarto não for concluído, este mercado será anulado.
						</p>
						<p>
							Handicap do quarto: Você tem que prever o vencedor de um determinado quarto
							adicionando ou subtraindo o spread indicado ao resultado do quarto, se o quarto
							estiver incompleto este mercado será anulado.
						</p>
						<p>
							Total do Quarto: Você deve prever se o número total de pontos marcados durante um
							determinado quarto será acima ou abaixo da linha indicada, se o quarto não estiver
							concluído, este mercado será anulado.
						</p>
						<p>
							Total do quarto em casa/fora: Você tem que prever se o número total de pontos marcados
							pela equipe nomeada (casa ou visitante) durante o quarto será acima ou abaixo da linha
							indicada, se o quarto estiver incompleto, este mercado será ser anulado.
						</p>
						<p>
							Margem de Vitória do Quarto: Mercado de apostas que prevê a quantidade de diferença
							que uma equipe terá de seu oponente no final do período selecionado.
						</p>
						<p>
							Quarto com maior pontuação: Você deve prever qual quarto terá mais pontos marcados.
						</p>
						<p>
							Xº Quarto - Para Marcar o Último Ponto: Você deve prever qual time marcará o último
							ponto do quarto selecionado. *Todos os quartos ou metades devem ter sido concluídos
							para que as apostas sejam válidas.
						</p>
						<p>
							xº quarto - xº ponto: Você tem que prever qual equipe marcará o Xº ponto durante o
							quarto selecionado.
						</p>
						<p>
							Qual a equipe que vai ganhar cada quarto: Tem de prever qual das duas equipes vai
							ganhar todos os quartos (em caso de empate em qualquer quarto, a aposta é perdida).
						</p>
						<p>
							*Todos os quartos ou metades devem ter sido concluídos para que as apostas sejam
							válidas.
						</p>
						<p>
							Potenciais tempos extras serão contados para o 4º quarto em mercados que incluam
							tempos extras.
						</p>
						<p className="pH2">Mercados Especiais de Jogador</p>
						<p>
							Jogador pontos (mais/menos): Consiste em prever a quantidade de pontos que o jogador
							específico irá registrar, somente em tempo padrão a menos que o mercado especifique
							(Inc OT).
						</p>
						<p>
							Assistências de Jogadores (mais/menos): Consiste em prever o número de assistências
							que um determinado jogador irá registrar no evento, somente em tempo padrão a menos
							que o mercado especifique (Inc OT).
						</p>
						<p>
							Rebotes do Jogador (mais/menos): Consiste em prever a quantidade de rebotes que um
							determinado jogador irá registrar em tempo padrão a menos que o mercado especifique
							(Inc OT).
						</p>
						<p>
							Cestas de 3pt feitas do Jogador (mais/menos): Consiste em prever a quantidade de
							cestas de três pontos que um determinado jogador irá registrar em tempo padrão a menos
							que o mercado especifique (Inc OT).
						</p>
						<p>
							Roubos do jogador (mais/menos): Consiste em prever a quantidade de roubos que o
							jogador específico irá registrar, apenas em tempo padrão, a menos que o mercado
							especifique (Inc OT).
						</p>
						<p>
							Bloqueios de Jogador mais/menos): Consiste em prever a quantidade de blocos que o
							jogador específico irá gravar, somente em tempo padrão a menos que o mercado
							especifique (Inc OT).
						</p>
						<p>
							Pontos do jogador + rebotes + assistências (mais/menos): Consiste em prever a
							quantidade combinada de pontos, rebotes e assistências que o jogador específico
							registrará, apenas em tempo padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Rebotes + assistências do jogador (mais/menos): Consiste em prever a quantidade
							combinada de rebotes e assistências que o jogador específico registrará, apenas em
							tempo padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Jogador triplo-duplo: Consiste em prever se o jogador específico irá registrar um
							triplo-duplo (10 de 3 categorias de estatísticas principais, como pontos,
							assistências, rebotes, roubos, bloqueios), apenas o tempo padrão, a menos que o
							mercado especifique (Inc AT).
						</p>
						<p>
							Primeiro jogador a marcar: Consiste em prever qual jogador marcará primeiro na partida
							(o jogador selecionado deve iniciar a partida, caso contrário a aposta será
							considerada nula).
						</p>
						<p>
							Primeiro jogador a fazer uma cesta de 3 pontos: Consiste em prever qual jogador irá
							marcar primeiro uma cesta de 3 pontos na partida (o jogador selecionado deve começar a
							partida, caso contrário a aposta será considerada nula).
						</p>
						<p>
							Mais pontos por EQUIPE: Consiste em prever qual jogador fará mais pontos para sua
							equipe.
						</p>
						<p>
							Pontos de jogadores no confronto direto: Consiste em prever qual dos jogadores
							mencionados irá marcar mais pontos na partida.
						</p>
						<p>
							Rebotes no confronto direto entre jogadores: Consiste em prever qual dos jogadores
							mencionados irá marcar mais rebotes na partida.
						</p>
						<p>
							Assistências de jogadores no confronto direto: Consiste em prever qual dos jogadores
							mencionados registrará mais assistências na partida.
						</p>
						<p>
							Player Points (no mínimo): Consiste em prever pelo menos quantos pontos o jogador
							específico irá registrar, apenas o tempo padrão a menos que o mercado especifique (Inc
							OT).
						</p>
						<p>
							Assistências do Jogador (no mínimo): Consiste em prever pelo menos quantas
							assistências o jogador específico irá registrar, apenas o tempo padrão, a menos que o
							mercado especifique (Inc OT).
						</p>
						<p>
							Rebotes do Jogador (pelo menos): Consiste em prever pelo menos quantos rebotes o
							jogador específico irá registrar, apenas o tempo padrão a menos que o mercado
							especifique (Inc OT).
						</p>
						<p>
							Cestas de 3pt feitas do Jogador (pelo menos): Consiste em prever pelo menos quantas
							cestas de 3pt o jogador específico irá registrar, apenas em tempo padrão a menos que o
							mercado especifique (Inc OT).
						</p>
						<p>
							Roubos do Jogador (pelo menos): Consiste em prever pelo menos quantos roubos o jogador
							específico irá registrar, apenas em tempo padrão, a menos que o mercado especifique
							(Inc OT).
						</p>
						<p>
							Bloqueios de Jogador (no mínimo): Consiste em prever pelo menos quantos bloqueios o
							jogador específico irá marcar, somente em tempo padrão a menos que o mercado
							especifique (Inc OT).
						</p>
						<p>
							Pontos do jogador + rebotes + assistências (no mínimo): Consiste em prever pelo menos
							quantos pontos, rebotes e assistências combinados o jogador específico registrará,
							apenas em tempo padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Rebotes + assistências do JOGADOR (no mínimo): Consiste em prever pelo menos quantos
							rebotes e assistências combinados o jogador específico registrará, apenas em tempo
							padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Mais Pontos (apenas jogadores listados - incl. OT): Tem de prever qual dos jogadores
							indicados marcará mais pontos (OT incluído).
						</p>
						<p>
							Maior número de pontos + rebotes + assistências (somente jogadores listados -
							incluindo o tempo extra): você deve prever qual dos jogadores indicados marcará o
							maior número de pontos + rebotes + assistências (incluindo o tempo extra).
						</p>
						<p>
							Para registrar um duplo-duplo: Você deve prever se os jogadores indicados registrarão
							um duplo-duplo.
						</p>
						<p>
							Maior número de rebotes: Você deve prever qual dos jogadores dados registrará o maior
							número de rebotes.
						</p>
						<p>
							Maior número de assistências: Você deve prever qual dos jogadores indicados registrará
							o maior número de assistências.
						</p>
						<p>
							Marcador do primeiro ponto: Você deve prever qual dos jogadores indicados marcará o
							primeiro ponto da partida.
						</p>
						<p>
							*Se um jogador não participar da partida, todas as apostas serão consideradas
							anuladas.
						</p>
						<p>
							Faltas pessoais cometidas pelo jogador: Consiste em prever a quantidade de faltas que
							o jogador específico registrará apenas no tempo padrão, a menos que o mercado
							especifique (Inc OT).
						</p>
						<p>
							Total de arremessos de 3 pontos do jogador tentados: Consiste em prever pelo menos
							quantos arremessos de 3 pontos o jogador específico tentará, apenas no tempo padrão, a
							menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Total de arremessos de dois pontos do jogador tentados: Consiste em prever pelo menos
							quantos arremessos de 2 pontos o jogador específico tentará, apenas no tempo padrão, a
							menos que o mercado especifique (Inc OT).
						</p>
						<p>
							Total de cestas marcados pelo jogador: Consiste em prever pelo menos quantas cestas o
							jogador específico irá registrar, apenas no tempo padrão, a menos que o mercado
							especifique (Inc OT).
						</p>
						<p>
							Total de cestas tentados pelo jogador: Consiste em prever pelo menos quantas cestas o
							jogador específico tentará, apenas no tempo padrão, a menos que o mercado especifique
							(Inc OT).
						</p>
						<p>
							Total de lances livres marcados pelo jogador: Consiste em prever pelo menos quantos
							lances livres o jogador específico irá registrar, apenas no tempo padrão, a menos que
							o mercado especifique (Inc OT).
						</p>
						<p>
							Total de lances livres tentados pelo jogador: Consiste em prever pelo menos quantos
							lances livres o jogador específico tentará, apenas no tempo padrão, a menos que o
							mercado especifique (Inc OT).
						</p>
						<p>
							Primeiro período do jogador - Total de pontos: Consiste em prever a quantidade de
							pontos que o jogador específico registrará durante o primeiro período.
						</p>
						<p>
							Primeiro período do jogador - Total de rebotes: Consiste em prever a quantidade de
							rebotes que o jogador específico registrará durante o primeiro período.
						</p>
						<p>
							Primeiro período do jogador - Total de assistências: Consiste em prever a quantidade
							de assistências que o jogador específico registrará durante o primeiro período.
						</p>
						<p>
							Total de arremessos de dois pontos marcados pelo jogador: Consiste em prever pelo
							menos quantos arremessos de 2 pontos o jogador específico irá registrar, apenas no
							tempo padrão, a menos que o mercado especifique (Inc OT).
						</p>
						<p className="pH2">Mercados Extras</p>
						<p>
							Ambas as equipes marcarão mais de 80 pontos: Você deve prever se ambas as equipes
							marcarão mais de 80 pontos na partida (OT incluído).
						</p>
						<p>
							Ambas as equipes marcarão mais de 90 pontos: Você deve prever se ambas as equipes
							marcarão mais de 90 pontos na partida (OT incluído).
						</p>
						<p>
							Ambas as equipes marcarão mais de 100 pontos: Você deve prever se ambas as equipes
							marcarão mais de 100 pontos na partida (OT incluído).
						</p>
						<p>
							Ambas as equipes marcarão mais de 110 pontos: Você deve prever se ambas as equipes
							marcarão mais de 110 pontos na partida (OT incluído).
						</p>
						<p>
							Tentativa de primeiro arremesso - Time da casa: Você tem que prever se o primeiro
							arremesso do time da casa durante o jogo será bem-sucedido.
						</p>
						<p>
							Primeira tentativa de arremesso - Time visitante: Você tem que prever se o primeiro
							arremesso do time visitante durante o jogo será bem-sucedido.
						</p>
						<p>
							Primeiro arremesso do jogo feito: Você tem que prever se o primeiro tiro durante o
							jogo será bem-sucedido.
						</p>
						<p>
							Total de arremessos 1X2: Você deve prever o time que fará mais arremessos na partida,
							incluindo a prorrogação. Existem 3 resultados possíveis: 1 (o time da casa faz o maior
							número de arremessos), X (os times farão o mesmo número de arremessos), 2 (o time
							visitante faz o maior número de arremessos).
						</p>
						<p>
							1X2 Total de arremesso a gol: Você deve prever o time que fará mais chutes a gol na
							partida, incluindo a prorrogação. Existem 3 resultados possíveis: 1 (o time da casa
							realiza o maior número de chutes a gol), X (as equipes realizam o mesmo número de
							chutes a gol), 2 (o time visitante realiza o maior número de chutes a gol).
						</p>
						<p>
							1X2: Você deve prever qual time terá mais impedimentos na partida, incluindo a
							prorrogação. Existem 3 resultados possíveis: 1 (o time da casa comete o maior número
							de impedimentos), X (as equipes cometerão o mesmo número de impedimentos), 2 (o time
							visitante comete o maior número de impedimentos).
						</p>
						<p>
							Faltas 1X2: Você tem que prever qual time cometerá mais faltas, incluindo a
							prorrogação. Existem 3 resultados possíveis: 1 (a equipa da casa comete mais faltas),
							X (as equipas cometerão o mesmo número de faltas), 2 (a equipa visitante comete mais
							faltas).
						</p>
						<p>
							Impedimento total: Você deve prever se o número total de impedimentos na partida
							estará acima ou abaixo da linha indicada, incluindo a prorrogação.
						</p>
						<p>
							Total de Faltas: Você deve prever se o número total de faltas na partida ficará acima
							ou abaixo da linha indicada, incluindo a prorrogação.
						</p>
						<p>
							Equipe da casa/visitante - Total de impedimentos: Você deve prever se o número total
							de impedimentos que a equipe da casa ou visitante registrará na partida estará acima
							ou abaixo da linha indicada. incluindo prorrogação.
						</p>
						<p>
							Equipe da casa/visitante - Total de faltas: Total de faltas: Você deve prever se o
							número total de faltas que a equipe da casa ou visitante registrará na partida será
							maior ou menor que a linha indicada. incluindo prorrogação.
						</p>
						<p>
							Em que velocidade o próximo arremesso será lançado: Você deve prever a faixa de
							velocidade com que o arremessador lançará a bola no arremesso específico. 5 são os
							resultados possíveis: Menos de 80 mph, entre 80-89 mph, entre 90-95 mph, entre 96-99
							mph, superior a 99 mph.
						</p>
						<p className="pH3">Resultado do argumento de venda</p>
						<ol>
							<li>
								A interferência do receptor anulará todos os mercados de resultados do arremesso.
							</li>
							<li>
								A violação do relógio do arremesso por parte do arremessador ou batedor anulará
								todos os mercados de resultados do arremesso.
							</li>
							<li>
								Os resultados da velocidade e do tipo de arremesso serão baseados nas estatísticas
								oficiais do órgão dirigente da liga.
							</li>
						</ol>
						<p>
							Qual será o próximo tipo de arremesso: Você deve prever o tipo de arremesso que o
							arremessador lançará no arremesso específico. 7 são os resultados possíveis: Bola
							rápida, cortador, chumbada, curva, controle deslizante, mudança, outros.
						</p>
						<p>Resultado do arremesso</p>
						<ol>
							<li>
								A interferência do receptor anulará todos os mercados de resultados do arremesso.
							</li>
							<li>
								A violação do relógio do arremesso por parte do arremessador ou batedor anulará
								todos os mercados de resultados do arremesso.
							</li>
							<li>
								Os resultados da velocidade e do tipo de arremesso serão baseados nas estatísticas
								oficiais do órgão dirigente da liga.
							</li>
						</ol>
						<p>
							Qual será o resultado do atbat: Você deve prever o resultado do batedor mencionado na
							aparência da placa mencionada. 9 são os resultados possíveis: home run, strikeout,
							simples, triplo, fly out, walk, strikeout swing, double, ground out.
						</p>
						<p className="pH3">Resultado no bastão</p>
						<ol>
							<li>
								O At-Bat deve ocorrer no turno especificado contra o arremessador especificado. Caso
								contrário, as apostas serão
							</li>
							<li>
								Se o turno terminar antes da conclusão da rebatida (ou seja, o corredor da base foi
								pego roubo ou apanhado), as apostas serão anuladas.
							</li>
							<li>roubo ou apanhado), as apostas serão anuladas.</li>
							<li>As apostas serão anuladas no caso de uma caminhada intencional automática.</li>
							<li>A interferência do receptor será definida como um alcance em caso de erro.</li>
						</ol>
						<p>
							Qual será o próximo arremesso: Você deve prever o resultado do arremesso específico. 4
							são os resultados possíveis: rebatida, bola, rebatida durante o jogo, saída durante o
							jogo.
						</p>
						<p className="pH3">Resultado do arremesso</p>
						<ol>
							<li>
								A interferência do receptor anulará todos os mercados de resultados do arremesso.
							</li>
							<li>
								A violação do relógio do arremesso por parte do arremessador ou batedor anulará
								todos os mercados de resultados do arremesso.
							</li>
							<li>
								Os resultados da velocidade e do tipo de arremesso serão baseados nas estatísticas
								oficiais do órgão dirigente da liga.
							</li>
						</ol>
						<p className="pH2">Basquetebol - Outrights</p>
						<p>
							Vencedor: Você deve prever o vencedor de determinada competição de acordo com o
							ranking oficial da competição.
						</p>
						<p>
							Campeonato H2H (Temporada Regular): Você deve prever qual das duas Equipes terminará
							melhor durante a temporada regular do torneio em questão. Se as duas Equipes pontuarem
							o mesmo número de pontos, esta aposta será anulada. (A saber: H2H significa head to
							head, o que pode ser traduzido como "cabeça a cabeça", o que indica comparação entre
							dois adversários)
						</p>
						<p>
							Pontos Menos/Mais (Temporada Regular): Você tem que prever se o número total de pontos
							registrados por uma equipe em uma determinada rodada de um campeonato será acima ou
							abaixo da linha indicada. Se uma ou mais partidas forem canceladas/interrompidas e se
							as partidas restantes ou partes restantes das partidas não tiverem impacto no
							resultado das apostas, os resultados atuais permanecerão válidos (neste caso, qualquer
							eventual partida repetida seria irrelevante); caso contrário, esta aposta será
							considerada nula.
						</p>
						<p>
							Resultado correto Série de Playoffs (4/7 ou 3/5): Você tem que prever o resultado
							final da série de jogos entre as 2 equipes indicadas. Para efeitos de divulgação
							apenas os sites oficiais de cada competição serão considerados válidos. Se a série não
							for concluída, esta aposta será anulada.
						</p>
						<p>
							H2H para se classificar: Você tem que prever qual das duas equipes indicadas passará a
							fase de qualificação ou play-off. (A saber: H2H significa head to head, o que pode ser
							traduzido como "cabeça a cabeça", o que indica comparação entre dois adversários)
						</p>
						<p>
							Finalistas: Você tem que prever quais duas equipes vão se encontrar na final do
							torneio.
						</p>
						<p>
							Melhor Marcador: Você deve prever o jogador que fará mais pontos durante o torneio. Se
							o jogador escolhido jogar pelo menos uma vez durante o torneio, esta aposta será
							válida, caso contrário, será anulada.
						</p>
						<p>
							Marcador H2H: Você tem que prever qual dos dois jogadores irá marcar mais pontos
							durante o torneio. Se os dois jogadores obtiverem o mesmo número de pontos, esta
							aposta será anulada. (A saber: H2H significa head to head, o que pode ser traduzido
							como "cabeça a cabeça", o que indica comparação entre dois adversários)
						</p>
						<p>
							Melhor jogador do torneio (MVP): Você tem que prever qual jogador será eleito o MELHOR
							JOGADOR (MVP) do evento. Para efeitos de divulgação apenas os sites oficiais de cada
							competição serão considerados válidos. Se um jogador não entrar na súmula em nenhuma
							das partidas incluídas no mercado, as apostas nesse jogador serão consideradas nulas.
						</p>
						<p>
							Rebaixamento: Você tem que prever a equipe que será rebaixada de determinado
							campeonato. Para fins de relatório, qualquer decisão tomada antes ou durante os
							playoffs será considerada. Todas as decisões tomadas após o final dos playoffs não
							serão consideradas para a liquidação da aposta.
						</p>
						<p>
							Conferência Vencedora: Você deve prever o vencedor da conferência do torneio em
							questão de acordo com o ranking oficial da competição.
						</p>
						<p>
							Divisão do Vencedor: Você deve prever o vencedor de uma determinada Divisão de um
							determinado torneio de acordo com a classificação oficial da competição.
						</p>
						<p>
							Top4, Top6, Top8, Top10: Você tem que prever se a equipe selecionada terminará na
							posição superior respectiva quando a competição terminar.
						</p>
						<p>
							Vitórias da Temporada Regular (Abaixo/Acima): Você deve prever o número total de
							vitórias (abaixo/acima) da equipe selecionada durante o torneio em questão de acordo
							com a classificação oficial da competição.
						</p>
						<p>
							Prêmios - Jogador que Mais Evoluiu (reg. temporada): Você deve prever quem ganhará o
							Prêmio de Jogador que Mais Evoluiu durante a temporada regular da competição em
							questão.
						</p>
						<p>
							Jogador Defensivo do Ano (reg. temporada): Você tem que prever quem ganhará o prêmio
							de Jogador Defensivo do Ano durante a temporada regular da competição em questão.
						</p>
						<p>
							Prêmios - Sexto Homem do Ano (reg. temporada): Você tem que prever quem ganhará o
							Sexto Homem do Ano durante a temporada regular da competição em questão.
						</p>
						<p>
							Eles vão para os playoffs (Sim/Não): Você deve prever se a equipe selecionada irá para
							os playoffs (Sim) ou não (Não) durante a competição de acordo com o ranking oficial da
							competição.
						</p>
						<p>
							Mercados H2H do Jogador: as apostas aplicam-se ao tempo normal mais tempo extra (se
							houver). Se o jogador listado não participar da partida, as apostas serão consideradas
							nulas. Em caso de empate entre os jogadores, as apostas são anuladas. (A saber: H2H
							significa head to head, o que pode ser traduzido como "cabeça a cabeça", o que indica
							comparação entre dois adversários).
						</p>
						<p>
							Todos os mercados especiais de jogadores de basquetebol são liquidados de acordo com a
							fonte oficial relevante. As prorrogações potenciais são incluídas na liquidação de
							todos os mercados disponíveis.
						</p>
					</div>
				</details>
				{/* Basquetebol 3x3  */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 33 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<g clip-path="url(#clip0_414_465)">
								{' '}
								<path
									d="M19.9269 20.5054C20.2266 19.9044 20.5264 19.2032 20.8261 18.4018C16.2299 17.0996 14.931 11.59 13.8319 6.98208C13.2324 4.27741 12.5329 1.47256 11.4338 0.671174C9.03579 1.47256 6.63775 2.77481 4.73931 4.77827C4.1398 5.37931 3.64021 5.98035 3.14062 6.68156C7.23726 11.4899 12.9326 16.9994 19.9269 20.5054Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M17.7287 24.0115C18.1283 23.5106 18.528 22.9096 18.9277 22.3086C11.8335 18.7023 6.13816 13.293 1.9416 8.48468C0.143073 11.6902 -0.356517 15.4968 0.242991 19.0029C2.44119 20.7058 4.63939 21.5072 8.03661 21.9079C12.2332 22.3086 15.4305 23.0098 17.7287 24.0115Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M21.4256 16.4985C22.5247 12.5918 22.9244 7.68329 22.225 1.27221C19.5272 0.0701348 16.5296 -0.230384 13.632 0.170308C14.6312 1.6729 15.2307 3.97689 15.7303 6.48121C16.8294 10.989 17.9285 15.597 21.4256 16.4985Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M23.5239 16.799C26.3216 16.799 29.2193 15.597 30.6181 9.68675C29.8188 7.88364 28.7197 6.28087 27.3208 4.77827C26.4215 3.87671 25.4224 3.07533 24.4232 2.47429C24.9228 8.28433 24.5231 12.9925 23.5239 16.799Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M19.6271 24.9131C20.6263 25.5141 21.4256 26.3155 21.9252 27.1169C22.8245 28.5193 22.6247 29.9217 22.4248 30.8233C24.2233 30.0219 25.822 28.92 27.3208 27.5176C27.9203 26.9165 28.32 26.4157 28.8196 25.7145C26.0219 25.2136 23.3241 24.312 20.8261 23.2101C20.4265 23.8112 20.0268 24.4122 19.6271 24.9131Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M31.7172 12.8923C30.1185 16.799 27.4207 18.7023 23.5239 18.7023H22.9244C22.6247 19.7041 22.225 20.5055 21.8253 21.407C24.2233 22.4087 26.7213 23.3103 29.4191 23.711C29.7188 23.8112 29.9187 23.8112 30.0186 23.8112C31.8171 20.5055 32.4166 16.5987 31.7172 12.8923Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M20.3265 30.8233C20.5264 30.2222 20.926 29.2205 20.2266 28.1186C19.9269 27.6177 19.3274 27.0167 18.3282 26.4157C16.3298 28.6195 14.2315 30.2222 12.1333 31.5245C14.7311 32.2257 17.5288 32.1255 20.1267 31.4243C20.1267 31.3241 20.2266 31.0236 20.3265 30.8233Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M16.4297 25.6143C14.5313 24.9131 11.8335 24.312 7.93669 23.8112C5.13898 23.5106 3.0407 22.9096 1.14225 21.8077C1.9416 23.8112 3.14062 25.7145 4.73931 27.3172C6.23808 28.8198 7.93669 29.9217 9.73522 30.7231C11.8335 29.4209 14.2315 27.8181 16.4297 25.6143Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
							</g>{' '}
							<defs>
								{' '}
								<clipPath id="clip0_414_465">
									{' '}
									<rect
										data-darkreader-inline-fill=""
										fill="white"
										height="28"
										style={{ fill: '#FFFFFF' }}
										transform="translate(0.00317383)"
										width="28"
									>
										{' '}
									</rect>{' '}
								</clipPath>{' '}
							</defs>{' '}
						</svg>
						Basquetebol 3x3
					</summary>
					<div className="textItem">
						<p className="pH2">Principais Mercados</p>
						<p>{`Money Line (Vencedor) (inclui tempo extra): Preveja o vencedor da partida, independentemente da margem de pontos. Este mercado incluirá tempo extra.

`}</p>
						<p>{`Total (mais/menos) (inclui tempo extra): Consiste em prever se o total de pontos marcados por ambas as equipes será maior ou menor que a linha dada no mercado de apostas escolhido. Por exemplo: Acima de 215,5 - Abaixo de 215,5. Este mercado incluirá tempo extra.

`}</p>
						<p>{`Handicap (spread) (inclui tempo extra): Você tem que prever o vencedor de toda a partida adicionando ou subtraindo o spread indicado ao resultado da partida. Este mercado incluirá tempo extra.

`}</p>
						<p>{`Vencedor da partida 1X2: Preveja se o vencedor será o time da casa ou visitante com a opção de selecionar também o empate. Nenhuma hora extra está incluída.

`}</p>
						<p>{`Par/ímpar (inclui tempo extra): Aqui você prevê se o resultado da partida será um número par ou ímpar. Este mercado incluirá tempo extra.

`}</p>
						<p>{`Total de pontos por equipe (casa - visitante) (inclui tempo extra): Consiste em prever se o total de pontos marcados pela equipe da casa ou visitante será maior ou menor que a linha dada no mercado de apostas escolhido. Por exemplo: Mais de 215,5 - Menos de 215,5. Este mercado incluirá tempo extra.

`}</p>
					</div>
				</details>
				{/* Biatlo / Atletismo  */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 33 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<g clip-path="url(#clip0_472_356)">
								{' '}
								<path
									d="M28.6316 14.9868H32.0032C31.5115 6.93166 25.0693 0.501567 17.0116 0V3.37053C23.2029 3.86207 28.1499 8.79749 28.6316 14.9868Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M15.0047 3.37053V0C6.93701 0.501567 0.504898 6.93166 0.00317383 14.9969H3.3848C3.87649 8.80752 8.82349 3.86207 15.0047 3.37053Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M17.0116 22.8313V26.6232C22.0991 26.1417 26.1531 22.089 26.6347 17.0031H22.8417C22.4002 20.0125 20.022 22.39 17.0116 22.8313Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M9.1747 17.0031H5.38166C5.86332 22.089 9.91725 26.1417 14.9947 26.6232V22.8313C11.9844 22.39 9.60618 20.0125 9.16467 17.0031H9.1747Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M20.9151 16C20.9151 13.3016 18.7175 11.0947 16.0082 11.0947C13.2989 11.0947 11.1013 13.2915 11.1013 16C11.1013 18.7085 13.2989 20.9053 16.0082 20.9053C18.7175 20.9053 20.9151 18.7085 20.9151 16ZM16.0082 18.0063C14.9044 18.0063 14.0013 17.1034 14.0013 16C14.0013 14.8966 14.9044 13.9937 16.0082 13.9937C17.112 13.9937 18.0151 14.8966 18.0151 16C18.0151 17.1034 17.112 18.0063 16.0082 18.0063Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M9.1747 14.9969C9.61622 11.9875 11.9944 9.61003 15.0047 9.16865V5.3768C9.91725 5.85831 5.86332 9.91097 5.3917 14.9969H9.18473H9.1747Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M22.8316 14.9868H26.6247C26.143 9.91097 22.0891 5.85831 17.0116 5.3768V9.16865C20.012 9.61003 22.3901 11.9875 22.8316 14.9868Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M28.6316 16.9931C28.1499 23.1824 23.2029 28.1279 17.0016 28.6194V31.99C25.0693 31.4884 31.5014 25.0483 32.0032 16.9831H28.6316V16.9931Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M3.3848 17.0031H0.00317383C0.504898 25.0683 6.93701 31.4984 15.0047 32V28.6295C8.81346 28.1379 3.86645 23.1925 3.3848 17.0031Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
							</g>{' '}
							<defs>
								{' '}
								<clipPath id="clip0_472_356">
									{' '}
									<rect
										data-darkreader-inline-fill=""
										fill="white"
										height="28"
										style={{ fill: '#FFFFFF' }}
										transform="translate(0.00317383)"
										width="28"
									>
										{' '}
									</rect>{' '}
								</clipPath>{' '}
							</defs>{' '}
						</svg>
						Biatlo / Atletismo
					</summary>
					<div className="textItem">
						<p className="pH2">Mercado Outright:</p>
						<p>{`Vencedor: Você prevê que o jogador selecionado será o vencedor do torneio/evento.

`}</p>
						<p>{`H2H: Você deve prever qual dos dois jogadores especificados na aposta alcançará a melhor posição no torneio/evento. No caso de ambos os jogadores se retirarem ou serem desqualificados na mesma fase da competição, esta tipologia de aposta será considerada nula.

`}</p>
					</div>
				</details>
				{/* Boxe / MMA  */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<path
								d="M15.96 27.1185C15.96 28.4089 15.52 29.4992 14.66 30.3595C13.83 31.1797 12.66 31.6799 11.39 32H18C20.21 32 22 30.2094 22 27.9987V23.9975H14.88C15.58 24.8178 15.96 25.8681 15.96 27.1185Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M23.84 18.0356H4.16C4.06 18.3357 4 18.6558 4 18.9859V20.9866C4 21.3367 4.08 21.6768 4.19 21.9869H23.95C24.05 20.9365 23.99 19.9862 23.91 18.9859C23.89 18.6758 23.86 18.3557 23.84 18.0356Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M20 7.0422C20 7.59237 19.55 8.04251 19 8.04251C18.45 8.04251 18 7.59237 18 7.0422V0C17.12 0.0200063 16.13 0.100031 14.99 0.270084V8.0125C14.99 8.56268 14.54 9.01282 13.99 9.01282C13.44 9.01282 12.99 8.56268 12.99 8.0125V0.620194C11.87 0.850266 10.88 1.11035 10.01 1.39043V9.00281C10.01 9.55299 9.56 10.0031 9.01 10.0031C8.46 10.0031 8.01 9.55299 8.01 9.00281V2.14067C4.88 3.5311 4 5.01157 4 5.01157C4 5.01157 3 6.01188 3 10.5133C3 12.824 3.53 14.7246 4.04 16.035H23.82C23.83 15.7649 23.85 15.4948 23.88 15.2148C24.13 12.934 24.32 10.1632 24.46 6.98218C24.46 6.92216 24.49 6.88215 24.5 6.82213C24.5 3.81119 24.43 1.9306 24 1.50047C23.68 1.18037 22.65 0.300094 20 0.0500156V7.0422Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M27.52 12.0038L26.2 11.6036C26.1 12.9941 26 20.2563 25.99 21.0266C26.4 20.6465 26.78 20.2463 27.11 19.8262C28.18 18.4658 28.93 16.9153 29.41 15.6049C29.99 14.0044 28.98 12.4439 27.51 12.0038H27.52Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M13.96 27.1185C13.96 24.5377 11.47 23.9975 9.38 23.9975H5V27.9987C5 28.959 5.35 29.8293 5.91 30.5195C8.33 30.5195 11.79 30.3795 13.25 28.939C13.73 28.4689 13.96 27.8787 13.96 27.1285V27.1185Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
						</svg>
						Boxe / MMA
					</summary>
					<div className="textItem">
						<p>{`O som do sino é o sinal para o início da primeira rodada para fins de apostas. Quando um lutador não pode atender o sino para o próximo round, então o outro lutador será considerado o vencedor do round anterior.

`}</p>
						<p>{`No Boxe, uma rodada é considerada totalmente jogada, quando 1:30 minutos da rodada são jogados.

`}</p>
						<p>{`No MMA, um round é considerado completo, quando são jogados 2:30 minutos do round.

`}</p>
						<p>{`Quando uma luta é declarada como "No contest" (luta sem decisão) todas as apostas serão anuladas, com exceção daquelas que já foram liquidadas pela evolução do evento.

`}</p>
						<p>{`Empate ou empate técnico: Empate é um empate por pontos. Empate técnico é se o árbitro interromper a luta antes do quinto round começar, por qualquer motivo que não seja nocaute, nocaute técnico ou desqualificação.

`}</p>
						<p>{`Nocaute: Um nocaute é quando um lutador não se levanta após a contagem de 10. Nocaute técnico é quando a regra dos 3 nocautes se aplica ou se o árbitro assim decidir. Qualquer desistência no canto será considerado um nocaute técnico a menos que a luta seja decidida pelos pontos dos juízes ou se for declarado como "No contest".

`}</p>
						<p>{`Decisão técnica: É determinada pelos marcadores de pontos dos árbitros em qualquer momento que não seja o final da luta.

`}</p>
						<p>{`Nocaute: Um nocaute ocorre quando o lutador não se levanta após a contagem de 10. O nocaute técnico acontece quando a regra dos 3 nocautes se aplica ou quando o árbitro decide assim. Qualquer aposentadoria no canto será considerada um nocaute técnico, a menos que a luta seja decidida pelos pontos dos juízes ou declarada como “Sem contestação”.

`}</p>
						<p className="pH2">{`Mercados de boxe/MMA:`}</p>
						<p>{`Vencedor (1,2): adivinhe qual lutador vai vencer a partida, diferentemente do mercado 1X2, você não pode escolher a opção de empate.

`}</p>
						<p>{`Vencedor (1X2): preveja o resultado de toda a partida. Existem 3 resultados possíveis: 1 (o boxeador 1 vence), X (empate) ou 2 (o boxeador 2 vence).

`}</p>
						<p>{`Total de rodadas: preveja a quantidade total de rodadas no evento.

`}</p>
						<p>{`Método de vitória: preveja quem vai ganhar e de que forma, as opções incluem KO (Knockout), decisão ou empate.

`}</p>
						<p>{`Golpes Significativos: São quaisquer Golpes de Distância ou Golpes Clinch/Ground que são considerados "Golpes Poderosos" pelos marcadores oficiais. Um Golpe Significativo contará como um golpe e um golpe significativo e valerá um total de 0,4 Pts

`}</p>
						<p>{`Knockdown: É concedido ao lutador que derruba seu oponente devido à debilitação por um tempo que os marcadores oficiais consideram um período de tempo apreciável. No MMA e no UFC, golpes regulares referem-se a qualquer técnica legal de golpes, incluindo socos, chutes, cotoveladas e joelhadas, que um lutador usa para atacar seu oponente.

`}</p>
						<p>{`Esses golpes são contados nas estatísticas gerais de golpes de um lutador. Por outro lado, os golpes significativos são um subconjunto dos golpes regulares e são definidos como golpes que têm um impacto claro no oponente, seja pousando com força significativa ou afetando visivelmente o oponente.

`}</p>
						<p>{`Golpes significativos são usados para medir a trocação efetiva de um lutador durante uma luta e costumam ser um fator-chave para julgar o resultado de uma luta. Em resumo, enquanto os golpes regulares abrangem todas as técnicas legais de golpes, os golpes significativos referem-se especificamente aos golpes que têm um impacto perceptível no adversário.

`}</p>
						<p>{`A luta vai durar (sim/não): você deve prever se a luta chegará ao final do número de rounds programado.

`}</p>
						<p>{`Vencedor e Rodadas Exatas: preveja quem será o vencedor e exatamente em quantas rodadas.

`}</p>
						<p>{`Vencedor e intervalo de rodadas: preveja quem será o vencedor e exatamente dentro de qual intervalo de rodadas.

`}</p>
						<p>{`Apostas em grupos de rounds: preveja se um lutador vencerá por nocaute, nocaute técnico ou desqualificação durante um round específico ou grupo de rounds. Observe que, se uma Decisão Técnica for declarada antes do final programado do evento, todas as apostas serão resolvidas como uma vitória por Decisão.

`}</p>
						<p>{`Apostas em Grupo de Rodada e Vencedor (Lutador X): preveja o vencedor da partida e o grupo de rodada específico em que alcançará a vitória.

`}</p>
						<p>{`O lutador deve vencer por nocaute, nocaute técnico ou desqualificação durante o grupo de rounds selecionado. Se uma Decisão Técnica for declarada antes do final programado da luta, todas as apostas serão resolvidas como vitória por Decisão.

`}</p>
						<p>{`Definição de Empate: um Empate se refere a um empate no scorecard, no qual nenhum dos lutadores é declarado vencedor.

`}</p>
						<p>{`Definição de Empate Técnico: o Empate Técnico ocorre se o árbitro interromper a luta antes do início do 5º round, por qualquer motivo que não seja Nocaute, Nocaute Técnico ou desclassificação.

`}</p>
						<p>{`Resultado de No Contest: se uma luta for declarada "No Contest", todas as apostas serão anuladas e todas as apostas serão reembolsadas.

`}</p>
						<p>{`Retirada do lutador durante os rounds: no caso de um lutador se retirar para o banco entre os rounds (por exemplo, entre os rounds 9 e 10), os fins de liquidação considerarão o último round totalmente concluído, que neste caso é o Round 9.

`}</p>
						<p>{`Fighter Strikes Landed: Você tem que prever quantos golpes irão comp 1, comp 2 e qualquer um (comp 1 e comp 2 ambos para marcar, por exemplo, 200 golpes, não combinados) lutador pousar em uma partida (300 ou mais).

`}</p>
						<p>{`Total de golpes de ambos os lutadores: Você deve prever quantos golpes acertarão o comp 1 e a comp 2 combinados na partida (250 ou mais).

`}</p>
						<p>{`Golpes significativos do lutador acertados: Você tem que prever quantos golpes significativos irão acertar o comp 1, comp 2 e (comp 1 e comp 2 ambos para marcar, por exemplo, 200 golpes, não combinados) na partida (30 ou mais).

`}</p>
						<p>{`Quedas de lutadores: você tem que prever quantas quedas ocorrerão no comp 1, no comp 2 e (no comp 1 e no compo 2, ambas para marcar, por exemplo, 8 quedas, não combinadas) o lutador pousará em uma partida (10 ou mais).

`}</p>
						<p>{`Total de golpes significativos acertados: quantos golpes significativos acertarão o comp 1 e o comp 2 combinados na partida (30 ou mais).

`}</p>
						<p>{`Total de golpes significativos do Lutador X: Você deve prever quantos golpes significativos o lutador X acertará na partida (10 ou mais).

`}</p>
						<p>{`Total de golpes acertados (acima/abaixo): Você deve prever quantos golpes totais serão acertados na partida dos 2 lutadores combinados, por exemplo. Acima/Abaixo de 220,5.

`}</p>
						<p>{`Total de golpes do Fighter X acertados (acima/abaixo): Você deve prever quantos golpes totais serão acertados na partida do Fighter X.

`}</p>
						<p>{`Total de quedas (acima/abaixo): Você deve prever quantas quedas ocorrerão durante a partida entre os 2 lutadores combinados, por exemplo. Acima/Abaixo de 12,5

`}</p>
						<p>{`Total de quedas do lutador X (acima/abaixo): Você deve prever quantas quedas o lutador X fará durante a partida.

`}</p>
						<p>{`Total de golpes acertados no Round 1 (acima/abaixo): Você deve prever quantos golpes acertarão o comp 1 e o compo 2 combinados no Round 1, por exemplo. Acima/Menos de 30,5.

`}</p>
						<p>{`Round 1 lutador X total de golpes acertado (Over/Under): Você deve prever quantos golpes totais serão acertados na disputa do lutador X no Round 1.

`}</p>
						<p>{`Total de golpes significativos acertados no Round 1 (acima/abaixo): você deve prever quantos golpes significativos acertarão o comp 1 e o comp 2 combinados no Round 1, por exemplo. Acima/Abaixo de 10,5.

`}</p>
						<p>{`Round 1 do Lutador X Total de Golpes Significativos Acertados (Acima/Abaixo): Você deve prever quantos golpes significativos serão acertados na partida do Lutador X no Round 1.

`}</p>
						<p>{`Round 1 Lutador golpes acertados: Você tem que prever quantos golpes o comp 1, comp 2 e (comp 1 e comp 2 ambos para marcar, por exemplo, 50 golpes, não combinados) acertarão no Round 1 (30 ou mais).

`}</p>
						<p>{`Round 1 Total de Golpes Acertados de Ambos os Lutadores: Você tem que prever quantos golpes acertarão o comp 1 e o comp 2 combinadas no round 1 (20 ou mais).

`}</p>
						<p>{`Round 1 Golpes Significativos do Lutador Acertados: Você tem que prever quantos golpes significativos acertarão o comp 1 e o comp 2 combinados no Round 1 (10 ou mais).

`}</p>
						<p>{`Round 1 Total de golpes significativos de ambos os lutadores: Você tem que prever quantos golpes significativos acertarão o comp 1 e comp 2 combinados no Round 1 (30 ou mais).

`}</p>
						<p>{`Maior número de golpes acertados (1x2): Você tem que prever quem fará mais golpes na luta.

`}</p>
						<p>{`Golpes mais significativos acertados (1x2): Você deve prever quem fará os golpes mais significativos na luta.

`}</p>
						<p>{`Maior número de golpes acertados no primeiro round (1x2): Você precisa prever quem acertará mais golpes no primeiro round.

`}</p>
						<p>{`Golpes Mais Significativos Acertados no Round 1 (1x2): Você tem que prever quem fará golpes mais significativos na Round 1.

`}</p>
						<p>{`Socos do Lutador: Você deve prever o número de socos que Comp1 ou Comp2 darão durante a luta (comp1/comp2 150.200.250 ou mais, etc.)

`}</p>
						<p>{`Socos de Lutadores Combinados: Você deve prever o número de socos que serão dados por ambos os lutadores combinados durante a luta (500.600 ou mais, etc.)

`}</p>
						<p>{`Lutador Socos acertados: Você tem que prever o número de socos que comp1 e comp2 acertarão durante a luta (comp1/comp2 50,75,100 ou mais etc)

`}</p>
						<p>{`Socos acertados combinados: Você tem que prever o número de socos que serão acertados por ambos os lutadores combinados durante a luta (200.250 ou mais, etc.)

`}</p>
						<p>{`Mais socos dados: você tem que prever qual lutador dará mais socos durante a luta.

`}</p>
						<p>{`Mais socos acertados: você tem que prever qual lutador acertará mais socos durante a luta.

`}</p>
						<p className="pH2">Mercados de apostas de knockdown</p>
						<p>{`Para fins de liquidação, um knockdown (quando o lutador é derrubado e toca a lona) é definido como um lutador recebendo uma contagem obrigatória de 8 do árbitro. É importante notar que qualquer coisa considerada um deslize pelo árbitro não será considerada um knockdown.

`}</p>
						<p>{`Um lutador para marcar um knockdown: preveja um lutador para ser derrubado durante o evento.

`}</p>
						<p>{`Ambos os lutadores marcarão um knockdown: preveja se ambos os lutadores serão derrubados durante o evento.

`}</p>
						<p>{`Qualquer um dos lutadores marcará um knockdown: preveja se pelo menos um dos dois lutadores será derrubado durante o evento.

`}</p>
						<p>{`Aposta de knockdown no Round (Fighter X): preveja se um lutador específico será derrubado durante um determinado round.

`}</p>
						<p>{`Apostas de knockdown no round (qualquer lutador): preveja se um jogador será derrubado durante um round específico.

`}</p>
						<p>{`Total de knockdown (acima/abaixo): preveja se o número total de vezes que os jogadores serão derrubados durante todo o evento ficará acima ou abaixo da linha indicada.

`}</p>
						<p>{`Total de knockdown do lutador X: Preveja se o número total de vezes que um lutador específico for derrubado ficará acima ou abaixo da linha indicada.

`}</p>
						<p>{`Sofrer knockdown e vencer (Lutador X, Sim/Não): preveja se um lutador específico será derrubado e, finalmente, se vai ganhar ou perder o evento.

`}</p>
					</div>
				</details>
				{/* Bowls  */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Bowls
					</summary>
					<div className="textItem">
						<p className="pH2">{`Principais Mercados
`}</p>
						<p>{`Vencedor (1,2): Mercado de apostas que consiste em prever o vencedor da partida independentemente da margem de pontos.

`}</p>
						<p>{`Handicap Sets: Você tem que prever o resultado em termos de conjuntos ganhos por cada jogador adicionando ou subtraindo ao resultado final o spread especificado na aposta.

`}</p>
						<p>{`Pontuação correta: Você tem que prever a pontuação correta da partida em termos de sets ganhos por cada jogador. Se um jogador se aposentar durante a partida, todas as apostas indecisas serão consideradas nulas.

`}</p>
						<p>{`Total de Sets (Over/Under): Você tem que prever se o número total de sets jogados na partida será maior ou abaixo do spread indicado.

`}</p>
						<p>{`Xth Set - 1X2: Você tem que prever o resultado do Xth set. Existem 3 resultados possíveis: 1 (jogador 1 ganha), X (jogadores vão empatar), 2 (jogador 2 ganha).

`}</p>
						<p>{`Xº set - Sorteio sem Aposta: Você tem que prever o vencedor do 1º tempo, se a metade terminar como um sorteio todas as apostas serão anuladas, se a metade estiver incompleta este mercado será tornado nulo.

`}</p>
						<p>{`Xº set - Handicap: Você tem que prever o vencedor do conjunto mencionado (em pontos ganhos) adicionando ou subtraindo o spread indicado ao resultado do conjunto (em pontos).

`}</p>
						<p>{`Xº set - Total: Prever se o total de pontos acumulados por ambos os jogadores no conjunto mencionado estará acima ou abaixo da linha.

`}</p>
						<p>{`Xth set - Player 1/2 total: Você tem que prever se o número total de pontos marcados pelo jogador mencionado durante o conjunto dado será acima ou abaixo da linha indicada, se o conjunto estiver incompleto este mercado será anulado.

`}</p>
						<p className="pH2">{`Bowls Outrights
`}</p>
						<p>{`Vencedor: Você tem que prever o vencedor do torneio dado de acordo com o ranking oficial da competição.

`}</p>
					</div>
				</details>
				{/* Beisebol  */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 33 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<g clip-path="url(#clip0_471_311)">
								{' '}
								<path
									d="M27.3132 4.68997C23.7932 1.15997 19.0432 -0.370029 14.4432 0.0799711C10.8832 0.429971 7.41316 1.95997 4.69316 4.68997C1.97316 7.41997 0.42316 10.88 0.0831603 14.44C0.0531603 14.7 0.0431603 14.97 0.0231603 15.23C0.00316034 15.63 0.00316034 16.03 0.0131603 16.44C0.12316 20.39 1.68316 24.3 4.69316 27.32C7.70316 30.33 11.6232 31.89 15.5732 32C16.2332 32.02 16.8932 32 17.5432 31.93C17.5432 31.93 17.5632 31.93 17.5732 31.93C21.1332 31.58 24.6032 30.05 27.3232 27.32C30.0532 24.59 31.5832 21.13 31.9332 17.57C31.9932 16.92 32.0232 16.27 32.0032 15.62C32.0032 15.6 32.0032 15.58 32.0032 15.57C31.8932 11.62 30.3332 7.70997 27.3232 4.68997H27.3132ZM3.55316 16.16L3.16316 14.2C3.76316 14.08 4.35316 13.92 4.93316 13.73L5.57316 15.62C4.91316 15.84 4.23316 16.02 3.55316 16.16ZM7.51316 14.82L6.63316 13.03C7.17316 12.76 7.70316 12.46 8.21316 12.11L9.32316 13.77C8.73316 14.16 8.13316 14.51 7.51316 14.82ZM11.7532 11.78C11.5032 12.03 11.2532 12.27 10.9932 12.5L9.67316 11C9.90316 10.8 10.1232 10.59 10.3432 10.37C10.5632 10.15 10.7732 9.92997 10.9732 9.69997L12.4732 11.02C12.2432 11.28 12.0032 11.54 11.7532 11.78ZM13.7432 9.35997L12.0832 8.24997C12.4232 7.73997 12.7332 7.20997 13.0032 6.66997L14.7932 7.54997C14.4832 8.16997 14.1332 8.77997 13.7432 9.35997ZM13.6932 4.96997C13.8932 4.38997 14.0432 3.79997 14.1632 3.19997L16.1232 3.58997C15.9832 4.26997 15.8032 4.94997 15.5832 5.60997L13.6932 4.96997ZM17.8132 28.85L15.8532 28.46C15.9932 27.78 16.1732 27.1 16.3932 26.44L18.2832 27.08C18.0832 27.66 17.9332 28.25 17.8132 28.85ZM18.9832 25.39L17.1932 24.51C17.5032 23.89 17.8532 23.28 18.2432 22.7L19.9032 23.81C19.5632 24.32 19.2532 24.85 18.9832 25.39ZM21.6432 21.68C21.4232 21.9 21.2132 22.12 21.0132 22.35L19.5132 21.03C19.7432 20.77 19.9832 20.51 20.2332 20.27C20.4832 20.02 20.7332 19.78 20.9932 19.55L22.3132 21.05C22.0832 21.25 21.8632 21.46 21.6432 21.68ZM23.7632 19.93L22.6532 18.27C23.2432 17.88 23.8432 17.53 24.4632 17.22L25.3432 19.01C24.8032 19.28 24.2732 19.58 23.7632 19.93ZM27.0332 18.31L26.3932 16.42C27.0532 16.2 27.7332 16.02 28.4132 15.88L28.8032 17.84C28.2032 17.96 27.6132 18.12 27.0332 18.31Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
							</g>{' '}
							<defs>
								{' '}
								<clipPath id="clip0_471_311">
									{' '}
									<rect
										data-darkreader-inline-fill=""
										fill="white"
										height="28"
										style={{ fill: '#FFFFFF' }}
										transform="translate(0.00317383)"
										width="28"
									>
										{' '}
									</rect>{' '}
								</clipPath>{' '}
							</defs>{' '}
						</svg>
						Beisebol
					</summary>
					<div className="textItem">
						<p className="pH2">{`Regras de Beisebol
`}</p>
						<p>{`Liga da MLB para Beisebol: a Moneyline (Mercado do Vencedor) é considerada decidida se os oficiais da liga considerarem o jogo como finalizado e se:

`}</p>
						<p>{`pelo menos 5 entradas são concluídas

`}</p>
						<p>{`OU

`}</p>
						<p>{`4.5 turnos são completados e o time da casa (ou o segundo rebatedor) está na frente. Em todos os outros casos, as apostas na linha de dinheiro são consideradas nulas.

`}</p>
						<p>{`Para evitar dúvidas, as apostas em todos os outros mercados (por exemplo, Totais, Spread, etc.) serão válidas, a menos que já tenham sido decididas, se:

`}</p>
						<p>{`pelo menos 9 entradas forem concluídas

`}</p>
						<p>{`OU

`}</p>
						<p>{`8,5 turnos são completados e o time da casa (ou o segundo rebatedor) está na frente.

`}</p>
						<p>{`Em todos os outros casos, as apostas são consideradas nulas. No caso de uma Regra de Misericórdia ser chamada, todas as apostas serão válidas no placar naquele momento.

`}</p>
						<p>{`Liga da MLB para Beisebol, todas as Linhas de Arremessador (Mercados PL para Moneyline, Spread e Totais) são anuladas em caso de mudança no arremessador inicial listado. As apostas feitas nos mercados da linha de arremessadores incluirão a indicação (PL) dentro do boletim de apostas e nas páginas de histórico de apostas. Caso o indicador (PL) não esteja visível dentro do boletim de apostas, a aposta é feita na Linha de Ação e será liquidada de acordo. As linhas de ação são determinadas com base no resultado do evento, independentemente de quaisquer alterações de arremessador. Quaisquer novas linhas de arremessadores oferecidas seguirão as regras acima. As linhas de ação estão seguindo as regras gerais com as exceções referentes à MLB, conforme acima.

`}</p>
						<p>{`No Beisebol e no caso de um jogo de 7 entradas, as apostas em todos os outros mercados (por exemplo, Totais, Spread etc) serão válidas, a menos que já tenha sido decidido, se:

`}</p>
						<p>{`pelo menos 7 entradas são concluídas

`}</p>
						<p>{`OU

`}</p>
						<p>{`6,5 turnos são completados e o time da casa (ou o segundo rebatedor) está na frente.

`}</p>
						<p>{`A exceção é a Moneyline (Vencedor da Partida) que é considerada decidida se:

`}</p>
						<p>{`pelo menos 5 entradas são concluídas

`}</p>
						<p>{`OU`}</p>
						<p>{`4.5 turnos são completados e o time da casa (ou o segundo rebatedor) está na frente.

`}</p>
						<p>{`Em todos os outros casos, as apostas na linha de dinheiro são liquidadas como nulas.
`}</p>
						<p>{`Bases totais: são estritamente o que vem de rebatidas de batedor, como simples, duplas, triplas ou home runs. Total de bases - Um home run tem 4 bases no total, um triplo tem 3, um duplo tem 2 e um simples tem 1.
`}</p>
						<p>{`Caminhadas, ser atingido por um arremesso (HBP), roubar uma base, chegar a uma base por erro ou escolha do defensor NÃO contam para o suporte Total Bases - apenas rebatidas.
`}</p>
						<p>{`*As bases totais são calculadas somando todos os acertos que um jogador dá de acordo com Simples = 1 Base, Duplo = 2, Triplo = 3, Home Run = Somente estes contam.

`}</p>
						<p className="pH2">{`Principais Mercados
`}</p>
						<p>{`Money Line (1/2) (incl.extra innings): Preveja a equipe vencedora, independentemente do lançador inicial.

`}</p>
						<p>{`Handicap (incl. entradas extras): Você tem que prever o vencedor de toda a partida adicionando ou subtraindo o spread indicado ao resultado da partida, incluindo quaisquer entradas extras.

`}</p>
						<p>{`Total (incluindo entradas extras): Nesta aposta você deve especificar o número total de corridas alcançadas por ambas as equipes, incluindo quaisquer entradas extras.

`}</p>
						<p>{`Total de corridas da equipe da casa (incluindo entradas extras): Nesta aposta, você deve especificar o número total de corridas alcançadas pela equipe da casa, incluindo quaisquer entradas extras.

`}</p>
						<p>{`Total de corridas da equipe visitante (incluindo entradas extras): Nesta aposta, você deve especificar o total de corridas alcançadas pela equipe visitante, incluindo quaisquer entradas extras.

`}</p>
						<p>{`Total de acertos (incluindo entradas extras): Nesta aposta você deve especificar o número total de acertos alcançados por ambas as equipes, incluindo quaisquer entradas extras.

`}</p>
						<p>{`Total de acertos da equipe da casa (incluindo entradas extras): Nesta aposta, você deve especificar o número total de acertos alcançados pela equipe da casa, incluindo quaisquer entradas extras.

`}</p>
						<p>{`Total de acertos da equipe visitante (incluindo entradas extras): Nesta aposta você deve especificar o total de acertos alcançados pela equipe visitante, incluindo quaisquer entradas extras.

`}</p>
						<p>{`Ganhar o turno atual ou o próximo turno: Preveja se o time da casa ou visitante vencerá o turno atual ou o próximo. A primeira e a segunda partes do turno especificado devem ser concluídas, exceto quando a equipe que atingir o segundo estiver liderando quando o jogo for suspenso ou abandonado.

`}</p>
						<p>{`Total de corridas na X entrada: Nesta aposta você deve especificar o número total de corridas alcançadas por ambas as equipes na X entrada. A primeira e a segunda parte do turno específico devem ter sido concluídas, a menos que o mercado já esteja determinado.

`}</p>
						<p>{`Pontuação da entrada atual ou da próxima entrada: Preveja a pontuação da entrada atual ou da próxima entrada. A primeira e a segunda parte do turno específico devem ter sido concluídas, a menos que a aposta já tenha sido determinada.

`}</p>
						<p>{`Marcador do turno atual / Golpe em ½ turno ou turno seguinte: A primeira e a segunda parte do turno específico devem ser completadas, a menos que uma corrida tenha sido completada ou um rebatido tenha sido realizado, quando o jogo for suspenso ou abandonado.

`}</p>
						<p>{`Equipe para obter mais rebatidas na entrada atual ou na próxima entrada: Para que a aposta seja válida, a primeira e a segunda partes da entrada específica devem ser concluídas, a menos que a aposta já tenha sido determinada.

`}</p>
						<p>{`Total de acertos no turno atual ou próximo turno ou total de corridas no turno atual ou próximo turno: A primeira e a segunda parte do turno específico devem ter sido concluídas, a menos que a aposta já tenha sido liquidada.

`}</p>
						<p>{`Líder após xx turnos: Para que a aposta seja válida, a primeira e a segunda partes do turno específico devem ser concluídas, a menos que a aposta já tenha sido liquidada.

`}</p>
						<p>{`Mercados 'Race to xx'/Totais da equipe/Total de acertos: A regra das 8½ entradas será aplicada, a menos que as apostas já tenham sido liquidadas ou finais naturais (por exemplo, sem suspender a partida) da partida determinem as apostas.

`}</p>
						<p>{`Se uma partida chegar a um empate e o final natural da partida (por exemplo, sem suspender a partida) exigir um vencedor, as apostas nos mercados 'Race to xx' serão anuladas. Por exemplo, se um jogo da MLB for suspenso ou abandonado, ou suspenso com um gol de 3-3 após 10 entradas, as apostas nos mercados de 4 corridas serão anuladas. As apostas nos mercados de 5, 6 ou 7 corridas serão liquidadas como anuladas.

`}</p>
						<p>{`Próxima equipe a pontuar: No caso de a partida ser suspensa, todas as apostas em corridas já marcadas serão contabilizadas. As apostas na próxima corrida no momento da suspensão ou abandono serão anuladas.

`}</p>
						<p>{`Margem de vitória: Mercado de apostas que prevê a diferença que uma equipe terá do seu adversário no final do jogo, por exemplo, a equipe da casa por 1-3 corridas. A regra das 8½ entradas será aplicada. Inclui entradas adicionais para MLB (Major League Baseball). Para MLB, um jogo que termina em empate, as apostas que não oferecem uma opção de empate serão anuladas; no caso de eventos não-MLB onde o jogo pode terminar empatado, essa opção estará disponível.

`}</p>
						<p>{`Importante: Recomendamos que você considere o seguinte exemplo no mercado Winning Margin em nosso modo de jogo ao vivo. Nossa plataforma pode mostrar o mercado da seguinte forma: +3 (corridas), -3 (corridas) Onde o sinal (+) significa time da casa e o sinal (-) time visitante, > = + 3 e <=- 3 onde o primeiro significa acima ou igual a 3 corridas da equipe da casa e a segunda abaixo ou igual a 3 corridas da equipe visitante.

`}</p>
						<p>{`Quando a primeira corrida será pontuada (incl. entradas extras): Preveja em qual entrada a primeira corrida será pontuada.

`}</p>
						<p>{`Vencedor e Total: Este mercado de apostas combina dois mercados de apostas principais onde você deve prever quem vencerá a partida e quantas corridas totais (mais/menos) serão marcadas na partida.

`}</p>
						<p>{`Máximo de corridas consecutivas por qualquer equipe: Você deve prever qual será o número máximo de corridas consecutivas marcadas por qualquer equipe.

`}</p>
						<p>{`Corridas exatas na entrada com maior pontuação: Você deve prever o número exato de corridas na entrada com a maior pontuação.

`}</p>
						<p>{`Intervalo de corridas (incluindo entradas extras): Você deve prever um intervalo dentro do qual será o total de corridas do evento.

`}</p>
						<p>{`Resultado do x lance: Você deve prever o resultado do lance mencionado.

`}</p>
						<p>{`Rebatida no xº arremesso: Você tem que prever se haverá ou não um rebatimento no referido arremesso.

`}</p>
						<p>{`Home run no xº arremesso: Você deve prever se haverá um home run no campo mencionado ou não.

`}</p>
						<p className="pH2">{`Mercados de Entradas
`}</p>
						<p>{`Xª entrada - 1X2: Prever o resultado da entrada mencionada.

`}</p>
						<p>{`Xª entrada - total: Nesta aposta você deve especificar o número total de corridas alcançadas por ambas as equipes na entrada mencionada.

`}</p>
						<p>{`Xª entrada - equipe a pontuar: Você deve prever qual equipe pontuará na entrada mencionada.

`}</p>
						<p>{`Xª entrada - handicap: Você deve prever o vencedor da entrada mencionada adicionando ou subtraindo o spread indicado ao resultado da partida.

`}</p>
						<p>{`Xª entrada - total de acertos: Você deve prever o número total de acertos da entrada mencionada.

`}</p>
						<p>{`Xª entrada - total de rebatidas da equipe: Você deve prever o número total de rebatidas para o time da casa ou visitante da entrada mencionada.

`}</p>
						<p>{`Entradas 1 a 5 - 1X2: Preveja o resultado das entradas 1 a 5.

`}</p>
						<p>{`Entradas 1 a 5 - total: Nesta aposta você deve especificar o número total de corridas alcançadas por ambas as equipes nas entradas 1 a 5.

`}</p>
						<p>{`Entradas 1 a 5 - handicap: Você tem que prever o vencedor das entradas 1 a 5 somando ou subtraindo o spread indicado ao resultado da partida.

`}</p>
						<p>{`Entradas 1 a 5 - total de acertos: Você deve prever o número total de acertos dos turnos 1 a 5.

`}</p>
						<p>{`Entradas 1 a 5 - total de rebatidas da equipe: Você deve prever o número total de rebatidas para o time da casa ou visitante das entradas 1 a 5.

`}</p>
						<p>{`Equipe para ganhar mais entradas: Você deve prever qual time ganhará mais entradas na partida.

`}</p>
						<p>{`Equipe com maior pontuação: Você deve prever qual equipe terá a maior pontuação em uma única entrada (ou se haverá empate).

`}</p>
						<p>{`Haverá uma entrada extra: Adivinhe se o evento (sim-não) terá entradas extras.

`}</p>
						<p>{`Primeiras x entradas 1x2 e 1x2 (incluindo entradas extras): Você deve prever o resultado dos primeiros X turnos, bem como o resultado no final da partida.

`}</p>
						<p>{`Ambas as equipes acima de X.5 (incluindo entradas extras): Você deve prever se ambas as equipes marcarão mais de X.5 corridas na partida ou não.

`}</p>
						<p>{`Corrida para X corridas (incluindo entradas extras): Você tem que prever qual time chegará primeiro em X corridas, incluindo tempo extra.

`}</p>
						<p>{`Time da casa para rebater na 9ª entrada: Você tem que prever se o time da casa vai rebater na 9ª entrada.

`}</p>
						<p>{`Total de entradas sem pontuação: Você tem que prever quantas entradas terminarão sem pontuação (0-0).

`}</p>
						<p>{`Entrada com maior pontuação: Você deve prever qual será a entrada com a maior pontuação.

`}</p>
						<p>{`Quando a partida será decidida: Você deve prever em que turno a partida será decidida.

`}</p>
						<p>{`Rebatida na próxima entrada (sim/não): Você precisa prever se haverá uma rebatida na próxima entrada.

`}</p>
						<p>{`Xª entrada Rebatida (sim/não): Você precisa prever se haverá uma rebatida na Xª entrada.

`}</p>
						<p className="pH2">{`Mercados Especiais de Jogador de Beisebol
`}</p>
						<p>{`Todos os mercados abaixo da seção "Especiais de jogadores" seguem esta regra: se o jogador listado não estiver na escalação inicial da partida, as apostas serão consideradas nulas.

`}</p>
						<p>{`Golpes de jogadores: Consiste em prever a quantidade de golpes que um determinado jogador irá registrar.

`}</p>
						<p>{`Golpes de jogador (pelo menos): Consiste em prever pelo menos quantos golpes o jogador específico irá registrar.

`}</p>
						<p>{`Acertos do jogador (no mínimo): Consiste em prever pelo menos quantos acertos o jogador específico irá gravar.

`}</p>
						<p>{`Bases totais do jogador (no mínimo): Consiste em prever pelo menos quantas bases totais o jogador específico irá registrar.

`}</p>
						<p>{`Rebatidas + corridas + rbi 's do jogador: Consiste em prever a quantidade de rebatidas, corridas e rbi's combinadas que o jogador específico irá registrar.

`}</p>
						<p>{`Rebatidas + corridas + rbi's (no mínimo): Consiste em prever pelo menos quantos rebatidas, corridas e rbi's combinados o jogador específico irá registrar.

`}</p>
						<p>{`Home runs do jogador (pelo menos): Consiste em prever pelo menos quantos home runs o jogador específico registrará.

`}</p>
						<p>{`Bases totais no confronto direto: Consiste em prever qual dos jogadores mencionados fará o maior número de bases totais na partida.

`}</p>
						<p>{`Strikes frente a frente: Consiste em prever qual dos jogadores mencionados fará mais strikeouts na partida.

`}</p>
						<p>{`Acertos do jogador + bases totais: Consiste em prever a quantidade de acertos combinados e o total de bases que o jogador específico irá registrar.

`}</p>
						<p>{`Bases totais do jogador + corridas + rbi 's: Consiste em prever a quantidade de bases totais combinadas, corridas e rbi's que o jogador específico irá registrar.

`}</p>
						<p>{`Rebatidas do rebatedor: Consiste em prever a quantidade de rebatidas que o rebatedor específico registrará.

`}</p>
						<p>{`Total de bases do rebatedor: Consiste em prever a quantidade de bases totais que o rebatedor específico registrará.

`}</p>
						<p>{`Eliminações do arremessador: Consiste em prever a quantidade de eliminações que o arremessador específico registrará.

`}</p>
						<p>{`Resultado da enésima vez do Xº jogador no bastão: você deve prever o resultado da enésima vez do Xº jogador no bastão.

`}</p>
						<p>{`Xº jogador a rebater pela enésima vez no bastão: Você deve prever se o xº jogador rebaterá pela enésima vez no bastão.

`}</p>
						<p>{`Maior número total de bases: Você deve prever qual equipe registrará o maior número de bases totais.

`}</p>
						<p>{`Maior número total de eliminações: Você deve prever qual equipe registrará o maior número de eliminações.

`}</p>
						<p className="pH2">{`Mercados de beisebol outright:
`}</p>
						<p>{`Vencedor: Você deve prever o vencedor de determinada competição de acordo com o ranking oficial da competição.

`}</p>
						<p>{`Vencedor da Divisão/Conferência: Você deve prever o vencedor de uma determinada divisão ou conferência de acordo com o ranking oficial da competição.

`}</p>
						<p>{`Pontos da Temporada Regular - Equipe: Você deve prever quantos pontos (mais/menos) a equipe mencionada irá acumular de acordo com o ranking oficial da competição.

`}</p>
						<p>{`H2H - Pontuação Correta da Série: Você tem que prever o resultado final da série de partidas entre as 2 equipes indicadas. Para efeitos de divulgação serão considerados válidos apenas os sites oficiais de cada competição. (A saber: H2H significa head to head, o que pode ser traduzido como "cabeça a cabeça", o que indica comparação entre dois adversários)

`}</p>
						<p>{`H2H - Quando terminará a série?: Você deve prever quantos jogos terminará a série de partidas entre as 2 equipes indicadas. Para efeitos de divulgação serão considerados válidos apenas os sites oficiais de cada competição. (A saber: H2H significa head to head, o que pode ser traduzido como "cabeça a cabeça", o que indica comparação entre dois adversários)

`}</p>
						<p>{`H2H - Vencedor: Você deve prever qual das duas equipes indicadas se qualificará na fase de qualificação ou no play-off. (A saber: H2H significa head to head, o que pode ser traduzido como "cabeça a cabeça", o que indica comparação entre dois adversários)

`}</p>
						<p>{`Eles vão para os playoffs? - Equipe: Você tem que prever se a equipe mencionada chegará ao playoff do torneio em questão de acordo com o ranking oficial da competição.

`}</p>
						<p>{`Top4, Top6, Top8, Top10: Você deve prever se a equipe selecionada terminará na posição superior respectiva quando a competição terminar.

`}</p>
						<p>{`Todos os mercados especiais de jogadores de beisebol são liquidados de acordo com a fonte oficial relevante. Potenciais entradas extras jogadas estão incluídas na liquidação de todos os mercados disponíveis.

`}</p>
						<p>{`Todos os mercados abaixo da seção Especiais de Jogadores seguem esta regra: Se o jogador listado não estiver na escalação inicial da partida, as apostas serão consideradas nulas.

`}</p>
						<p>{`Mercados H2H do Jogador: . Se o jogador listado não participar da partida, as apostas serão consideradas nulas. Em caso de empate entre os jogadores, as apostas são anuladas. (A saber: H2H significa head to head, o que pode ser traduzido como "cabeça a cabeça", o que indica comparação entre dois adversários).

`}</p>
						<p className="pH2">{`Mercados Extra
`}</p>
						<p>{`Qual será o próximo tipo de arremesso? Você deve prever o tipo de arremesso que o arremessador fará no arremesso específico. Existem 7 possíveis resultados: Fastball, cutter, sinker, curve, slider, changeup, outro.

`}</p>
						<p>{`Resultado do Arremesso:

`}</p>
						<ol>
							<li>
								Interferência do receptor: Qualquer interferência do receptor invalidará todos os
								mercados de resultado do arremesso.
							</li>
							<li>
								Violação do cronômetro de arremesso: Qualquer violação do cronômetro de arremesso,
								seja do arremessador ou do rebatedor, invalidará todos os mercados de resultado do
								arremesso.
							</li>
							<li>
								Velocidade do arremesso e resultados do tipo de arremesso: Os resultados de
								velocidade e tipo de arremesso serão baseados nas estatísticas oficiais do órgão
								regulador da liga.
							</li>
							<li>Sweepers e slurves: Serão classificados como sliders.</li>
							<li>
								Outro tipo de arremesso: Qualquer outro arremesso não explicitamente mencionado nas
								opções do mercado será classificado como “Outro”.
							</li>
						</ol>
					</div>
				</details>
				{/* Corrida de Cavalos */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="32"
							viewBox="0 0 33 32"
							width="33"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<path
								d="M18.0205 4.04352C17.9532 1.27129 15.4068 -0.241713 13.9654 0.0316044C13.6675 0.0901725 13.8693 0.57824 14.5035 4.03375H18.0205V4.04352Z"
								data-darkreader-inline-fill=""
								fill="#ffffff"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M31.5695 16.3916L26.6784 21.3601C27.0723 21.4578 27.4855 21.5261 27.8987 21.5261C29.1575 21.5261 30.426 21.0673 31.1467 20.1009C32.2709 18.5977 32.1556 17.4068 31.5599 16.4014L31.5695 16.3916Z"
								data-darkreader-inline-fill=""
								fill="#ffffff"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M30.3107 14.9079C29.9936 14.6151 28.9269 13.678 28.9269 13.678L22.8251 19.8569L22.7194 19.9838C22.6521 20.1107 22.6137 20.1888 22.6233 20.5597V20.794C22.6233 22.9415 21.326 24.7864 19.4907 25.577C19.3561 26.3677 19.1063 27.1291 18.7604 27.8221C21.4413 27.3341 23.5938 25.294 24.2953 22.6486C24.449 22.0532 24.5451 21.4382 24.5451 20.794V20.7745L30.3299 14.8981L30.3107 14.9079Z"
								data-darkreader-inline-fill=""
								fill="#ffffff"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M20.7303 6.47409C20.3651 6.15197 19.9039 5.97626 19.4234 5.97626H14.5323L16.9154 17.6215L20.836 19.1443L27.4663 12.409L20.7303 6.47409ZM18.9814 11.8819C18.4721 12.0771 17.8955 11.8135 17.7034 11.2962C17.5112 10.7788 17.7706 10.1932 18.2799 9.99794C18.7892 9.80271 19.3658 10.0663 19.5579 10.5836C19.7501 11.101 19.4907 11.6866 18.9814 11.8819Z"
								data-darkreader-inline-fill=""
								fill="#ffffff"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M6.8065 29.9013C5.72066 28.8666 4.94231 27.5 4.60599 25.9773C4.49068 25.4404 4.42342 24.884 4.42342 24.3081C4.42342 20.0619 7.82508 16.6064 12.0051 16.6064C13.0141 16.6064 13.975 16.8114 14.8494 17.1725L12.5624 5.97626H10.0832C9.622 5.97626 9.17037 6.17149 8.80522 6.5229L0.733475 14.4003C0.272232 14.8493 0.00317383 15.5131 0.00317383 16.2159V25.9675C0.00317383 25.9675 0.0512199 27.012 0.445198 29.8916C1.08902 31.141 2.35743 32 3.83725 32H8.94936C9.39138 32 9.81419 31.9121 10.2082 31.7755C8.95897 31.4631 7.8443 30.8482 6.92181 29.9989C6.88338 29.9599 6.84494 29.9306 6.8065 29.8916V29.9013Z"
								data-darkreader-inline-fill=""
								fill="#ffffff"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M15.0704 19.4762C14.1864 18.8905 13.139 18.5586 12.0051 18.5586C8.88209 18.5586 6.34526 21.1356 6.34526 24.3081C6.34526 24.884 6.43174 25.4501 6.58549 25.9773C7.17165 27.9198 8.73796 29.423 10.7078 29.9013C11.121 29.9989 11.5535 30.0575 12.0051 30.0575C12.0916 30.0575 12.1684 30.0575 12.2549 30.0477C12.4567 30.0477 12.6681 30.0184 12.8603 29.9892C13.8405 29.833 14.7437 29.4328 15.4932 28.8373C16.3869 28.1247 17.0788 27.1389 17.4151 26.0065C17.5784 25.4697 17.6649 24.9035 17.6649 24.3178C17.6649 22.2972 16.6271 20.5109 15.0704 19.486V19.4762ZM13.2927 27.09C13.2927 27.6269 12.8603 28.0662 12.3318 28.0662C11.8033 28.0662 11.3709 27.6269 11.3709 27.09V23.9371L10.8616 24.474C10.6694 24.6692 10.4196 24.7668 10.1697 24.7668C9.91989 24.7668 9.68927 24.679 9.49708 24.4935C9.11271 24.1226 9.1031 23.4979 9.47786 23.1172L11.6399 20.8525C11.7264 20.7647 11.8321 20.6964 11.9378 20.6378C11.9378 20.6378 11.9378 20.6378 11.9474 20.6378C12.0627 20.589 12.1781 20.5695 12.303 20.5695C12.3414 20.5695 12.3798 20.589 12.4183 20.589C12.5048 20.5988 12.5816 20.6085 12.6585 20.6378C12.7354 20.6671 12.8027 20.7257 12.8795 20.7745C12.9084 20.794 12.9468 20.8037 12.9756 20.833C13.0621 20.9111 13.1198 21.0185 13.1678 21.1259C13.1678 21.1259 13.1774 21.1454 13.187 21.1551C13.187 21.1551 13.187 21.1747 13.187 21.1844C13.2255 21.2918 13.2543 21.4089 13.2543 21.5358V27.0998L13.2927 27.09Z"
								data-darkreader-inline-fill=""
								fill="#ffffff"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
						</svg>
						Corrida de Cavalos
					</summary>
					<div className="textItem">
						<p className="pH2">{`Aposta no prêmio (e em cada sentido)
`}</p>
						<p>{`As apostas são liquidadas para ganhar, a menos que "Each-Way" seja selecionado. Uma aposta Each-Way é para 2 vezes selecionada a mesma aposta por aposta. Ela contém uma aposta de participação na opção "Ganhar" e uma aposta de mesma participação na opção "Colocar", de acordo com os termos anunciados para o evento. A parte de colocação das apostas Each-Way será liquidada de acordo com os seguintes termos de colocação:

`}</p>
						<div>
							<table>
								<thead>
									<tr>
										<th>Número de participantes</th>
										<th>Formato</th>
										<th>Parâmetros do local EW</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>16+</td>
										<td>Deficiência</td>
										<td>4 lugares, 1/4</td>
									</tr>
									<tr>
										<td>12-15</td>
										<td>Deficiência</td>
										<td>3 lugares, 1/3</td>
									</tr>
									<tr>
										<td>8+</td>
										<td>Todas as corridas (8-11 se houver handicap)</td>
										<td>3 lugares, 1/5</td>
									</tr>
									<tr>
										<td>5-7</td>
										<td>Todas as raças</td>
										<td>2 lugares 1/4</td>
									</tr>
									<tr>
										<td>2-4</td>
										<td>Todas as raças</td>
										<td>1 lugar 1/1</td>
									</tr>
								</tbody>
							</table>
						</div>
						<p>
							Em todas as corridas, o número de participantes será o número de pessoas nas linhas de
							largada. As apostas em não corredores serão anuladas. Aplicam-se as regras de dead
							heat. Ao apostar em cotas fixas, se outro participante se tornar um não-corredor, as
							seguintes deduções serão aplicadas aos ganhos líquidos. Posteriormente, a parte local
							das apostas EW é calculada com base nos ganhos deduzidos.
						</p>
						<div>
							<table>
								<thead>
									<tr>
										<th>Probabilidades de no momento da retirada</th>
										<th>Dedução sobre ganhos líquidos</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>probabilidade ≤ 1,1112</td>
										<td>90%</td>
									</tr>
									<tr>
										<td>1,1112 &lt; probabilidade ≤ 1,1819</td>
										<td>85%</td>
									</tr>
									<tr>
										<td>1,1819 &lt; probabilidade ≤ 1,25</td>
										<td>80%</td>
									</tr>
									<tr>
										<td>1,25 &lt; probabilidade ≤ 1,30</td>
										<td>75%</td>
									</tr>
									<tr>
										<td>1,30 &lt; probabilidade ≤ 1,40</td>
										<td>70%</td>
									</tr>
									<tr>
										<td>1,40 &lt; probabilidade ≤ 1,5334</td>
										<td>65%</td>
									</tr>
									<tr>
										<td>1,5334 &lt; probabilidade ≤ 1,6154</td>
										<td>60%</td>
									</tr>
									<tr>
										<td>1,6154 &lt; probabilidade ≤ 1,80</td>
										<td>55%</td>
									</tr>
									<tr>
										<td>1,80 &lt; probabilidade ≤ 1,9524</td>
										<td>50%</td>
									</tr>
									<tr>
										<td>1,9524 &lt; probabilidade ≤ 2,20</td>
										<td>45%</td>
									</tr>
									<tr>
										<td>2,20 &lt; probabilidade ≤ 2,50</td>
										<td>40%</td>
									</tr>
									<tr>
										<td>2,50 &lt; chances ≤ 2,75</td>
										<td>35%</td>
									</tr>
									<tr>
										<td>2,75 &lt; probabilidade ≤ 3,25</td>
										<td>30%</td>
									</tr>
									<tr>
										<td>3,25 &lt; probabilidade ≤ 4</td>
										<td>25%</td>
									</tr>
									<tr>
										<td>4 &lt; chances ≤ 5</td>
										<td>20%</td>
									</tr>
									<tr>
										<td>5 &lt; probabilidade ≤ 6,5</td>
										<td>15%</td>
									</tr>
									<tr>
										<td>6,5 &lt; probabilidade ≤ 10</td>
										<td>10%</td>
									</tr>
									<tr>
										<td>10 &lt; preço ≤ 15</td>
										<td>5%</td>
									</tr>
									<tr>
										<td>preço &gt; 15</td>
										<td>Sem dedução</td>
									</tr>
								</tbody>
							</table>
						</div>
						<p>{`Se vários participantes se tornarem não corredores, a dedução total nunca ultrapassará 90%. As apostas que usam o Preço Inicial (SP) serão liquidadas usando o último preço cotado (odds) antes do início da corrida.

`}</p>
						<p className="pH2">{`Fazer uma aposta de 2/3/4
`}</p>
						<p>{`Uma aposta de colocação é ganha se a seleção for classificada nas primeiras 2/3/4 posições da corrida, dependendo do parâmetro da aposta de colocação. As apostas em não corredores serão anuladas. Aplicam-se as regras de dead heat. Se outros participantes se tornarem não competidores, as seguintes deduções serão aplicadas sobre os ganhos líquidos da aposta:

`}</p>
						<div>
							<table>
								<thead>
									<tr>
										<th>Probabilidades de no momento da retirada</th>
										<th>Dedução sobre ganhos líquidos (2 lugares)</th>
										<th>Dedução sobre ganhos líquidos (3 lugares)</th>
										<th>Dedução sobre ganhos líquidos (4 lugares)</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>probabilidade ≤ 1,1112</td>
										<td>45%</td>
										<td>30%</td>
										<td>20%</td>
									</tr>
									<tr>
										<td>1,1112 &lt; probabilidade ≤ 1,1819</td>
										<td>40%</td>
										<td>30%</td>
										<td>20%</td>
									</tr>
									<tr>
										<td>1,1819 &lt; probabilidade ≤ 1,25</td>
										<td>40%</td>
										<td>25%</td>
										<td>20%</td>
									</tr>
									<tr>
										<td>1,25 &lt; probabilidade ≤ 1,3</td>
										<td>35%</td>
										<td>25%</td>
										<td>20%</td>
									</tr>
									<tr>
										<td>1,3 &lt; probabilidade ≤ 1,4</td>
										<td>35%</td>
										<td>25%</td>
										<td>15%</td>
									</tr>
									<tr>
										<td>1,4 &lt; probabilidade ≤ 1,5334</td>
										<td>30%</td>
										<td>20%</td>
										<td>15%</td>
									</tr>
									<tr>
										<td>1,5334 &lt; probabilidade ≤ 1,6154</td>
										<td>30%</td>
										<td>20%</td>
										<td>15%</td>
									</tr>
									<tr>
										<td>1,6154 &lt; probabilidade ≤ 1,8</td>
										<td>25%</td>
										<td>20%</td>
										<td>15%</td>
									</tr>
									<tr>
										<td>1,8 &lt; probabilidade ≤ 1,9524</td>
										<td>25%</td>
										<td>15%</td>
										<td>10%</td>
									</tr>
									<tr>
										<td>1,9524 &lt; probabilidade ≤ 2,2</td>
										<td>20%</td>
										<td>15%</td>
										<td>10%</td>
									</tr>
									<tr>
										<td>2,2 &lt; probabilidade ≤ 2,5</td>
										<td>20%</td>
										<td>15%</td>
										<td>10%</td>
									</tr>
									<tr>
										<td>2,5 &lt; chances≤ 2,75</td>
										<td>15%</td>
										<td>10%</td>
										<td>10%</td>
									</tr>
									<tr>
										<td>2,75 &lt; probabilidade ≤ 3,25</td>
										<td>15%</td>
										<td>10%</td>
										<td>Sem dedução</td>
									</tr>
									<tr>
										<td>3,25 &lt; probabilidade ≤ 4</td>
										<td>10%</td>
										<td>10%</td>
										<td>Sem dedução</td>
									</tr>
									<tr>
										<td>4 &lt; chances ≤ 5</td>
										<td>10%</td>
										<td>Sem dedução</td>
										<td>Sem dedução</td>
									</tr>
									<tr>
										<td>chances &gt; 5</td>
										<td>Sem dedução</td>
										<td>Sem dedução</td>
										<td>Sem dedução</td>
									</tr>
								</tbody>
							</table>
						</div>
						<p>{`No caso de múltiplos não participantes, a dedução total nunca pode ultrapassar 90%. Há casos em que o mercado Lugar-3/4 não é mais oferecido após um não corredor. Por exemplo, uma aposta pode ser feita no mercado da posição 3, mas depois de um não corredor, somente o mercado da posição 2 é oferecido. Nesse caso, os ganhos líquidos serão deduzidos de acordo com o mercado da posição 2 usando a tabela acima. O lugar 4 será anulado se os participantes restantes forem 5 ou menos. O lugar 3 e o lugar 2 serão anulados se os participantes restantes forem 4 ou menos.

`}</p>
						<p className="pH2">{`Aposta de Previsão
`}</p>
						<p>{`As previsões são aceitas para todas as corridas com 3 ou mais participantes ativos e são estabelecidas como uma previsão direta (escolhas para terminar em 1º e 2º lugar na ordem exata), de acordo com o dividendo de previsão direta do computador. Se houver menos de 4 participantes ativos, todas as previsões para essa corrida serão anuladas.

`}</p>
						<p>{`Quando um cliente seleciona previsões ABC combinadas e aposta em 6 apostas, isso será liquidado como 6 previsões diretas da seguinte forma:

`}</p>
						<ul>
							<li>AB, BA, AC, CA, BC, CB</li>
						</ul>
						<p>{`Se qualquer previsão incluir um Não Participante, a aposta será anulada. Em corridas em que um cavalo/cachorro termina sozinho e nenhum dividendo de previsão é devolvido.

`}</p>
						<p>{`No caso de dois ou mais cavalos/cães terminarem juntos em 1º ou 2º lugar, serão declarados e pagos dividendos separados para cada previsão bem-sucedida. Se não forem declarados dividendos separados, serão aplicadas as regras de dead heat.

`}</p>
						<p className="pH2">{`Aposta Tricast
`}</p>
						<p>{`As tricast são aceitas para todas as corridas com 3 ou mais participantes ativos e são liquidadas como uma tricast direta (escolhas para terminar em 1º, 2º e 3º na ordem exata), de acordo com o dividendo da tricast direta do computador. Se houver menos de 4 participantes ativos, todos os tricast para essa corrida serão anulados.

`}</p>
						<p>{`Se qualquer tricast incluir um Não Participante, a aposta será anulada. No caso de dois ou mais cavalos/cães terminarem juntos em 1º, 2º ou 3º lugar, serão declarados e pagos dividendos separados para cada tricast bem-sucedido. Se não forem declarados dividendos separados, serão aplicadas as regras de dead heat.

`}</p>
						<p className="pH2">{`Regras do Dead Heat
`}</p>
						<p>{`Quando as seleções são dead-heat, a aposta é distribuída igualmente pelo número de seleções e é paga com as chances totais.

`}</p>
						<p>{`Exemplo 1.

`}</p>
						<p>{`Mercado = Ganho. Suponha que uma aposta seja feita com um valor de 30u em odds (6,0) para ganhar 180u.

`}</p>
						<ul>
							<li>
								O empate de 2 participantes em primeiro lugar resultaria em classificações: 1-2,
								1-2, 3º, 4º etc. Nesse caso, o retorno seria de 180/2 = 90u
							</li>
							<li>
								O empate de 3 participantes em primeiro lugar resultaria em classificações: 1-3,
								1-3, 1-3, 4º etc. Nesse caso, o retorno seria de 180/3 = 60u
							</li>
						</ul>
						<p>{`Exemplo 2.

`}</p>
						<p>{`Mercado = Lugar (3 lugares). Suponha que uma aposta seja feita com um valor de 30u em odds (3.0) para ganhar 90u.

`}</p>
						<ul>
							<li>
								O empate de 2 participantes em primeiro lugar resultaria em classificações: 1-2,
								1-2, 3º, 4º etc. Nesse caso, o retorno seria pago integralmente.
							</li>
							<li>
								O empate de 2 participantes no terceiro lugar resultaria em classificações: 1º, 2º,
								3-4, 3-4, 5º etc. Nesse caso, o retorno seria 90/2 = 45u
							</li>
							<li>
								O empate de 3 participantes no segundo lugar resultaria em classificações: 1º, 2-4,
								2-4, 2-4, 2-4, 5º etc. Nesse caso, o retorno seria 90 * (⅔) = 60u
							</li>
						</ul>
						<p className="pH2">{`Corridas Adiadas/Reprogramadas
`}</p>
						<p>{`Se uma corrida for adiada ou remarcada para mais tarde no mesmo dia (com base na data do local) e as inscrições finais forem válidas, as apostas serão mantidas. No entanto, as apostas na corrida serão anuladas se:

`}</p>
						<ul>
							<li>A corrida é abandonada.</li>
							<li>A corrida é oficialmente declarada nula.</li>
							<li>
								As condições da corrida estão sujeitas a alterações após a validação das apostas. A
								pista muda.
							</li>
							<li>
								Mudança da superfície da corrida (por exemplo, grama para terra/todo tipo de clima
								ou vice-versa).
							</li>
							<li>A corrida é remarcada para outra data (com base na data do local).</li>
						</ul>
						<p className="pH2">{`Repetições
`}</p>
						<p>{`Caso uma largada inválida, etc., resulte em uma repetição da corrida, as linhas da largada não serão consideradas e as apostas serão reembolsadas em cavalos/cães que não participarem da segunda corrida. Os reembolsos dos cavalos/cães restantes estão sujeitos a deduções de preço. O número de participantes que participam da segunda corrida é o número de inscritos.

`}</p>
					</div>
				</details>
				{/* Corridas de Galgos */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="32"
							viewBox="0 0 32 32"
							width="32"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<g clip-path="url(#clip0_414_647)">
								{' '}
								<path
									d="M31.888 8.51266L30.356 5.29165L30.1328 4.82151V4.7915C29.7878 4.04126 28.6312 1.6105 27.4848 0.970303C25.902 0.080025 18.6884 0 16.2535 0C16.152 0 16.0911 0 16.0708 0C16.0708 0 16.0505 0 16.0404 0C15.9897 0 15.9288 0 15.8781 0C13.6257 0.0300094 6.1179 0.0500156 4.50473 0.9603C3.34812 1.6105 2.19151 4.06127 1.89729 4.72148C1.88714 4.74148 1.87699 4.76149 1.86685 4.78149L1.66393 5.22163L0.0913493 8.51266C-0.142002 9.01282 0.0710579 9.613 0.578343 9.84308C0.720383 9.90309 0.862423 9.9331 1.00446 9.9331C1.39 9.9331 1.75525 9.72304 1.92772 9.35292L2.86113 7.39231C3.64235 7.6724 4.8091 8.10253 5.6512 8.80275C5.75266 8.89278 5.86426 8.9528 5.96571 9.01282C5.93528 9.33292 5.91499 9.66302 5.91499 9.99312C5.91499 11.6937 6.51358 13.1341 7.10203 14.5145L7.31509 15.0247C8.88768 19.116 8.99928 25.2279 8.92826 28.5089C8.90797 29.4292 9.26307 30.3095 9.9124 30.9697C10.5719 31.6299 11.4545 32 12.3981 32H15.2592V27.9487C14.1736 27.5386 13.4025 26.5183 13.4025 25.3079C13.4025 23.7474 14.691 22.477 16.2738 22.477C17.8565 22.477 19.145 23.7474 19.145 25.3079C19.145 26.5183 18.3739 27.5486 17.2883 27.9487V32H20.048C21.9249 32 23.4874 30.4995 23.5178 28.649C23.6395 22.1369 24.0961 17.2054 24.786 15.0747C24.9078 14.7046 25.0599 14.3345 25.202 13.9544C25.6585 12.784 26.176 11.4536 26.176 10.0031C26.176 9.65302 26.1557 9.30291 26.1252 8.9628C26.1963 8.92279 26.2673 8.87277 26.3383 8.81275C27.1804 8.11254 28.337 7.6924 29.1284 7.40231L30.0618 9.36293C30.2342 9.72304 30.5995 9.94311 30.985 9.94311C31.1271 9.94311 31.2793 9.9131 31.4111 9.85308C31.9184 9.62301 32.1416 9.02282 31.8981 8.52266L31.888 8.51266ZM13.1793 10.0932C13.1793 10.6933 12.6822 11.1835 12.0734 11.1835C11.4647 11.1835 10.9675 10.6933 10.9675 10.0932C10.9675 9.49297 11.4647 9.00281 12.0734 9.00281C12.6822 9.00281 13.1793 9.49297 13.1793 10.0932ZM21.4886 10.0932C21.4886 10.6933 20.9915 11.1835 20.3828 11.1835C19.774 11.1835 19.2769 10.6933 19.2769 10.0932C19.2769 9.49297 19.774 9.00281 20.3828 9.00281C20.9915 9.00281 21.4886 9.49297 21.4886 10.0932Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
							</g>{' '}
							<defs>
								{' '}
								<clipPath id="clip0_414_647">
									{' '}
									<rect
										data-darkreader-inline-fill=""
										fill="white"
										height="32"
										style={{ fill: '#FFFFFF' }}
										width="32"
									></rect>{' '}
								</clipPath>{' '}
							</defs>{' '}
						</svg>
						Corridas de Galgos
					</summary>
					<div className="textItem">
						<p className="pH2">{`Aposta no prêmio (e em cada sentido)
`}</p>
						<p>{`As apostas são liquidadas para ganhar, a menos que "Each-Way" seja selecionado. Uma aposta Each-Way é para 2 vezes selecionada a mesma aposta por aposta. Ela contém uma aposta de participação na opção "Ganhar" e uma aposta de mesma participação na opção "Colocar", de acordo com os termos anunciados para o evento. A parte de colocação das apostas Each-Way será liquidada de acordo com os seguintes termos de colocação:

`}</p>
						<div>
							<table>
								<thead>
									<tr>
										<th>Número de participantes</th>
										<th>Formato</th>
										<th>Parâmetros do local EW</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>16+</td>
										<td>Deficiência</td>
										<td>4 lugares, 1/4</td>
									</tr>
									<tr>
										<td>12-15</td>
										<td>Deficiência</td>
										<td>3 lugares, 1/3</td>
									</tr>
									<tr>
										<td>8+</td>
										<td>Todas as corridas (8-11 se houver handicap)</td>
										<td>3 lugares, 1/5</td>
									</tr>
									<tr>
										<td>5-7</td>
										<td>Todas as raças</td>
										<td>2 lugares 1/4</td>
									</tr>
									<tr>
										<td>2-4</td>
										<td>Todas as raças</td>
										<td>1 lugar 1/1</td>
									</tr>
								</tbody>
							</table>
						</div>
						<p>{`(A parte EW será colocada no vencedor)

`}</p>
						<p>{`Em todas as corridas, o número de participantes será o número de pessoas nas linhas de largada. As apostas em não corredores serão anuladas. Aplicam-se as regras de dead heat. Ao apostar em cotas fixas, se outro participante se tornar um não-corredor, as seguintes deduções serão aplicadas aos ganhos líquidos. Posteriormente, a parte local das apostas EW é calculada com base nos ganhos deduzidos.

`}</p>
						<div>
							<table>
								<thead>
									<tr>
										<th>Probabilidades de no momento da retirada</th>
										<th>Dedução sobre ganhos líquidos</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>probabilidade ≤ 1,1112</td>
										<td>90%</td>
									</tr>
									<tr>
										<td>1,1112 &lt; probabilidade ≤ 1,1819</td>
										<td>85%</td>
									</tr>
									<tr>
										<td>1,1819 &lt; probabilidade ≤ 1,25</td>
										<td>80%</td>
									</tr>
									<tr>
										<td>1,25 &lt; probabilidade ≤ 1,30</td>
										<td>75%</td>
									</tr>
									<tr>
										<td>1,30 &lt; probabilidade ≤ 1,40</td>
										<td>70%</td>
									</tr>
									<tr>
										<td>1,40 &lt; probabilidade ≤ 1,5334</td>
										<td>65%</td>
									</tr>
									<tr>
										<td>1,5334 &lt; probabilidade ≤ 1,6154</td>
										<td>60%</td>
									</tr>
									<tr>
										<td>1,6154 &lt; probabilidade ≤ 1,80</td>
										<td>55%</td>
									</tr>
									<tr>
										<td>1,80 &lt; probabilidade ≤ 1,9524</td>
										<td>50%</td>
									</tr>
									<tr>
										<td>1,9524 &lt; probabilidade ≤ 2,20</td>
										<td>45%</td>
									</tr>
									<tr>
										<td>2,20 &lt; probabilidade ≤ 2,50</td>
										<td>40%</td>
									</tr>
									<tr>
										<td>2,50 &lt; chances ≤ 2,75</td>
										<td>35%</td>
									</tr>
									<tr>
										<td>2,75 &lt; probabilidade ≤ 3,25</td>
										<td>30%</td>
									</tr>
									<tr>
										<td>3,25 &lt; probabilidade ≤ 4</td>
										<td>25%</td>
									</tr>
									<tr>
										<td>4 &lt; chances ≤ 5</td>
										<td>20%</td>
									</tr>
									<tr>
										<td>5 &lt; probabilidade ≤ 6,5</td>
										<td>15%</td>
									</tr>
									<tr>
										<td>6,5 &lt; probabilidade ≤ 10</td>
										<td>10%</td>
									</tr>
									<tr>
										<td>10 &lt; preço ≤ 15</td>
										<td>5%</td>
									</tr>
									<tr>
										<td>preço &gt; 15</td>
										<td>Sem dedução</td>
									</tr>
								</tbody>
							</table>
						</div>
						<p>{`Se vários participantes se tornarem não corredores, a dedução total nunca ultrapassará 90%. As apostas que usam o Preço Inicial (SP) serão liquidadas usando o último preço cotado (odds) antes do início da corrida.

`}</p>
						<p className="pH2">{`Fazer uma aposta de 2/3/4
`}</p>
						<p>{`Uma aposta de colocação é ganha se a seleção for classificada nas primeiras 2/3/4 posições da corrida, dependendo do parâmetro da aposta de colocação. As apostas em não corredores serão anuladas. Aplicam-se as regras de dead heat. Se outros participantes se tornarem não competidores, as seguintes deduções serão aplicadas sobre os ganhos líquidos da aposta:

`}</p>
						<div>
							<table>
								<thead>
									<tr>
										<th>Probabilidades de no momento da retirada</th>
										<th>Dedução sobre ganhos líquidos (2 lugares)</th>
										<th>Dedução sobre ganhos líquidos (3 lugares)</th>
										<th>Dedução sobre ganhos líquidos (4 lugares)</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>probabilidade ≤ 1,1112</td>
										<td>45%</td>
										<td>30%</td>
										<td>20%</td>
									</tr>
									<tr>
										<td>1,1112 &lt; probabilidade ≤ 1,1819</td>
										<td>40%</td>
										<td>30%</td>
										<td>20%</td>
									</tr>
									<tr>
										<td>1,1819 &lt; probabilidade ≤ 1,25</td>
										<td>40%</td>
										<td>25%</td>
										<td>20%</td>
									</tr>
									<tr>
										<td>1,25 &lt; probabilidade ≤ 1,3</td>
										<td>35%</td>
										<td>25%</td>
										<td>20%</td>
									</tr>
									<tr>
										<td>1,3 &lt; probabilidade ≤ 1,4</td>
										<td>35%</td>
										<td>25%</td>
										<td>15%</td>
									</tr>
									<tr>
										<td>1,4 &lt; probabilidade ≤ 1,5334</td>
										<td>30%</td>
										<td>20%</td>
										<td>15%</td>
									</tr>
									<tr>
										<td>1,5334 &lt; probabilidade ≤ 1,6154</td>
										<td>30%</td>
										<td>20%</td>
										<td>15%</td>
									</tr>
									<tr>
										<td>1,6154 &lt; probabilidade ≤ 1,8</td>
										<td>25%</td>
										<td>20%</td>
										<td>15%</td>
									</tr>
									<tr>
										<td>1,8 &lt; probabilidade ≤ 1,9524</td>
										<td>25%</td>
										<td>15%</td>
										<td>10%</td>
									</tr>
									<tr>
										<td>1,9524 &lt; probabilidade ≤ 2,2</td>
										<td>20%</td>
										<td>15%</td>
										<td>10%</td>
									</tr>
									<tr>
										<td>2,2 &lt; probabilidade ≤ 2,5</td>
										<td>20%</td>
										<td>15%</td>
										<td>10%</td>
									</tr>
									<tr>
										<td>2,5 &lt; chances≤ 2,75</td>
										<td>15%</td>
										<td>10%</td>
										<td>10%</td>
									</tr>
									<tr>
										<td>2,75 &lt; probabilidade ≤ 3,25</td>
										<td>15%</td>
										<td>10%</td>
										<td>Sem dedução</td>
									</tr>
									<tr>
										<td>3,25 &lt; probabilidade ≤ 4</td>
										<td>10%</td>
										<td>10%</td>
										<td>Sem dedução</td>
									</tr>
									<tr>
										<td>4 &lt; chances ≤ 5</td>
										<td>10%</td>
										<td>Sem dedução</td>
										<td>Sem dedução</td>
									</tr>
									<tr>
										<td>chances &gt; 5</td>
										<td>Sem dedução</td>
										<td>Sem dedução</td>
										<td>Sem dedução</td>
									</tr>
								</tbody>
							</table>
						</div>
						<p>{`No caso de múltiplos não participantes, a dedução total nunca pode ultrapassar 90%. Há casos em que o mercado Lugar-3/4 não é mais oferecido após um não corredor. Por exemplo, uma aposta pode ser feita no mercado da posição 3, mas depois de um não corredor, somente o mercado da posição 2 é oferecido. Nesse caso, os ganhos líquidos serão deduzidos de acordo com o mercado da posição 2 usando a tabela acima. O lugar 4 será anulado se os participantes restantes forem 5 ou menos. O lugar 3 e o lugar 2 serão anulados se os participantes restantes forem 4 ou menos.

`}</p>
						<p>{`Aposta de Previsão
`}</p>
						<p>{`As previsões são aceitas para todas as corridas com 3 ou mais participantes ativos e são estabelecidas como uma previsão direta (escolhas para terminar em 1º e 2º lugar na ordem exata), de acordo com o dividendo de previsão direta do computador. Se houver menos de 4 participantes ativos, todas as previsões para essa corrida serão anuladas.

`}</p>
						<p>{`Quando um cliente seleciona previsões ABC combinadas e aposta em 6 apostas, isso será liquidado como 6 previsões diretas da seguinte forma:

`}</p>
						<ul>
							<li>AB, BA, AC, CA, BC, CB</li>
						</ul>
						<p>{`Se qualquer previsão incluir um Não Participante, a aposta será anulada. Em corridas em que um cavalo/cachorro termina sozinho e nenhum dividendo de previsão é devolvido.

`}</p>
						<p>{`No caso de dois ou mais cavalos/cães terminarem juntos em 1º ou 2º lugar, serão declarados e pagos dividendos separados para cada previsão bem-sucedida. Se não forem declarados dividendos separados, serão aplicadas as regras de dead heat.

`}</p>
						<p className="pH2">{`Aposta Tricast
`}</p>
						<p>{`As tricast são aceitas para todas as corridas com 3 ou mais participantes ativos e são liquidadas como uma tricast direta (escolhas para terminar em 1º, 2º e 3º na ordem exata), de acordo com o dividendo da tricast direta do computador. Se houver menos de 4 participantes ativos, todos os tricast para essa corrida serão anulados.

`}</p>
						<p>{`Se qualquer tricast incluir um Não Participante, a aposta será anulada. No caso de dois ou mais cavalos/cães terminarem juntos em 1º, 2º ou 3º lugar, serão declarados e pagos dividendos separados para cada tricast bem-sucedido. Se não forem declarados dividendos separados, serão aplicadas as regras de dead heat.

`}</p>
						<p className="pH2">{`Regras do Dead Heat
`}</p>
						<p>{`Quando as seleções são dead-heat, a aposta é distribuída igualmente pelo número de seleções e é paga com as chances totais.

`}</p>
						<p>{`Exemplo 1.

`}</p>
						<p>{`Mercado = Ganho. Suponha que uma aposta seja feita com um valor de 30u em odds (6,0) para ganhar 180u.

`}</p>
						<ul>
							<li>
								O empate de 2 participantes em primeiro lugar resultaria em classificações: 1-2,
								1-2, 3º, 4º etc. Nesse caso, o retorno seria de 180/2 = 90u
							</li>
							<li>
								O empate de 3 participantes em primeiro lugar resultaria em classificações: 1-3,
								1-3, 1-3, 4º etc. Nesse caso, o retorno seria de 180/3 = 60u
							</li>
						</ul>
						<p>{`Exemplo 2.

`}</p>
						<p>{`Mercado = Lugar (3 lugares). Suponha que uma aposta seja feita com um valor de 30u em odds (3.0) para ganhar 90u.

`}</p>
						<ul>
							<li>
								O empate de 2 participantes em primeiro lugar resultaria em classificações: 1-2,
								1-2, 3º, 4º etc. Nesse caso, o retorno seria pago integralmente.
							</li>
							<li>
								O empate de 2 participantes no terceiro lugar resultaria em classificações: 1º, 2º,
								3-4, 3-4, 5º etc. Nesse caso, o retorno seria 90/2 = 45u
							</li>
							<li>
								O empate de 3 participantes no segundo lugar resultaria em classificações: 1º, 2-4,
								2-4, 2-4, 2-4, 5º etc. Nesse caso, o retorno seria 90 * (⅔) = 60u
							</li>
						</ul>
						<p className="pH2">{`Corridas Adiadas/Reprogramadas
`}</p>
						<p>{`Se uma corrida for adiada ou remarcada para mais tarde no mesmo dia (com base na data do local) e as inscrições finais forem válidas, as apostas serão mantidas. No entanto, as apostas na corrida serão anuladas se:

`}</p>
						<ul>
							<li>A corrida é abandonada.</li>
							<li>A corrida é oficialmente declarada nula.</li>
							<li>
								As condições da corrida estão sujeitas a alterações após a validação das apostas. A
								pista muda.
							</li>
							<li>
								Mudança da superfície da corrida (por exemplo, grama para terra/todo tipo de clima
								ou vice-versa).
							</li>
							<li>A corrida é remarcada para outra data (com base na data do local).</li>
						</ul>
						<p className="pH2">{`Repetições
`}</p>
						<p>{`Caso uma largada inválida, etc., resulte em uma repetição da corrida, as linhas da largada não serão consideradas e as apostas serão reembolsadas em cavalos/cães que não participarem da segunda corrida. Os reembolsos dos cavalos/cães restantes estão sujeitos a deduções de preço. O número de participantes que participam da segunda corrida é o número de inscritos.

`}</p>
					</div>
				</details>
				{/* Ciclismo  */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 28 28"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<g clip-path="url(#clip0_414_481)">
								{' '}
								<path
									d="M6.21915 32C9.6539 32 12.4383 29.2217 12.4383 25.7945C12.4383 22.3673 9.6539 19.589 6.21915 19.589C2.78441 19.589 0 22.3673 0 25.7945C0 29.2217 2.78441 32 6.21915 32Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M25.7808 32C29.2156 32 32 29.2217 32 25.7945C32 22.3673 29.2156 19.589 25.7808 19.589C22.3461 19.589 19.5617 22.3673 19.5617 25.7945C19.5617 29.2217 22.3461 32 25.7808 32Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M22.2443 7.42857C24.2939 7.42857 25.9617 5.76441 25.9617 3.7193C25.9617 1.67419 24.2939 0 22.2443 0C20.1947 0 18.5268 1.66416 18.5268 3.7193C18.5268 5.77444 20.1947 7.42857 22.2443 7.42857Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M14.0961 18.8672C16.3667 17.213 18.4364 14.7368 19.5316 13.3133C20.7673 14.9173 21.8223 16.0401 22.837 16.4311C24.7862 17.1729 28.0414 16.7118 28.4132 16.6516C28.9658 16.5714 29.3375 16.0602 29.2571 15.5088C29.1768 14.9574 28.6543 14.5865 28.1118 14.6667C27.2678 14.797 24.7962 15.0276 23.5604 14.5464C22.5859 14.1754 20.7272 11.5689 19.6119 10.015C17.9542 7.69925 17.3915 6.96742 16.5777 6.93734C15.4223 6.87719 13.9253 7.7193 12.1469 9.42356C10.6399 10.8672 8.23862 13.6942 8.23862 15.1078C8.23862 16.8521 10.3284 18.4662 12.5287 20.1805C13.7746 21.1429 15.1812 22.2356 15.583 22.9574C15.9548 23.6391 15.6132 26.4862 15.0505 28.7218C14.9199 29.2632 15.2414 29.8045 15.784 29.9348C15.8644 29.9549 15.9447 29.9649 16.0352 29.9649C16.4873 29.9649 16.8892 29.6642 17.0097 29.213C17.3312 27.9499 18.2958 23.6992 17.3614 21.995C16.8088 20.9925 15.5228 19.9499 14.1162 18.8571L14.0961 18.8672Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
							</g>{' '}
							<defs>
								{' '}
								<clipPath id="clip0_414_481">
									{' '}
									<rect
										data-darkreader-inline-fill=""
										fill="white"
										height="28"
										style={{ fill: '#FFFFFF' }}
										width="28"
									></rect>{' '}
								</clipPath>{' '}
							</defs>{' '}
						</svg>
						Ciclismo
					</summary>
					<div className="textItem">
						<p>{`O resultado de uma aposta em uma competição de ciclismo é baseado nos primeiros resultados oficiais publicados. Se uma corrida for encurtada ou afetada de outra forma pelas condições climáticas, as apostas serão determinadas de acordo com as decisões tomadas pelos dirigentes do torneio.

`}</p>
						<p>{`Se uma corrida for oficialmente cancelada, todas as apostas relacionadas serão consideradas nulas. Sempre que uma corrida por etapas for adiada ou suspensa, todas as apostas relacionadas permanecerão válidas até que a corrida seja concluída ou cancelada. O vencedor da corrida será aquele que ficar em primeiro lugar no pódio. Qualquer desqualificação, dada após a corrida, não será levada em consideração na liquidação das apostas.

`}</p>
						<p className="pH2">{`Mercados de ciclismo:
`}</p>
						<p>{`Vencedor: Você deve prever o vencedor da corrida ou competição.

`}</p>
						<p>{`Vencedor do grupo: Você deve prever qual dos ciclistas nomeados incluídos na aposta alcançará o melhor posicionamento dentro do grupo. Se um ou mais ciclistas do grupo se retirarem antes do início da corrida, todas as apostas serão anuladas.

`}</p>
						<p>{`Pódio: Você deve prever que o ciclista selecionado chegará ao pódio (primeira, segunda ou terceira posição).

`}</p>
						<p>{`Top 6: Você tem que prever que o ciclista selecionado irá completar a prova dentro das primeiras seis posições.

`}</p>
						<p>{`Top 10: Você tem que prever que o ciclista selecionado vai completar a prova dentro das dez primeiras posições.

`}</p>
						<p>{`H2H: Você deve prever qual dos dois ciclistas especificados na aposta alcançará a melhor posição no evento geral. Sempre que em uma etapa, um dos dois ciclistas for desclassificado durante uma etapa avançada da competição que seu oponente ainda não tenha alcançado, o participante desclassificado será considerado o vencedor. Se um dos dois pilotos desistir ou for desclassificado durante uma das etapas da corrida, o piloto que permanecer na corrida será considerado o vencedor. Se ambos os concorrentes não atingirem a fase seguinte, a aposta será anulada. (A saber: H2H significa head to head, o que pode ser traduzido como "cabeça a cabeça", o que indica comparação entre dois adversários)

`}</p>
						<p>{`Vencedor da Etapa: O vencedor da Etapa será aquele que ficar em primeiro lugar no pódio. Qualquer desqualificação não será levada em consideração ao liquidar as apostas.

`}</p>
						<p>{`Não participantes: Se um corredor desistir da competição ou for desqualificado quando a corrida ou etapa já tiver começado, as apostas neste corredor serão consideradas perdidas.

`}</p>
						<p>{`Apostas de matchmaking - por etapa e classificação geral: Pelo menos um dos corredores ou equipes deve completar a etapa ou corrida para que a aposta de matchmaking seja válida. Se ambos não terminarem a etapa ou a corrida, todas as apostas serão anuladas.

`}</p>
					</div>
				</details>
				{/* Críquete  */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<g clip-path="url(#clip0_472_386)">
								{' '}
								<path
									d="M4.18348 19.41C3.71197 20.0216 3.27056 20.8237 3.27056 21.8564C3.27056 22.6584 3.54142 23.3201 3.87249 23.8615L0.872874 26.8593C-0.300887 28.0323 -0.300887 29.9372 0.872874 31.1102C2.04664 32.2832 3.95274 32.2832 5.1265 31.1102L8.12611 28.1125C8.66785 28.4433 9.31994 28.704 10.1125 28.704C11.1458 28.704 11.9383 28.2629 12.5603 27.7917C12.6807 27.7014 12.8212 27.5711 12.9516 27.4608L4.52458 19.0291C4.41422 19.1594 4.2838 19.2897 4.19351 19.4201L4.18348 19.41Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M29.4745 11.0184C30.0764 10.4169 30.6583 9.83538 31.0796 9.28396C31.5511 8.67238 31.9926 7.87031 31.9926 6.83765C31.9926 5.80499 31.5511 5.01294 31.0796 4.39134C30.6583 3.83992 30.0764 3.25842 29.4745 2.65687L29.324 2.50648C28.7221 1.90493 28.1402 1.32343 27.5884 0.902343C26.9765 0.431128 26.1739 -0.0100098 25.1406 -0.0100098C24.1073 -0.0100098 23.3148 0.431128 22.6928 0.902343C22.141 1.32343 21.5591 1.90493 20.9572 2.50648L5.89895 17.5653L14.4162 26.0773L29.4745 11.0285V11.0184Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M7.94551 8.99318C9.60769 8.99318 10.9552 7.64656 10.9552 5.98542C10.9552 4.32429 9.60769 2.97767 7.94551 2.97767C6.28333 2.97767 4.93587 4.32429 4.93587 5.98542C4.93587 7.64656 6.28333 8.99318 7.94551 8.99318Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
							</g>{' '}
							<defs>
								{' '}
								<clipPath id="clip0_472_386">
									{' '}
									<rect
										data-darkreader-inline-fill=""
										fill="white"
										height="28"
										style={{ fill: '#FFFFFF' }}
										width="28"
									></rect>{' '}
								</clipPath>{' '}
							</defs>{' '}
						</svg>
						Críquete
					</summary>
					<div className="textItem">
						<p>{`Todas as apostas serão liquidadas de acordo com o resultado oficial.

`}</p>
						<p>{`Os mercados do 1º turno num jogo jogado com uma única entrada (por exemplo, eventos T10, T20) são considerados mercados a tempo inteiro para efeitos de resultados. Num jogo com duas entradas (por exemplo, Série de Testes), os mercados de 1.ª entrada e 2.ª entrada corresponderão a cada entrada separadamente para efeitos de resultados; os mercados cumulativos a tempo inteiro não incluirão nenhuma entrada na descrição dos mercados.

`}</p>
						<p>{`Se um jogo for cancelado antes de qualquer jogo ter ocorrido, todos os mercados serão considerados nulos, a menos que o jogo seja repetido dentro de 48 horas do seu início inicial. No caso de um over não ser concluído, todos os mercados indecisos neste over específico são considerados nulos, a menos que os turnos tenham chegado à sua conclusão natural, por exemplo. declaração, equipe completa, etc.

`}</p>
						<p>{`Alguns torneios podem durar até 5 dias (por exemplo, Série de Testes), os mercados decididos serão determinados instantaneamente, quaisquer mercados que exijam que um evento seja totalmente concluído (por exemplo, Vencedor, Handicap) será o resultado após os eventos serem anunciados oficialmente como concluído.

`}</p>
						<p>{`Em alguns casos, o método Duckworth-Lewis pode ser aplicado pelos dirigentes para determinar o vencedor. O método Duckworth-Lewis-Stern (DL) é uma formulação matemática projetada para calcular a pontuação alvo para a equipe que rebate em segundo lugar em uma partida interrompida pelo clima ou outras circunstâncias.

`}</p>
						<p>{`Se os mercados permanecerem abertos com uma pontuação incorreta que tenha um impacto significativo nos preços, reservamo-nos o direito de anular as apostas.

`}</p>
						<p>{`No caso de uma partida ser reduzida em overs para uma ou ambas as equipes (por exemplo, de 50 para 35 overs devido a condições climáticas adversas), reservamo-nos o direito de anular quaisquer apostas não decididas feitas no formato inicial e ajustar as probabilidades e os mercados/linhas de acordo para que sejam oferecidas novamente com base no novo formato.
`}</p>
						<p>{`O resultado super over está incluído apenas em mercados com indicação (incl super over)
`}</p>
						<p>{`Se uma partida for criada no formato errado (ou seja, T10 em vez de T20), as apostas serão anuladas e uma nova partida será criada.

`}</p>
						<p className="pH2">{`Mercados de críquete
`}</p>
						<p>{`Vencedor (incluindo super over): Preveja o vencedor da partida (o resultado inclui o super over).

`}</p>
						<p>{`Total (mais/menos): Preveja se as corridas serão acima ou abaixo de um determinado número em todo o evento.

`}</p>
						<p>{`Handicap Asiático: Preveja quem vencerá o jogo com handicap (sem empate).

`}</p>
						<p>{`1X2: Preveja o vencedor da partida (o resultado não inclui o super over). Opções disponíveis: Casa, Empate, Fora.

`}</p>
						<p>{`Resultado Correto: Prever qual será o placar ao final do jogo.

`}</p>
						<p>{`Dupla Chance: Você tem que prever o resultado do tempo regulamentar de toda a partida. Existem 3 resultados possíveis: 1X (no final do jogo o time da casa vence ou empata), X2 (no final do jogo o time visitante vence ou empata), 12 (no final do jogo o time da casa vence ou o time visitante vence).

`}</p>
						<p>{`Marcar mais quatros: Qual time marcará mais quatros. Quatro corridas são marcadas se a bola quicar ou rolar pelo chão, antes de tocar ou passar pela borda do campo. Se não tocar a borda do campo, deve tocar o solo além dele.

`}</p>
						<p>{`Para marcar mais Seis: Qual equipe marcará mais Seis. Seis é um termo no cricket que significa que a bola voa sobre o limite sem tocar o chão dentro do campo, o que credita o batedor em 6 corridas em vez de 4.

`}</p>
						<p>{`Total (mais/menos) - Partida de Quatros: O número total de Quatros marcados no jogo estará abaixo/acima de uma linha específica.

`}</p>
						<p>{`Total (mais/menos) - Match Sixes: O número total de quadros marcados no jogo será abaixo/acima de uma linha específica.

`}</p>
						<p>{`Ímpar/Par: Preveja se o Total de execuções alcançadas durante um período de tempo especificado será um número par ou ímpar.

`}</p>
						<p>{`Equipe Casa/Fora Ímpar/Par: Preveja se o total de corridas alcançadas durante um período de tempo especificado será um número par ou ímpar para a equipe da casa/fora.

`}</p>
						<p>{`Parceria de abertura mais alta: Qual equipe marcará mais corridas antes de perder seu primeiro wicket.

`}</p>
						<p>{`Método do 1º wicket: Prever qual será o método do 1º wicket. As opções disponíveis são: Capturado, Lançado, LBW, Run Out, Stumped ou qualquer Outro (inclui Expulso/Retirado).

`}</p>
						<p>{`Método de Demissão 6-Way: Qual será o método de eliminação. As opções disponíveis são: Caught (Pegou), Bowled (Eliminado pelo lançamento), LBW (Eliminado por LBW), Run Out (Eliminado por corrida), Stumped (Eliminado por stumping) ou qualquer outro. Se não houver mais eliminações, todas as apostas serão consideradas nulas.

`}</p>
						<p>{`Método de Demissão: A próxima demissão será uma pegadinha ou não. As opções disponíveis são: Capturado, Não Capturado.

`}</p>
						<p>{`Corridas na queda do wicket da equipe da casa/visitante: Número total de corridas para a equipe da casa/fora depois de atingir o wicket da outra equipe.

`}</p>
						<p>{`Over na queda do Wicket equipe da casa/visitante Team: Prever em qual wicket o próximo wicket da equipe da casa/fora cairá. Por exemplo, se um wicket cair após 6,2 overs, a liquidação é feita no 7º over. Se a liquidação das apostas puder ser determinada, elas serão liquidadas de acordo. Por exemplo, no caso de uma equipe deixar o campo devido a uma interrupção durante mais de 15, os saldos anteriores menores que isso serão resolvidos. No entanto, overs superiores a isso serão anulados.

`}</p>
						<p>{`Total de runs Ímpar/Par em Over: Preveja se o Total de execuções alcançadas durante um over especificado será um número par ou ímpar.

`}</p>
						<p>{`Total de Runs Ímpar/Par no Over - Time da Casa/visitante: Preveja se o Total de Runs alcançados durante um over especificado será um número par ou ímpar para o time da casa/fora.

`}</p>
						<p>{`Total de execuções acima: Preveja se as execuções serão acima ou abaixo de um determinado número em uma ultrapassagem especificada. O over deve ser concluído para que as apostas sejam válidas, a menos que o resultado já tenha sido decidido.

`}</p>
						<p>{`Total de corridas em over - time da casa/visitante: Preveja se as corridas serão acima ou abaixo de um determinado número em um over especificado para a equipe da casa/fora. O over deve ser concluído para que as apostas sejam válidas, a menos que o resultado já tenha sido decidido.

`}</p>
						<p>{`Total de Runs em Over - Time da casa/visitante 1st entrada: Preveja se as corridas serão acima ou abaixo de um determinado número em um over especificado para o time Casa/Fora no 1º turno. O over deve ser concluído para que as apostas sejam válidas, a menos que o resultado já tenha sido decidido.

`}</p>
						<p>{`Total de corridas em over - time da casa/fora na 2ª entrada: Preveja se as corridas serão acima ou abaixo de um determinado número em um over especificado para a equipe da casa/fora na 2ª entrada. O over deve ser concluído para que as apostas sejam válidas, a menos que o resultado já tenha sido decidido.

`}</p>
						<p>{`Wicket em Over - Time da casa/visitante: Prever se haverá um wicket ou não em um over especificado para o time da casa/fora. Se um turno terminar durante um over, esse over será considerado completo, a menos que o turno termine devido ao mau tempo, caso em que todas as apostas não decididas serão anuladas.

`}</p>
						<p>{`Xª Entrega de Runs Off - Equipe da Casa/visitante: Preveja se o número de corridas para a equipe da casa/fora na Xª entrega será mais/menos de uma linha específica.

`}</p>
						<p>{`Para Ganhar o Sorteio: Preveja qual time ganhará o cara ou coroa no início do jogo.

`}</p>
						<p>{`Um cinquenta a ser marcado na partida: Preveja se haverá pelo menos um batedor para marcar 50 corridas ou mais. Se uma partida for reduzida em overs e um resultado oficial da partida estiver disponível, todas as apostas serão válidas. No caso de uma interrupção e a partida não ser retomada dentro de 48 horas, todas as apostas não decididas serão anuladas.

`}</p>
						<p>{`100 a serem marcados na partida: Preveja se haverá pelo menos um batedor para marcar 100 corridas ou mais. Se uma partida for reduzida em overs e um resultado oficial da partida estiver disponível, todas as apostas serão válidas. No caso de uma interrupção e a partida não ser retomada dentro de 48 horas, todas as apostas não decididas serão anuladas.

`}</p>
						<p>{`Mais Run Outs: Preveja qual equipe terá mais Run Outs. Uma corrida geralmente ocorre quando os batedores estão tentando correr entre os wickets, e a equipe de campo consegue levar a bola para um wicket antes que o batedor tenha chegado a essa extremidade. Se uma partida for abandonada por qualquer motivo, todas as apostas não decididas serão anuladas, a menos que a liquidação já tenha sido determinada. Se uma partida for reduzida em overs e um resultado da partida for alcançado, a equipe que conseguiu mais run-outs enquanto jogava, independentemente da quantidade de overs lançados, será a vencedora.

`}</p>
						<p>{`Melhor Batedor - equipe Casa/visitante: Preveja o Melhor Batedor para a equipe Casa/Fora. Aquele que fizer mais corridas para o time da casa/fora será o vencedor. Aqueles que começaram a partida, mas não rebateram, são considerados perdedores. As apostas feitas em qualquer jogador que não participe da partida serão anuladas. No caso de mais de um jogador atingir o mesmo número de corridas, aquele com a melhor proporção de pontuação será considerado o vencedor.

`}</p>
						<p>{`Melhor Lançador - Equipe da Casa/visitante: Preveja o Melhor Lançador da equipe da Casa/Fora. Aquele que tiver mais wickets é o vencedor. Se dois ou mais jogadores tiverem o mesmo número de wickets, aquele com o menor número de corridas é considerado o vencedor. Se todos os jogadores tiverem 0 wickets, todas as apostas serão anuladas. As apostas feitas em qualquer jogador que não participe da partida serão anuladas.

`}</p>
						<p>{`Man Of The Match: Preveja qual jogador será o melhor jogador da partida. As apostas serão determinadas no jogador oficialmente declarado da partida.

`}</p>
						<p>{`Batedor marcará cinquenta na partida: Preveja qual jogador marcará cinquenta na partida.

`}</p>
						<p>{`Pontuação mais alta dos 1ºs 6 overs: Preveja qual time tem o maior número de corridas comparando os 6 primeiros overs para ambas as equipes. No caso de o mesmo número de corridas para ambas as equipes, as apostas serão anuladas.

`}</p>
						<p>{`Jogador que marca mais seis: Preveja qual jogador marcará mais seis no jogo. No caso de mais de um jogador atingir o mesmo número de seis, aquele com a melhor relação de pontuação será considerado vencedor.

`}</p>
						<p>{`Pontuação Individual Mais Alta: Preveja se a pontuação individual mais alta em corridas alcançada por qualquer jogador será mais/menos de uma linha específica.

`}</p>
						<p>{`Total (mais/menos) Wides: Preveja se o número de Wides lançados na partida será mais/menos de uma linha específica.

`}</p>
						<p>{`Total (mais/menos) Ducks: Preveja se o número de Ducks na partida estará mais/menos de uma linha específica.

`}</p>
						<p>{`Total (mais/menos) Wickets: Preveja se o número de Wickets conquistados na partida será mais/menos de uma linha específica.

`}</p>
						<p>{`Total (mais/menos) Extras: Preveja se o número de Extras na partida será mais/menos de uma linha específica.

`}</p>
						<p>{`Queda do 1º wicket: Quantas corridas serão marcadas na queda do 1º wicket.

`}</p>
						<p>{`Queda do 1º wicket - equipe da casa/visitante: Quantas corridas a equipe da casa/fora irá marcar na queda do 1º wicket.

`}</p>
						<p>{`Time com o melhor batedor: Preveja em qual time será o melhor batedor do jogo.

`}</p>
						<p>{`Time com o melhor lançador: Preveja em qual time será o melhor lançador do jogo.

`}</p>
						<p>{`Total (mais/menos) Melhor batedor: Preveja se a pontuação em corridas para a pontuação do Melhor batedor será mais/menos de uma linha específica.

`}</p>
						<p>{`1ª entrada Xª Over Dispensa - Equipe da casa/visitante: Prever se uma expulsão ocorrerá na Xª entrada da 1ª entrada para a equipe da casa/fora.

`}</p>
						<p>{`Maior pontuação acima - Total (mais/menos): Preveja se a pontuação na pontuação mais alta será mais/menos de uma linha específica.

`}</p>
						<p>{`Total (mais/menos) de corridas: Preveja se o número de corridas será mais/menos de uma linha específica.

`}</p>
						<p>{`Handicap da Partida: Qual equipe vencerá a partida com handicap de wickets e runs.

`}</p>
						<p>{`Para ganhar o sorteio e a partida: Qual equipe ganhará o sorteio e a partida.

`}</p>
						<p>{`Total (mais/menos) 1º Acima: Preveja se a pontuação em corridas no 1º Acima está mais/menos de uma linha específica.

`}</p>
						<p>{`O jogo irá para Super Over?: Preveja se haverá um Super Over no jogo.

`}</p>
						<p>{`Partida empatada: Preveja se uma partida terminará empatada no tempo regulamentar. Um empate é quando na conclusão do jogo, ambas as equipes completaram seus turnos e suas pontuações são iguais.

`}</p>
						<p>{`Partida Completa: Preveja se a partida será completada. Uma partida é considerada concluída se houver um resultado oficial.
`}</p>
						<p>{`Empate sem aposta: Qual time vencerá a partida, visto que todas as apostas serão anuladas se a partida empatar. Um empate será resolvido como empate.
`}</p>
						<p>{`Marcos da partida: Preveja quantos dos marcos especificados (50/100) serão marcados no total na partida. Isso é determinado por quantas corridas individuais de 50+ ou 100+ são marcadas na partida. Uma pontuação superior a 100 contaria como 50 e 100.
`}</p>
						<p>{`Jogador a ser apanhado no 1º/2º turno: Preveja se um jogador individual será apanhado durante o primeiro ou segundo turno. Resultados disponíveis: Sim/Não.
`}</p>
						<p>{`Total de corridas do jogador ímpar/par no 1º/2º turno: Preveja se a pontuação em corridas alcançadas por um jogador individual será um número ímpar ou par durante o primeiro ou segundo turno.

`}</p>
						<p>{`"Método de Eliminação do Batedor: Preveja como o batedor nomeado será eliminado. Se o batedor especificado não for eliminado, todas as apostas serão nulas. Se o batedor especificado se retirar e não voltar a bater mais tarde, todas as apostas serão nulas. Se o batedor voltar a bater mais tarde e for eliminado, as apostas serão mantidas. ""Caught and bowled"" (Eliminado por pegada e arremesso) está incluído na categoria de ""pegada de fielder"".

`}</p>
						<p>{`Resultado dos primeiros X Overs: Preveja o resultado em corridas para os primeiros X overs. Resultados disponíveis: Casa, Empate, Fora.

`}</p>
						<p>{`Jogador que alcançará X Runs Sim/Não: Prever se um jogador específico marcará um determinado número de runs na partida.

`}</p>
						<p>{`Total de Fours da Partida Ímpar ou Par: Preveja se o número total de limites (fours) atingidos durante a partida será um número par ou ímpar.

`}</p>
						<p>{`Total de Sixes da Partida Par ou Ímpar: Preveja se o número total de limites (seis) atingidos durante a partida será um número par ou ímpar.

`}</p>
						<p>{`Total de corridas acima/abaixo do primeiro X Overs da equipe Home/Away: Preveja se o número total de corridas estará acima/abaixo de uma linha específica nos primeiros X Overs para o time da casa/fora.

`}</p>
						<p>{`Primeiro X Overs do time da casa/fora Total de Runs Par ou Ímpar: Preveja se o número total de corridas será par ou ímpar nos primeiros X Overs da equipe da casa/fora.

`}</p>
						<p>{`Extra no primeiro over do time da casa/fora Sim/Não: Preveja se haverá corridas extras (por exemplo, wides, no-balls, byes ou leg-byes) lançadas no primeiro over para o time da casa/fora.

`}</p>
						<p>{`Time da Casa/Viagem 1º Over Limite Quatro Marcado Sim/Não: Preveja se um limite (quatro) será marcado no primeiro over pelo time da Casa/Viagem.

`}</p>
						<p>{`Time da Casa/Viagem 1º Over Boundary Six Scored Sim/Não: Preveja se um boundary (seis) será marcado no primeiro over pelo time da Casa/Viagem.

`}</p>
						<p>{`Total de Runs do Time da Casa/Viagem na Queda do 1º Wicket Ímpar ou Par: Preveja se o total de corridas marcadas pelo time da casa/fora na queda do primeiro wicket será um número par ou ímpar.

`}</p>
						<p>{`Total de corridas na primeira entrega da equipe da casa/fora: Preveja quantas corridas serão marcadas na primeira entrega da da casa/fora.

`}</p>
						<p>{`Total de corridas na primeira bola do time da casa/fora de casa acima/abaixo: Preveja se o total de corridas marcadas na primeira bola pelo time da casa/fora estará acima ou abaixo de uma linha específica.

`}</p>
						<p>{`Total de quatros da equipe Home/Away ímpar ou par: Preveja se o número total de quatros acertados pela equipe da casa/fora será um número par ou ímpar.

`}</p>
						<p>{`Equipe da casa/fora Corridas exatas na X entrega do X over no X Innings: Uma previsão de mercado específica, como "Corridas exatas na 3ª entrega do 5º over no 1º turno".

`}</p>
						<p>{`Xth innings - Race to X Runs: Preveja qual equipe marcará primeiro uma quantidade específica de corridas nos innings.

`}</p>
						<p>{`Xth innings - Player Total Deliveries faced: Prever se o número total de entregas enfrentadas por um jogador será superior ou inferior a um número específico. O total de lançamentos enfrentados refere-se ao número de bolas legais que um rebatedor enfrentou durante o tempo em que esteve na base.

`}</p>
						<p>{`Xº turno - Jogador Runs concedidas: Prever se o número de corridas concedidas por um jogador será superior ou inferior a um número especificado. As corridas concedidas referem-se ao número total de corridas que um arremessador cedeu ao entregar seus overs.

`}</p>
						<p>{`Xº turno Equipe da casa/fora Xº limite do bastão, quatro ou seis: Preveja se o Xº Boundary atingido pelo rebatedor do time da casa/fora no Xº turno será um quatro (4 corridas) ou seis (6 corridas).

`}</p>
						<p>{`Marcos totais do batedor (50/100): Preveja o número de cinquenta (50 corridas) e centenas (100 corridas) marcados pelos batedores durante uma partida.

`}</p>
						<p>{`Intervalo total da equipe da casa/fora em X over dos X turnos: Preveja o intervalo total em corridas para a equipe da casa/fora em um turno específico e em um over. Por exemplo, uma equipe pode conseguir entre 6-15 corridas no 5º over do primeiro turno.

`}</p>
						<p>{`Intervalo de corridas do time da casa/fora de casa nos X turnos: Preveja o intervalo total de corridas para a equipe da casa/fora em um específico. Por exemplo, uma equipe pode conseguir entre 229-310+ corridas no primeiro turno.

`}</p>
						<p>{`Xth Innings Total de Limites do Jogador Individual Acima/Abaixo: Preveja quantos quatros e/ou seis um determinado jogador acertará durante seu tempo no bastão.

`}</p>
						<p>{`Xth Innings Individual Player Balls Faced Over/Under: Preveja quantas bolas um jogador específico enfrentará durante seus innings.

`}</p>
						<p>{`Total de corridas de um jogador individual no Xº Innings (intervalo): Prever quantas corridas um jogador específico marcará em um intervalo de determinado intervalo, como 0-24, 25-30, etc.

`}</p>
						<p className="pH2">{`Mercados Outright:
`}</p>
						<p>{`Vencedor: Você deve prever o vencedor de um determinado torneio de acordo com a classificação oficial da competição.

`}</p>
						<p>{`Vencedor da Série: Você tem que prever qual time vencerá a Série (alguns jogos)

`}</p>
					</div>
				</details>
				{/* Curling  */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Curling
					</summary>
					<div className="textItem">
						<p>{`Os mercados são considerados decididos se uma partida for oficialmente concluída ou concedida pela equipe derrotada.

`}</p>
						<p>{`Os finais extras serão contados para fins de liquidação.

`}</p>
						<p>{`Caso uma partida seja adiada ou abandonada sem ser retomada em 48 horas, todos os mercados não decididos serão considerados nulos.

`}</p>
						<p className="pH2">{`Principais mercados de Curling
`}</p>
						<p>{`Vencedor (fins extra incluídos): Tem de prever o vencedor do jogo, independentemente da margem de pontos.

`}</p>
						<p>{`Total de pontos (incluindo fins extra): Tem de prever se o número total de pontos de ambas as equipas combinadas será superior ou inferior ao número selecionado.

`}</p>
						<p>{`Handicap (fins extra incluídos): Tem de prever o vencedor de toda a partida adicionando ou subtraindo o spread indicado ao resultado do jogo.

`}</p>
						<p className="pH2">{`Mercado de Curling Outright
`}</p>
						<p>{`Vencedor: Você deve prever o vencedor do torneio de acordo com a classificação oficial da competição.

`}</p>
					</div>
				</details>
				{/* Dardos  */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="33"
							viewBox="0 0 33 33"
							width="33"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<path
								d="M32.7047 1.71597C33.0958 1.3246 33.0958 0.692397 32.7047 0.301031C32.3135 -0.090334 31.6816 -0.090334 31.2904 0.301031L27.2684 4.32507L28.6827 5.74001L32.7047 1.71597Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M28.452 11.0887C28.5121 9.68377 28.0708 8.30897 27.2484 7.16498H27.2584L25.8442 5.72997H25.8341C24.7008 4.91714 23.3267 4.48563 21.9225 4.53581C20.3177 4.59602 18.763 5.29847 17.4491 6.52274L26.466 15.5442C27.6797 14.2397 28.3818 12.6842 28.452 11.0786V11.0887Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M13.5675 27.1748L12.6247 24.5456L11.2506 23.1708L6.84741 27.5762L8.20146 31.3393C8.25161 31.4798 8.33185 31.6103 8.43215 31.7106C8.56254 31.8411 8.73305 31.9414 8.92361 31.9816C9.2546 32.0618 9.60565 31.9515 9.8564 31.7106L13.3468 28.2184C13.6176 27.9475 13.7079 27.5361 13.5775 27.1648L13.5675 27.1748Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M8.44218 20.3711L5.82435 19.4278C5.46328 19.2973 5.05205 19.3876 4.77121 19.6586L1.29081 23.1608C1.05009 23.4016 0.94979 23.7529 1.02 24.094C1.06012 24.2847 1.16042 24.4553 1.29081 24.5858C1.39111 24.6861 1.5215 24.7664 1.66192 24.8166L5.42316 26.1713L9.82631 21.7659L8.44218 20.3811V20.3711Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M9.44517 18.5346L14.42 23.512C17.0479 22.067 21.8723 19.3174 24.9615 16.8889L16.1051 8.02799C13.6778 11.1087 10.8995 15.9155 9.44517 18.5346Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
						</svg>
						Dardos
					</summary>
					<div className="textItem">
						<p>{`Considera-se que um jogo de dardos começou quando o primeiro dardo foi lançado na primeira rodada do primeiro set. Se o número indicado de sets não for concluído, as apostas para o resultado exato serão anuladas. A pontuação mais alta possível com três dardos é 180, obtida quando todos os três dardos caem no triplo 20 (o termo pode ser encontrado em muitos mercados).

`}</p>
						<p className="pH2">{`Principais Mercados
`}</p>
						<p>{`1X2: Você tem que prever o resultado de toda a partida. Existem 3 resultados possíveis: 1 (o time da casa ganha), X (os times vão empatar), 2 (o time visitante ganha).

`}</p>
						<p>{`Handicap de Set: Você deve prever o resultado em termos de sets ganhos por cada jogador adicionando ou subtraindo ao resultado final o spread especificado na aposta.

`}</p>
						<p>{`Total de 180s: Você deve prever se o número total de 180s alcançados na partida por ambos os jogadores estará acima ou abaixo do spread indicado.

`}</p>
						<p>{`Mais 180s: Você tem que prever qual jogador alcançará mais 180s na partida (ou se haverá empate).

`}</p>
						<p>{`Rei do Oche (Match Treble): Rei do oche é o jogador que vence a partida, marca mais 180s que seu oponente e tem o maior checkout da partida.

`}</p>
						<p>{`Jogador com maior checkout: Qual jogador terá o maior checkout em uma única leg.

`}</p>
						<p>{`Maior checkout da partida: Qual será o maior checkout da partida por qualquer jogador.

`}</p>
						<p>{`Total x + checkout: Preveja se a pontuação total do checkout será de um número específico e superior. Por exemplo. acima/abaixo de 100+ checkouts.

`}</p>
						<p>{`Vencedor da partida e checkout mais alto: Qual jogador vencerá a partida e qual jogador terá o checkout mais alto. O checkout mais alto pode ser igual.

`}</p>
						<p>{`Vencedor da partida e mais 180s: Qual jogador vencerá a partida e qual jogador marcará mais 180s, os 180s podem ser iguais.

`}</p>
						<p>{`Checkout mais alto e mais 180s: Qual jogador terá o checkout mais alto e qual jogador marcará mais 180s. Tanto o checkout mais alto quanto os 180s podem ser iguais.

`}</p>
						<p>{`Para liderar após a xª leg: Qual será o jogador que liderará o jogo após a xª leg. Três resultados possíveis: jogador1, empate, jogador2

`}</p>
						<p>{`Total de checkout da xª leg: Qual será o checkout de uma leg específica, a oferta usual neste mercado é O/U 40.5.

`}</p>
						<p>{`Pontuação após x legs: Qual será a pontuação após x legs no jogo.

`}</p>
						<p>{`170 checkout na partida: Qualquer jogador com o maior checkout do jogo (170) {T20, T20, BULL}. para este modelo

`}</p>
						<p>{`Para marcar e receber cartão e assistência: Você precisa prever se o jogador marcará pelo menos um gol, fará pelo menos uma assistência e receberá um cartão (amarelo ou vermelho) na partida. A prorrogação também está incluída.

`}</p>
						<p>{`Handicap de 180s: Você deve prever o resultado em termos de 180s alcançados por cada jogador adicionando ou subtraindo ao resultado final o spread especificado na aposta.

`}</p>
						<p>{`Total de 180s do time da casa: Você deve prever se o número total de 180s alcançados na partida pelo jogador 1 será superior ou inferior ao spread indicado.

`}</p>
						<p>{`Total de 180s da equipe visitante: Você deve prever se o número total de 180s alcançados na partida pelo jogador 2 será superior ou inferior ao spread indicado.

`}</p>
						<p>{`Handicap de Set (3-way): Você deve prever o resultado em termos de sets ganhos por cada jogador adicionando ou subtraindo ao resultado final o spread especificado na aposta.

`}</p>
						<p>{`Resultado correto (em sets): Você deve prever o resultado correto em sets de toda a partida.

`}</p>
						<p>{`Jogador para marcar 180 pontos: Você tem que prever qual jogador alcançará os 180 pontos selecionados na correspondência (ou se não houver).

`}</p>
						<p>{`Mercados Rápidos:

`}</p>
						<p>{`Xº set - Vencedor da Nth Leg: Você tem que prever qual jogador vencerá a Leg N do set X.

`}</p>
						<p>{`1x set - pontuação correta (leg handicap): Prever a pontuação correta em etapas do set mencionado.

`}</p>
						<p>{`x set - leg handicap: Você tem que prever o vencedor do set mencionado (em legs) somando ou subtraindo o spread indicado ao resultado da partida (em partidas).

`}</p>
						<p>{`Xº set - total legs: Preveja se o total de partidas jogadas em um determinado set será superior ou inferior a um determinado número no mercado.

`}</p>
						<p>{`x set - legs pares/ímpares: Preveja se o total de legs jogadas em um determinado set será um número par ou ímpar.

`}</p>
						<p>{`xº set leg x - total de dardos: Você deve prever se o total de dardos lançados por um jogador para vencer uma determinada etapa será superior ou inferior ao spread indicado.

`}</p>
						<p>{`x ª set leg x - jogador com maior pontuação em x visitas: Você tem que prever qual jogador marcará mais pontos em uma visita específica.

`}</p>
						<p>{`x set leg x - intervalo de pontos na x visita: Você deve prever qual será o intervalo de pontos da visita específica de um jogador.

`}</p>
						<p>{`x set leg x - pontuação de checkout x:y+: Você tem que prever se a pontuação de checkout de uma leg específica será acima ou abaixo de 40,5.

`}</p>
						<p>{`xª set leg x - cor da saída: Você tem que prever se a cor da saída de uma leg específica será vermelha ou verde.

`}</p>
						<p>{`xº set - mais 180s: Você tem que prever qual jogador alcançará mais 180s no set mencionado (ou se haverá empate).

`}</p>
						<p>{`x set - total 180s: Você tem que prever se o número total de 180s alcançados no set mencionado por ambos os jogadores estará acima ou abaixo do spread indicado.

`}</p>
						<p>{`xº set - Total de 180s do time da casa: Você tem que prever se o número total de 180s alcançados no set mencionado pelo jogador 1 será acima ou abaixo do spread indicado.

`}</p>
						<p>{`x set - Time visitante total 180s: Você tem que prever se o número total de 180s alcançados no set mencionado pelo jogador 2 será acima ou abaixo do spread indicado.

`}</p>
						<p>{`x ª set leg x - qualquer jogador para marcar 180: Você tem que prever se algum jogador atingirá 180 no set e na leg mencionado (ou se não houver nenhum).

`}</p>
						<p>{`x set leg x - Equipe da casa marca 180: Você tem que prever se o jogador 1 alcançará 180 no set e na leg mencionado (ou se não houver).

`}</p>
						<p>{`x set leg x - Equipe visitante para marcar 180: Você tem que prever se o jogador 2 atingirá 180 no set e na leg mencionado (ou se não houver).

`}</p>
						<p>{`Mercados definitivos:

`}</p>
						<p>{`Vencedor: Você deve prever o vencedor de um determinado torneio de acordo com o ranking oficial da competição.

`}</p>
						<p>{`Top 2: Você deve prever os finalistas de um determinado torneio de acordo com o ranking oficial da competição.

`}</p>
						<p>{`Quem irá mais longe? Preveja qual dos jogadores mencionados chegará à fase posterior (ou a mesma).

`}</p>
						<p>{`Fase de Eliminação: Preveja em qual rodada o jogador selecionado será eliminado.

`}</p>
						<p>{`Nacionalidade Vencedora: Você deve prever a nacionalidade do vencedor.

`}</p>
						<p>{`Metade Vencedora: Você deve prever que o vencedor do torneio virá da metade superior ou da metade inferior.

`}</p>
						<p>{`Quarto vencedor: Você deve prever que o vencedor do torneio virá do 1º/2º/3º/4º quarto.

`}</p>
						<p>{`Vencedor pela primeira vez? Você tem que prever se haverá um vencedor pela primeira vez ou não.

`}</p>
						<p>{`Vencedor do Xº quarto: Você deve prever o vencedor do quarto mencionado (1º/2º/3º/4º).

`}</p>
					</div>
				</details>
				{/* E-sports  */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						E-sports
					</summary>
					<div className="textItem">
						<p className="pH2">Regras Gerais</p>

						<p>
							Todos os mercados de esports são baseados em eventos de pontuação no jogo ou
							resultados no final de uma partida/mapa agendado. Todos os assentamentos ocorrerão
							usando a pontuação oficial e os resultados que são declarados no fluxo de vídeo
							oficial ou no fluxo do jogo das partidas relevantes.
						</p>

						<p>
							Todas as datas e horários de início de partidas exibidos para partidas de Esports são
							apenas para fins de indicação e não são garantidos como corretos. As apostas serão
							válidas se uma partida for oferecida com uma data e/ou hora incorretas.
						</p>

						<p>
							Se uma partida for pausada/adiada e não for reagendada para um horário posterior
							dentro de 48 horas da hora de início programada, todas as apostas nessa partida serão
							anuladas.
						</p>

						<p>
							Se o nome de um jogador/equipe/torneio estiver escrito incorretamente, todas as
							apostas ainda permanecerão, a menos que seja óbvio que o nome escrito incorretamente é
							o mesmo que uma entidade diferente.
						</p>

						<p>
							Se o nome de uma equipe for alterado devido a uma equipe deixar a organização,
							ingressar em outra organização ou devido a uma mudança oficial do nome da equipe,
							todas as apostas permanecerão.
						</p>

						<p>
							Se o organizador do evento permitir stand-ins e houver um resultado oficial, todas as
							apostas serão realizadas normalmente.
						</p>

						<p>
							No caso de haver uma anulação do resultado de uma partida pelo organizador devido a
							circunstâncias imprevistas - como trapaça - todas as apostas nessa partida serão
							anuladas.
						</p>

						<p>
							Se uma partida tiver sido declarada como uma vitória walkover pelo organizador do
							torneio, todas as apostas serão anuladas.
						</p>

						<p>
							Se uma equipe se aposentar durante uma partida, apenas as apostas nos mapas
							individuais concluídos serão resultadas. O mercado de partidas, os mercados de match
							side e todos os outros mercados de mapas indecisos serão anulados.
						</p>

						<p>
							Todos os mercados consideram apenas o tempo regulamentar, salvo indicação em contrário
							no nome do mercado.
						</p>

						<p>
							Se o formato da partida for alterado ou diferente do que está sendo oferecido,
							reservamo-nos o direito de anular todas as apostas.
						</p>

						<p>
							Se o jogo estiver listado incorretamente, reservamo-nos o direito de anular todas as
							apostas.
						</p>

						<p>
							Se uma partida for jogada antes da data/hora de início programada, todas as apostas
							feitas após o início real da partida serão reembolsadas. Todas as apostas feitas antes
							do início real da partida serão mantidas.
						</p>

						<p>
							Se uma partida ou mapa for repetido devido a um organizador ou problemas técnicos,
							todos os mercados indecisos serão anulados, partidas repetidas ou mapas serão tratados
							separadamente como nova partida.
						</p>

						<p>
							Se a duração/duração final do jogo for igual a um limite específico, ele será
							resolvido como OVER.
						</p>

						<p>
							Quando um evento envolve os mesmos dois jogadores ou equipes jogando vários jogos ou
							mapas, por exemplo "melhor de 3", e um ou mais jogos ou mapas não são jogados porque o
							resultado do evento já foi determinado, as apostas em jogos ou mapas não jogados são
							anulados e as apostas reembolsadas.
						</p>

						<p>
							As datas e horários de início são mostrados apenas para fins informativos e podem não
							ser precisos.
						</p>

						<p>
							Quando um evento for cancelado, adiado ou interrompido e não for concluído dentro de
							48 horas do horário de início originalmente programado, as apostas nesse evento serão
							anuladas e reembolsadas. No entanto, jogos ou mapas concluídos dentro de 48 horas são
							liquidados normalmente, mesmo que jogos ou mapas adicionais que deveriam fazer parte
							do mesmo confronto sejam cancelados ou adiados.
						</p>

						<p>
							As apostas são determinadas com base na transmissão oficial do jogo pelo editor ou
							organizador do evento. Onde a transmissão mostra um contador de rodadas vencidas,
							mortes, dragões, torres etc., isso geralmente será usado para liquidar apostas
							relevantes. Se o resultado de uma aposta não estiver claro na transmissão ou se não
							houver transmissão, a API de estatísticas do jogo será usada quando disponível.
						</p>

						<p>
							<strong>
								No caso de mercados indexados ou numerados (como o vencedor de uma rodada específica
								no Counter Strike
							</strong>
							2, ou a equipe que marcou uma determinada morte numerada em League of Legends ou
							DOTA2), o índice determina o objetivo é que conta. Palavras como "próximo" no nome do
							mercado não são garantidas como corretas, pois as transmissões podem ser atrasadas e
							nem sempre podemos avançar o índice precisamente quando um objetivo é marcado ou uma
							rodada concluída. Todas as apostas são, portanto, liquidadas na rodada numerada
							específica ou objetivo especificado, independentemente de qualquer outra palavra no
							nome do mercado ou seu tempo em relação ao momento em que a aposta foi feita.
						</p>

						<p>
							Se o número programado de rodadas ou mapas for alterado, ou se os mercados forem
							oferecidos erroneamente com base em um número diferente de rodadas ou mapas do número
							real agendado, as apostas na margem de ganho (incluindo handicap), total de rodadas /
							mapas, pontuações corretas etc. são anuladas e as apostas reembolsadas.
						</p>

						<p>
							As apostas do vencedor do mapa e do vencedor do confronto são válidas. Se algum mapa
							não for jogado ou for concedido a um jogador ou equipe por falta ou padrão sem que o
							jogo tenha começado, todas as apostas nesse mapa e no confronto como um todo serão
							anuladas e as apostas reembolsadas. As apostas relacionadas apenas a mapas que são
							jogados são válidas. Considera-se que um mapa começou assim que o cronômetro do jogo
							começa ou um time ou jogador realiza uma ação de jogo relacionada a esse mapa,
							incluindo escolhas, banimentos e compras de armas.
						</p>

						<p>
							• Round: A equipe vence rodadas para ganhar o mapa. A rodada é vencida quando: 1) uma
							equipe elimina a outra; 2) os terroristas detonam a bomba com sucesso; ou 3) os
							contra-terroristas impedem a detonação da bomba em até 120 segundos após o início da
							rodada. A primeira equipe a marcar 13 rodadas vence o mapa.
						</p>

						<p>
							Mapa X - Duração do Mapa: Você deve prever a duração total da partida no mapa X.
							Aposte na duração do mapa especificado em minutos (mais/menos). O cálculo é feito de
							acordo com o cronômetro do jogo. Por exemplo, para uma aposta em uma duração de 40,5
							no over: Para que a aposta seja vencedora, o tempo no mapa deve ser de 40 minutos e 30
							segundos ou mais. Para que a aposta seja perdida, o tempo deve ser de 40 minutos e 29
							segundos ou menos. Depois que o cronômetro atingir a marca de 36 minutos, o 37º minuto
							começa, portanto 37&gt;36,5. Se o mapa durar menos de 36 minutos (incluindo exatamente
							36 minutos e 00 segundos), a aposta será considerada perdedora.
						</p>

						<p>
							Mapa X. - Segunda parte - Total de rodadas: Uma aposta no número total de rodadas no
							mapa especificado durante o segundo tempo. Por exemplo, se um jogador apostar em mais
							de 22,5 e houver um total de 20 rodadas jogadas no mapa, a aposta perde porque o
							número total de rodadas jogadas é menor que o valor total. Se a aposta foi feita em
							menos de 22.5 com 22 rodadas jogadas, ele vence. O número máximo de rodadas sem
							prorrogação em partidas no formato MR12 é 24.
						</p>

						<p className="pH2">REGRAS DE COUNTER-STRIKE 2</p>

						<p>
							A maioria das apostas no mapa são baseadas no número estipulado de rodadas (geralmente
							melhor de 30) excluindo rodadas extras em caso de empate. Se o mercado vencedor do
							mapa X for oferecido sem a opção Empate, o mercado será liquidado contando as rodadas
							extras jogadas.
						</p>

						<p>
							<strong>Vocabulário específico</strong>:
						</p>

						<p>
							<strong>• T / CT (Terroristas / Contra-terroristas)</strong>: nome específico do
							título da equipe Dark / Light
						</p>

						<p>
							<strong>• Rodada</strong>: Equipe vence Rodadas para ganhar o Mapa. A rodada é vencida
							quando 1) uma equipe elimina a outra 2) por terroristas quando detonam com sucesso a
							bomba 3) por contra-terroristas quando a bomba não detona em 120 segundos do início da
							rodada. A primeira equipe a marcar 13 rodadas ganha o Mapa.<br></br>
							Quando o prolongamento puder ser disputado, este será incluído na liquidação dos
							mercados; a menos que o participante do sorteio esteja cotado para um mercado
							específico, caso em que a liquidação será baseada no número legal de rodadas.
						</p>

						<p>
							<strong>• Prorrogação</strong>: No caso de pontuação do sorteio do mapa (15:15), a
							primeira prorrogação está sendo jogada no formato Bo6 (melhor de 6). Em caso de outro
							empate (18:18), a próxima prorrogação com as mesmas regras será jogada. Esse processo
							se repete até que uma equipe vença a prorrogação. As regras de horas extras podem ser
							específicas do torneio.
						</p>

						<p>
							<strong>• Rodada de pistola</strong>: 1. e 13. rodada em um determinado Mapa.
						</p>

						<p className="pH2">REGRAS DO DOTA2</p>

						<p>
							Para apostas envolvendo torres, todas as torres destruídas contam como tendo sido
							destruídas pela equipe adversária, mesmo que o último golpe tenha sido de um lacaio.
						</p>

						<p>
							Para apostas envolvendo quartéis, todos os quartéis destruídos contam como tendo sido
							destruídos pela equipe adversária, mesmo que o último golpe tenha sido de um lacaio.
							Os quartéis à distância e corpo a corpo em cada par contam como quartéis separados, de
							modo que cada equipe tem um total de seis quartéis.
						</p>

						<p>
							Para apostas envolvendo mortes (exceto "First Blood"), a transmissão oficial ou API do
							jogo, se disponível, é definitiva para determinar se a morte de um Campeão conta como
							uma morte. Por exemplo, quando um Campeão é morto por dano de torre ou lacaio sem o
							envolvimento de um Campeão inimigo, isso não pode ser registrado como uma morte na
							transmissão, caso em que não conta como uma morte para fins de liquidação de apostas.
						</p>

						<p>
							Para apostas em First Blood, a transmissão ou pontuação oficial da API deve registrar
							o abate como First Blood. Quando, por exemplo, uma morte é negada por um companheiro
							de equipe, ela não pode ser contada como First Blood (independentemente de ser
							registrada como uma morte no contador de mortes da transmissão), caso em que não
							contará como First Blood para fins de liquidação de apostas.
						</p>

						<p>
							Para evitar dúvidas, todos os mercados de mortes que não sejam "First Blood" são
							liquidados com base no contador de mortes, mas uma morte registrada no contador de
							mortes contará como First Blood somente se for anunciada como tal.
						</p>

						<p>
							Para apostas em Roshans, a equipe que marcar o último hit em Roshan conforme
							determinado pela transmissão ou API do jogo, se disponível, é considerada como tendo
							matado Roshan, independentemente do jogador que pegar a égide (aegis) do imortal.
						</p>

						<p>
							Para apostas envolvendo a próxima equipe a marcar um objetivo específico ou a equipe a
							marcar mais de um objetivo específico, quando uma opção "nem" ou "empate" é oferecida
							e é o resultado vencedor, as apostas em qualquer equipe são perdedoras. Quando tal
							seleção não for oferecida e nenhuma equipe for vencedora, todas as apostas no mercado
							serão anuladas e reembolsadas.
						</p>

						<p>
							<strong>
								24.3.9 Quando uma equipe se rende, as apostas são válidas e liquidadas da seguinte
								forma
							</strong>
							:
						</p>

						<p>
							Para apostas envolvendo o vencedor do mapa, a equipe vencedora é a equipe que não se
							rendeu;
						</p>

						<p>
							As apostas envolvendo Roshans, quartéis e mortes são determinadas com base na situação
							no momento em que a rendição ocorre;
						</p>

						<p>
							As apostas envolvendo torres são liquidadas como se a equipe vencedora tivesse
							destruído o número mínimo de torres adicionais teoricamente necessárias para vencer o
							jogo normalmente a partir da posição em que ocorreu a rendição.
						</p>

						<p>
							Por exemplo, se a equipe vencedora destruiu todas as torres de nível 1 e uma torre de
							nível 2, será considerado que ela destruiu mais três torres (sete no total), uma vez
							que seria necessário destruir pelo menos uma torre de nível 3 e as duas torres antigas
							para vencer o jogo normalmente a partir dessa posição.
						</p>

						<h3>Vocabulário específico do título</h3>

						<p>
							<strong>• Ancião</strong>: O objetivo principal do Mapa. A primeira equipe a destruir
							o Ancient da equipe adversária ganha o Mapa.
						</p>

						<p>
							<strong>• GG</strong>: Isso permite que a equipe relevante entregue o Mapa quando
							digitado em todo o chat.
						</p>

						<p>
							<strong>• Dire / Radiant</strong>: O nome específico do título das equipes adversárias
							Dark / Light
						</p>

						<p>
							<strong>• Kill</strong>: A pontuação da equipe Light/Dark, que representa o número
							total de vezes que os membros da equipe adversária foram mortos.
						</p>

						<p>
							<strong>• Aegis (égide)</strong>: Um item que aparece depois que o objetivo do jogo
							Roshan é morto. Ele pode ser pego por um jogador.
						</p>

						<p>
							<strong>• Torre</strong>: Um objetivo de jogo específico da equipe, que pode ser
							destruído pela equipe adversária.
						</p>

						<p>
							<strong>• Quartel</strong>: Um objetivo de jogo específico da equipe, que pode ser
							destruído pela equipe adversária.
						</p>

						<p>
							Duração do Mapa: Refere-se à duração total da partida no mapa, se ela será acima ou
							abaixo de um valor específico. Caso a duração final do mapa seja exatamente igual ao
							valor limite, a aposta será resolvida como ACIMA. A duração é determinada com base na
							tela de resultado final, que está disponível na API oficial do Steam, assim que o mapa
							termina.
						</p>

						<p className="pH2">REGRAS DE LEAGUE OF LEGENDS (LOL)</p>

						<p>
							Para apostas envolvendo torres, todas as torres destruídas contam como tendo sido
							destruídas pela equipe adversária, mesmo que o último golpe tenha sido de um lacaio.
						</p>

						<p>
							Para apostas envolvendo inibidores, todos os inibidores destruídos contam como tendo
							sido destruídos pela equipe adversária, mesmo que o último golpe tenha sido de um
							lacaio. Para apostas envolvendo o número de inibidores destruídos, cada um dos seis
							inibidores conta apenas uma vez, mesmo que seja destruído, reaparece e é destruído
							novamente. Para apostas envolvendo o próximo inibidor destruído, cada destruição de um
							inibidor conta separadamente, mesmo quando ele ressurgiu e está sendo destruído por um
							segundo ou tempo subsequente.
						</p>

						<p>
							Para apostas envolvendo mortes (incluindo "First Blood", que em League of Legends é
							sinônimo de primeira morte no mapa), a transmissão oficial ou API do jogo, se
							disponível, é definitiva para determinar se a morte de um Campeão conta como uma
							matança. Por exemplo, quando um Campeão é morto por dano de torre ou lacaio sem o
							envolvimento de um Campeão inimigo, isso não pode ser registrado como uma morte na
							transmissão, caso em que não conta como uma morte para fins de liquidação de apostas.
						</p>

						<p>
							Para apostas envolvendo a próxima equipe a marcar um objetivo específico ou a equipe a
							marcar mais de um objetivo específico, onde uma opção "nem" ou "empate" é oferecida e
							é o resultado vencedor, as apostas em qualquer equipe são perdedoras. Quando nenhuma
							seleção é oferecida e nenhuma equipe é vencedora, todas as apostas no mercado são
							anuladas e as apostas reembolsadas.
						</p>

						<p>
							<strong>
								Quando uma equipe se rende, as apostas são válidas e liquidadas da seguinte forma
							</strong>
							:
						</p>

						<p>
							<strong>Para apostas envolvendo o vencedor do mapa</strong>: a equipe vencedora é a
							equipe que não se rendeu.
						</p>

						<p>
							As apostas envolvendo dragões, barões e mortes são determinadas com base na situação
							no momento em que a rendição ocorre.
						</p>

						<p>
							As apostas envolvendo torres e inibidores são liquidadas como se a equipe vencedora
							tivesse destruído o número mínimo de torres e/ou inibidores adicionais teoricamente
							necessários para vencer o jogo normalmente a partir da posição em que ocorreu a
							rendição.
						</p>

						<p>
							Por exemplo, se qualquer inibidor da equipe perdedora estiver inativo no momento da
							rendição, nenhum inibidor adicional será considerado destruído. Se nenhum inibidor da
							equipe perdedora for derrotado, a equipe vencedora será considerada como tendo
							destruído um inibidor adicional, com prioridade dada a um inibidor que já foi
							destruído se tal inibidor existir e reaparecer. Se a equipe vencedora destruiu todas
							as torres de nível 1 e uma torre de nível 2, será considerado que destruiu mais três
							torres (sete no total), pois seria necessário destruir pelo menos uma torre de nível 3
							e os dois nexos torres ter vencido o jogo normalmente dessa posição.
						</p>

						<p>
							<strong>Vocabulário específico do título</strong>:
						</p>

						<p>
							<strong>• Nexus</strong>: o objetivo principal do Mapa. A primeira equipe a destruir o
							Nexus da equipe adversária ganha o Mapa.
						</p>

						<p>
							<strong>• Matar (kill)</strong>: A pontuação da equipe Azul/Vermelho, que representa o
							número total de vezes que os membros da equipe adversária foram mortos.
						</p>

						<p>
							<strong>• Torre (turret)</strong>: um objetivo de jogo específico da equipe, que pode
							ser destruído pela equipe adversária.
						</p>

						<p>
							<strong>• Inibidor (inhibitor)</strong>: um objetivo de jogo específico da equipe, que
							pode ser destruído pela equipe adversária.
						</p>

						<p>
							<strong>• Dragão (dragon)</strong>: um objetivo do jogo, pode ser morto pelos
							jogadores.
						</p>

						<p>
							<strong>• Barão (baron)</strong>: um objetivo do jogo, pode ser morto pelos jogadores.
						</p>

						<p className="pH2">Mercados Gerais de E-sports</p>

						<p>
							<strong>
								*Um ou mais mercados da seção específica podem ser encontrados em diferentes títulos
								de esportes eletrônicos oferecidos em nossa plataforma de apostas esportivas. Alguns
								desses títulos são
							</strong>
							: KoG (Kings of Glory), Rainbow Six, Starcraft, WoW (World of Warcraft), VALORANT, GoW
							(God of War), HALO, HOTS (Heroes of the Storm), Rocket League, SMITE.
						</p>

						<p>
							<strong>Vencedor (1,2)</strong>: Determinar o vencedor do jogo (x mapas) de acordo com
							o número de mapas oferecidos no evento.
						</p>

						<p>
							<strong>24.5.3 Vencedor (1X2)</strong>: Determinar o vencedor do jogo (x mapas) de
							acordo com o número de mapas oferecidos no evento, ou se a partida terminará empatada.
						</p>

						<p>
							<strong>Handicap do Mapa</strong>: aposta em que o vencedor da partida deve ser
							decidido com a respectiva margem do mapa. A pontuação correta é somada ou subtraída
							dos mapas propostos no handicap, e após a referida operação, será determinado quem
							vence: equipe da casa ou equipe visitante.
						</p>

						<p>
							<strong>Exemplo de partida NomGaming vs Team Spotnet</strong>:
						</p>

						<p>
							Nom-Gaming (-1.5) ➔ Este mercado refere-se aos mapas Nom win (X) dando uma desvantagem
							de 1.5, se o evento terminar 3-0 a favor do Nom, ele ganharia a linha de aposta, pois
							o handicap que selecionamos é 1.5 , Nom continua na liderança do placar com 1,5 a 0 a
							seu favor.
						</p>

						<p>
							Team Spotnet (+1.5) ➔ Este mercado é para dar uma vantagem de 1,5 ao Team Spotnet em
							todos os mapas estabelecidos pelo jogo, se o evento terminar 2 - 1, o vencedor será o
							Team Spotnet desde a vantagem de 1,5 dá-lhe uma pontuação a seu favor de 2,5
							aproveitando a equipe 1, com o resultado final sendo 2 - 2,5.
						</p>

						<p>
							<strong>Total de mapas</strong>: Este mercado refere-se ao número de mapas que o jogo
							terá.
						</p>

						<p>
							<strong>Pontuação exata (nos mapas)</strong>: Este mercado refere-se à pontuação exata
							e final da partida oferecendo as opções:
						</p>

						<p>
							<strong>0</strong>:2 - 1:2
						</p>

						<p>
							<strong>2</strong>:0 - 2:1
						</p>

						<p>
							<strong>
								Primeiro Mapa - vencedor (incl. OT) - Segundo Mapa - vencedor (incl. OT)
							</strong>
							: Este mercado define apenas o vencedor do primeiro ou do segundo mapa do evento,
							incluindo tempo extra.
						</p>

						<p>
							<strong>Primeiro mapa - vencedor 1x2</strong>: Neste mercado oferecemos-lhe as 3
							opções regulares, que são (Casa - Fora - Empate) e são definidas de acordo com o mapa
							que está em jogo no momento.
						</p>

						<p className="pH2">Mercados CS 2</p>

						<p>
							<strong>Vencedor</strong>: Determinar o vencedor do jogo (x mapas) de acordo com a
							quantidade de mapas oferecidos no evento
						</p>

						<p>
							<strong>Primeiro mapa - total de rodadas (incl. OT)</strong>: Este mercado de apostas
							define se o mapa que está disponível terá mais de 26,5 rodadas ou menos de 26,5
							rodadas incluindo tempo extra que ocorrem no evento.
						</p>

						<p>
							<strong>Primeiro mapa - handicap de ronda (incl. OT)</strong>: Neste mercado de
							apostas pode dar uma vantagem ou desvantagem à equipe X sobre o número total de rondas
							que o mapa selecionado tem. Exemplo de partida Ffamix x Exdt:
						</p>

						<p>
							Ffamix (-2.5) ➔ Este mercado refere que Ffamix vencerá a primeira rodada do mapa mesmo
							dando uma desvantagem de -2,5 pontos (se o mapa terminar 20-10 tendo Ffamix a
							vantagem, ele ainda ganharia a linha de aposta já que ficaria com uma pontuação a seu
							favor de (17,5-10).
						</p>

						<p>
							Exdt (+2,5) ➔ Este mercado significa que o jogador Exdt vencerá as rodadas com uma
							vantagem de +2,5 pontos. Se a pontuação final for 15-15, o vencedor dessas rodadas é a
							Exdt com uma pontuação de 17,5 pontos.
						</p>

						<p>
							<strong>X° Mapa Overtime (sim/não)</strong>: Preveja se haverá uma prorrogação no X°
							Mapa.
						</p>

						<p>
							<strong>Mapa X - Vencedor da 1ª rodada de pistola</strong>: Preveja quem vencerá a 1ª
							rodada de pistola no mapa X.
						</p>

						<p>
							<strong>Mapa X - Vencedor da 2ª rodada de pistola</strong>: Preveja quem vencerá a 2ª
							rodada de pistola no mapa X.
						</p>

						<p>
							<strong>X° Mapa - Equipe que vencerá a Nª rodada</strong>: Preveja qual equipe vencerá
							a Nª rodada do Xº mapa.
						</p>

						<p>
							<strong>X° Mapa - corrida para 3/6/9/12 rodadas</strong>: Preveja qual equipe chegará
							primeiro a 3/6/9/12 rodadas, no X° Mapa.
						</p>

						<p className="pH2">Mercados extras de CS 2</p>

						<p>
							<strong>Equipe a ganhar pelo menos 1 Mapa sim/não</strong>: se uma determinada equipe
							ganha pelo menos um Mapa em determinada Partida.
						</p>

						<p>
							<strong>Prorrogação Sim/Não</strong>: se a prorrogação será jogada ou não.
						</p>

						<p>
							<strong>Vencedor da rodada de pistola (primeira, segunda rodada de pistola)</strong>:
							qual equipe (terrorista/contra-terrorista) ganha a pistola especificada (1./13.)
							rodada.
						</p>

						<p>
							<strong>
								Vencedor do primeiro tempo: qual equipe (Terroristas / Contra-terroristas) tem o
								maior número de rodadas vencidas após as primeiras 12 rodadas.{' '}
							</strong>
						</p>

						<p>
							<strong>
								Vencedor do segundo tempo: qual equipe (Terroristas / Contra-terroristas) tem o
								maior número de rodadas vencidas após as primeiras 12 rodadas e antes que o mapa
								seja concluído como empate ou vencido por uma das equipes.{' '}
							</strong>
						</p>

						<p>
							<strong>
								Duração do Mapa: Refere-se ao tempo total de jogo no mapa, se será acima ou abaixo
								de um valor específico. Caso a duração seja exatamente igual ao valor limite, a
								aposta será resolvida como ACIMA. A duração é determinada com base na tela de
								resultados final, que está disponível através da API oficial do Steam, quando o mapa
								termina.{' '}
							</strong>
						</p>

						<p className="pH2">
							<strong>Mercados Dota2</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor</strong>: Determinar o vencedor do jogo (x mapas) de acordo com a
								quantidade de mapas oferecidos no evento
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mapa X - 1ª égide</strong>: A liquidação da aposta é determinada pela equipe
								que coleta a Égide do Imortal e não por quem mata Roshan.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mapa X - 1ª torre</strong>: Neste mercado de apostas você pode selecionar
								qual das duas equipes destruirá uma torre primeiro.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mapa X - 1º Quartel</strong>: Neste mercado de apostas você pode selecionar
								qual das duas equipes destruirá um quartel primeiro.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro mapa - vencedor</strong>: Este mercado define o vencedor do
								primeiro mapa apenas no tempo normal, não incluindo tempo extra.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Segundo mapa - vencedor</strong>: Este mercado define o vencedor do segundo
								mapa apenas no tempo regulamentar sem incluir tempo extra.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro mapa - abates, empate anula aposta</strong>: Este mercado define o
								vencedor do primeiro mapa em abates alcançados, esclarecendo que se o evento
								terminar empatado, isso será anulado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro mapa - desvantagem de morte</strong>: Neste mercado podemos dar
								vantagem ou desvantagem ao time X selecionado como aquele que terá mais mortes no
								primeiro mapa.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de mapas</strong>: Este mercado refere-se ao número de mapas que o
								jogo terá.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap do Mapa</strong>: aposta em que o vencedor da partida deve ser
								decidido com a respectiva margem do mapa. A pontuação correta é somada ou subtraída
								dos mapas propostos no handicap, e após a referida operação, será determinado quem
								vence: equipe da casa ou equipe visitante.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Equipe para Destruir a Próxima Torre</strong>: Preveja qual equipe
								irá destruir a próxima torre no mapa específico.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Time para desenhar o First Blood</strong>: Preveja qual time fará
								a primeira morte do mapa específico.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Time para marcar mais Kills</strong>: Preveja qual time fará mais
								kills no mapa específico (ou empate).
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Time para marcar a próxima Kill</strong>: Preveja qual time fará o
								próximo kill(#).{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Equipe que vai matar o próximo Roshan</strong>: Preveja qual time
								matará o próximo Roshan(#).
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Total de Kills Ímpar/Par</strong>: Você tem que prever se o número
								total de mortes no X° Mapa será par ou ímpar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Total de Kills Pontuados mais/menos</strong>: Este mercado
								refere-se ao número de mortes que o mapa específico terá.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Total Roshan Slains/roshans mortos</strong>: Este mercado se
								refere ao número exato de Roshans mortos que o mapa específico terá.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Total de Roshans mortos mais/menos</strong>: Este mercado
								refere-se ao número de Roshan mortos que o mapa específico terá (mais/menos).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Xº Mapa - Total de Torres Destruídas</strong>: Este mercado refere-se ao
								número exato de torres que foram destruídas no mapa específico.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Total de Torres Destruídas mais/menos</strong>: Este mercado
								refere-se ao número de torres que foram destruídas no mapa específico (mais/menos).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe para Marcar um Rampage</strong>: Você tem que prever qual time (ou
								nenhum time) irá marcar um Rampage. Rampage é uma conquista distinta de matar
								sozinho 5 campeões inimigos em curta sucessão - Time A/Time B. Se não houver Rampage
								Kill no Mapa, a aposta será considerada como perdida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe para marcar uma Ultra Kill</strong>: Você tem que prever qual time
								(ou nenhum time) irá marcar um Ultra Kill. Uma Ultra Kill é uma conquista distinta
								de matar sozinho 4 campeões inimigos em uma curta sucessão - Equipe A/Equipe B. Se
								não houver Ultra Kill no Mapa, a aposta será considerada como perda.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Tempo de jogo Mais/Menos</strong>: Você tem que prever quantos
								minutos o X° Mapa será jogado - Over/Under.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Tempo para marcar mais Kills Handicap</strong>: aposta em que o
								vencedor da partida deve ser decidido com a respectiva margem de kills. A pontuação
								correta é somada ou subtraída das eliminações propostas no handicap, e após a
								referida operação, será determinado quem vence: time da casa ou time visitante.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Corrida para 5/10/15/20 Kills</strong>: Preveja qual time
								alcançará 5/10/15/20 kills primeiro, no X° Mapa.
							</strong>
						</p>

						<p className="pH2">
							<strong>Mercados Extra de Dota2</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe a ganhar pelo menos 1 Mapa sim/não</strong>: se uma determinada
								equipe ganha pelo menos um Mapa em determinada Partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Duração do Mapa</strong>: se a decorrer/duração final do jogo de um mapa
								está acima ou abaixo de um determinado valor.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Resultante</strong>: Uma duração igual ao limite é resolvida como seleção
								OVER. A duração é resolvida com base na tela de pontuação final, que está disponível
								na API oficial do Steam, quando o mapa termina.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mapa X° Kill</strong>: o vencedor deste mercado é o time que fizer um kill
								forçando a soma do total de kills de ambos os times a ser igual a N.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mapa Rampage</strong>: se pelo menos um jogador, das equipes Dark ou Light,
								marcou 5 ou mais mortes em um curto período de tempo e este evento é anunciado no
								jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mapa Ultrakill</strong>: se pelo menos um jogador, das equipes Dark ou
								Light, marcou 4 ou mais mortes em um curto período de tempo e este evento é
								anunciado no jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mapa Beyond Godlike (Além do Divino)</strong>: se pelo menos um jogador, das
								equipes Dark ou Light marcou 10 ou mais mortes sem morrer e este evento é anunciado
								no jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mapa Megacreeps</strong>: se todos os quartéis das Trevas ou Luzes são
								destruídos e este evento é anunciado no jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mapa Tipo de runa ativada gerada em horário específico do mapa</strong>:
								Tipo de runa, que gera em horário específico do jogo (limiares) e é ativada (ou
								engarrafada e ativada posteriormente) por um dos jogadores.
							</strong>
						</p>

						<p className="pH2">
							<strong>Mercados de League of Legends</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor</strong>: Determinar o vencedor do jogo (x mapas) de acordo com a
								quantidade de mapas oferecidos no evento.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap do Mapa</strong>: aposta em que o vencedor da partida deve ser
								decidido com a respectiva margem do mapa. A pontuação correta é somada ou subtraída
								dos mapas propostos no handicap, e após a referida operação, será determinado quem
								vence: equipe da casa ou equipe visitante.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de mapas</strong>: Este mercado refere-se ao número de mapas que o
								jogo terá.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pontuação exata (nos mapas)</strong>: Este mercado refere-se à pontuação
								exata e final da partida oferecendo as opções:
							</strong>
						</p>

						<p>
							<strong>
								<strong>0</strong>: 2 - 1: 2
							</strong>
						</p>

						<p>
							<strong>
								<strong>2</strong>: 0 - 2: 1
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro mapa - primeiro inibidor</strong>: Neste mercado de apostas você
								pode selecionar qual das duas equipes destruirá um inibidor primeiro no primeiro
								mapa.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro mapa - 1ª torre</strong>: Neste mercado de apostas você pode
								selecionar qual das duas equipes destruirá uma torre primeiro no primeiro mapa.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro mapa - primeiro dragão</strong>: Neste mercado de apostas você pode
								selecionar qual das duas equipes matará um dragão primeiro no primeiro mapa.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro mapa - primeiro barão</strong>: Neste mercado de apostas você pode
								selecionar qual das duas equipes matará um barão primeiro no primeiro mapa.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro mapa - primeira morte</strong>: Neste mercado de apostas você pode
								selecionar qual das duas equipes fará a primeira morte no primeiro mapa.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Equipe para Destruir a Próxima Torre</strong>: Preveja qual equipe
								irá destruir a próxima torre no mapa específico.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Time que vai desenhar o First Blood</strong>: Preveja qual time
								fará a primeira morte do mapa específico.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Time que vai marcar mais Kills</strong>: Preveja qual time fará
								mais kills no mapa específico (ou empate).
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Time para marcar o próximo Kill</strong>: Preveja qual time fará o
								próximo kill.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Total de Kills Ímpar/Par</strong>: Você tem que prever se o número
								total de mortes no X° Mapa será par ou ímpar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Total Kills Scored Mais/Menos</strong>: Este mercado refere-se ao
								número de mortes que o mapa específico terá
							</strong>
						</p>

						<p>
							<strong>
								<strong>Xº Mapa - Total de Torres Destruídas Mais/Menos</strong>: Este mercado
								refere-se ao número de torres que foram destruídas no mapa específico.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Tempo de jogo Mais/Menos</strong>: Você tem que prever quantos
								minutos o X° Mapa será jogado - Mais/Menos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Xº Mapa - Equipe a Marcar Handicap de Mais Kills</strong>: aposta em que o
								vencedor do jogo deve ser decidido com a respectiva margem de abates. A pontuação
								correta é somada ou subtraída das eliminações propostas no handicap, e após a
								referida operação, será determinado quem vence: time da casa ou time visitante.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Corrida para 5/10/15/20 Kills</strong>: Preveja qual time
								alcançará 5/10/15/20 kills primeiro, no X° Mapa.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Xº Mapa - Ambas as Equipes Para Destruir um Inibidor</strong>: Preveja se
								ambas as equipes irão destruir um inibidor no mapa específico ou não.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Ambas as equipes para matar um barão</strong>: Preveja se ambas as
								equipes matarão um barão no mapa específico ou não.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Ambas as equipes para matar um dragão</strong>: Preveja se ambas
								as equipes vão matar um dragão no mapa específico ou não.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Xº Mapa - Equipe para Destruir o Próximo Inibidor</strong>: Preveja qual
								equipe irá destruir o próximo inibidor no mapa específico.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Time que vai matar o próximo barão</strong>: Preveja qual time vai
								matar o próximo barão no mapa específico.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Time que vai matar o próximo dragão</strong>: Preveja qual time
								vai matar o próximo dragão no mapa específico.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Total Barons Slain</strong>: Este mercado refere-se ao número
								exato de Barons mortos que o mapa específico terá.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Total de Barões Mortos mais/menos</strong>: Este mercado refere-se
								ao número de Barões mortos que o mapa específico terá (mais/menos).
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Total Dragons Slain (mortos)</strong>: Este mercado refere-se ao
								número exato de Dragons mortos que o mapa específico terá.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Total Dragons Slain Mais/Menos</strong>: Este mercado refere-se ao
								número de Dragons mortos que o mapa específico terá (mais/menos).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Xº Mapa - Total de Inibidores Destruídos</strong>: Este mercado refere-se ao
								número exato de Inibidores destruídos que o mapa específico terá.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Xº Mapa - Total de Inibidores Destruídos mais/menos</strong>: Este mercado
								refere-se ao número de inibidores destruídos que o mapa específico terá
								(mais/menos).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe para marcar um Penta Kill</strong>: Você tem que prever qual time (ou
								nenhum time) irá marcar um Penta Kill. Um Penta Kill é uma conquista distinta de
								matar sozinho 5 campeões inimigos em uma curta sucessão - Time A/Time B. Se não
								houver Penta Kill no Mapa, a aposta será considerada como perda.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe para marcar um Quadra Kill</strong>: Você tem que prever qual time
								(ou nenhum time) irá marcar um Quadra Kill. Um quadra kill é uma conquista distinta
								de matar sozinho 4 campeões inimigos em uma curta sucessão - Equipe A/Equipe B. Se
								não houver Quadra Kill no Mapa, a aposta será considerada como perda.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Time que vai matar o Rift Herald</strong>: Preveja qual equipe irá
								matar o Rift Herald no mapa específico.
							</strong>
						</p>

						<p className="pH2">
							<strong>Mercados Extras de League of Legends</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe que vencerá pelo menos 1 Mapa sim/não</strong>: se uma determinada
								equipe vencer pelo menos um Mapa em determinada Partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Duração do Mapa</strong>: se a duração/duração final do jogo de um mapa está
								acima ou abaixo de um determinado valor.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Resultante</strong>: Uma duração igual ao limite é resolvida como seleção
								OVER. A duração é resolvida com base na tela de pontuação final, que está disponível
								na API oficial do Steam, quando o mapa termina.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Map X° Kill</strong>: o vencedor deste mercado é o time que fizer um kill
								forçando a soma do total de kills de ambos os times a ser igual a N.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Torres Totais do Mapa</strong>: se a contagem final de torres destruídas
								(com base na pontuação visível no jogo, que é a soma das torres destruídas Vermelhas
								+ Azuis) em um determinado mapa está acima ou abaixo de uma certa figura.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mapa QuadraKill</strong>: se pelo menos um jogador, das equipes Vermelha ou
								Azul, marca 4 ou mais mortes em um curto período de tempo e este evento é anunciado
								no jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mapa PentaKill</strong>: se pelo menos um jogador, das equipes Vermelha ou
								Azul, marcou 5 ou mais mortes em um curto período de tempo e este evento é anunciado
								no jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Map X° Dragon type</strong>: Tipo de primeiro / segundo dragão gerado desde
								o início do mapa.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Map Dragon soul type</strong>: Tipo de terceiro dragão gerado desde o início
								do mapa.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mapa Certo tipo de matança de dragão</strong>: se um dragão de um certo tipo
								será morto pelo menos uma vez em um determinado mapa.
							</strong>
						</p>

						<p className="pH2">
							<strong>Mercados Call of Duty</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor</strong>: Determinar o vencedor do jogo (x mapas) de acordo com a
								quantidade de mapas oferecidos no evento.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap do Mapa</strong>: aposta em que o vencedor da partida deve ser
								decidido com a respectiva margem do mapa. A pontuação correta é somada ou subtraída
								dos mapas propostos no handicap, e após a referida operação, será determinado quem
								vence: equipe da casa ou equipe visitante.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de mapas</strong>: Este mercado refere-se ao número de mapas que o
								jogo terá.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pontuação exata (nos mapas)</strong>: Este mercado refere-se à pontuação
								exata e final da partida oferecendo as opções:
							</strong>
						</p>

						<p>
							<strong>
								<strong>0</strong>: 2 - 1: 2
							</strong>
						</p>

						<p>
							<strong>
								<strong>2</strong>: 0 - 2: 1
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - Equipe que vencerá a Nª rodada</strong>: Preveja qual equipe
								vencerá a Nª rodada do Xº mapa.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa - corrida para 3/6/9/12 rodadas</strong>: Preveja qual equipe
								chegará primeiro a 3/6/9/12 rodadas, no X° Mapa.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Xº mapa - total de rodadas (incl. OT)</strong>: Este mercado de apostas
								define se o mapa que está disponível terá mais de 26,5 rodadas ou menos de 26,5
								rodadas incluindo tempo extra que ocorrem no evento.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mapa X - handicap de rodada (incl. OT)</strong>: Neste mercado de apostas
								você pode dar uma vantagem ou desvantagem à equipe X sobre o número total de rodadas
								que o mapa selecionado possui. Exemplo de partida Ffamix x Exdt:
							</strong>
						</p>

						<p>
							<strong>
								Ffamix (-2.5) ➔ Este mercado refere que Ffamix vencerá a primeira rodada do mapa
								mesmo dando uma desvantagem de -2,5 pontos (se o mapa terminar 20-10 tendo Ffamix a
								vantagem, ele ainda ganharia a linha de aposta já que ficaria com uma pontuação a
								seu favor de (17,5-10).
							</strong>
						</p>

						<p>
							<strong>
								Exdt (+2,5) ➔ Este mercado significa que o jogador Exdt vencerá as rodadas com uma
								vantagem de +2,5 pontos. Se a pontuação final for 15-15, o vencedor dessas rodadas é
								a Exdt com uma pontuação de 17,5 pontos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa Overtime (sim/não)</strong>: Preveja se haverá uma prorrogação no X°
								map.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa Total de Pontos Marcados mais/menos</strong>: Este mercado refere-se
								ao número de pontos marcados que o mapa específico terá.
							</strong>
						</p>

						<p className="pH2">
							<strong>Mercados Overwatch</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor</strong>: Determinar o vencedor do jogo (x mapas) de acordo com a
								quantidade de mapas oferecidos no evento.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap do Mapa</strong>: aposta em que o vencedor da partida deve ser
								decidido com a respectiva margem do mapa. A pontuação correta é somada ou subtraída
								dos mapas propostos no handicap, e após a referida operação, será determinado quem
								vence: equipe da casa ou equipe visitante.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de mapas</strong>: Este mercado refere-se ao número de mapas que o
								jogo terá.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pontuação exata (nos mapas)</strong>: Este mercado refere-se à pontuação
								exata e final da partida oferecendo as opções:
							</strong>
						</p>

						<p>
							<strong>
								<strong>0</strong>: 2 - 1: 2
							</strong>
						</p>

						<p>
							<strong>
								<strong>2</strong>: 0 - 2: 1
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Map - Equipe que vencerá a Nª rodada</strong>: Preveja qual equipe
								vencerá a Nª rodada do Xº mapa.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Map - corrida para 3/6/9/12 rodadas</strong>: Preveja qual equipe chegará
								primeiro a 3/6/9/12 rodadas, no X° Map.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Xº mapa - total de rodadas (incl. OT)</strong>: Este mercado de apostas
								define se o mapa que está disponível terá mais de 26,5 rodadas ou menos de 26,5
								rodadas incluindo tempo extra que ocorrem no evento.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mapa X - handicap de ronda (incl. OT)</strong>: Neste mercado de apostas
								pode dar uma vantagem ou desvantagem à equipe X sobre o número total de rondas que o
								mapa selecionado tem. Exemplo de partida Ffamix x Exdt:
							</strong>
						</p>

						<p>
							<strong>
								Ffamix (-2.5) ➔ Este mercado refere que o Ffamix vencerá a primeira rodada do mapa
								mesmo dando uma desvantagem de -2,5 pontos (se o mapa terminar 20-10 tendo Ffamix a
								vantagem, eles ainda ganhariam a linha de aposta já que ele ficaria com uma
								pontuação a seu favor de (17,5-10).
							</strong>
						</p>

						<p>
							<strong>
								Exdt (+2,5) ➔ Este mercado significa que o jogador Exdt vencerá as rodadas com uma
								vantagem de +2,5 pontos. Se a pontuação final for 15-15, o vencedor dessas rodadas é
								a Exdt com uma pontuação de 17,5 pontos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa Overtime (sim/não)</strong>: Preveja se haverá uma prorrogação no X°
								map.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° Mapa Total de Pontos Marcados mais/menos</strong>: Este mercado refere-se
								ao número de pontos marcados que o mapa específico terá.
							</strong>
						</p>
					</div>
				</details>
				{/* Esportes de Inverno  */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Esportes de Inverno
					</summary>
					<div className="textItem">
						<p>
							<strong>
								Refere-se a esportes de inverno como esqui cross-country, esqui alpino, salto de
								esqui e biatlo. As posições no pódio contarão como resultados oficiais,
								independentemente de qualquer desqualificação posterior. Se não houver cerimônia
								para o pódio, o resultado será determinado de acordo com o resultado oficial
								declarado ao final da competição pela organização reguladora.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Eventos adiados ou cancelados</strong>: Se, por qualquer motivo, um evento
								(exceto os Jogos Olímpicos ou Campeonatos Mundiais) for adiado ou cancelado, todas
								as apostas nesse evento serão anuladas. A menos que a competição ocorra dentro de 48
								horas do horário originalmente programado para começar, ou um resultado oficial seja
								declarado por uma organização reguladora dentro de 48 horas. Se, por qualquer
								motivo, um atleta olímpico ou a competição do Campeonato Mundial for adiada ou
								cancelada, todas as apostas nesse evento serão anuladas. A menos que o evento ocorra
								antes da cerimônia de encerramento dos jogos.
							</strong>
						</p>

						<p className="pH2">
							<strong>Mercados de esportes de inverno:</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor</strong>: Você deve prever o vencedor da competição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pódio</strong>: Você prevê que o competidor selecionado alcançará o pódio
								(primeira, segunda ou terceira posição).
							</strong>
						</p>

						<p>
							<strong>
								<strong>H2H</strong>: Se um dos dois participantes não iniciar, as apostas serão
								anuladas. Se nenhum dos participantes terminar a corrida, as apostas serão anuladas.
								Se um dos participantes conseguir terminar a corrida e o outro não, o primeiro
								mencionado será o vencedor. Se um dos competidores não terminar e o outro não se
								qualificar após a preliminar, o competidor mais bem classificado na preliminar será
								o vencedor. Se nenhum dos participantes se qualificar após a preliminar, o melhor
								colocado na preliminar será o vencedor. Se um dos participantes não conseguir
								terminar depois de ter passado na preliminar e o outro não conseguir passar na
								preliminar, o primeiro mencionado será o vencedor.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Grupo Vencedor</strong>: Você deve prever qual dos competidores
								especificados para este tipo de aposta terá o melhor resultado no evento. Caso
								nenhum dos competidores complete a competição, o vencedor será aquele que obtiver o
								melhor tempo na fase anterior. No caso de competições que consistem em duas
								corridas, se ambos os competidores desistirem na primeira corrida, a aposta será
								declarada nula.
							</strong>
						</p>
					</div>
				</details>
				{/* Floorbol  */}
				<details>
					<summary className="detailsTitle">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="28"
							height="28"
							viewBox="0 0 32 32"
							fill="none"
						>
							<g clipPath="url(#clip0_511_258)">
								<path
									d="M9 5C5.69 5 3 7.69 3 11C3 14.31 5.69 17 9 17C12.31 17 15 14.31 15 11C15 7.69 12.31 5 9 5ZM9 8C9.55 8 10 8.45 10 9C10 9.55 9.55 10 9 10C8.45 10 8 9.55 8 9C8 8.45 8.45 8 9 8ZM7 12C6.45 12 6 11.55 6 11C6 10.45 6.45 10 7 10C7.55 10 8 10.45 8 11C8 11.55 7.55 12 7 12ZM9 14C8.45 14 8 13.55 8 13C8 12.45 8.45 12 9 12C9.55 12 10 12.45 10 13C10 13.55 9.55 14 9 14ZM11 12C10.45 12 10 11.55 10 11C10 10.45 10.45 10 11 10C11.55 10 12 10.45 12 11C12 11.55 11.55 12 11 12Z"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M7.88 26.71L6.81 30.68L9.82 31.49L10.89 27.51L7.88 26.71Z"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M0.06 24.61C-0.16 26.96 1.33 29.21 3.7 29.85L4.87 30.16L5.94 26.19L0.06 24.61Z"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M7.45 20.62L6.27 20.3C4.03 19.7 1.73 20.74 0.65 22.7L6.47 24.26L7.45 20.62Z"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M11.41 25.58L12.41 21.88C12.13 21.84 11.86 21.79 11.58 21.72L9.38 21.13L8.4 24.77L11.42 25.58H11.41Z"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M29.46 0.28C28 -0.11 26.47 0.65 25.9 2.05L19.51 17.78C18.62 19.97 16.69 21.45 14.49 21.84L11.79 31.86C16.79 32.4 21.64 29.56 23.51 24.74L31.47 4.25C32.12 2.58 31.18 0.73 29.45 0.26L29.46 0.28Z"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_511_258">
									<rect width="28" height="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Floorbol
					</summary>
					<div className="textItem">
						<p className="pH2">
							<strong>Principais Mercados</strong>
						</p>
						<p>
							<strong>
								<strong>1X2</strong>: Você tem que prever o resultado de todo o tempo regulamentar
								da partida. Existem 3 resultados possíveis: 1 (o time da casa vence), X (os times
								vão empatar), 2 (o time visitante vence).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap</strong>: Você tem que prever o vencedor de todo o tempo
								regulamentar da partida adicionando ou subtraindo o spread indicado ao resultado da
								partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total (mais/menos)</strong>: Você deve prever se o número total de gols
								marcados durante o tempo regular inteiro da partida será acima ou abaixo da linha
								indicada.
							</strong>
						</p>

						<p className="pH2">
							<strong>Outrights</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor</strong>: Você deve prever o vencedor do torneio de acordo com a
								classificação oficial da competição.
							</strong>
						</p>
					</div>
				</details>
				{/* Futebingo  */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Futebingo
					</summary>
					<div className="textItem">
						<p className="pH2">
							<strong>FUTEBINGO ESTRELABET</strong>
						</p>

						<p>
							<strong>
								Mostre o seu conhecimento em futebol e teste a sua sorte em uma aposta no Futebingo
								EstrelaBet. Você pode dar seus palpites, a partir de R$2,00, em uma sequência de
								jogos e ganhar lucros enormes.
							</strong>
						</p>

						<p className="pH2">
							<strong>O que é o Futebingo?</strong>
						</p>

						<p>
							<strong>
								O Futebingo é uma modalidade de aposta bastante popular ao redor do mundo, e no
								Brasil a EstrelaBet oferece aos seus apostadores. Além do prêmio, ao acertar o
								Futebingo você ganha reconhecimento por mostrar o quanto entende de futebol. Alguns
								jogos são selecionados pela casa e sua tarefa é fazer palpites em cada um desses
								jogos. Se acertar todos os resultados, você será um dos ganhadores do Futebingo.
							</strong>
						</p>

						<p className="pH2">
							<strong>Prêmios do Futebingo</strong>
						</p>

						<p>
							<strong>
								O prêmio do Futebingo é dividido entre todos os apostadores que acertaram seus
								palpites. Apostas ganhas com palpites em partidas em que os favoritos venceram
								tendem a pagar menos, pois serão mais apostadores dividindo o prêmio. No Futebingo
								em que o apostador acerta o palpite em uma zebra, é provável que seu prêmio seja
								maior, pois será dividido com menos pessoas.
							</strong>
						</p>

						<p className="pH2">
							<strong>Resultado Final do Futebingo</strong>
						</p>

						<p>
							<strong>
								O Futebingo 1x2 é muito simples: aqui você simplesmente palpita em quem acredita que
								ganhará os confrontos, ou se preferir, palpita em um empate. Você deve fazer um
								palpite em cada um dos jogos pré-selecionados e acertar todos para ser um dos
								vencedores do Futebingo.
							</strong>
						</p>

						<p className="pH2">
							<strong>Futebingo Score</strong>
						</p>

						<p>
							<strong>
								No Futebingo Score, é essencial que você seja preciso em seus palpites. Para vencer
								nesta modalidade, é necessário acertar o placar exato das partidas pré-selecionadas.
								Em caso de acerto, o prêmio será dividido entre os demais vencedores.
							</strong>
						</p>

						<p className="pH2">
							<strong>Como Apostar no Futebingo</strong>
						</p>

						<p>
							<strong>
								Apostar no Futebingo da EstrelaBet é muito simples, mas vamos te dar mais um
								empurrãozinho com um passo a passo.
							</strong>
						</p>

						<ul>
							<li>
								<strong>Conecte-se à sua conta. Caso ainda não tenha uma, </strong> registre-se aqui
							</li>
							<li>
								<strong>Acesse o nosso lobby no menu lateral.</strong>
							</li>
							<li>
								<strong>
									Faça seus palpites nos jogos pré-selecionados e confirme sua aposta.
								</strong>
							</li>
						</ul>

						<p>
							<strong>Pronto, agora é só cruzar os dedos e torcer!</strong>
						</p>
					</div>
				</details>
				{/* Futebol  */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 28 28"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<g clip-path="url(#clip0_414_716)">
								{' '}
								<path
									d="M4.45018 27.0857C5.81505 28.5029 7.44373 29.6571 9.25591 30.4914L7.6043 27.6457L4.45018 27.0743V27.0857Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M29.7978 7.86286L29.4308 11.3943L31.8853 13.76C31.5871 11.6229 30.8645 9.63429 29.8093 7.86286H29.7978Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M23.5814 30.0914C25.0495 29.3029 26.3799 28.2857 27.5384 27.0971L25.3591 27.6343L23.5928 30.0914H23.5814Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M27.9857 13.1886L22.6753 15.5543L21.1039 20.3657L20.8516 21.1429L25.0265 25.3714L29.7634 24.2057C31.0366 22.0914 31.828 19.6686 32 17.0857L27.9857 13.2V13.1886Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M13.0179 22.5943H13.0065L9.72616 26.7314L12.5591 31.6229C13.6717 31.8629 14.8186 32 16 32C17.2846 32 18.5233 31.8286 19.7161 31.5543L23.1799 26.7429L19.0738 22.5829H13.0179V22.5943Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M2.30538 7.68C1.02079 9.78286 0.194982 12.1943 0 14.7886L2.58065 11.4743L2.30538 7.68Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M17.147 9.96571L17.9498 10.5486L21.8839 13.3943L27.1599 11.0514L27.7792 5.15429C26.529 3.80571 25.0495 2.66286 23.3979 1.80571L17.147 4.58286V9.96571Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M10.1161 13.4057L14.853 9.97714V4.58286L8.60215 1.81714C7.03082 2.62857 5.62007 3.69143 4.41577 4.96L4.86308 11.0743L10.1161 13.4057Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M20.4158 0.628572C19.005 0.228571 17.5254 0 16 0C14.4746 0 12.9835 0.228571 11.5728 0.628572L16 2.59429L20.4158 0.628572Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M7.8681 25.3829L11.1713 21.2343V21.2229L9.32473 15.5657L4.11756 13.2457L0.126165 18.3429C0.447312 20.5371 1.21577 22.5829 2.33978 24.3886L7.85663 25.3829H7.8681Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M13.2817 20.3086H18.7183L20.4043 15.1543L16 11.9657L11.6072 15.1543L13.2817 20.3086Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
							</g>{' '}
							<defs>
								{' '}
								<clipPath id="clip0_414_716">
									{' '}
									<rect
										data-darkreader-inline-fill=""
										fill="white"
										height="28"
										style={{ fill: '#FFFFFF' }}
										width="28"
									></rect>{' '}
								</clipPath>{' '}
							</defs>{' '}
						</svg>
						Futebol
					</summary>
					<div className="textItem">
						<p>
							<strong>
								Alguns dos mercados listados abaixo podem aparecer no E-Soccer (aplicam-se as mesmas
								regras)
							</strong>
						</p>

						<p>
							<strong>
								<strong>1X2 / Resultado Final</strong>: Você tem que prever o resultado do tempo
								regulamentar de toda a partida. Existem 3 resultados possíveis: 1 (o time da casa
								ganha), X (os times vão empatar), 2 (o time visitante ganha).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Dupla chance</strong>: Você tem que prever o resultado do tempo regulamentar
								de toda a partida. Existem 3 resultados possíveis: 1X (no final do jogo o time da
								casa vence ou empata), X2 (no final do jogo o time visitante vence ou empata), 12
								(no final do jogo o time da casa vence ou o time visitante vence).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total (mais/menos)</strong>: Você deve prever se o número total de gols
								marcados durante o tempo regulamentar de toda a partida será acima ou abaixo da
								linha indicada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Para se classificar</strong>: Você deve prever se a equipe indicada vai se
								classificar para a fase seguinte do torneio.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ambos marcam (GG/NG)</strong>: existem dois resultados possíveis: GG (ambas
								as equipes marcam pelo menos um gol cada durante todo o jogo), NG (uma ou ambas as
								equipes não marcam nenhum gol durante todo o jogo).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Empate anula aposta (DNB)</strong>: este mercado de apostas consiste no
								seguinte: para definir uma aposta como vencedora, deve necessariamente haver uma
								equipe vencedora, o que significa que, se a partida terminar empatada, a aposta em
								dinheiro deve ser reembolsada. Por exemplo, se uma pontuação final resultar em
								empate, a aposta será considerada nula.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Próximo gol</strong>: Você tem que prever qual time vai marcar o próximo
								gol. Existem 3 resultados possíveis: 1 (pontuação da equipe da casa), nenhum, 2
								(pontuação da equipe visitante).{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qual equipe vencerá o resto da partida</strong>: Independentemente do placar
								real do evento, no momento de fazer a aposta o placar do evento será considerado
								0-0.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Resultado Correto</strong>: prever o resultado exato de uma partida, ou
								seja, ao final dos 90 minutos do tempo regulamentar, por exemplo: (1-0, 3-0, 2-3…).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap (2 vias)</strong>: aposta em que o vencedor do jogo deve ser
								decidido com a respectiva margem de gols. A pontuação correta é somada ou subtraída
								dos gols propostos no handicap, e após a referida operação, será determinado quem
								vence: equipe da casa, empate ou equipe visitante.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap (3 vias)</strong>: Você deve prever o resultado final da partida
								levando em consideração o handicap entre parênteses.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Por exemplo</strong>: (0:1) indica que o time visitante tem um gol de
								vantagem, já para (1:0) indica que o time da casa tem um gol de vantagem.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Tipos de apostas disponíveis neste mercado</strong>:
							</strong>
						</p>

						<p>
							<strong>
								<strong>➔ 1H (0:1)</strong>: O time da casa vencerá a partida com 2 ou mais gols de
								diferença.
							</strong>
						</p>

						<p>
							<strong>
								<strong>➔ XH (0:1)</strong>: A equipe da casa vencerá o jogo com 1 gol de diferença.
							</strong>
						</p>

						<p>
							<strong>
								<strong>➔ 2H (0:1)</strong>: O time visitante vencerá a partida ou irá empatar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>➔ 1H (0:2)</strong>: O time da casa vencerá a partida com 3 ou mais gols de
								diferença.
							</strong>
						</p>

						<p>
							<strong>
								<strong>➔ XH (0:2)</strong>: O time da casa vencerá a partida com 2 gols de
								diferença.
							</strong>
						</p>

						<p>
							<strong>
								<strong>➔ 2H (0:2)</strong>: O time visitante vencerá a partida, irá empatar ou
								perder com 1 gol de diferença.
							</strong>
						</p>

						<p>
							<strong>
								<strong>➔ 1H (0:3)</strong>: O time da casa vencerá a partida com 4 ou mais gols de
								diferença.
							</strong>
						</p>

						<p>
							<strong>
								<strong>➔ XH (0:3)</strong>: O time da casa vencerá a partida com 3 gols de
								diferença.
							</strong>
						</p>

						<p>
							<strong>
								<strong>➔ 2H (0:3)</strong>: O time visitante vencerá a partida, irá empatar ou
								perder com 1 ou 2 gols de diferença.
							</strong>
						</p>

						<p>
							<strong>
								<strong>➔ 1H (1:0)</strong>: O time da casa vencerá a partida ou irá empatar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>➔ XH (1:0)</strong>: A equipe visitante vencerá o jogo com 1 gol de
								diferença.
							</strong>
						</p>

						<p>
							<strong>
								<strong>➔ 2H (1:0)</strong>: O time visitante vencerá a partida com 2 ou mais gols
								de diferença.
							</strong>
						</p>

						<p>
							<strong>
								<strong>➔ 1H (2:0)</strong>: O time da casa vencerá a partida, irá empatar ou perder
								com 1 gol de diferença.
							</strong>
						</p>

						<p>
							<strong>
								<strong>➔ XH (2:0)</strong>: O time visitante vencerá a partida com 2 gols de
								diferença.
							</strong>
						</p>

						<p>
							<strong>
								<strong>➔ 2H (2:0)</strong>: O time visitante vencerá a partida com 3 ou mais gols
								de diferença.
							</strong>
						</p>

						<p>
							<strong>
								<strong>➔ 1H (3:0)</strong>: O time da casa vencerá a partida, irá empatar ou perder
								com 1 ou 2 gols de diferença.
							</strong>
						</p>

						<p>
							<strong>
								<strong>➔ XH (3:0)</strong>: O time visitante vencerá a partida com 3 gols de
								diferença.
							</strong>
						</p>

						<p>
							<strong>
								<strong>➔ 2H (3:0)</strong>: O time visitante vencerá a partida com 4 ou mais gols
								de diferença.
							</strong>
						</p>

						<p className="pH2">
							<strong>Pagamentos por Linhas Asiáticas</strong>
						</p>

						<p>
							<strong>
								Aplica-se a todos os mercados que podem ter linhas asiáticas como seleções
								disponíveis em todos os esportes (pontos/sets/jogos/rodadas/etc).
							</strong>
						</p>

						<div>
							<table>
								<thead>
									<tr>
										<th scope="col">
											<strong>Seleção de linha de gol asiática</strong>
										</th>
										<th scope="col">
											<strong>Total de gols marcados</strong>
										</th>
										<th scope="col">
											<strong>Resultado da Seleção</strong>
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Mais de 0.5</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>0</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Mais de 0.5</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>1 ou mais</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Mais de 0.75</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>0</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Mais de 0.75</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>1</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Metade Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Mais de 0.75</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>2 ou mais</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Mais de 1</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>0</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdido</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Mais de 1</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>1</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Devolvida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Mais de 1</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>2 ou mais</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Mais de 1.25</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>0</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Mais de 1.25</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>1</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Metade Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Mais de 1.25</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>2 ou mais</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Mais de 1.5</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>1 ou menos</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Mais de 1.5</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>2 ou mais</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Mais de 1.75</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>1 ou menos</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Mais de 1.75</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>2</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Metade Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Mais de 1.75</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>3 ou mais</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Mais de 2</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>1 ou menos</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Mais de 2</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>2</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Devolvida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Mais de 2</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>3 ou mais</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div>
							<table>
								<thead>
									<tr>
										<th scope="col">
											<strong>Seleção de linha de gol asiática</strong>
										</th>
										<th scope="col">
											<strong>Total de gols marcados</strong>
										</th>
										<th scope="col">
											<strong>Resultado da Seleção</strong>
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Menos 0.5</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>0</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Menos 0.5</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>1 ou mais</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Menos 0.75</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>0</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Menos 0.75</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>1</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Metade Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Menos 0.75</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>2 ou mais</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Menos 1</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>0</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Menos 1</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>1</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Devolvida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Menos 1</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>2 ou mais</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Menos 1.25</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>0</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Menos 1.25</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>1</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Metade Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Menos 1.25</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>2 ou mais</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Menos 1.5</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>1 ou menos</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Menos 1.5</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>2 ou mais</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Menos 1.75</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>1 ou menos</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Menos 1.75</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>2</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Metade Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Menos 1.75</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>3 ou mais</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Menos 2</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>1 ou menos</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Menos 2</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>2</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Devolvida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de linha de gol asiática">
											<strong>Menos 2</strong>
										</td>
										<td data-label="Total de gols marcados">
											<strong>3 ou mais</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<p>
							<strong>
								<strong>Explicação dos resultados semi-ganhos/meio-perdidos</strong>: Uma seleção
								semi-ganha tem metade da aposta considerada como ganha e a outra metade considerada
								como nula. Uma seleção meio perdida tem metade da aposta considerada perdida e a
								outra metade considerada nula.
							</strong>
						</p>

						<p>
							<strong>Tabela de handicap de 2 vias</strong>
						</p>

						<div>
							<table>
								<thead>
									<tr>
										<th scope="col">
											<strong>Seleção de Handicap de 2 vias</strong>
										</th>
										<th scope="col">
											<strong>Resultado Final</strong>
										</th>
										<th scope="col">
											<strong>Resultado da Seleção</strong>
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (-0)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A vence</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (-0)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Empate</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Devolvida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (-0)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A perde</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (-0.25)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A vence</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (-0.25)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Empate</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Metade Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (-0.25)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A perde</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (-0.5)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A vence</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (-0.5)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Empate ou Equipe A Perde</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (-0.75)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A vence por 1 gol</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Metade Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (-0.75)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A vence por 2 ou mais gols</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (-0.75)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Empate ou Equipe A Perde</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (-1)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A vence por 1 gol</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Devolvida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (-1)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A vence por 2 ou mais gols</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (-1)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Empate ou Equipe A Perde</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (-1.25)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A vence por 1 gol</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Metade Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (-1.25)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A vence por 2 ou mais gols</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (-1.25)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Empate ou Equipe A Perde</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (-1.5)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A vence por 2 ou mais gols</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (-1.5)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A vence por 1 gol ou Empate ou Equipe A Perde </strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div>
							<table>
								<thead>
									<tr>
										<th scope="col">
											<strong>Seleção de Handicap de 2 vias</strong>
										</th>
										<th scope="col">
											<strong>Resultado Final</strong>
										</th>
										<th scope="col">
											<strong>Resultado da Seleção</strong>
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (+0)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A vence</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (+0)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Empate</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Devolvida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (+0)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A perde</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (+0.25)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A vence</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (+0.25)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Empate</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Metade Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (+0.25)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A perde</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (+0.5)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A vence ou empata</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (+0.5)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A perde</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (0.75)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A vence ou empata</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (0.75)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A perde por 1 gol</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Metade Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (0.75)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A perde por 2 ou mais gols</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (+1)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A vence ou empata</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (+1)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A perde por 1 gol</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Devolvida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (+1)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A perde por 2 ou mais gols</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (+1.25)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A vence ou empata</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (+1.25)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A perde por 1 gol</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Metade Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (+1.25)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A perde por 2 ou mais gols</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (+1.5)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A vence ou empata ou perde por 1 gol</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Ganha</strong>
										</td>
									</tr>
									<tr>
										<td data-label="Seleção de Handicap de 2 vias">
											<strong>Equipe A (+1.5)</strong>
										</td>
										<td data-label="Resultado Final">
											<strong>Equipe A perde por 2 ou mais gols</strong>
										</td>
										<td data-label="Resultado da Seleção">
											<strong>Perdida</strong>
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<p>
							<strong>
								<strong>Explicação dos resultados semi-ganhos/meio-perdidos</strong>: Uma seleção
								semi-ganha tem metade da aposta considerada como ganha e a outra metade considerada
								como nula. Uma seleção meio perdida tem metade da aposta considerada perdida e a
								outra metade considerada nula.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Intervalo / Final do Jogo</strong>: Você deve prever o resultado do 1º tempo
								da partida junto com o resultado o tempo regular de toda a partida. Os resultados
								possíveis são: (1/1, 1/X, 1/2, X/1, X/X, X/2, 2/1, 2/X e 2/2).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Último Gol</strong>: Neste mercado devemos prever qual das duas equipes
								marcará o último Gol deste jogo. Se você selecionou a opção Nenhum, está indicando
								que não serão marcados mais gols.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Margem de vitória</strong>: neste tipo de aposta, você prevê qual time
								vencerá e por quanto de margem vencerá.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total time de casa</strong>: Você tem que prever se o número total de gols
								marcados, do mandante, durante o tempo regulamentar de toda a partida será superior
								ou inferior a linha indicada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total da equipe visitante</strong>: Você deve prever se o número total de
								gols marcados, da equipe visitante, durante o tempo regulamentar de toda a partida
								será superior ou inferior a linha indicada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Gols Exatos</strong>: Você deve prever o número exato de gols marcados
								durante a partida. Os resultados possíveis são 0 gols, 1,2,3,4,5+.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qual equipe marcar</strong>: consiste em prever se apenas a equipe da casa,
								a equipe visitante, ambas as equipes ou nenhuma irá marcar na partida. Consiste em
								selecionar SIM ou NÃO se um dos seguintes mercados de apostas disponíveis na seção
								especial for escolhido.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Casa devolve aposta (1 devolve aposta)</strong>: Você deve prever se o time
								visitante vencerá a partida ou se a partida irá terminar empatada. Se o time da casa
								vencer a partida, a aposta será considerada nula.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Visitante devolve aposta (2 devolve aposta)</strong>: Você tem que prever se
								o time da casa vencerá a partida ou se a partida terminará empatada. Se o time
								visitante vencer a partida, a aposta será considerada nula.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Gols Exatos da Casa</strong>: Você deve prever o número exato de gols
								marcados pela equipe da casa durante a partida. Os resultados possíveis são 0 gols,
								1,2,3+.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Gols Exatos Fora</strong>: Você deve prever o número exato de gols marcados
								pela equipe visitante durante a partida. Os resultados possíveis são 0 gols, 1,2,3+.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ímpar/Par</strong>: Você tem que prever se o resultado da partida é um
								número par ou ímpar, se o resultado da partida for "0:0″, as apostas são contadas
								como "par".
							</strong>
						</p>

						<p>
							<strong>
								<strong>Casa Ímpar/Par</strong>: Você deve prever se o número de gols marcados pela
								equipe da casa durante o tempo regulamentar de toda a partida será par ou ímpar. Se
								o time da casa não marcar nenhum gol, a seleção vencedora é par.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Fora Ímpar/Par</strong>: Você deve prever se o número de gols marcados pela
								equipe visitante durante o tempo regulamentar de toda a partida será par ou ímpar.
								Se o time da casa não marcar nenhum gol, a seleção vencedora é par.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time da casa marcará</strong>: Você deve prever se o time da casa marcará
								pelo menos um gol durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Fora de casa para marcará</strong>: Você tem que prever se a equipe
								visitante vai marcar pelo menos um gol durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Multigols</strong>: Você deve prever o número de gols marcados durante a
								partida com base nos diferentes intervalos oferecidos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Multigols da casa</strong>: Você deve prever o número de gols marcados pelo
								time da casa durante a partida com base nos diferentes intervalos oferecidos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Multigols fora de casa</strong>: Você deve prever o número de gols marcados
								pela equipe visitante durante a partida com base nos diferentes intervalos
								oferecidos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Próximo tipo de pontuação</strong>: Você deve prever o tipo de pontuação
								entre os seguintes resultados:
							</strong>
						</p>

						<p>
							<strong>
								<strong>➔ Tiro livre</strong>: O gol deve ser marcado diretamente de uma cobrança de
								falta ou escanteio para se qualificar como gol por tiro livre. Chutes desviados
								contam desde que o gol seja concedido ao cobrador de falta ou escanteio;
							</strong>
						</p>

						<p>
							<strong>
								<strong>➔ Pênalti</strong>: O gol deve ser marcado diretamente do pênalti. Gols após
								um rebote de um pênalti perdido não contam.
							</strong>
						</p>

						<p>
							<strong>
								<strong>➔ Gol Contra</strong>: Se o gol for declarado como um gol contra;
							</strong>
						</p>

						<p>
							<strong>
								<strong>➔ Cabeceio</strong>: O último toque do marcador tem que ser com a cabeça;
							</strong>
						</p>

						<p>
							<strong>
								<strong>➔ Chute</strong>: Gol tem que ser com qualquer outra parte do corpo que não
								a cabeça e os outros tipos não se aplicam;
							</strong>
						</p>

						<p>
							<strong>
								<strong>➔ Nenhum gol</strong>
							</strong>
						</p>

						<p>
							<strong>
								<strong>Haverá uma disputa de pênaltis</strong>: Você tem que prever se na partida
								haverá uma disputa de pênaltis
							</strong>
						</p>

						<p>
							<strong>
								<strong>Prorrogação Sim/Não</strong>: Você deve prever se a partida irá para a
								prorrogação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Método de Vitória</strong>: Você deve prever o método de vitória do time da
								casa ou do time visitante. Existem seis (6) resultados possíveis oferecidos:
							</strong>
						</p>

						<p>
							<strong>➔ Equipe da casa vence no tempo regulamentar</strong>
						</p>

						<p>
							<strong>➔ Equipe visitante vence no tempo regulamentar</strong>
						</p>

						<p>
							<strong>➔ Equipe da casa vence na prorrogação</strong>
						</p>

						<p>
							<strong>➔ Equipe visitante vence na prorrogação</strong>
						</p>

						<p>
							<strong>➔ Equipe da casa vence após pênaltis</strong>
						</p>

						<p>
							<strong>➔ Equipe visitante vence após pênaltis</strong>
						</p>

						<p>
							<strong>
								<strong>Prorrogação e gol</strong>: Você tem que prever se a partida irá para a
								prorrogação e se haverá um gol (Sim) ou não (Não).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Prorrogação - 1x2</strong>: Você tem que prever o resultado 1X2 apenas do
								período de Prorrogação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Prorrogação - qual equipe ganhará o resto</strong>: Independentemente do
								placar real do evento, no momento de fazer a aposta o placar do evento será
								considerado 0-0. O mercado considerará apenas tempo extra.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Prorrogação - próximo gol</strong>: Você deve prever qual Equipe durante o
								período Prorrogação marcará o próximo gol. Existem 3 resultados possíveis: 1 (gol da
								equipe da casa), nenhum, 2 (gol da equipe visitante).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Prorrogação - total</strong>: Você tem que prever se o número total de gols
								marcados apenas durante a prorrogação será acima ou abaixo do spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Prorrogação - handicap</strong>: Você deve prever o resultado final da
								Prorrogação levando em consideração o handicap entre parênteses. Por exemplo, (0:1)
								indica que o time visitante tem um gol de vantagem, já para (1:0) indica que o time
								da casa tem um gol de vantagem.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Prorrogação - resultado exato</strong>: Você tem que prever a pontuação
								correta da Prorrogação apenas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Cobrança de pênaltis - vencedor</strong>: Você tem que prever qual time
								vencerá a disputa de pênaltis (1-2).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Cobrança de pênaltis - xº pênalti marcado</strong>: Você deve prever se o
								pênalti "x" será marcado ou não durante a disputa de pênaltis.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Cobrança de pênaltis - xº gol</strong>: Você deve prever qual time fará o
								gol "x" durante a disputa de pênaltis. 3 Resultados possíveis: 1, X, 2.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Cobrança de pênaltis - margem de vitória</strong>: Você tem que prever a
								margem de vitória para a disputa de pênaltis para o time da casa ou visitante, ou se
								a partida termina empatada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Cobrança de pênaltis - total</strong>: Você tem que prever se o total de
								gols marcados durante a disputa de pênaltis será Acima ou Abaixo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Cobrança de pênaltis - Total da casa</strong>: Você deve prever se o total
								de gols marcados pela equipe da casa durante a disputa de pênaltis será Acima ou
								Abaixo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Cobrança de pênaltis - Total visitante</strong>: Você deve prever se o total
								de gols marcados pela equipe visitante durante a disputa de pênaltis será Acima ou
								Abaixo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Cobrança de pênaltis - gols exatos</strong>: Você tem que prever se os gols
								exatos marcados durante a disputa de pênaltis. 7 são os resultados possíveis:
								0-4,5,6,7,8,9,10+.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Cobrança de pênaltis - par/ímpar</strong>: Você deve prever se o número de
								gols marcados durante o período de cobrança de pênaltis será par ou ímpar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Cobrança de pênaltis - Casa ímpar/par</strong>: Você deve prever se o número
								de gols marcados pela equipe da casa durante o período de cobrança de pênaltis será
								par ou ímpar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Cobrança de pênaltis - Visitante ímpar/par</strong>: Você deve prever se o
								número de gols marcados pela equipe visitante durante o período de pênaltis será par
								ou ímpar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Cobrança de pênaltis - resultado exato</strong>: Você deve prever a
								pontuação correta durante o período de disputa de pênaltis.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Cobrança de pênaltis - vencedor e total</strong>: Você deve prever o
								resultado 1X2 da disputa de pênaltis junto com o número de gols marcados
								considerando a linha indicada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>
									Resultado no intervalo da prorrogação (incluindo gols no tempo normal)
								</strong>
								: você tem que prever o resultado do 1º tempo da prorrogação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Prorrogação Xª equipe a marcar (incluindo gols no tempo normal)</strong>:
								Você tem que prever qual equipe marcará o X gol na prorrogação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>
									Placar correto no intervalo da prorrogação (incluindo gols no tempo normal)
								</strong>
								: Você tem que prever o placar correto no final do 1º tempo da prorrogação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Prorrogação 1º Tempo Total de gols (incluindo gols no tempo normal)</strong>
								: Você tem que prever o número de gols (a maior/a menor) no 1º tempo da prorrogação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>
									Handicap asiático no intervalo do tempo extra (incluindo gols no tempo normal)
								</strong>
								: Você tem que prever o resultado do 1º tempo da prorrogação, levando em
								consideração o handicap entre parênteses.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Resultado após X minutos</strong>: Você tem que prever o resultado da
								partida após X minutos.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de gols a mais/ a menos após X minutos</strong>: Você tem que prever o
								número de gols (a mais/ a menos) após X minutos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap Asiático Após X Minutos</strong>: Você tem que prever o resultado
								após X minutos, levando em consideração o handicap entre parênteses.
							</strong>
						</p>

						<p className="pH2">
							<strong>Mercados do primeiro tempo</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - 1x2</strong>: Você só tem que prever o resultado do primeiro
								tempo da partida. Os gols marcados no segundo tempo não contam.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Total</strong>: Você tem que prever se o número total de gols
								marcados apenas durante o primeiro tempo será acima ou abaixo do indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - qual equipe ganha o resto</strong>: Independentemente do placar
								real do evento, no momento de fazer a aposta o placar do evento será considerado
								0-0. O mercado considerará apenas o 1º tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Próximo gol</strong>: Você tem que prever qual Time durante o 1º
								tempo marcará o próximo gol. Existem 3 resultados possíveis: 1 (gol da equipe da
								casa), nenhum, 2 (gol da equipe visitante).
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - chance dupla</strong>: Você tem que prever o resultado do 1º
								tempo. Existem 3 resultados possíveis: 1X (no final do 1º tempo o time da casa vence
								ou empata), X2 (no final do 1º tempo o time visitante vence ou empata), 12 (no final
								do 1º tempo vitória do time da casa ou vitória do time visitante).
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - empate anula aposta</strong>: Você tem que prever qual time irá
								vencer apenas o primeiro tempo da partida. Se o primeiro tempo terminar empatado, a
								seleção será anulada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap do 1º Tempo (2 Vias)</strong>: Você deve prever o resultado final
								do primeiro tempo da partida levando em consideração o handicap entre parênteses.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap 1º Tempo (3 Vias)</strong>: Você deve prever o resultado final do
								primeiro tempo da partida levando em consideração o handicap entre parênteses. Por
								exemplo, (0:1) indica que o time visitante tem um gol de vantagem, já para (1:0)
								indica que o time da casa tem um gol de vantagem.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - gols exatos do competidor 1</strong>: Você deve prever o número
								de gols que serão marcados pela equipe da casa durante o primeiro tempo da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - competidor 2 gols exatos</strong>: Você deve prever o número de
								gols que serão marcados pela equipe visitante durante o primeiro tempo da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - par/ímpar</strong>: Você tem que prever se o número de gols
								marcados apenas durante o primeiro tempo será par ou ímpar. A linha de pontuação do
								intervalo 0-0 é considerada par.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - ambas as equipes marcam</strong>: Você tem que prever se ambas as
								equipes marcam pelo menos um gol cada durante o primeiro tempo OU apenas uma equipe
								ou ambas as equipes NÃO marcam nenhum gol durante o primeiro tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Sem sofrer gols em casa</strong>: Clean sheet é um termo usado
								para descrever uma equipe que não sofreu nenhum gol. Você tem que prever se o time
								da casa não sofrerá gols durante o primeiro tempo da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1ª tempo - Sem sofrer gols fora</strong>: Não sofrer gols é um termo usado
								para descrever uma equipe que não sofreu gols. Você tem que prever se a equipe
								visitante não sofrerá gols durante a primeira metade da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1ª tempo - 1x2 &amp; ambas as equipes a marcar</strong>: Tem de prever o
								resultado do primeiro tempo e se ambas as equipes irão marcar ou não apenas no
								primeiro tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - 1x2 &amp; total</strong>: Você tem que prever a combinação do
								resultado do primeiro tempo e se o número total de gols marcados no primeiro tempo
								será acima ou abaixo do indicado. Existem 6 resultados possíveis:
							</strong>
						</p>

						<p>
							<strong>
								➔ 1&amp;Ac=O time da casa vence o primeiro tempo e o total de gols está acima da
								linha indicada
							</strong>
						</p>

						<p>
							<strong>
								➔ 1&amp;Ab=O time da casa vence o primeiro tempo e o total de gols está abaixo da
								linha indicada
							</strong>
						</p>

						<p>
							<strong>
								➔ X&amp;Ac= O primeiro tempo termina empatado e o total de gols é superior a linha
								indicada
							</strong>
						</p>

						<p>
							<strong>
								➔ X&amp;Ab= O primeiro tempo termina empatado e o total de gols está abaixo da linha
								indicada
							</strong>
						</p>

						<p>
							<strong>
								➔ 2&amp;Ac= O time visitante vence o primeiro tempo e o total de gols está acima da
								linha indicada{' '}
							</strong>
						</p>

						<p>
							<strong>
								➔ 2&amp;Ab= O time visitante vence o primeiro tempo e o total de gols está abaixo da
								linha indicada{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - resultado correto</strong>: Você tem que prever o resultado
								correto do primeiro tempo da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - multigols</strong>: Você deve prever o número de gols marcados
								durante o 1º tempo com base nas diferentes opções oferecidas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º Tempo Casa para marcar</strong>: Você deve prever se o time da casa
								marcará pelo menos um gol durante o 1º Tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º Tempo Fora para Marcar</strong>: Você deve prever se o time visitante
								marcará pelo menos um gol durante o 1º Tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Chance dupla e ambas marcam</strong>: Você tem que prever o resultado do 1º
								Tempo com 3 possíveis resultados de dupla chance (1X, 12 e X2) e se ambas as equipes
								marcarão no 1º tempo ou não.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Multigols no 1º tempo</strong>: Você deve prever o número de gols marcados
								durante o 1º tempo com base em diferentes opções.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º Tempo 1X2 ou GG/NG</strong>: Você tem que prever o resultado da vitória
								do 1º Tempo OU se ambas, uma ou nenhuma equipe marcará no 1º Tempo. Apenas uma
								previsão deve ocorrer para que a aposta seja vencedora.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Último Gol no 1º Tempo</strong>: Você tem que prever a equipe que marcará o
								último gol no primeiro tempo da partida.
							</strong>
						</p>

						<p>
							1º tempo - Total de chutes a gol: Você deve prever o número total de chutes a gol
							cobrados por ambas as equipes combinadas durante o primeiro tempo.
						</p>

						<p>
							<strong>
								<strong>Mercados do segundo tempo</strong>
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - 1x2</strong>: Você só tem que prever o resultado do segundo tempo
								da partida. Gols marcados no primeiro tempo da partida não contam.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - Total</strong>: Você tem que prever se o número total de gols
								marcados apenas durante o segundo tempo será acima ou abaixo da linha indicada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - qual equipe ganha o resto</strong>: Independentemente do placar
								real do evento, no momento de fazer a aposta o placar do evento será considerado
								0-0. O mercado considerará apenas o segundo tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - Próximo gol</strong>: Você tem que prever qual Time durante o
								segundo tempo marcará o próximo gol. Existem 3 resultados possíveis: 1 (o resultado
								da equipe da casa), nenhum , 2 (o resultado da equipe visitante).
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - chance dupla</strong>: Você tem que prever o resultado do segundo
								tempo. Existem 3 resultados possíveis: 1X (no final do segundo tempo o time da casa
								ganha ou empata), X2 (no final do segundo tempo o time visitante ganha ou empata),
								12 (no final do segundo tempo vitória do time da casa ou vitória do time visitante).
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - empate anula aposta</strong>: Você tem que prever qual time
								vencerá apenas o segundo tempo da partida. Se o segundo tempo terminar empatado, a
								seleção será anulada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap 2º Tempo (2 Vias)</strong>: Você deve prever o resultado final do
								segundo tempo da partida levando em consideração o handicap entre parênteses.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap 2º Tempo (3 Vias)</strong>: Você deve prever o resultado final do
								segundo tempo da partida levando em consideração o handicap entre parênteses. Por
								exemplo, (0:1) indica que o time visitante tem um gol de vantagem, já para (1:0)
								indica que o time da casa tem um gol de vantagem.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - gols exatos do competidor 1</strong>: Você deve prever o número
								de gols que serão marcados pela equipe da casa durante o segundo tempo da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - gols exatos do competidor 2</strong>: Você deve prever o número
								de gols que serão marcados pela equipe visitante durante o segundo tempo da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - par/ímpar</strong>: Você tem que prever se o número de gols
								marcados apenas durante o segundo tempo será par ou ímpar. A linha de pontuação 0-0
								é considerada par.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - ambas as equipes marcam</strong>: Você tem que prever se ambas as
								equipes marcam pelo menos um gol cada durante o segundo tempo OU apenas uma equipe
								ou ambas as equipes NÃO marcam nenhum gol durante o segundo tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - Sem sofrer gols em casa</strong>: Clean Sheet é um termo usado
								para descrever uma equipe que não sofreu nenhum gol. Você tem que prever se o time
								da casa não sofrerá gols durante o segundo tempo da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2ª parte - Sem sofrer gols fora</strong>: Clean Sheet é um termo usado para
								descrever uma equipe que não sofreu gols. Você tem que prever se a equipe visitante
								não sofrerá gols durante o segundo tempo da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - 1x2 &amp; ambas as equipes marcam</strong>: Você tem que prever o
								resultado do segundo tempo e se ambas as equipes marcarão ou não apenas no segundo
								tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - 1x2 &amp; total</strong>: Você tem que prever a combinação do
								resultado do segundo tempo da partida e se o número total de gols marcados no
								segundo tempo estará acima ou abaixo da linha indicada. Existem 6 resultados
								possíveis:
							</strong>
						</p>

						<p>
							<strong>
								<strong>1&amp;Mais</strong>: O time da casa vence o segundo tempo e o total de gols
								está acima da linha indicada
							</strong>
						</p>

						<p>
							<strong>
								<strong>1&amp;Menos</strong>: O time da casa vence o segundo tempo e o total de gols
								está abaixo da linha indicada
							</strong>
						</p>

						<p>
							<strong>
								<strong>X&amp;Mais</strong>: O segundo tempo termina empatado e o total de gols está
								acima da linha indicada
							</strong>
						</p>

						<p>
							<strong>
								<strong>X&amp;Menos</strong>: O segundo tempo termina empatado e o total de gols
								está abaixo da linha indicada
							</strong>
						</p>

						<p>
							<strong>
								<strong>2&amp;Mais</strong>: O time visitante vence o segundo tempo e o total de
								gols está acima da linha indicada
							</strong>
						</p>

						<p>
							<strong>
								<strong>2&amp;Menos</strong>: O time visitante vence o segundo tempo e o total de
								gols está abaixo da linha indicada
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - resultado correto</strong>: Você deve prever o resultado correto
								do segundo tempo da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - multigols</strong>: Você deve prever o número de gols marcados
								durante o segundo tempo com base nos diferentes intervalos oferecidos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º Tempo Fora para Marcar</strong>: Você deve prever se o time da casa
								marcará pelo menos um gol durante o segundo tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º Tempo Fora para Marcar</strong>: Você tem que prever se o time visitante
								marcará pelo menos um gol durante o segundo tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Dupla Chance do 2º Tempo e GG (ambas marcam)/NG (nenhuma marca)</strong>:
								Você deve prever o resultado do segundo tempo com 3 possíveis resultados de dupla
								chance (1X, 12 e X2) e se ambas as equipes marcarão ou não na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo multigols</strong>: Você deve prever o número de gols marcados
								durante o segundo tempo com base nos diferentes intervalos oferecidos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º Tempo 1X2 ou GG (ambas marcam)/NG (nenhuma marca)</strong>: Você tem que
								prever o resultado vencedor do segundo tempo OU se ambas, uma ou nenhuma equipe
								marcará no segundo tempo. Apenas uma previsão deve ocorrer para que a aposta seja
								vencedora.
							</strong>
						</p>

						<p>
							2º tempo - Total de chutes a gol: Você deve prever o número total de chutes a gol
							cobrados por ambas as equipes combinadas durante o segundo tempo
						</p>

						<p>
							<strong>
								<strong>Último Gol no 2º Tempo</strong>: Você deve prever o time que marcará o
								último gol no segundo tempo da partida.
							</strong>
						</p>

						<p className="pH2">
							<strong>Mercados Combinados</strong>
						</p>

						<p>
							<strong>
								<strong>1X2 &amp; GG (ambas marcam)</strong>: Você tem que prever se ambas as
								equipes marcam e o resultado da partida junto com o resultado final. 6 resultados
								possíveis são oferecidos:
							</strong>
						</p>

						<p>
							<strong>
								<strong>1&amp;GG</strong>: A equipe da casa vencerá e ambas as equipes marcarão;
							</strong>
						</p>

						<p>
							<strong>
								<strong>X&amp;GG</strong>: As equipes empatam e ambas as equipes marcam;
							</strong>
						</p>

						<p>
							<strong>
								<strong>2&amp;GG</strong>: A equipe visitante vencerá e ambas as equipes marcam;
							</strong>
						</p>

						<p>
							<strong>
								<strong>1&amp;NG</strong>: O time da casa vencerá e pelo menos um time não marcará;
							</strong>
						</p>

						<p>
							<strong>
								<strong>X&amp;NG</strong>: As equipes vão empatar e pelo menos uma equipe não vai
								marcar;
							</strong>
						</p>

						<p>
							<strong>
								<strong>2&amp;NG</strong>: A equipe visitante vencerá e pelo menos uma equipe não
								marcará.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total &amp; GG Ambas equipes marcam sim ou não</strong>: Você tem que prever
								o mercado Total (Menos/Mais gols) junto com ambas as equipes marcam pelo menos um
								gol cada durante toda a partida (sim) ou uma ou ambas as equipes não marcam nenhum
								gol durante toda a partida (não). A aposta oferece 4 resultados possíveis: Acima de
								Abaixo de&amp;não; Abaixo de&amp;sim, Abaixo de&amp;não.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>1X2 &amp; mais/menos</strong>: Você deve prever o resultado da partida
								juntamente com o número de gols marcados durante a partida considerando o intervalo
								indicado. Seis resultados são possíveis: 1&amp;Mais de "X" ; X&amp;Mais de "X";
								2&amp;Mais de "X"; 1&amp;Menos de "X"; X&amp;Menos de "X"; 2&amp;Menos de "X".
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º/2º tempo Ambas equipes marcam</strong>: Você tem que prever o resultado
								do intervalo/final do jogo junto com ambas as equipes. 4 resultados possíveis são
								oferecidos: Não/não, Sim/não, Sim/Sim, Não/Sim.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total 2.5 ou Ambas equipes marcam</strong>: Você deve prever se o número de
								gols na partida está acima ou abaixo do intervalo indicado OU se ambas, uma ou
								nenhuma equipe marcará na partida. 4 resultados são possíveis: Acima de 2,5 ou NG,
								Acima de 2,5 ou GG, Abaixo de 2,5 ou NG, Abaixo de 2,5 ou GG.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mercado 1x2 e Total (O/U) e GG/NG</strong>: Você deve prever a combinação do
								resultado final da partida e o resultado de ambas as equipes marcam e a partida será
								superior ou inferior ao intervalo indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mercado 1x2 e Multigols {`{Marcar}`}</strong>: Você deve prever a combinação
								do resultado final mais se o intervalo do total de gols marcados durante a partida
								estiver entre o intervalo indicado.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ambas as equipes marcam + Multigoals {`{Marcar}`}</strong>: Tem de prever a
								combinação de ambas as equipes marcam mais se o intervalo do total de gols marcados
								durante o jogo estiver entre o intervalo indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro gol e 1x2 (Matchflow)</strong>: Você tem que prever ao mesmo tempo
								se o resultado final da partida será 1, X ou 2 e qual time marcará o primeiro gol da
								partida. A aposta oferece sete resultados possíveis:
							</strong>
						</p>

						<p>
							<strong>1-1º gol &amp; 1;</strong>
						</p>

						<p>
							<strong>1-1º gol &amp; X;</strong>
						</p>

						<p>
							<strong>1-1º gol &amp; 2;</strong>
						</p>

						<p>
							<strong>2-1º gol &amp; 1;</strong>
						</p>

						<p>
							<strong>2-1º gol &amp; X;</strong>
						</p>

						<p>
							<strong>2-1º gol &amp; 2;</strong>
						</p>

						<p>
							<strong>Sem Gols (0-0).</strong>
						</p>

						<p>
							<strong>
								<strong>Dupla chance (jogo) &amp; 1º tempo ambas equipes marcam</strong>: Você tem
								que prever o resultado da partida com 3 possíveis resultados de dupla chance (1X, 12
								e X2) e se ambas as equipes marcam ou não no 1º tempo somente.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Dupla chance (jogo) &amp; 2º tempo ambas equipes marcam</strong>: Você tem
								que prever o resultado da partida com 3 possíveis resultados de dupla chance (1X, 12
								e X2) e se ambas as equipes marcam ou não no 2º tempo somente.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Dupla chance e ambas equipes marcam</strong>: Você tem que prever o
								resultado da partida com 3 possíveis resultados de dupla chance (1X, 12 e X2) e se
								ambas as equipes marcam na partida ou não.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Dupla chance e total</strong>: Você tem que prever o resultado da partida
								com 3 possíveis resultados de dupla chance (1X, 12 e X2) e se o número total de gols
								será acima ou abaixo do número indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Intervalo/tempo integral e total</strong>: Você tem que prever o resultado
								do intervalo mais se o total de gols será acima ou abaixo do intervalo indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Intervalo/tempo integral e 1º tempo total</strong>: Você tem que prever o
								resultado do intervalo mais se o total de gols no primeiro tempo será acima ou
								abaixo do intervalo indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Intervalo/final e gols exatos</strong>: Você tem que prever o resultado do
								intervalo mais os gols exatos marcados durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>
									3 Chance Mix (Casa ou mais, Casa ou menos, Empate ou mais, Empate ou menos, Fora
									ou mais, Fora ou menos, Casa ou GG, Empate ou GG, Fora ou GG, Casa ou qualquer
									folha limpa, Empate ou qualquer folha limpa, fora de casa ou qualquer folha limpa)
								</strong>
								: Você tem que prever o placar vencedor da partida OU se ambas, uma ou nenhuma
								equipe marca na partida OU a quantidade total de gols da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Abaixo do 1º Tempo e Abaixo do 2º Tempo</strong>: Você tem que prever se o
								número de gols no 1º Tempo estará Abaixo do intervalo indicado, mais se o número de
								gols no 2º Tempo somente estará Abaixo do intervalo indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Exemplo</strong>: Menos de 1,5/Menos de 1,5. Esta seleção é vencedora se o
								total de gols no primeiro tempo estiver abaixo de 1,5 mais o total de gols no
								segundo tempo estiver abaixo de 1,5.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Exemplo</strong>: Abaixo de 1,5/Acima de 1,5. Esta seleção é vencedora se o
								total de gols no primeiro tempo estiver abaixo de 1,5 mais o total de gols no
								segundo tempo estiver acima de 1,5.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mais de no 1º Tempo e Menos de no 2º Tempo</strong>: Você tem que prever se
								o número de gols no 1º Tempo será Acima do spread indicado, mais se o número de gols
								somente no 2º Tempo será Abaixo do intervalo indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Exemplo</strong>: Mais de 1,5/Menos de 1,5. Esta seleção é vencedora se o
								total de gols no primeiro tempo for Acima de 1,5 mais o total de gols no segundo
								tempo estiver abaixo de 1,5.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mais de no 1º Tempo e Mais de no 2º Tempo</strong>: Você deve prever se o
								número de gols no 1º Tempo será Acima do intervalo indicado, mais se o número de
								gols somente no 2º Tempo será Acima do intervalo indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Exemplo</strong>: Acima de 1,5/ Acima de 1,5. Esta seleção é vencedora se o
								total de gols no primeiro tempo for Acima de 1,5 mais o total de gols no segundo
								tempo for Acima de 1,5.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Intervalo OU Tempo regulamentar</strong>: Você deve prever o resultado
								vencedor da partida OU o primeiro tempo. Apenas uma previsão deve ocorrer para que a
								aposta seja vencedora.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1X2 Intervalo/Dupla Chance FT</strong>: Você tem que prever o resultado do
								intervalo junto com 3 possíveis resultados de dupla chance (1X, 12 e X2) do tempo
								regular de toda a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Dupla Chance HT/1X2 Tempo regulamentar</strong>: Você tem que prever o
								resultado da dupla chance no intervalo junto com o resultado final de toda a
								partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>DC Intervalo/DC Tempo regulamentar</strong>: Aposte no resultado de dupla
								chance tanto no 1º tempo quanto no tempo regulamentar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pelo menos uma metade X</strong>: Você tem que prever se haverá pelo menos
								uma metade que termina em empate. Por exemplo: 1º HT 1-1 / FT 1-2. O resultado
								vitória = Sim.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Dupla chance ou Ambas as equipes marcam</strong>: Você tem que prever o
								resultado da vitória da partida (Dupla Chance) OU se ambas, uma ou nenhuma equipe
								marcará na partida. Apenas uma previsão deve ocorrer para que a aposta seja
								vencedora.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Dupla chance ou Mais/menos</strong>: Você tem que prever o resultado da
								vitória da partida (Double Chance) OU se ambas, uma ou nenhuma equipe marcará na
								partida. Apenas uma previsão deve ocorrer para que a aposta seja vencedora.
							</strong>
						</p>

						<p>
							<strong>
								<strong>{`Acima {Total} {$Competitor 1} + Acima {Total} {$Competitor 2}`}</strong>:
								Você tem que prever se o número de gols no time da casa será acima do spread
								indicado, e se o número de gols no time visitante será acima do spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>{`Acima {Total} {$Competitor 1} + Abaixo {Total} {$Competitor 2}`}</strong>:
								Você tem que prever se o número de gols no time da casa será acima do spread
								indicado, e se o número de gols no time visitante estará abaixo do spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>{`Abaixo {Total} {$Competitor 1} + Abaixo {Total} {$Competitor 2}`}</strong>
								: Você tem que prever se o número de gols no time da casa estará abaixo do spread
								indicado, e se o número de gols no time visitante estará abaixo do spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>{`Abaixo {Total} {$Competitor 1} + Acima {Total} {$Competitor 2}`}</strong>:
								Você tem que prever se o número de gols no time da casa estará abaixo do spread
								indicado, e se o número de gols no time visitante será acima do spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>{`1º tempo - 1x2 ou {total}`}</strong>: Você tem que prever o resultado
								vencedor do 1º tempo da partida OU o número total de gols (acima ou abaixo). Apenas
								uma previsão precisa ocorrer para que a aposta seja vencedora.
							</strong>
						</p>

						<p>
							<strong>
								<strong>{`2º tempo - 1x2 ou {total}`}</strong>: Você tem que prever o resultado
								vencedor do 2º tempo da partida OU o número total de gols (acima ou abaixo). Apenas
								uma previsão precisa ocorrer para que a aposta seja vencedora.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Chance Dupla 1X &amp; {`{total}`} &amp; Ambas as equipes marcam</strong>:
								Você tem que prever a combinação do resultado final chance dupla (1X), o resultado
								marcado de ambas as equipes e se a partida será acima ou abaixo do spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Chance Dupla X2 &amp; {`{total}`} &amp; Ambas as equipes marcarão</strong>:
								Você deve prever a combinação do resultado final chance dupla (X2) e o resultado de
								ambas as equipes para marcar mercado e a partida será acima ou abaixo do spread
								indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Chance dupla 12 &amp; {`{total}`} &amp; Ambas as equipes marcam</strong>:
								Você tem que prever a combinação do resultado final chance dupla (12), o resultado
								marcado de ambas as equipes e se partida será acima ou abaixo do spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ambas as equipes marcam 1º Tempo e Multigol (partida)</strong>: É preciso
								prever a combinação de ambas as equipes para marcar no primeiro tempo da partida, e
								se o intervalo de gols marcados durante a partida estará entre o intervalo indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Multigols time da casa e Multigols visitante</strong>: Você tem que prever o
								número de gols marcados durante a partida do time da casa e do time visitante com
								base nas diferentes faixas oferecidas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Multigol 1º Tempo e Multigol 2º Tempo</strong>: Você tem que prever o número
								de gols marcados durante o primeiro tempo da partida e o segundo tempo, com base em
								diferentes intervalos oferecidos.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Combo Var (jogo 1X2 + Var S/N)</strong>: Você tem que prever a combinação
								correta do resultado da partida no tempo regulamentar e se haverá VAR (com revisão
								do monitor) ou não. Existem 6 resultados possíveis:
							</strong>
						</p>

						<p>
							<strong>Equipe 1 e Sim</strong>
						</p>

						<p>
							<strong>Equipe 1 e Não</strong>
						</p>

						<p>
							<strong>Empate e Sim</strong>
						</p>

						<p>
							<strong>Empate e Não</strong>
						</p>

						<p>
							<strong>Equipe 2 e Sim</strong>
						</p>

						<p>
							<strong>Equipe 2 e Não</strong>
						</p>

						<p>
							1º tempo - Time da casa - Total de chutes a gol: Você deve prever o número total de
							chutes a gol feitos pelo da casa durante o primeiro tempo.
						</p>

						<p>
							2º Tempo - Time da casa - Total de chutes a gol: Você deve prever o número total de
							chutes a gol feitos pelo da casa durante o segundo tempo.
						</p>

						<p>
							Time visitante - Total de chutes a gol: Você deve prever o número total de chutes a
							gol feitos pelo time visitante durante o tempo regulamentar da partida.
						</p>

						<p>
							1º tempo - Time visitante - Total de chutes a gol: Você deve prever o número total de
							chutes a gol feitos pelo visitante durante o primeiro tempo.
						</p>

						<p>
							2º tempo - Time visitante - Total de chutes a gol: Você deve prever o número total de
							chutes a gol feitos pelo visitante durante o segundo tempo.
						</p>

						<p className="pH2">
							<strong>Mercados de Escanteios</strong>
						</p>

						<p>
							<strong>Escanteios marcados mas não cobrados não contam.</strong>
						</p>

						<p>
							<strong>
								<strong>Escanteio 1x2</strong>: Você deve prever qual time da partida receberá mais
								escanteios.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Próximo escanteio</strong>: Você tem que prever qual time vai ganhar o
								próximo escanteio da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Último escanteio</strong>: Você deve prever qual equipe receberá o último
								escanteio da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap de escanteio</strong>: Você deve prever a equipe que terá mais
								escanteios na partida levando em consideração o intervalo de handicap oferecido.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de escanteios</strong>: Você deve prever se a quantidade total de
								escanteios cobrados na partida está acima ou abaixo do intervalo indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de escanteios da casa</strong>: Você tem que prever se o número total
								de escanteios cobrados na partida apenas pelo time da casa está acima ou abaixo do
								intervalo indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de escanteios fora</strong>: Você deve prever se o número total de
								escanteios marcados na partida apenas pela equipe visitante está acima ou abaixo do
								intervalo indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Escala de escanteios</strong>: Você deve prever o alcance de escanteios
								feitos na partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Escala de escanteios da casa</strong>: Você deve prever o alcance de
								escanteios cobrados na partida pelo time da casa.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Escala de cantos visitante</strong>: Você deve prever o alcance de
								escanteios cobrados na partida pela equipe visitante.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Escanteios pares/ímpares</strong>: Você deve prever se o total de escanteios
								marcados na partida é um número par ou ímpar. Nenhum escanteio concedido = par.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Corrida para x escanteios</strong>: Você deve prever qual equipe alcançará o
								número x de escanteios primeiro durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - escanteio 1x2</strong>: Você tem que prever qual time terá mais
								escanteios no primeiro tempo (1X2).
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - xº escanteio</strong>: Você deve prever qual equipe receberá o
								próximo escanteio durante o 1º tempo do jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Último escanteio do 1º tempo</strong>: Você deve prever qual equipe receberá
								o último escanteio durante o 1º tempo da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Handicap de escanteio</strong>: Você deve prever a equipe que
								terá mais escanteios no primeiro tempo da partida levando em consideração o
								intervalo de handicap oferecido.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1ª parte - escanteios totais</strong>: Você tem que prever se a quantidade
								total de escanteios na primeira tempo será superior ou inferior ao intervalo total
								(mais/menos).
							</strong>
						</p>

						<p>
							<strong>
								<strong>1ª parte - Total de cantos da casa</strong>: Você tem que prever se o número
								total de escanteios no primeiro tempo concedidos pela equipe da casa será superior
								ou inferior ao spread total (mais/menos).
							</strong>
						</p>

						<p>
							<strong>
								<strong>1ª parte - Total de escanteios fora</strong>: Você tem que prever se a
								quantidade total de escanteios no primeiro tempo concedidos pela equipe visitante
								será superior ou inferior ao intervalo total (mais/menos).
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Escanteios exatos da casa</strong>: Você tem que prever o número
								exato de cantos cobrados durante o primeiro tempo da partida do time da casa. 4
								resultados possíveis: 0-1, 2,3,4+.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Escanteios exatos fora</strong>: Você tem que prever o número
								exato de escanteios marcados durante o 1º tempo da partida da equipe visitante. 4
								resultados possíveis: 0-1, 2,3,4+.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - intervalo de escanteios</strong>: Você deve prever o intervalo de
								escanteios cobrados no 1º tempo da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1ª tempo - cantos pares/ímpares</strong>: Tem de prever se o total de
								escanteios marcados na primeira parte do jogo é um número par ou ímpar. Nenhum
								escanteio concedido = par.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - corrida para x escanteios</strong>: Você tem que prever qual
								equipe alcançará o número x de curvas primeiro durante o primeiro tempo da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de escanteios (Abaixo-exato-Acima)</strong>: Você deve prever se o
								número de escanteios durante a partida será acima, abaixo ou exato do intervalo
								indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º Tempo - Total de Cantos (Abaixo-exato-Acima)</strong>: Você deve prever
								se o número de escanteios no 1º Tempo será superior, inferior ou exato do intervalo
								indicado.
							</strong>
						</p>

						<p>
							1X2 Partida + 1X2 Escanteios: Você deve prever a combinação correta para o resultado
							da partida e qual equipe cobrará o maior número de escanteios no final da partida no
							tempo regulamentar.
						</p>

						<p>
							Partida 1X2 e cantos acima/abaixo: Você deve prever a combinação correta para o
							resultado da partida e se o número total de escanteios na partida é maior ou menor do
							que a linha indicada no final da partida em horário normal.
						</p>

						<p className="pH2">
							<strong>Mercados De Cartões</strong>
						</p>

						<p>
							<strong>
								Um cartão amarelo conta como um cartão. Um cartão vermelho conta como dois cartões.
								Se um jogador receber um amarelo mais um segundo amarelo levando a um cartão
								vermelho, isso conta como três cartões. Como resultado, um jogador não pode receber
								mais de três cartões. O resultado será baseado em todos os dados de cartão
								disponíveis que aparecem durante o tempo normal de jogo de um evento. Os cartões
								mostrados após o apito final não serão levados em consideração. Os cartões em
								jogadores que não estão em campo (jogadores que já foram substituídos, treinadores,
								jogadores no banco) não são levados em consideração. Além disso, se o jogador estava
								no banco quando recebeu o cartão, ele não , mesmo que mais tarde ele entre em campo
								para jogar. *Os mercados de reserva estão sendo calculados conforme definido abaixo,
								dependendo se são mercados de reserva ou mercados de reserva com pontos (se forem
								definidos com pontos, isso estará especificado no título do mercado){' '}
							</strong>
						</p>

						<p className="pH2">
							<strong>Mercados de cartões com pontos</strong>
						</p>

						<p>
							<strong>
								Um cartão amarelo conta como 10 pontos e o vermelho e o segundo amarelo-vermelho
								como 25. O segundo amarelo para um jogador que leva a um cartão vermelho não é
								contado. Como resultado, um jogador não pode receber mais de 35 pontos. O resultado
								será baseado em todos os dados de cartão disponíveis que aparecem durante o tempo
								normal de jogo de um evento. Os cartões mostrados após o apito final não devem ser
								levados em consideração. Os cartões em jogadores que não jogaram (jogadores que já
								foram substituídos, treinadores, jogadores no banco que não participaram no jogo)
								não são levados em consideração.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Cartão 1x2</strong>: Você deve prever qual das duas equipes receberá o maior
								número de cartões durante o tempo regulamentar da partida.
							</strong>
						</p>

						<p>
							<strong>
								➔ Cartão amarelo = 10 pontos, Cartão vermelho = 25
								<strong>Próximo cartão</strong>: Você deve prever qual time durante o tempo
								regulamentar da partida receberá o cartão especificado na aposta.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de pontos de cartões</strong>: Você deve prever se o número total de
								pontos de cartão concedidos durante a partida está acima ou abaixo do intervalo
								indicado.
							</strong>
						</p>

						<p>
							<strong>➔ Cartão amarelo = 10 pontos, Cartão vermelho = 25 pontos</strong>
						</p>

						<p>
							<strong>
								<strong>Total de cartões</strong>: Você deve prever se o número total de cartões
								concedidos durante a partida está acima ou abaixo do intervalo indicado.
							</strong>
						</p>

						<p>
							<strong>➔ Cartão amarelo = 1 cartão amarelo, cartão vermelho = 2 cartões</strong>
						</p>

						<p>
							<strong>
								<strong>Total de cartões da casa</strong>: Você deve prever se o número total de
								cartões concedidos para a equipe da casa durante a partida está acima ou abaixo do
								intervalo indicado.
							</strong>
						</p>

						<p>
							<strong>➔ Cartão amarelo = 1 cartão amarelo, cartão vermelho = 2 cartões</strong>
						</p>

						<p>
							<strong>
								<strong>Total de cartões como visitante</strong>: Você deve prever se o número total
								de cartões concedidos para a equipe visitante durante a partida está acima ou abaixo
								do intervalo indicado.
							</strong>
						</p>

						<p>
							<strong>➔ Cartão amarelo = 1 cartão amarelo, cartão vermelho = 2 cartões</strong>
						</p>

						<p>
							<strong>
								<strong>Cartões exatos</strong>: Você deve prever o número exato de cartões marcados
								durante a partida.
							</strong>
						</p>

						<p>
							<strong>➔ Cartão amarelo = 1 cartão amarelo, cartão vermelho = 2 cartões</strong>
						</p>

						<p>
							<strong>
								<strong>Cartões exatos da casa</strong>: Você deve prever o número exato de cartões
								concedidos pela equipe da casa durante a partida.
							</strong>
						</p>

						<p>
							<strong>➔ Cartão amarelo = 1 cartão amarelo, cartão vermelho = 2 cartões</strong>
						</p>

						<p>
							<strong>
								<strong>Cartões exatos como visitante</strong>: Você deve prever o número exato de
								cartões concedidos pela equipe visitante durante a partida.
							</strong>
						</p>

						<p>
							<strong>➔ Cartão amarelo = 1 cartão amarelo, cartão vermelho = 2 cartões</strong>
						</p>

						<p>
							<strong>
								<strong>Intervalo de pontos de cartão</strong>: Você deve prever o intervalo de
								pontos de cartão concedidos pelas equipes durante a partida. 5 são os resultados
								possíveis: 0-3, 31-45, 46-60, 61-75, 76+.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Expulsão</strong>: Você deve prever se um cartão vermelho será sacado ou não
								durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Expulsão da casa</strong>: Você deve prever se um cartão vermelho será
								sacado ou não durante a partida para a equipe da casa.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Expulsão visitante</strong>: Você deve prever se um cartão vermelho será
								sacado ou não durante a partida para a equipe visitante.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - cartão 1x2</strong>: Você deve prever qual das duas equipes
								receberá o maior número de cartões amarelos durante o 1º tempo da partida.
							</strong>
						</p>

						<p>
							<strong>➔ Cartão amarelo = 10 pontos, Cartão vermelho = 25 pontos</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Próximo cartão</strong>: Você deve prever qual time durante o 1º
								tempo do jogo receberá o cartão de cartão especificado na aposta.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - total de pontos de cartão</strong>: Você deve prever se o número
								total de pontos de cartão concedidos durante o 1º tempo da partida está acima ou
								abaixo do intervalo indicado.
							</strong>
						</p>

						<p>
							<strong>➔ Cartão amarelo = 10 pontos, Cartão vermelho = 25 pontos</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - total de cartões</strong>: Você deve prever se o número total de
								cartões concedidos durante o 1º tempo do jogo está acima ou abaixo do intervalo
								indicado.
							</strong>
						</p>

						<p>
							<strong>➔ Cartão amarelo = 1 cartão amarelo, cartão vermelho = 2 cartões</strong>
						</p>

						<p>
							<strong>
								<strong>1ª parte - Total de cartões da casa</strong>: Tem de prever se o número
								total de cartões atribuídos à equipe da casa durante a 1ª parte do jogo está acima
								ou abaixo do intervalo indicado.{' '}
							</strong>
						</p>

						<p>
							<strong>➔ Cartão amarelo = 1 cartão amarelo, cartão vermelho = 2 cartões</strong>
						</p>

						<p>
							<strong>
								<strong>1ª parte - Total de cartões do visitante</strong>: Tem de prever se o número
								total de cartões atribuídos à equipe visitante durante a 1ª parte do jogo está acima
								ou abaixo do intervalo indicado.{' '}
							</strong>
						</p>

						<p>
							<strong>➔ Cartão amarelo = 1 cartão amarelo, cartão vermelho = 2 cartões</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - cartões exatos</strong>: Você deve prever o número exato de
								cartões concedidos durante o 1º tempo da partida.
							</strong>
						</p>

						<p>
							<strong>➔ Cartão amarelo = 1 cartão amarelo, cartão vermelho = 2 cartões</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Cartões exatos da casa</strong>: Você deve prever o número exato
								de cartões concedidos pela equipe da casa durante o 1º tempo da partida.
							</strong>
						</p>

						<p>
							<strong>➔ Cartão amarelo = 1 cartão amarelo, cartão vermelho = 2 cartões</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Cartões exatos como visitante</strong>: Você deve prever o número
								exato de cartões concedidos pela equipe visitante durante o 1º tempo da partida.
							</strong>
						</p>

						<p>
							<strong>➔ Cartão amarelo = 1 cartão amarelo, cartão vermelho = 2 cartões</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Intervalo de pontos de cartão</strong>: Você deve prever o
								intervalo de pontos de cartão concedidos pelas equipes durante o 1º tempo da
								partida. 4 são os resultados possíveis: 0-10, 11-25, 26-40, 41+.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Expulsão</strong>: Você tem que prever se um cartão vermelho será
								sacado ou não durante o 1º tempo da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Expulsão da casa</strong>: Você tem que prever se um cartão
								vermelho será sacado ou não durante o 1º tempo do jogo para a equipe da casa.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Expulsão visitante</strong>: Você tem que prever se um cartão
								vermelho será sacado ou não durante o 1º tempo do jogo para o time visitante.
							</strong>
						</p>

						<p className="pH2">
							<strong>Mercados de Marcadores / Mercados Especiais de Jogadores</strong>
						</p>

						<p>
							<strong>
								As apostas aplicam-se apenas ao tempo regulamentar. Gols contra (com base na
								autoridade oficial) omitidos ou contam como "sem marcador" se o jogo tiver apenas
								"gols contra".
							</strong>
						</p>

						<p>
							<strong>
								Aposta no Primeiro Marcador será NULA se um jogador nunca jogar ou entrar em campo
								após o primeiro gol do jogo ter sido marcado, exceto no caso de um gol contra, que é
								ignorado.
							</strong>
						</p>

						<p>
							<strong>
								As apostas no último goleador serão anuladas se um jogador nunca jogar. Jogador para
								marcar se aplica a qualquer jogador, independentemente da hora em que ele entrou no
								jogo.
							</strong>
						</p>

						<p>
							<strong>
								Apostas no Marcar a Qualquer Momento, aplicam-se a qualquer jogador envolvido no
								jogo, independentemente da hora em que entram no jogo. As apostas no marcador a
								qualquer momento serão anuladas se um jogador nunca jogar.
							</strong>
						</p>

						<p>
							<strong>
								No caso de um jogo ser abandonado mas se houver pelo menos um marcador, as apostas
								no primeiro marcador são válidas e as apostas no último marcador são anuladas. O
								mercado de Marcar a qualquer momento para este jogador é liquidado como vencedor e
								as apostas em outros jogadores são anuladas.{' '}
							</strong>
						</p>

						<p>
							<strong>
								Para os seguintes mercados especiais de jogadores, as apostas aplicam-se ao tempo
								regulamentar mais a prorrogação (se houver), um potencial desempate por cobranças de
								pênalti não contará para resolução da aposta. A atualização aplica-se a qualquer
								jogador que entre em campo, salvo indicação ao contrário no nome do mercado
								("somente titulares"). Nesse caso, se o jogador listado não estiver na escalação
								inicial da partida, as apostas serão consideradas nulas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Para marcar e receber cartão e assistência:</strong> Você precisa prever se
								o jogador marcará pelo menos um gol, fará pelo menos uma assistência e receberá um
								cartão (amarelo ou vermelho) na partida. A prorrogação também está incluída.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Para marcar ou receber um cartão ou dar assistência:</strong> Você precisa
								prever se o jogador marcará pelo menos um gol OU fará pelo menos uma assistência OU
								receberá um cartão (amarelo ou vermelho) na partida. O tempo extra também está
								incluído.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro a marcar</strong>: Você tem que prever se o jogador selecionado vai
								marcar o primeiro gol da partida. Se um jogador nunca jogar ou entrar em campo após
								o primeiro gol do jogo ter sido marcado, a aposta será anulada.
							</strong>
						</p>

						<p>
							<strong>
								Se o jogador selecionado não marcar o primeiro gol e for substituído por um reserva,
								a aposta será perdedora.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Chutes ao Gol:</strong>
								Um chute ao gol por definição refere-se a qualquer tentativa que:
							</strong>
						</p>

						<ul>
							<li>
								<strong>Vai para a rede independentemente da intenção - Apenas para gols.</strong>
							</li>
							<li>
								<strong>
									É uma clara tentativa de gol que teria ido para a rede se não fosse defendida pelo
									goleiro ou fosse interrompida por um jogador que é o último homem e o goleiro não
									tivesse chance de impedir o gol.
								</strong>
							</li>
						</ul>

						<p>
							<strong>
								Os chutes que atingem diretamente o poste ou a trave não são contados como chutes ao
								alvo, a menos que a bola entre e seja considerada um gol. Os remates bloqueados por
								outro jogador, que não seja o último jogador, não serão contados como remate ao
								alvo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Chutes para fora do Gol:</strong>
								Um chute para fora do gol por definição refere-se a qualquer tentativa que:
							</strong>
						</p>

						<ul>
							<li>
								<strong>
									Passa por cima ou para fora do gol sem fazer contato com outro jogador.
								</strong>
							</li>
							<li>
								<strong>
									Teria passado por cima ou fora do gol se não fosse parado por uma defesa do
									goleiro ou por um jogador de campo. Atinge diretamente o poste ou a trave e o gol
									não é marcado.
								</strong>
							</li>
						</ul>

						<p>
							<strong>
								<strong>Próximo artilheiro</strong>: Você deve prever se o jogador selecionado fará
								o gol "x" na partida. Se o jogador selecionado não participar da partida, a aposta
								será anulada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Último artilheiro</strong>: Você deve prever que o jogador selecionado
								marcará o último gol da partida. Se o jogador selecionado não participar da partida,
								a aposta será anulada. Se o jogador selecionado não marcar nenhum gol durante a
								partida, a aposta será perdida, mesmo que ele tenha sido substituído por outro
								jogador antes do último gol ter sido marcado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Marcador a qualquer momento e 1x2</strong>: Você tem que prever um jogador
								para marcar a qualquer momento na partida, além de prever o resultado final do jogo
								combinado. Apenas tempo regulamentar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Marcador a qualquer momento e placar correto</strong>: Você tem que prever
								um jogador para marcar a qualquer momento na partida, além de prever o placar final
								exato do jogo combinado. Apenas horário normal.
							</strong>
						</p>

						<p>
							<strong>
								<strong>xº marcador &amp; 1X2</strong>: Você tem que prever um jogador para marcar o
								gol "x" na partida, além de prever o resultado final do jogo combinado. Apenas tempo
								regulamentar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>xº marcador e placar correto</strong>: Você tem que prever um jogador para
								marcar o gol "x" na partida, além de prever o placar final do jogo combinado. Apenas
								tempo regulamentar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador a marcar 2+</strong>: Você deve prever que o jogador selecionado
								marcará pelo menos dois gols durante a partida. Se o jogador que você selecionou não
								participar da partida, a aposta será anulada. Se o jogador participar do jogo e não
								marcar pelo menos dois gols, a aposta será perdida independentemente do resultado
								final da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador a marcar 3+</strong>: Você deve prever que o jogador selecionado
								marcará pelo menos três gols durante a partida. Se o jogador que você selecionou não
								participar da partida, a aposta será anulada. Se o jogador participar do jogo e não
								marcar pelo menos três gols, a aposta será perdida independentemente do resultado
								final da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe da casa xº marcador</strong>: Você tem que prever se o jogador
								selecionado da equipe da casa vai marcar o gol "x" na partida. Se o jogador
								selecionado não participar da partida, a aposta será anulada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe visitante xº marcador</strong>: Você deve prever se o jogador
								selecionado da equipe visitante fará o gol "x" na partida. Se o jogador selecionado
								não participar da partida, a aposta será anulada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Maior número de chutes</strong>: Você deve prever qual dos jogadores
								registrará mais chutes.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Maior número de chutes a gol</strong>: você deve prever qual dos jogadores
								registrará mais chutes a gol.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Marcador a qualquer momento no primeiro tempo</strong>: Você deve prever se
								um jogador marcará durante o primeiro tempo da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Marcador a qualquer momento no segundo tempo</strong>: Você deve prever se
								um jogador marcará durante o segundo tempo da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro ou Último Marcador</strong>: Você deve prever se um jogador marcará
								o Primeiro ou o Último Marcador durante a partida, apenas no tempo regulamentar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro e último marcador</strong>: Você deve prever qual jogador marcará o
								primeiro e o último gol durante a partida, apenas no tempo regulamentar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Marcador a qualquer momento + Chance Dupla</strong>: Você deve prever se um
								jogador marcará a qualquer momento da partida, além do resultado final Chance Dupla,
								apenas no tempo regulamentar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>xº artilheiro + chance dupla</strong>: Você deve prever se um jogador
								marcará o xº gol na partida mais o resultado final chance dupla, apenas no tempo
								regulamentar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Artilheiro a qualquer momento + Multiscores</strong>: Você deve prever se um
								jogador marcará em qualquer momento da partida mais o multiscore da partida, apenas
								no tempo regulamentar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>xº artilheiro + multiscores</strong>: Você deve prever se um jogador marcará
								o xº gol na partida mais o multiscore da partida, apenas no tempo regulamentar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>{`Marcador a qualquer momento + Total {total}`}</strong>: Você deve prever
								se um jogador marcará em qualquer momento da partida e se o número total de gols
								durante a partida será Acima ou Abaixo, apenas no tempo regulamentar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>{`xº artilheiro + Total {total}`} </strong>: Você deve prever se um jogador
								marcará o xº gol na partida e se o número total de gols durante a partida será Acima
								ou Abaixo, apenas no tempo regulamentar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Marcador a qualquer momento + Ambas as equipes marcarão</strong>: Você deve
								prever se um jogador marcará a qualquer momento da partida e se ambas as equipes
								marcarão, apenas no tempo regulamentar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>xº artilheiro + Ambas as equipes marcarão</strong>: Você deve prever se um
								jogador marcará o xº gol na partida e se ambas as equipes marcarão, apenas no tempo
								regulamentar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>A qualquer momento Marcador ou substituto para marcar</strong>: Você deve
								prever se, no tempo regulamentar da partida, o jogador "X" ou quem irá ocupar seu
								lugar no banco marcará (resultado SIM), ou não (resultado NÃO), pelo menos um gol.
								Para efeitos de aposta são considerados apenas o jogador "X" e o seu substituto
								direto do banco.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Marcador a qualquer momento + 1X2 + Mais/Menos X gols</strong>: Você tem que
								prever a combinação exata desses 3 mercados - Marcador a qualquer momento (se no
								tempo regulamentar da partida, o jogador "X", marcará pelo menos um gol), 1x2
								(prever o resultado final do jogo), Acima/Abaixo (se o número total de gols marcados
								durante o tempo regulamentar da partida estiver acima ou abaixo da linha indicada).
								Existem 6 resultados possíveis para esta aposta:
							</strong>
						</p>

						<p>
							<strong>Artilheiro a qualquer momento + 1 + Menos</strong>
						</p>

						<p>
							<strong>Artilheiro a qualquer momento + 1 + Mais</strong>
						</p>

						<p>
							<strong>Artilheiro a qualquer momento + 2 + Menos</strong>
						</p>

						<p>
							<strong>Artilheiro a qualquer momento + 2 + Mais</strong>
						</p>

						<p>
							<strong>Artilheiro a qualquer momento + Empate + Menos</strong>
						</p>

						<p>
							<strong>Artilheiro a qualquer momento + Empate + Mais</strong>
						</p>

						<p>
							<strong>
								<strong>
									1º artilheiro + 1X2 + Mais/Menos X gols. Você tem que prever a combinação exata
									desses 3 mercados - 1º artilheiro (se no tempo regulamentar da partida, o jogador
									"X", será o primeiro marcador da partida), 1x2 (prever o resultado final do jogo)
									, Acima/Abaixo (se o número total de gols marcados durante o tempo regulamentar da
									partida estiver acima ou abaixo da linha indicada). Existem 6 resultados possíveis
									para esta aposta
								</strong>
								:{' '}
							</strong>
						</p>

						<p>
							<strong>1º artilheiro + 1 + Menos</strong>
						</p>

						<p>
							<strong>1º artilheiro + 1 + Mais</strong>
						</p>

						<p>
							<strong>1º artilheiro + 2 + Menos</strong>
						</p>

						<p>
							<strong>1º artilheiro + 2 + Mais</strong>
						</p>

						<p>
							<strong>1º artilheiro + empate + Menos</strong>
						</p>

						<p>
							<strong>1º artilheiro + empate + Mais</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador ou seu substituto receberá um cartão</strong>: Você deve prever se,
								no tempo regulamentar da partida, o jogador "X" ou quem irá ocupar seu lugar no
								banco receberá um cartão (Amarelo ou Vermelho) (resultado SIM) ou não (resultado
								NÃO). Para efeitos de aposta são considerados apenas o jogador "X" e o seu
								substituto direto do banco.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Outros Especiais Jogador de Futebol </strong>: Para os seguintes mercados
								especiais de jogadores, as apostas aplicam-se ao tempo regulamentar mais o
								prolongamento (se houver),
							</strong>
						</p>

						<p>
							<strong>
								Um potencial desempate por penáltis não conta para a liquidação. A liquidação
								aplica-se a qualquer jogador que entre em campo, exceto se indicado de outra forma
								no nome do mercado ("titular"). Nesse caso, se o jogador listado não estiver na
								equipa inicial do jogo, as apostas são liquidadas como nulas.
							</strong>
						</p>

						<p>
							<strong>Total de Chutes do Jogador / Chutes do Jogador Acima/Abaixo.</strong>
						</p>

						<p>
							<strong>
								Total de Chutes a Gol do Jogador / Chutes a Gol do Jogador Acima/Abaixo Total de
								Cartões do Jogador / Cartões do Jogador Acima/Abaixo.
							</strong>
						</p>

						<p>
							<strong>
								Total de Desarmes do Jogador / Desarmes do Jogador Acima/Abaixo Total de
								Assistências do Jogador / Assistências do Jogador Acima/Abaixo Total de Passes do
								Jogador / Passes do Jogador Acima/Abaixo.
								<strong>Jogador que marcará mais de 2 gols e pontuação correta</strong>: Você deve
								prever se o jogador marcará pelo menos 2 gols na partida, além de prever o placar
								correto da partida combinada, apenas no tempo regulamentar.
								<strong>Jogador que marcará mais de 2 gols e 1X2:</strong> Você deve prever se o
								jogador marcará pelo menos 2 gols na partida, além de prever o resultado final da
								partida combinada, apenas no tempo regulamentar.
								<strong>A qualquer momento Artilheiro no 1º tempo + 1X2 no 1º tempo</strong>: Você
								deve prever se um jogador marcará durante o primeiro tempo da partida, além de
								prever o resultado final do primeiro tempo combinado.
								<strong>Chutes a gol e substituto do jogador (incl. madeira)</strong>: Você precisa
								prever se a soma total dos chutes a gol do jogador e de seu substituto direto no
								final da partida, incluindo eventual prorrogação, será maior do que a linha
								indicada. Os remates que acertam no poste e na trave também são considerados remates
								à baliza para efeitos desta aposta. A aposta é ganha se ocorrer pelo menos um destes
								casos: 1) O jogador realiza mais remates à baliza do que a linha indicada e não é
								substituído. 2) O jogador é substituído e a soma dos chutes a gol feitos pelo
								jogador e seu substituto é maior que a linha indicada. 3) Tanto o jogador quanto seu
								substituto direto realizam mais chutes a gol que a linha indicada. 4) O jogador
								entra na partida vindo do banco de reservas, realiza mais chutes a gol do que a
								linha indicada e não é substituído. 5) O jogador entra na partida vindo do banco de
								reservas, é então substituído e a soma dos chutes a gol do jogador e de seu
								substituto é superior à linha indicada. Se o jogador não participar do jogo, as
								apostas serão anuladas.
								<strong>Chutes do jogador e substituto</strong>: Você precisa prever se a soma total
								dos chutes do jogador e do seu substituto direto no final da partida, incluindo
								eventual prorrogação, será maior que a linha indicada. A aposta é ganha se pelo
								menos um destes casos ocorrer: 1) O jogador realiza mais arremessos do que a linha
								indicada e não é substituído. 2) O jogador é substituído e a soma dos arremessos
								feitos pelo jogador e seu substituto é maior que a linha indicada. 3) Tanto o
								jogador quanto seu substituto direto realizam mais arremessos que a linha indicada.
								4) O jogador entra no jogo vindo do banco de reservas, faz mais arremessos que a
								linha indicada e não é substituído. 5) O jogador entra no jogo vindo do banco de
								reservas, é então substituído e a soma dos arremessos do jogador e do seu substituto
								é superior à linha indicada. Se o jogador não participar do jogo, as apostas serão
								anuladas.
								<strong>Goleiro com defesas acima/abaixo:</strong> Você deve prever se o número de
								defesas feitas pelo goleiro específico mencionado estará acima ou abaixo do spread
								indicado. O tempo extra também está incluído.{' '}
							</strong>
						</p>

						<p>
							Jogador ou seu substituto que receberá uma assistência: Você deve prever se, no tempo
							regulamentar da partida, o jogador "X" ou quem o substituirá no banco de reservas
							receberá uma assistência
						</p>

						<p>
							Cartões amarelos de jogadores, incluindo substitutos (90 minutos): Você deve prever se
							um jogador específico, incluindo os substitutos, receberá um cartão amarelo durante o
							tempo regulamentar da partida.
						</p>

						<p>
							Jogador que receberá um cartão: Você deve prever se um jogador específico receberá
							algum cartão (amarelo ou vermelho) durante a partida, incluindo os substitutos, com
							base em suas ações durante o tempo regulamentar da partida.
						</p>

						<p>
							Jogador X (ou substituto) fará um gol ou dará uma assistência: Você deve prever se o
							Jogador X (ou substituto) marcará um gol ou uma assistência (seja como um passe que
							leva a um gol ou uma assistência direta) durante o tempo regulamentar da partida.
						</p>

						<p>
							Cartões do jogador X (ou substituto): Você deve prever se o Jogador X (ou substituto)
							receberá um cartão (amarelo ou vermelho) durante o tempo regulamentar da partida.
						</p>

						<p className="pH2">
							<strong>Outros Mercados</strong>
						</p>

						<p>
							Placar correto no primeiro tempo/tempo integral: Você deve prever o placar correto do
							primeiro tempo da partida junto com o placar correto do tempo regular da partida
							inteira. Exemplo: O placar no intervalo é 0-0, o placar no intervalo é 2-0. A seleção
							vencedora para esse exemplo é 0-0/2-0.
						</p>

						<p>
							Total de chutes a gol: Você deve prever se o número total de chutes a gol feitos por
							ambas as equipes combinadas durante o tempo regulamentar da partida
						</p>

						<p>
							Time da casa - Total de chutes a gol: Você deve prever o número total de chutes a gol
							feitos pelo time da casa durante o tempo regulamentar da partida.
						</p>

						<p>
							<strong>
								<strong>1º Tempo ou 1x2:</strong> Aqui você tem que prever o resultado do 1º tempo
								ou o resultado final. Prorrogação não é incluída.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de chutes ao gol do time da casa:</strong> Você deve prever se o
								número total de chutes ao gol do time da casa na partida ficará acima ou abaixo da
								linha indicada, incluindo a prorrogação.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de chutes ao gol do time visitante:</strong> Você deve prever se o
								número total de chutes ao gol do time visitante na partida ficará acima ou abaixo da
								linha indicada, incluindo a prorrogação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de chutes do time da casa:</strong> Você deve prever se o número total
								de chutes do time da casa na partida ficará acima ou abaixo da linha indicada,
								incluindo a prorrogação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de chutes do time visitante:</strong> Você deve prever se o número
								total de chutes do time visitante na partida ficará acima ou abaixo da linha
								indicada, incluindo a prorrogação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de Chutes:</strong> O total de chutes é a soma do número total de
								chutes a gol, chutes fora do gol e chutes bloqueados, incluindo a prorrogação
							</strong>
							<strong>.</strong>
						</p>

						<p>
							<strong>
								<strong>Resultado correto no intervalo/final</strong>: Você deve prever o resultado
								correto do 1º tempo da partida junto com o resultado correto de toda a partida.
								Exemplo: Pontuação em HT é 0-0, Pontuação em FT é 2-0. A seleção vencedora para este
								exemplo é 0-0/2-0.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Alcance de gols</strong>: Você deve prever o alcance de gols marcados
								durante a partida. 4 são as seleções possíveis: 0-1, 2-3,4-6,7+
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vitória em casa a zero</strong>: Você tem que prever se o time da casa
								vencerá ou não, concedendo algum gol ao adversário. Existem dois resultados
								possíveis: Sim (o time da casa vence sem sofrer nenhum gol) e Não (qualquer outro
								resultado).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vitória do visitante a zero</strong>: Você deve prever se o visitante
								vencerá ou não, concedendo algum gol ao adversário. Existem dois resultados
								possíveis: Sim (o time visitante vencer sem sofrer nenhum gol) e Não (qualquer outro
								resultado).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Tempo com mais gols</strong>: prever qual dos dois tempos da partida terá
								mais gols marcados.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ambos os tempos acima de 1,5</strong>: Mais de 1,5 gols são marcados em cada
								tempo, ou seja, mais de 1,5 no primeiro tempo e mais de 1,5 no segundo tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ambos os tempos abaixo de 1,5</strong>: Menos de 1,5 gols são marcados em
								cada tempo, ou seja, menos de 1,5 no primeiro tempo e menos de 1,5 no segundo tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>O time da casa vence os dois tempos</strong>: O time da casa vence o
								primeiro e o segundo tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Visitante vencedor os dois tempos</strong>: A equipe visitante ganhou tanto
								a primeira quanto a segunda.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Casa vence qualquer tempo</strong>: A equipe da casa vence um dos tempos,
								seja a primeira ou a segunda metade.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Visitante vence qualquer tempo</strong>: A equipe visitante vence um dos
								tempos, seja a primeira ou a segunda metade.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time da casa com mais gols em um dos tempos</strong>: prevê qual dos dois
								tempos do jogo terá mais gols marcados pela equipe da casa.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time visitante com mais gols em um dos tempos</strong>: prevê qual dos dois
								tempos terá mais gols marcados pela equipe visitante.
							</strong>
						</p>

						<p>
							<strong>
								<strong>A equipe visitante marca nos dois tempos</strong>: A equipe visitante marca
								gols no primeiro tempo e no segundo tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe da casa marca em ambas as partes</strong>: A equipe da casa marca
								gols na primeira parte e na segunda parte.
							</strong>
						</p>

						<p>
							<strong>
								<strong>GolContra</strong>: Você tem que prever se um gol contra será marcado
								durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pênalti na partida</strong>: Você deve prever se um pênalti será marcado na
								partida para a equipe da casa ou para a equipe visitante. O pênalti deve ser cobrado
								para ser considerado. Quaisquer penalidades atribuídas, mas anuladas pelo VAR não
								contam. As cobranças de pênalti após o término da partida não contam.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Para marcar um pênalti</strong>: Você deve prever se um gol de pênalti será
								convertido pela equipe da casa ou da equipe visitante.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Perder um pênalti</strong>: Você deve prever se um pênalti marcado na
								partida será perdido pelo time da casa ou visitante.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencer de virada</strong>: Você deve prever se o time da casa/fora vencerá a
								partida depois de estar atrás na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencer de virada (equipe da casa)</strong>: Você deve prever se o time da
								casa vencerá a partida depois de estar em desvantagem na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencer de virada (time visitante)</strong>: Você deve prever se o time
								visitante vencerá a partida depois de estar em desvantagem na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vídeo VAR S/N</strong>: Você tem que prever se haverá ou não uma decisão do
								VAR (com revisão do monitor) em uma partida selecionada apenas durante o tempo
								regulamentar. A prorrogação não contará. A liquidação das apostas feitas nos
								mercados VAR será validada no site oficial da federação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Multiresultados 1,2,3,4,5</strong>: Você deve prever qual seleção conterá o
								placar correto da partida. 5 mercados Multiresultados são oferecidos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Exemplo</strong>: Você escolhe a seleção 0-0 / 1-1 / 0-1 / 1-0
							</strong>
						</p>

						<p>
							<strong>
								Se a partida terminar com uma das pontuações da sua seleção, sua aposta será
								vencedora.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Posse de bola 1X2</strong>: Você deve prever se as equipes selecionadas
								terão uma posse de bola maior do que o intervalo especificado. Apenas o Tempo
								Regular é considerado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de gols da Rodada X</strong>: Deve prever o número total de gols
								marcados na Rodada X do referido Campeonato. São atribuídos dois gols no caso de um
								único jogo do dia específico ser adiado; no caso de 2 ou mais partidas adiadas,
								todas as apostas serão anuladas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ex.</strong>: Total de gols Rodada 36 Itália - Série B = VITÓRIA Acima de 15
							</strong>
						</p>

						<p>
							<strong>
								É vencedor se a soma dos gols marcados em todas as partidas da Série B for 16+
							</strong>
						</p>

						<p>
							<strong>
								<strong>Chutes a gol na partida</strong>: Você deve prever se o número total de
								chutes a gol feitos por ambas as equipes na partida, incluindo a prorrogação, é
								menor (abaixo) ou maior (acima) do que a linha indicada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Competidor1 com posse de bola</strong>: você deve prever se, na partida, o
								competidor 1 registrará uma porcentagem de posse de bola menor (abaixo) ou maior
								(acima) do que a diferença especificada durante o tempo regulamentar e a
								prorrogação, inclusive.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Competidor2 com posse de bola</strong>: você deve prever se, na partida, o
								competidor 2 registrará uma porcentagem de posse de bola menor (abaixo) ou maior
								(acima) do que o spread especificado durante o tempo regulamentar e a prorrogação,
								inclusive.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Rodada X - total de times da casa</strong>: Você deve prever, para a rodada
								em questão, quantos gols serão marcados no total pelos times da casa.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Rodada X - total de times visitantes</strong>: Você deve prever, para a
								rodada em questão, quantos gols serão marcados no total pelos times visitantes.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Rodada X - maior número de gols dos times da casa ou de fora</strong>: Você
								deve prever, para a rodada em questão, se o maior número de gols no total será
								marcado pelo time da casa ou pelo time visitante.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Rodada X - total de vitórias do time da casa</strong>: Você deve prever,
								para a rodada em questão, quantas vitórias serão registradas no total pelos times da
								casa.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Rodada X - total de empates</strong>: Você deve prever, para uma determinada
								rodada, quantas partidas terminarão empatadas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Rodada X - total de vitórias do time visitante</strong>: Você deve prever,
								para a rodada em questão, quantas vitórias serão registradas no total dos times
								visitantes.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Placar correto XL (50 resultados)</strong>: prever o resultado exato de uma
								partida ao final de 90 minutos do tempo regulamentar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Margem de vitória (4 resultados)</strong>: nesse tipo de aposta, você prevê
								qual equipe vencerá e por qual margem ela vencerá.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Margem de vitória (10 resultados)</strong>: nesse tipo de aposta, você prevê
								qual time vencerá e por qual margem ele vencerá.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de gols (3 vias)</strong>: Você precisa prever se o número de gols
								marcados durante a partida será superior, inferior ou exato com base nos diferentes
								intervalos oferecidos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Minuto do último gol (intervalos)</strong>: Você deve prever o intervalo em
								que o último gol da partida será marcado. Há 7 resultados possíveis: (0-15, 16-30,
								31-tempo, 46-60, 61-75, 76-tempo integral, sem gol)
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro gol no primeiro tempo</strong>: Você deve prever em que tempo será
								marcado o primeiro gol do jogo. Há 3 resultados possíveis: primeiro tempo, segundo
								tempo, nenhum.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Gol após o 90º minuto</strong>: Você deve prever se haverá pelo menos um gol
								no tempo de acréscimo do segundo tempo da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Substituto para marcar (r.t.)</strong>: Você deve prever se um jogador que
								sai do banco como substituto marcará um gol durante a partida, durante o tempo
								regulamentar de uma partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Substituição no 1º tempo</strong>: Você deve prever se haverá uma
								substituição durante o primeiro tempo da partida. As substituições que ocorrem
								durante o intervalo do primeiro tempo não contam como substituições do primeiro
								tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Expulsão do técnico</strong>: Você deve prever se um técnico receberá o
								cartão vermelho durante a partida, inclusive na prorrogação e nas cobranças de
								pênaltis.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Fazer um gol de fora da área de pênalti</strong>: Você deve prever se haverá
								um gol marcado de fora da área de pênalti durante o tempo regulamentar de uma
								partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pênalti defendido (pelo goleiro)</strong>: Você deve prever que um dos
								goleiros defenderá um pênalti durante o tempo regulamentar da partida. Há 2
								resultados possíveis: Sim (o goleiro defenderá um pênalti) - Não (nenhum pênalti foi
								concedido, um pênalti foi concedido e marcado ou um pênalti foi perdido, mas não
								defendido pelo goleiro).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Trave/Cruzamento</strong>: Você deve prever se a trave ou o travessão será
								atingido durante o tempo regulamentar da partida. Se a bola bater na trave e acabar
								no gol, ela não será contada como trave.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Faltas ímpares/pares</strong>: você deve prever se o número total de faltas
								na partida será par ou ímpar, incluindo tempo extra.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Impares/pares de impedimento</strong>: você deve prever se o número total de
								impedimentos é um número ímpar ou par na partida, incluindo a prorrogação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de chutes ímpares/pares</strong>: você deve prever se o número total
								de chutes é um número ímpar ou par na partida, incluindo a prorrogação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de chutes a gol ímpar/par</strong>: você deve prever que o número
								total de chutes a gol é um número ímpar ou par na partida, incluindo a prorrogação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Expulsão do técnico do time da casa</strong>: Você deve prever se o técnico
								do time da casa receberá o cartão vermelho durante a partida, incluindo prorrogação
								e cobranças de pênaltis.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Expulsão do técnico do time visitante</strong>: Você deve prever se o
								técnico do time visitante receberá o cartão vermelho durante a partida, incluindo
								prorrogação e cobranças de pênaltis.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pênalti + Expulsão</strong>: Você deve prever a combinação correta de
								pênaltis concedidos e cartões vermelhos durante a partida. Há 4 resultados
								possíveis:
							</strong>
						</p>

						<p>
							<strong>
								Sim/Sim - pelo menos um pênalti é concedido e pelo menos um cartão vermelho é
								mostrado
							</strong>
						</p>

						<p>
							<strong>
								Sim/Não - pelo menos um pênalti é concedido e nenhum cartão vermelho é mostrado
							</strong>
						</p>

						<p>
							<strong>
								Não/Sim - nenhum pênalti é concedido e pelo menos um cartão vermelho é mostrado
							</strong>
						</p>

						<p>
							<strong>
								Não/Não - nenhum pênalti é concedido e nenhum cartão vermelho é mostrado
							</strong>
						</p>

						<p>
							<strong>
								<strong>Gol diretamente de um escanteio</strong>: Você deve prever se um gol será
								marcado diretamente de um escanteio durante o tempo regulamentar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pênalti até o 5º minuto</strong>: Você deve prever se um pênalti será
								concedido nos primeiros 5 minutos do tempo regulamentar (de 0 a 4:59).
							</strong>
						</p>

						<p>
							<strong>
								<strong>2 Jogadores expulsos</strong>: Você deve prever se haverá pelo menos dois
								jogadores expulsos no tempo regulamentar da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador que recebeu um cartão OU seu substituto</strong>: Você deve prever
								se, no tempo regulamentar da partida, o jogador "X" ou quem o substituirá no banco
								receberá pelo menos um cartão (resultado SIM) ou não (resultado NÃO). Para fins da
								aposta, somente o jogador "X" e seu substituto direto do banco são considerados.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1X2 Total de chutes (OT.Incl)</strong>: Você deve prever a equipe que dará o
								maior número de chutes na partida, incluindo a prorrogação. Há três resultados
								possíveis: 1 (o time da casa dá o maior número de chutes), X (os times dão o mesmo
								número de chutes), 2 (o time visitante dá o maior número de chutes).
							</strong>
						</p>

						<p>
							<strong>
								<strong>1X2 Total de chutes a gol (OT.Incl.)</strong>: É preciso prever o time que
								dará mais chutes a gol na partida, incluindo a prorrogação. Há três resultados
								possíveis: 1 (o time da casa dá o maior número de chutes a gol), X (os times darão o
								mesmo número de chutes a gol), 2 (o time visitante dá o maior número de chutes a
								gol).
							</strong>
						</p>

						<p>
							<strong>
								<strong>1X2 impedimento</strong>: Você deve prever qual equipe cometerá o maior
								número de impedimentos na partida, incluindo o tempo extra. Existem 3 resultados
								possíveis: 1 (a equipe da casa comete mais impedimentos), X (as equipes cometerão o
								mesmo número de impedimentos), 2 (a equipe visitante comete mais impedimentos). .
							</strong>
						</p>

						<p>
							<strong>
								<strong>1X2 Faltas</strong>: Você deve prever qual equipe cometerá o maior número de
								faltas, incluindo o tempo extra. Existem 3 resultados possíveis: 1 (a equipe da casa
								comete mais faltas), X (as equipes cometerão o mesmo número de faltas), 2 (a equipe
								visitante comete mais faltas).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de impedimentos (OT.Incl)</strong>: Você deve prever se o número total
								de impedimentos na partida será maior ou menor do que a linha indicada, incluindo a
								prorrogação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de faltas (OT.Incl)</strong>: Você deve prever se o número total de
								faltas na partida será maior ou menor do que a linha indicada, incluindo a
								prorrogação.
								<br />
								<br />
								<strong>Defesas acima/abaixo do time da casa</strong>: Você deve prever se o total
								de defesas dos goleiros e/ou de qualquer outro jogador durante a partida do time da
								casa ficará acima ou abaixo da linha prevista. O tempo extra também está incluído.
								<br />
								<br />
								<strong>Defesas acima/abaixo do time visitante</strong>: Você deve prever se o total
								de defesas dos goleiros e/ou de qualquer outro jogador durante a partida do time
								visitante ficará acima ou abaixo da linha prevista. O tempo extra também está
								incluído.
								<br />
								<br />
								<strong>Defesas Acima/Abaixo</strong>: Você deve prever se o total de defesas dos
								goleiros e/ou de qualquer outro jogador durante a partida para ambas as equipes
								estará acima ou abaixo da linha prevista. O tempo extra também está incluído.
								<br />
								<br />
								<strong>Técnico da equipe da casa com cartão amarelo</strong>: Você deve prever se o
								técnico da equipe da casa receberá um cartão amarelo durante a partida, incluindo
								prorrogação e pênaltis. O cartão vermelho direto não é válido para este mercado.
								<strong>Técnico da equipe visitante com cartão amarelo</strong>: Você deve prever se
								o técnico da equipe visitante receberá um cartão amarelo durante a partida,
								incluindo prorrogação e pênaltis. O cartão vermelho direto não é válido para este
								mercado.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qual equipe receberá o primeiro cartão amarelo?</strong>
								Você deve prever se a equipe da casa ou a visitante receberá o primeiro cartão
								amarelo, incluindo o tempo extra.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qual equipe terminará com o maior número de chutes?</strong>
								Você deve prever se a equipe da casa ou a visitante terminará com o maior número de
								chutes, incluindo o tempo extra.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Cobranças alternadas na disputa de pênaltis - sim/não</strong>
								Você deve prever se a disputa de pênaltis prosseguirá para as cobranças alternadas
								ou não. Duas opções: 1) <strong>Sim</strong>: significa que uma equipe marcará e a
								outra errará logo em seguida; 2) <strong>Não</strong>: significa que uma equipe
								vencerá diretamente nas cinco primeiras cobranças de pênalti ou que a disputa
								terminará em empate antes que as regras de cobranças alternadas se apliquem.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe do último pênalti na disputa de pênaltis</strong>
								Você deve prever se a equipe da casa ou a visitante executará o último pênalti.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Resultado do último pênalti na disputa de pênaltis</strong>
								Você deve prever qual será o resultado do último pênalti cobrado na disputa.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Diferença de gols na disputa de pênaltis</strong>
								Você deve prever a diferença de gols com que uma equipe vencerá a disputa de
								pênaltis. Se a disputa estiver empatada antes da morte súbita, considera-se empate.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe da casa/visitante - Pênalti na partida</strong>
								Você deve prever se haverá um pênalti marcado contra a equipe da casa ou a visitante
								durante o jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ambas as equipes para marcar X+ cartões</strong>
								Você deve prever se ambas as equipes receberão igual ou mais do que X número de
								cartões durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ambas as equipes para marcar X+ gols</strong>
								Você deve prever se ambas as equipes marcarão igual ou mais do que X número de gols
								durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ambas as equipes para marcar X+ escanteios</strong>
								Você deve prever se ambas as equipes terão igual ou mais do que X número de
								escanteios durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Ambas as equipes para marcar X+ escanteios</strong>
								Você deve prever se ambas as equipes terão igual ou mais do que X número de
								escanteios no primeiro tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Ambas as equipes para marcar X+ gols</strong>
								Você deve prever se ambas as equipes marcarão igual ou mais do que X número de gols
								no primeiro tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Ambas as equipes para marcar X+ cartões</strong>
								Você deve prever se ambas as equipes receberão igual ou mais do que X número de
								cartões no primeiro tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de defesas do goleiro X</strong>
								Você deve prever o número total de defesas feitas pelo goleiro X durante a partida.
							</strong>
						</p>

						<p>A tentativa de entrega da bola de um jogador para outro jogador da mesma equipe</p>

						<p>
							Um jogador pode usar qualquer parte de seu corpo (permitida pelas leis do jogo) para
							executar um passe. A categorização do evento inclui passes em jogo aberto, chutes a
							gol, escanteios e cobranças de falta executadas como um passe.
						</p>

						<p>Inclui:</p>

						<ul>
							<li>Passes de jogo aberto</li>
							<li>Tiros de meta</li>
							<li>Escanteios</li>
							<li>Faltas jogadas como passe</li>
						</ul>

						<p>Exclui:</p>

						<ul>
							<li>Cruzamentos</li>
							<li>Lançamentos do goleiro</li>
							<li>Lançamentos laterais</li>
						</ul>

						<p>
							Cada passe é registrado com coordenadas X e Y, indicando seu ponto de origem e
							destino.
						</p>

						<p className="pH2">
							<strong>Mercados Rápidos / Mercados de Intervalo</strong>
						</p>

						<p>
							<strong>
								➔ Os mercados serão liquidados com base no tempo de gol anunciado pela TV. Se isso
								não estiver disponível, o tempo de acordo com o relógio da partida é considerado.
							</strong>
						</p>

						<p>
							<strong>
								➔ Os mercados de gols são determinados com base no momento em que a bola cruza a
								linha, e não no momento em que o chute é executado.
							</strong>
						</p>

						<p>
							<strong>
								➔ Os mercados de intervalo de escanteio são liquidados com base no momento em que o
								escanteio é cobrado e não no momento em que o escanteio é concedido ou ganho.
							</strong>
						</p>

						<p>
							<strong>
								➔ Os mercados de intervalo de cartões são liquidados com base no momento em que o
								cartão é mostrado e não no momento em que a infração é feita.
							</strong>
						</p>

						<p>
							<strong>
								➔ Os impedimentos serão liquidados com base no momento em que o árbitro decidir.
								Esta regra será aplicada a qualquer situação de árbitro assistente de vídeo (VAR).
							</strong>
						</p>

						<p>
							<strong>
								➔ Os mercados de pênaltis serão determinados com base no momento em que o árbitro
								decidir. Esta regra será aplicada a qualquer situação de árbitro assistente de vídeo
								(VAR).
							</strong>
						</p>

						<p>
							<strong>➔ Os pênaltis atribuídos, mas não batidos não são considerados.</strong>
						</p>

						<p>
							<strong>
								<strong>
									Estes tipos de mercados podem ser oferecidos em intervalos de minutos como
								</strong>
								: 1, 5, 10, 15, etc; conforme o caso. Dentro desta oferta, pode-se encontrar
								mercados baseados em Gols, Escanteios, Cartões com a fórmula 1X2, mais/menos,
								Handicap.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Intervalo de 1 minuto</strong>: Vai do segundo 00:00 ao segundo 00:59.
							</strong>
						</p>

						<p>
							<strong>
								<strong>intervalo de 5 minutos</strong>: o minuto 1 a 5 vai do minuto 00:00 ao
								minuto 04:59
							</strong>
						</p>

						<p>
							<strong>
								<strong>intervalo de 10 minutos</strong>: o minuto 1 a 10 vai do minuto 00:00 ao
								minuto 09:59
							</strong>
						</p>

						<p>
							<strong>
								<strong>intervalo de 15 minutos</strong>: Minuto 1 a 15 vai do minuto 00:00 ao
								minuto 14:59
							</strong>
						</p>

						<p>
							<strong>
								<strong>Regra 1</strong>: caso o mercado de intervalo selecionado contenha a opção
								NÃO ou NENHUMA. Portanto, se a aposta for gerada no Pré-jogo significa que no evento
								NÃO haverá gols, escanteios, cartões ou o resto; conforme o caso. Se a aposta for
								gerada ao vivo, significa que a partir desse momento NÃO haverá gols, escanteios,
								cartões ou o resto, conforme o caso.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Regra 2</strong>: caso qualquer um dos intervalos selecionados pelo usuário
								contenha o minuto 45 (Fim do primeiro tempo) ou o minuto 90 (Fim do segundo tempo ou
								tempo regulamentar), os minutos de tempo de lesão/interrupção concedidos pelo
								árbitro serão considerados.
							</strong>
						</p>

						<p className="pH2">
							<strong>Mercados de um minuto (do min. A ao min. B):</strong>
						</p>

						<p>
							<strong>➔ 1 minuto - total de gols de a a b</strong>
						</p>

						<p>
							<strong>➔ 1 minuto - total de escanteios de a a b</strong>
						</p>

						<p>
							<strong>➔ 1 minuto - total de cartões de a a b</strong>
						</p>

						<p>
							<strong>➔ 1 minuto - total de impedimentos de a a b</strong>
						</p>

						<p>
							<strong>➔ 1 minuto - total de penalidades atribuídas de a a b</strong>
						</p>

						<p>
							<strong>
								<strong>5, 10, 15 minutos Mercados (do min. A ao min. B)</strong>:
							</strong>
						</p>

						<p>
							<strong>➔ 1x2 de a a b</strong>
						</p>

						<p>
							<strong>➔ xº gol de a a b</strong>
						</p>

						<p>
							<strong>➔ total de gols de a a b</strong>
						</p>

						<p>
							<strong>➔ escanteio 1x2 de a a b</strong>
						</p>

						<p>
							<strong>➔ x escanteio de a a b</strong>
						</p>

						<p>
							<strong>➔ handicap de escanteios de a a b</strong>
						</p>

						<p>
							<strong>➔ total de escanteios de a a b</strong>
						</p>

						<p>
							<strong>➔ competidor 1 total de escanteios de a a b</strong>
						</p>

						<p>
							<strong>➔ competidor 2 total de escanteios de a a b</strong>
						</p>

						<p>
							<strong>➔ escanteios pares/ímpares de a a b</strong>
						</p>

						<p>
							<strong>
								<strong>10 minutos - 1x2</strong>: Você tem que prever o resultado dos primeiros dez
								(10) minutos. Os eventos devem acontecer entre 0:00 e 09:59 para serem classificados
								nos primeiros 10 minutos. Relatórios oficiais das ligas que organizam os eventos e
								relatórios de fornecedores oficiais serão usados para determinar o resultado
								correto.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quando um gol será marcado (intervalo de 15 min)</strong>: Você deve prever
								se um gol será marcado no período de tempo selecionado: 7 resultados possíveis:
							</strong>
						</p>

						<p>
							<strong>1-15</strong>
						</p>

						<p>
							<strong>16-30</strong>
						</p>

						<p>
							<strong>31-45</strong>
						</p>

						<p>
							<strong>46-60</strong>
						</p>

						<p>
							<strong>61-75</strong>
						</p>

						<p>
							<strong>76-90</strong>
						</p>

						<p>
							<strong>Nenhum</strong>
						</p>

						<p>
							<strong>
								<strong>Quando um gol será marcado (intervalo de 10 min)</strong>: Você deve prever
								se um gol será marcado no período de tempo selecionado: 10 resultados possíveis:
							</strong>
						</p>

						<p>
							<strong>1-10</strong>
						</p>

						<p>
							<strong>11-20</strong>
						</p>

						<p>
							<strong>21-30</strong>
						</p>

						<p>
							<strong>31-40</strong>
						</p>

						<p>
							<strong>41-50</strong>
						</p>

						<p>
							<strong>51-60</strong>
						</p>

						<p>
							<strong>61-70</strong>
						</p>

						<p>
							<strong>71-80</strong>
						</p>

						<p>
							<strong>81-90</strong>
						</p>

						<p>
							<strong>Nenhum</strong>
						</p>

						<p className="pH2">
							<strong>Liquidação estatística.</strong>
						</p>

						<p>
							<strong>
								Salvo indicação em contrário no nome do mercado, as seguintes estatísticas são
								liquidadas conforme descrito.
							</strong>
						</p>

						<p>
							<strong>Tiros bloqueados</strong>
						</p>

						<ul>
							<li>
								<strong>
									Uma tentativa de gol bloqueada por um jogador de campo, onde outros defensores ou
									um goleiro estão atrás do bloqueador. Inclui tiros bloqueados involuntariamente
									pelo companheiro do atirador.{' '}
								</strong>

								<p>
									<strong>&nbsp;</strong>
								</p>
								<strong> </strong>
							</li>
						</ul>

						<p className="pH3">
							<strong>Tiro livre</strong>
						</p>

						<ul>
							<li>
								<p className="pH3">
									<strong>
										Como tiro livre é definido qualquer tiro livre executado, excluindo pênaltis e
										incluindo impedimentos.
									</strong>
								</p>
							</li>
						</ul>

						<p className="pH3">
							<strong>Jogue dentro</strong>
						</p>

						<ul>
							<li>
								<p className="pH3">
									<strong>
										Um método de reiniciar o jogo quando a bola saiu pelas linhas laterais do campo
										de jogo. Como lançado é definido qualquer lançamento realizado.
									</strong>
								</p>
							</li>
						</ul>

						<p className="pH3">
							<strong>Tiros de Meta</strong>
						</p>

						<ul>
							<li>
								<p className="pH3">
									<strong>
										Método de reinício do jogo, quando a bola sai atrás das linhas de gol do campo
										de jogo pela equipe atacante. Como tiro de meta é definido qualquer tiro de meta
										executado.
									</strong>
								</p>
							</li>
						</ul>

						<p className="pH3">
							<strong>Salvar</strong>
						</p>

						<ul>
							<li>
								<p className="pH3">
									<strong>
										Guarda-redes que impede a bola de entrar na baliza com qualquer parte do corpo
										quando enfrenta um remate intencional de um jogador adversário. Como defesa é
										definida, qualquer defesa do goleiro, a menos que especificado de outra forma no
										mercado.
									</strong>
								</p>
							</li>
						</ul>

						<p className="pH3">
							<strong>Substituição</strong>
						</p>

						<ul>
							<li>
								<p className="pH3">
									<strong>
										Troca de um jogador do banco que entra em campo durante uma partida por um
										jogador que já estava em campo jogando.
									</strong>
								</p>
							</li>
						</ul>

						<p className="pH3">
							<strong>Fora dos limites</strong>
						</p>

						<ul>
							<li>
								<p className="pH3">
									<strong>
										Quando a bola sai do campo de jogo para um tiro de meta, escanteio ou reposição
										lateral.{' '}
									</strong>
								</p>
							</li>
						</ul>

						<p className="pH3">
							<strong>Impedimento</strong>
						</p>

						<ul>
							<li>
								<p className="pH3">
									<strong>
										Um evento atribuído ao jogador considerado em posição de impedimento quando um
										tiro livre é concedido.
									</strong>
								</p>
							</li>
							<li>
								<p className="pH2">
									<strong>Futebol - Outrights</strong>
								</p>
							</li>
						</ul>

						<p>
							<strong>
								<strong>Vencedor</strong>: Você deve prever o vencedor de um determinado torneio de
								acordo com o ranking oficial da competição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Top2, Top4, Top6, Top8, Top10</strong>: Você tem que prever se a equipe ou
								jogador selecionado terminará na posição superior respectiva quando a competição
								terminar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quem terminará melhor na Liga</strong>: Você deve prever qual das equipes
								indicadas alcançará o melhor posicionamento no final de determinado torneio ou
								temporada, considerando pontuações reais. Se as equipes completarem a competição com
								a mesma quantidade de pontos, a tabela oficial publicada pela Liga de Futebol do
								respectivo país será considerada para determinar o vencedor.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Para terminar em último</strong>: Você deve prever se a equipe ou jogador
								indicado terminará em último lugar quando a competição terminar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Melhor Equipe Promovida</strong>: Você deve prever qual equipe
								recém-promovida terminará na posição mais alta no torneio. Se houver uma situação de
								empate, a tabela oficial da liga na conclusão da partida final da temporada
								programada determinará a liquidação das apostas. Os play-offs de final de temporada
								contarão.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Para terminar na metade superior</strong>: Você deve prever qual das equipes
								nomeadas terminará na metade superior de um determinado torneio/liga (por exemplo,
								em uma liga de 16 equipes, se a equipe selecionada terminar nas posições 1-8).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor Sem (s/o) - equipes</strong>: Você tem que prever o vencedor da
								competição nomeada (qual equipe no mercado terminará melhor no torneio nomeado) sem
								levar em consideração a(s) equipe(s) nomeada(s). Por exemplo, Premier League 2020/21
								- sem os Big Six significaria qualquer time que terminasse mais alto na Premier
								League na temporada 2020/21 sem considerar Arsenal, Chelsea, Liverpool, Manchester
								City, Manchester Utd e Tottenham.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe a marcar mais gols</strong>: Você deve prever qual equipe marcará
								mais gols em todo o torneio. Se duas ou mais equipes marcarem o mesmo número de
								gols, as regras de empate serão aplicadas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe a marcar menos gols</strong>: Tem de prever qual a equipe que marcará
								menos gols em todo o torneio. Se duas ou mais equipes marcarem o mesmo número de
								gols, as regras de empate serão aplicadas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Melhor time do torneio</strong>: Você aposta em qual time da confederação
								vai mais longe durante a competição. Se houver empate entre várias equipes e elas
								forem eliminadas na mesma fase, será aplicada a regra Dead Heat.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Artilheiro</strong>: Você deve prever o jogador que fará mais gols durante o
								torneio. Gols marcados em outras competições não são levados em consideração. Se o
								jogador escolhido jogar pelo menos uma vez durante a temporada, esta tipologia de
								aposta permanecerá válida, caso contrário será anulada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Rebaixamento</strong>: Você tem que prever qual time ou times serão
								rebaixados da divisão.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador com mais assistências</strong>: Você deve prever qual jogador fará
								mais assistências durante o torneio indicado. Os resultados são retirados da
								federação e serão usados para fins de liquidação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor do Grupo</strong>: Você aposta na equipe que vai terminar com a
								maior quantidade de pontos em seu grupo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Fase de Eliminação</strong>: Você aposta na fase em que uma determinada
								equipe será eliminada da competição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qual time sofrerá mais gols</strong>: você aposta no time que vai sofrer
								mais gols durante sua participação na competição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe com mais gols</strong>: Aposta na equipe que vai marcar mais gols
								durante a sua participação na competição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time artilheiro</strong>: Você aposta em quem irá ser o artilheiro do
								respectivo time. A opção de "Sem artilheiro" significa que ninguém marcará gols no
								time em questão. No caso de empate entre dois ou mais jogadores, a regra Dead Heat
								será aplicada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Chegar à final/ Semifinal/Quartas de final</strong>: Você deve prever se a
								equipe ou jogador indicado se classificará para a rodada específica da competição
								nomeada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor e artilheiro</strong>: Você deve prever qual time vencerá o torneio
								e o jogador que marcará mais gols. As regras do vencedor e do artilheiro se aplicam
								ao mercado selecionado e ambas as seleções precisam vencer, para que o combo vença.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Melhor Jogador do Torneio</strong>: Você tem que prever quem será nomeado o
								melhor jogador do torneio. Os resultados são retirados da federação e serão usados
								para fins de liquidação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Grupo Vencedor</strong>: Você deve prever o grupo da equipe vencedora da
								competição nomeada.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qualificação do Grupo</strong>: Você deve prever se a equipe selecionada do
								referido grupo vai se classificar (Sim) ou não (Não).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Eliminação por pênaltis</strong>: Você tem que prever se a equipe
								selecionada será eliminada do torneio por pênaltis.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Straight Forecast</strong>: A aposta Straight Forecast é aquela em que você
								escolhe duas seleções que terminarão em primeiro e segundo na ordem correta e se
								qualificarão para a próxima rodada. Para ganhar, você deve prever corretamente as
								seleções de primeiro e segundo colocados, que precisam estar na ordem correta de
								colocação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pontos exatos do grupo</strong>: Você deve prever exatamente quantos pontos
								a equipe selecionada ganhará na fase de grupos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Dupla Avançada</strong>: A aposta Dupla Avançada é aquela em que você
								escolhe quais duas equipes avançarão de um grupo/torneio específico,
								independentemente de sua posição final. Para que a aposta vença, ambas as equipes
								selecionadas devem se classificar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mercados H2H de Jogador</strong>: Se o jogador listado não participar da
								partida, as apostas serão consideradas nulas. Em caso de empate entre os jogadores,
								as apostas são anuladas. (A saber: H2H significa head to head, o que pode ser
								traduzido como "cabeça a cabeça", o que indica comparação entre dois adversários).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de Gols do Jogador</strong>: O jogador deve participar do torneio para
								que as apostas sejam válidas. Gols em 90 minutos e prorrogação contam. Gols marcados
								em disputas de pênaltis não contam.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de Cartões Amarelos do Jogador</strong>: . Qualquer cartão amarelo
								exibido após o apito final será desconsiderado. Casa Caso uma partida seja
								abandonada antes dos 90 minutos terem sido jogados, todas as apostas serão anuladas,
								a menos que a liquidação das apostas já esteja determinada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de faltas cometidas pelo jogador</strong>: Uma falta sofrida é
								definida como qualquer infração penalizada como jogo sujo por um árbitro que resulta
								em um tiro livre ou pênalti.
							</strong>
						</p>

						<p>
							<strong>· Os impedimentos não são dados como falta concedida.</strong>
						</p>

						<p>
							<strong>
								· Incidentes em que um árbitro tenha aproveitado a vantagem e subsequentemente
								advertido um jogador não contribuem para a contagem total de faltas do jogador.
								Nestes cenários, um evento de cobrança de falta ou pênalti deve ocorrer para que uma
								falta seja concedida.
							</strong>
						</p>
					</div>
				</details>
				{/* Futebol Americano  */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 28 28"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<path
								d="M27.97 17.81L22.42 17.72L21.02 14.35C23.6 13.06 27.12 11.83 28.59 11.24C29.1 11.02 29.33 10.43 29.11 9.93C28.89 9.42 28.3 9.19 27.8 9.41L26.48 9.98C24.32 5.28 19.85 3 14.14 3C6.33 3 0 9.33 0 17.14C0 21.51 3.42 29.63 7.09 29.96C7.2 29.96 7.3 29.97 7.4 29.97C9.39 29.97 9.91 28.17 12.22 28.11C12.25 28.11 12.28 28.11 12.32 28.11C13.88 28.11 15.6 29.05 17.12 29.05C17.58 29.05 18.02 28.96 18.44 28.73C20.05 27.83 20.1 26.57 19.57 24.57H23.12L23.49 25.45C24.37 27.22 25.57 29.02 27.84 29.04C27.84 29.04 27.84 29.04 27.85 29.04H27.92C28.98 29.04 29.97 28.67 30.71 27.99C31.49 27.27 31.93 26.28 31.95 25.18L32 21.97C32.04 19.71 30.23 17.84 27.97 17.81ZM19.27 15.35L20.26 17.71L17.8 17.74C17.8 17.21 17.91 16.77 18.16 16.36C18.36 16.04 18.76 15.69 19.27 15.34V15.35ZM12.59 24.57C11.08 24.57 9.85 23.34 9.85 21.83C9.85 20.32 11.08 19.09 12.59 19.09C14.1 19.09 15.33 20.32 15.33 21.83C15.33 23.34 14.1 24.57 12.59 24.57ZM18.96 22.57C18.6 21.45 18.31 20.51 18.1 19.74L21.09 19.71L22.29 22.58H18.96V22.57ZM29.95 25.15C29.95 25.7 29.74 26.17 29.36 26.52C28.98 26.87 28.43 27.03 27.88 27.04C26.89 27.04 26.19 26.37 25.32 24.62L25.3 24.57H29.98V25.15H29.95ZM24.43 22.57L23.25 19.73L27.93 19.81C29.09 19.83 30.01 20.78 29.99 21.94V22.57H24.43Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
						</svg>
						Futebol Americano
					</summary>
					<div className="textItem">
						<p className="pH2">
							<strong>Principais Mercados</strong>
						</p>

						<p>
							<strong>
								<strong>MoneyLine (1-2)</strong>: Você deve acertar o vencedor do jogo
								independentemente do spread de pontos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total (incl. OT) (Under/Over)</strong>: Este tipo de aposta consiste em
								especificar o total de pontos no jogo, incluindo o OT.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total da equipe da casa (Abaixo/Acima)</strong>: Aposta que consiste em
								especificar os pontos totais da equipe da casa, este mercado inclui os pontos
								marcados no prolongamento possível.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total da equipe visitante (abaixo/acima)</strong>: Aposta que consiste em
								especificar a pontuação total da equipe visitante, este mercado inclui os pontos
								marcados na prorrogação possível.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Corrida para x pontos (incluindo prorrogação)</strong>: Preveja qual equipe
								chegará primeiro em X gols, incluindo prorrogação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Próximo gol (incluindo prorrogação)</strong>: Você tem que prever qual Time
								marcará o próximo gol. Existem 3 resultados possíveis: 1 (o placar do time da casa),
								X (ou nenhum para marcar), 2 (o placar do time visitante).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Próximo tipo de pontuação (incluindo prorrogação)</strong>: Você deve prever
								por qual tipo de pontuação será marcado o Xº gol. Temos 4 resultados possíveis:
								touchdown, field goal, safety, nenhum.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quarto com maior pontuação</strong>: Você deve prever qual quarto da partida
								terá mais pontos marcados.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Metade com maior pontuação</strong>: Você deve prever qual metade da partida
								terá mais pontos marcados.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Haverá tempo extra?</strong>: Você deve prever se haverá tempo extra ou não.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ímpar/par (incluindo prorrogação)</strong>: Preveja se o número total de
								pontos marcados durante a partida for um número par ou ímpar, caso contrário, se a
								pontuação final for 0:0, as apostas serão determinadas como par.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Casa ímpar/par (incluindo prorrogação)</strong>: Preveja se o número total
								de pontos marcados durante a partida pela equipe da casa for um número ímpar ou par,
								caso contrário, se a pontuação final for 0:0, as apostas serão determinadas como
								par.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Fora de casa ímpar/par (incluindo prorrogação)</strong>: Preveja se o número
								total de pontos marcados durante a partida pela equipe visitante for um número par
								ou ímpar, caso contrário, se a pontuação final for 0:0, as apostas serão
								determinadas como par.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de touchdowns (incluindo prorrogação)</strong>: Você deve prever o
								número total (mais/menos) de touchdowns marcados durante a partida e prorrogação
								incluída.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de field goals marcados (incluindo prorrogação)</strong>: Você deve
								prever o número total (mais/menos) de field goals marcados durante a partida e
								prorrogação incluída.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de turnovers (incluindo tempo extra)</strong>: Você deve prever o
								número total (mais/menos) de turnovers registrados durante a partida e tempo extra
								incluídas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de sacks (incluindo prorrogação)</strong>: Você deve prever o número
								total (mais/menos) de sacks registrados durante a partida e prorrogação incluída.
							</strong>
						</p>

						<p>
							<strong>
								<strong>xº field goal feito (incluindo prorrogação)</strong>: Você tem que prever
								qual time fará o Xº field goal durante a partida e prorrogação incluída.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Haverá tempo extra</strong>: Adivinhe se o evento terá tempo extra ou não.
							</strong>
						</p>

						<p className="pH2">
							<strong>Mercados do 1º tempo</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - 1x2</strong>: Você tem que prever o resultado do 1º tempo, as
								seleções são 1-o time da casa, 2-o time visitante e X-draw. Se a metade estiver
								incompleta, este mercado será anulado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - handicap</strong>: Você tem que prever o vencedor do 1º tempo
								somando ou subtraindo o spread indicado ao resultado do tempo, se o tempo estiver
								incompleto este mercado será anulado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - total</strong>: Você tem que prever se o número total de pontos
								marcados durante o 1º tempo será acima ou abaixo da linha indicada, se o tempo
								estiver incompleto este mercado será anulado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - empate anula aposta</strong>: Você tem que prever o vencedor do
								1º tempo, se o tempo terminar empatado todas as apostas serão anuladas para este
								mercado, se o tempo estiver incompleto este mercado será anulado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - par/ímpar</strong>: Você tem que prever se o número de pontos
								marcados durante o 1º tempo da partida será par ou ímpar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1ª parte - Equipe da casa ímpar/par</strong>: Tem de prever se o número de
								pontos marcados pela equipe da casa durante a 1ª parte do jogo será par ou ímpar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1ª parte - Equipe visitante ímpar/par</strong>: Tem de prever se o número de
								pontos marcados pela equipe visitante durante a 1ª parte do jogo será par ou ímpar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - próximo placar</strong>: Você tem que prever qual Time marcará o
								próximo gol durante o 1º tempo. Existem 3 resultados possíveis: 1 (o resultado da
								equipe da casa), X (o empate da equipe), 2 (o resultado da equipe visitante).
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo 1x2 e total do 1º tempo</strong>: Você deve prever o resultado e o
								número total de gols (mais/menos) para o 1º tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap do 1º tempo e total do 1º tempo</strong>: Você deve prever o
								resultado (levando em consideração o handicap na chave) e o número total de gols
								(mais/menos) do 1º tempo.
							</strong>
						</p>

						<p className="pH2">
							<strong>Mercados do 2º tempo</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - 1x2</strong>: Você tem que prever o resultado do 2º tempo, as
								seleções são 1-o time da casa, 2-o time visitante e X-emprate. Se a metade estiver
								incompleta, este mercado será anulado. As horas extraordinárias não estão incluídas,
								salvo indicação em contrário (inclui tempo extra).
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - handicap</strong>: Você tem que prever o vencedor do 2º tempo
								somando ou subtraindo o spread indicado ao resultado do tempo, se o tempo estiver
								incompleto este mercado será anulado. As horas extraordinárias não estão incluídas,
								salvo indicação em contrário (inclui tempo extra).
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - total (mais/menos)</strong>: você tem que prever se o número
								total de pontos marcados durante o 2º tempo será acima ou abaixo do spread indicado,
								se o tempo estiver incompleto este mercado será anulado. As horas extraordinárias
								não estão incluídas, salvo indicação em contrário (inclui tempo extra).
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - empate anula aposta (incluindo prorrogação)</strong>: Você tem
								que prever o vencedor do 2º tempo, se o tempo terminar empatado todas as apostas
								serão anuladas para este mercado, se o tempo estiver incompleto neste mercado será
								anulado. As horas extraordinárias não estão incluídas, salvo indicação em contrário
								(inclui tempo extra).
							</strong>
						</p>

						<p className="pH2">
							<strong>Mercados de quartos</strong>
						</p>

						<p>
							<strong>
								<strong>Quarto - 1x2</strong>: Você tem que prever o resultado do quarto
								selecionado, as seleções são 1-o time da casa, 2-o time visitante e X-empate. Se o
								quarto não estiver concluído, este mercado será anulado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quarto - total (mais/menos)</strong>: Você tem que prever se o número total
								de pontos marcados durante o quarto selecionado será superior ou inferior ao spread
								indicado, se o quarto estiver incompleto este mercado será anulado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quarto - empate anula aposta</strong>: Você tem que prever o vencedor do
								quarto selecionado, se o quarto terminar empatado todas as apostas serão anuladas
								para este mercado, se o quarto estiver incompleto este mercado será anulado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quarto - handicap</strong>: Você tem que prever o vencedor do quarto
								selecionado adicionando ou subtraindo o spread indicado ao resultado do quarto, se o
								quarto estiver incompleto este mercado será anulado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º quarto 1x2 e total do 1º quarto</strong>: você deve prever o resultado e
								o número total de gols (acima/abaixo) do 1º quarto.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap do 1º quarto e total do 1º quarto</strong>: Você deve prever o
								resultado (levando em consideração o handicap na chave) e o número total de gols
								(acima/abaixo) do 1º quarto.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Tentativas totais de passes (incl. OT):</strong>
								Você deve prever o número combinado de tentativas de passes feitas por ambas as
								equipes durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Completamentos totais de passes (incl. OT):</strong>
								Você deve prever o número combinado de passes completados feitos por ambas as
								equipes durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jardas totais de passes (incl. OT):</strong>
								Você deve prever o número combinado de jardas de passes ganhas por ambas as equipes
								durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Tackles totais (incl. OT):</strong>
								Você deve prever o número combinado de tackles feitos por ambas as equipes durante a
								partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jardas totais ofensivas (incl. OT):</strong>
								Você deve prever o número combinado de jardas ofensivas ganhas por ambas as equipes
								durante o jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Receptações totais (incl. OT):</strong>
								Você deve prever o número total de passes completados e recebidos pelos jogadores de
								ambas as equipes durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de passes para touchdown (incl. OT):</strong>
								Você deve prever o número total de touchdowns feitos por passes durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de corridas para touchdown (incl. OT):</strong>
								Você deve prever o número total de touchdowns feitos por corridas durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de recepções para touchdown (incl. OT):</strong>
								Você deve prever o número total de touchdowns feitos por recepções durante a
								partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de touchdowns ofensivos (incl. OT):</strong>
								Você deve prever o número total de touchdowns feitos ofensivamente pelas duas
								equipes durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jardas totais de recepção (incl. OT):</strong>
								Você deve prever o número total de jardas ganhas pelos jogadores através de passes
								completados durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jardas totais de corridas (incl. OT):</strong>
								Você deve prever o número total de jardas ganhas por todos os jogadores de ambas as
								equipes através de corridas durante a partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jardas totais de corridas e recepções (incl. OT):</strong>
								Você deve prever o número total de jardas combinadas ganhas por ambas as equipes
								através de corridas e recepções durante a partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jardas totais de passes e corridas (incl. OT):</strong>
								Você deve prever o número total de jardas combinadas ganhas por ambas as equipes
								através de passes e corridas durante a partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Tackles e assistências totais (incl. OT):</strong>
								Você deve prever o número combinado de tackles (tanto solo quanto assistidos) feitos
								pelos jogadores defensivos durante a partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Conversão de 2 pontos feitos (incl. OT):</strong>
								Você deve prever o número total de tentativas bem-sucedidas de conversões de 2
								pontos feitas pelas duas equipes durante a partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Conversão de 2 pontos tentados (incl. OT):</strong>
								Você deve prever o número total de tentativas de conversão de 2 pontos feitas pelas
								duas equipes após um touchdown durante a partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Fumbles totais (incl. OT):</strong>
								Você deve prever o número total de fumbles (perdidos ou recuperados) cometidos pelas
								duas equipes durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jardas totais de passes brutas (incl. OT):</strong>
								Você deve prever o número total de jardas ganhas por uma equipe através de passes
								durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								*Se um jogador não participar da partida, todas as apostas serão consideradas
								anuladas.*{' '}
							</strong>
						</p>

						<p className="pH2">
							<strong>Mercados de drive</strong>
						</p>

						<p>
							<strong>
								<strong>x drive da jogada x - tipo de jogada do competidor</strong>: Preveja se o
								tipo de jogada será uma corrida ou um passe. Apenas um passe para frente conta como
								uma jogada de passe por definição. Um sack também é considerado uma jogada de passe.
							</strong>
						</p>

						<p>
							<strong>
								<strong>x drive da jogada x - conclusão do passe do competidor</strong>: Preveja se
								haverá um passe completo durante a jogada declarada. Apenas um passe para frente
								será considerado para uma jogada de passe por definição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>x drive da jogada x - total de jardas ganhas do competidor</strong>: Preveja
								o total de jardas ganhas durante a jogada declarada. As jardas ganhas por meio de
								penalidades de jogo não serão consideradas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>x drive da jogada x - nova primeira descida do competidor</strong>: Preveja
								se o competidor ganhará uma nova primeira descida durante a jogada declarada. Um
								touchdown só é creditado como um novo primeiro down quando marcado pelo ataque.
								Primeiras descidas e jardas obtidas por penalidades de jogo não serão consideradas
								para liquidação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>x drive da jogada x - sack do competidor</strong>: Prever se haverá ou não
								um sack na jogada indicada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>x drive - resultado do competidor</strong>: Preveja o resultado da jogada
								declarada do competidor (punt, touchdown, tentativa de field goal) Resultados
								diferentes serão resolvidos com "outros" .
							</strong>
						</p>

						<p>
							<strong>
								*Caso não haja jogadas, todos os mercados serão liquidados com a próxima jogada ou
								anulados se a movimentação terminar antes de chegar à respectiva jogada.
							</strong>
						</p>

						<p>
							<strong>
								** No caso de o drive ser encerrado antes que o respectivo número de jogo seja
								alcançado, todos os mercados para o respectivo jogo serão considerados nulos. Isso
								inclui punts e field goals.
							</strong>
						</p>

						<p>
							<strong>
								*** A jarda de field goal não será considerada para o total de jardas ganhas em uma
								jogada.
							</strong>
						</p>

						<p className="pH2">
							<strong>Especiais do Jogador</strong>
						</p>

						<p>
							<strong>
								<strong>Jardas de passe do jogador</strong>: Consiste em prever a quantidade de
								jardas de passe que o jogador específico irá registrar, apenas o tempo padrão, a
								menos que o mercado especifique (Inc OT).{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jardas de passe do jogador (pelo menos)</strong>: Consiste em prever pelo
								menos quantas jardas de passe o jogador específico registrará, apenas o tempo
								padrão, a menos que o mercado especifique (Inc OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Conclusão de passes de jogadores</strong>: Consiste em prever a quantidade
								de finalizações de passes que o jogador específico irá registrar, apenas o tempo
								padrão, a menos que o mercado especifique (Inc OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Finalizações de passes do jogador (pelo menos)</strong>: Consiste em prever
								pelo menos quantas finalizações de passe o jogador específico registrará, apenas o
								tempo padrão, a menos que o mercado especifique (Inc OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Touchdowns de passe do jogador</strong>: Consiste em prever a quantidade de
								touchdowns de passe que o jogador específico irá registrar, apenas o tempo padrão, a
								menos que o mercado especifique (Inc OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Touchdowns de passe do jogador (pelo menos)</strong>: Consiste em prever
								pelo menos quantos touchdowns de passe o jogador específico gravará, apenas o tempo
								padrão, a menos que o mercado especifique (Inc OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Tentativas de corrida do jogador</strong>: Consiste em prever a quantidade
								de tentativas de corrida que o jogador específico gravará, apenas o tempo padrão, a
								menos que o mercado especifique (Inc OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Tentativas de corrida do jogador (pelo menos)</strong>: Consiste em prever
								pelo menos quantas tentativas de corrida o jogador específico gravará, apenas o
								tempo padrão, a menos que o mercado especifique (Inc OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador correndo jardas</strong>: Consiste em prever a quantidade de jardas
								correndo que o jogador específico irá registrar, apenas o tempo padrão, a menos que
								o mercado especifique (Inc OT).{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador correndo jardas (pelo menos)</strong>: Consiste em prever pelo menos
								quantas jardas correndo o jogador específico irá registrar, apenas o tempo padrão, a
								menos que o mercado especifique (Inc OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Touchdowns apressados do jogador</strong>: Consiste em prever a quantidade
								de touchdowns rápidos que o jogador específico gravará, apenas o tempo padrão, a
								menos que o mercado especifique (Inc OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Touchdowns apressados do jogador (pelo menos)</strong>: Consiste em prever
								pelo menos quantos touchdowns rápidos o jogador específico gravará, apenas o tempo
								padrão, a menos que o mercado especifique (Inc OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Recepções do jogador</strong>: Consiste em prever a quantidade de recepções
								que o jogador específico irá gravar, apenas o tempo padrão, a menos que o mercado
								especifique (Inc OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Recepções do jogador (pelo menos)</strong>: Consiste em prever pelo menos
								quantas recepções o jogador específico gravará, apenas o tempo padrão, a menos que o
								mercado especifique (Inc OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador recebendo jardas</strong>: Consiste em prever a quantidade de jardas
								recebidas que o jogador específico irá registrar, apenas o tempo padrão, a menos que
								o mercado especifique (Inc OT).{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador recebendo jardas (pelo menos)</strong>: Consiste em prever pelo
								menos quantas jardas de recebimento o jogador específico irá registrar, apenas o
								tempo padrão, a menos que o mercado especifique (Inc OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador recebendo touchdowns</strong>: Consiste em prever a quantidade de
								touchdowns recebidos que o jogador específico irá registrar, apenas o tempo padrão,
								a menos que o mercado especifique (Inc OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador recebendo touchdowns (pelo menos)</strong>: Consiste em prever pelo
								menos quantos touchdowns recebidos o jogador específico irá gravar, apenas o tempo
								padrão, a menos que o mercado especifique (Inc OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador para marcar primeiro touchdown</strong>: Prever qual jogador marcará
								o primeiro touchdown da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de interceptações lançadas pelo QB</strong>: Consiste em prever a
								quantidade de interceptações totais que o jogador específico irá registrar, apenas o
								tempo padrão, a menos que o mercado especifique (Inc OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Conclusão mais longa por QB</strong>: Consiste em prever a conclusão mais
								longa que o jogador específico registrará, apenas o tempo padrão, a menos que o
								mercado especifique (Inc OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Sacks do jogador</strong>: Consiste em prever a quantidade de sacks que o
								jogador específico irá registrar, apenas o tempo padrão, a menos que o mercado
								especifique (Inc OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Corrida mais longa do jogador</strong>: Consiste em prever a corrida mais
								longa que o jogador específico registrará, apenas o tempo padrão, a menos que o
								mercado especifique (Inc OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeira tentativa de rush por JOGADOR</strong>: Prever qual jogador irá
								gravar a primeira tentativa de rush da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeira recepção por JOGADOR</strong>: Prever qual jogador irá gravar a
								primeira recepção da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeira conclusão por QB</strong>: Prever qual QB registrará a primeira
								conclusão da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogada mais longa do jogo</strong>: Prever qual jogador registrará a jogada
								mais longa da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Recepção mais longa no jogo</strong>: Prever qual jogador registrará a
								recepção mais longa da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Confronto direto com jardas de passe</strong>: Consiste em prever qual dos
								jogadores mencionados registrará mais jardas de passe na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Finalizações de passes de jogadores cabeça-a-cabeça</strong>: Consiste em
								prever qual dos jogadores mencionados registrará mais finalizações de passes na
								partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Confronto direto com jardas de corrida</strong>: Consiste em prever qual dos
								jogadores mencionados registrará mais jardas de corrida na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Confronto direto com jardas recebidas</strong>: Consiste em prever qual dos
								jogadores mencionados registrará mais jardas recebidas na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Recepções de jogadores frente a frente</strong>: Consiste em prever qual dos
								jogadores mencionados registrará mais recepções na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador carrega pelo menos</strong>: Você tem que prever quantos carrega
								pelo menos o jogador listado vai marcar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador (defensivo) para ter uma interceptação</strong>: Você tem que prever
								se o jogador listado vai gravar uma interceptação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador primeiro rush (incl. OT)</strong>: Você tem que prever qual dos
								jogadores listados irá gravar o primeiro rush.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Tentativas de corrida do jogador, pelo menos</strong>: Você tem que prever
								pelo menos quantas tentativas de corrida o jogador listado irá gravar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador correndo jardas pelo menos</strong>: Você tem que prever pelo menos
								quantas jardas correndo o jogador listado vai registrar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador apressando-tds pelo menos</strong>: Você tem que prever pelo menos
								quantos tds apressados o jogador listado vai gravar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Recepções do jogador, pelo menos</strong>: Você tem que prever pelo menos
								quantas recepções o jogador listado irá registrar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador recebendo jardas pelo menos</strong>: Você tem que prever pelo menos
								quantas jardas recebidas o jogador listado irá registrar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador recebendo tds pelo menos</strong>: Você tem que prever pelo menos
								quantos tds recebendo o jogador listado irá gravar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Touchdowns de jogadores pelo menos</strong>: Você tem que prever pelo menos
								quantos touchdowns o jogador listado irá registrar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Tentativas de Passe do Jogador</strong>: Você tem que prever quantas
								tentativas de passe (acima/abaixo) o jogador listado irá gravar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Conclusão de passe mais longo do jogador</strong>: Você tem que prever qual
								jogador registrará as finalizações de passe mais longas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador correndo e recebendo jardas</strong>: Você tem que prever quantas
								jardas correndo e recebendo (acima / abaixo) o jogador listado irá registrar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pontos de chute do jogador</strong>: Você tem que prever quantos pontos de
								chute (acima ou abaixo) o jogador listado irá registrar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Interceptações de jogadores lançadas</strong>: Você tem que prever quantas
								interceptações (acima ou abaixo) o jogador listado irá gravar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Recepção mais longa do jogador</strong>: Você tem que prever qual jogador
								gravará a recepção mais longa.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Player Total Tackles</strong>: Você tem que prever quantos tackles (acima /
								abaixo) o jogador listado irá gravar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de Sacks do Jogador</strong>: Você tem que prever quantos sacks
								(acima/abaixo) o jogador listado irá registrar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador Passando jardas 1º tempo</strong>: Você tem que prever quantas
								jardas de passe (acima/abaixo) o jogador listado registrará no 1º tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador que passa TD no 1º tempo</strong>: Você tem que prever quantos TDs
								de passe (acima/abaixo) o jogador listado registrará no 1º tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador primeiro rush (incl. OT)</strong>: Você tem que prever qual jogador
								vai gravar o primeiro rush.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Posição do jogador do 1º TD</strong>: Você tem que prever qual será a
								posição do jogador listado em seu primeiro TD.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Posição do jogador do último TD</strong>: Você tem que prever qual será a
								posição do jogador listado em seu último TD.
							</strong>
						</p>

						<p>
							<strong>
								<strong>QB para ter uma interceptação</strong>: Você tem que prever se o QB listado
								registrará uma interceptação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>QB conclusão mais longa (incl. OT)</strong>: Você tem que prever qual QB
								registrará a conclusão mais longa.
							</strong>
						</p>

						<p>
							<strong>
								<strong>QB primeira conclusão (incl. OT)</strong>: Você tem que prever qual QB
								registrará a primeira conclusão.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qualquer QB para lançar para 300+ jardas (incl. OT)</strong>: Você tem que
								prever se algum QB listado registrará um lançamento de 300+ jardas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qualquer QB para lançar para 350+ jardas (incl. OT)</strong>: Você tem que
								prever se algum QB listado registrará um lançamento de 350+ jardas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qualquer QB para lançar para 400+ jardas (incl. OT)</strong>: Você tem que
								prever se algum QB listado registrará um lançamento de 400+ jardas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qualquer jogador para ter 100+ jardas corridas (incl. OT)</strong>: Você tem
								que prever se algum jogador listado irá registrar um 100+ jardas corridas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qualquer jogador para ter 150+ jardas de corrida (incl. OT)</strong>: Você
								tem que prever se algum jogador listado vai registrar um 150+ jardas corridas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qualquer jogador que tenha 100+ jardas recebidas (incl. OT)</strong>: Você
								tem que prever se algum jogador listado registrará 100+ jardas recebidas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qualquer jogador que tenha 150+ jardas recebidas (incl. OT)</strong>: Você
								tem que prever se algum jogador listado registrará 150+ jardas recebidas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>
									A maioria das jardas recebidas (somente jogadores listados - incluindo OT)
								</strong>
								: Você tem que prever qual dos jogadores listados registrará mais jardas recebidas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mais jardas de passe Jogador 1 vs Jogador 2</strong>: Você tem que prever
								qual dos jogadores listados registrará mais jardas de passe.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Maior número de finalizações de passes Jogador 1 vs Jogador 2</strong>: Você
								tem que prever qual dos jogadores listados registrará mais finalizações de passes.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mais jardas de Rush Jogador 1 vs Jogador 2</strong>: Você tem que prever
								qual dos jogadores listados registrará mais jardas corridas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mais jardas recebidas Jogador 1 vs Jogador 2</strong>: Você tem que prever
								qual dos jogadores listados registrará mais jardas recebidas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mais Recepções Jogador 1 vs Jogador 2</strong>: Você tem que prever qual dos
								jogadores listados registrará mais recepções.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador mais eliminado 1 vs jogador 2</strong>: Você tem que prever qual dos
								jogadores listados registrará mais eliminações.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador Mais Gols 1 vs Jogador 2</strong>: Você tem que prever qual dos
								jogadores listados registrará mais gols.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Most Marks Player 1 vs Player 2</strong>: Você tem que prever qual dos
								jogadores listados registrará mais marcas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Most Passing-tds Player 1 vs Player 2</strong>: Você tem que prever qual dos
								jogadores listados registrará mais touchdowns de passe.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Most Rushing Yards</strong>: Você tem que prever qual dos jogadores listados
								registrará mais jardas corridas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mais jardas recebidas</strong>: Você tem que prever qual dos jogadores
								listados registrará mais jardas recebidas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mais 1º downs</strong>: Você tem que prever qual dos jogadores listados
								registrará mais 1º downs.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Maioria dos sacks</strong>: Você tem que prever qual dos jogadores listados
								registrará mais sacks.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de Tentativas de Passe do Jogador (incl. OT)</strong>: Você tem que
								prever pelo menos quantas tentativas de passe o jogador listado irá registrar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Tentativas de passe do jogador sobre/abaixo (incl. OT)</strong>: Você tem
								que prever se as tentativas de passe dos jogadores em questão estarão acima ou
								abaixo das linhas dadas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de Interceptações de Passes do Jogador (incl. OT)</strong>: Você tem
								que prever pelo menos quantas interceptações de passe o jogador listado irá
								registrar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Interceptações de passes de jogadores por cima/por baixo (incl. OT)</strong>
								: Você tem que prever se as interceptações de passe dos jogadores em questão estarão
								acima ou abaixo das linhas dadas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de Tackles do Jogador (incl. OT)</strong>: Você tem que prever pelo
								menos quantos tackles o jogador listado vai gravar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ataca o jogador por cima/por baixo (incl. OT)</strong>: Você tem que prever
								se os tackles dos jogadores em questão estarão acima ou abaixo das linhas dadas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de Sacks do Jogador (incl. OT)</strong>: Você tem que prever pelo
								menos quantos sacks o jogador listado vai registrar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Sacks de jogadores Over/Under (incl. OT)</strong>: Você tem que prever se os
								sacks dos jogadores em questão estarão acima ou abaixo das linhas dadas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de interceptações de jogadores (incl. OT)</strong>: Você tem que
								prever pelo menos quantas interceptações o jogador listado vai registrar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Interceptações de jogadores Over/Under (incl. OT)</strong>: Você tem que
								prever se as interceptações dos jogadores em questão estarão acima ou abaixo das
								linhas dadas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jardas de passes do jogador Over / Under (incl. OT):</strong>
								Você deve prever se um jogador específico terá mais ou menos jardas passadas do que
								um número pré-determinado durante a partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Completamentos de passes do jogador Over / Under (incl. OT):</strong>
								Você deve prever se o quarterback fará mais (Over) ou menos (Under) passes completos
								do que um número pré-determinado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Touchdowns de passes do jogador Over / Under (incl. OT):</strong>
								Você deve prever se um jogador específico fará mais (Over) ou menos (Under)
								touchdowns de passes do que um número estabelecido.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jardas de corrida do jogador Over / Under (incl. OT):</strong>
								Você deve prever se um jogador específico terá mais ou menos jardas corridas do que
								uma quantidade pré-determinada durante a partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jardas de recepção do jogador Over / Under (incl. OT):</strong>
								Você deve prever se um jogador específico terá mais ou menos jardas recebidas do que
								um valor pré-estabelecido durante a partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Touchdowns de recepção do jogador Over / Under (incl. OT):</strong>
								Você deve prever se um jogador específico marcará mais ou menos touchdowns de
								recepção do que um número estabelecido durante a partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Recepções do jogador Over / Under (incl. OT):</strong>
								Você deve prever se um jogador específico (geralmente um kicker) fará mais ou menos
								recepções do que um número pré-determinado durante a partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Field goals do jogador Over / Under (incl. OT):</strong>
								Você deve prever se um kicker específico fará mais ou menos field goals
								bem-sucedidos do que um número pré-determinado durante a partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Assistências do jogador Over / Under (incl. OT):</strong>
								Você deve prever se um jogador específico fará mais (Over) ou menos (Under)
								assistências em tackles do que o número estabelecido pela casa de apostas.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Maior passe completo do jogador Over / Under (incl. OT):</strong>
								Você deve prever se o maior passe completado por um quarterback específico será mais
								ou menos do que a distância estabelecida durante a partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Maior recepção do jogador Over / Under (incl. OT):</strong>
								Você deve prever se a maior recepção completada por um jogador específico será mais
								ou menos do que a distância estabelecida durante a partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Tentativas de corrida do jogador Over / Under (incl. OT):</strong>
								Você deve prever se um jogador específico fará mais ou menos tentativas de corrida
								do que o número pré-determinado durante a partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Sacks totais da equipe Casa/Fora (incl. OT):</strong>
								Você deve prever se o número total de sacks registrados pela equipe Casa ou Fora
								durante a partida será maior ou menor que o número pré-determinado.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Maior corrida do jogador Over / Under (incl. OT):</strong>
								Você deve prever se a maior tentativa de corrida de um jogador específico será mais
								ou menos do que a distância estabelecida durante a partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Intercepções defensivas do jogador Over / Under (incl. OT):</strong>
								Você deve prever se um jogador defensivo específico fará mais ou menos intercepções
								do que o número estabelecido durante a partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>
									Tackles e assistências defensivas do jogador Over / Under (incl. OT):
								</strong>
								Você deve prever se um jogador defensivo específico fará mais ou menos tackles e
								assistências combinadas do que o número pré-determinado durante a partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro marcador de touchdown (incl. OT):</strong>
								Você deve prever qual jogador marcará o primeiro touchdown da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Último marcador de touchdown (incl. OT):</strong>
								Você deve prever qual jogador marcará o último touchdown da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Marcador de touchdown a qualquer momento (incl. OT):</strong>
								Você deve prever se um jogador específico marcará um touchdown em qualquer ponto da
								partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jardas de passes e corridas do jogador Over / Under (incl. OT):</strong>
								Você deve prever se as jardas totais de passes ou corridas de um jogador específico
								serão mais ou menos do que a linha estabelecida durante a partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Fumbles do jogador Over / Under (incl. OT):</strong>
								Você deve prever se um jogador específico fará mais ou menos fumbles durante a
								partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Fumbles perdidos do jogador Over / Under (incl. OT):</strong>
								Você deve prever se um jogador específico perderá a bola devido a um fumble mais ou
								menos do que o número estabelecido durante a partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ponto extra convertido:</strong>
								Você deve prever se uma equipe converterá com sucesso um ponto extra após um
								touchdown.
							</strong>
						</p>

						<p className="pH2">
							<strong>Especiais da Equipe</strong>
						</p>

						<p>
							<strong>
								<strong>Competidor 1/Concorrente 2 punts</strong>: Você tem que prever quantos punts
								(acima/menos) o Concorrente 1 e o Concorrente 2 registrarão.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Concorrente 1/Concorrente 2 sacks</strong>: Você tem que prever quantos
								sacks (over/under) o Concorrente 1 e o Concorrente 2 registrarão.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Competidor 1/Concorrente 2 total de field goals</strong>: Você tem que
								prever quantos field goals (acima/menos) o Concorrente 1 e o Concorrente 2
								registrarão.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Concorrente 1/Concorrente 2 total de field goals 2 vias</strong>: Você tem
								que prever quantos field goals (acima/menos) o Concorrente 1 e o Concorrente 2
								registrarão.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Faturamento total do concorrente 1/concorrente 2</strong>: Você tem que
								prever quantos turnovers totais (over/under) o concorrente 1 e o concorrente 2
								registrarão.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Concorrente 1/Concorrente 2 para pontuar em seu primeiro drive</strong>:
								Você tem que prever se o Concorrente 1/Competitor 2 pontuará em seu primeiro drive.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Touchdowns totais do Concorrente 1/Concorrente 2</strong>: Você tem que
								prever quantos touchdowns (acima/abaixo) o Concorrente 1 e o Concorrente 2
								registrarão.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Punt mais longo do Concorrente 1/Concorrente 2</strong>: Você tem que prever
								qual será o punt mais longo que o Concorrente 1 e o Concorrente 2 gravarão.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Competidor 1/Concorrente 2 punt mais curto</strong>: Você tem que prever
								qual será o punt mais curto que o Concorrente 1 e o Concorrente 2 gravarão.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Concorrente 1/Concorrente 2 jardas brutas de punt</strong>: Você tem que
								prever qual jarda bruta de punt (acima/abaixo) registrará o Concorrente 1 e o
								Concorrente 2.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Competidor 1/Concorrente 2 jardas ofensivas líquidas</strong>: Você tem que
								prever quantas jardas ofensivas líquidas (acima/abaixo) o Competidor 1 e o
								Concorrente 2 registrarão.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Competidor 1/Concorrente 2 jardas corridas</strong>: Você tem que prever
								quantas jardas corridas (acima/abaixo) o Competidor 1 e o Concorrente 2 registrarão.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Concorrente 1/Concorrente 2 total 4º conversões para baixo</strong>: Você
								tem que prever quantas conversões 4º para baixo (acima/abaixo) o Concorrente 1 e o
								Concorrente 2 registrarão.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Competidor 1/Concorrente 2 touchdowns apressados</strong>: Você tem que
								prever quantos touchdowns rápidos (acima/abaixo) o Concorrente 1 e o Concorrente 2
								registrarão.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Concorrente 1/Concorrente 2 pontos totais do primeiro tempo</strong>: Você
								tem que prever quantos pontos (mais/menos) o Concorrente 1 e o Concorrente 2
								registrarão no primeiro tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Competidor 1/Concorrente 2 jardas totais de field goal</strong>: Você tem
								que prever quanta jarda total de field goal (acima/abaixo) registrará o Competidor 1
								e o Concorrente 2.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Competidor 1/Concorrente 2 total de touchdowns corridos</strong>: Você tem
								que prever quantos touchdowns rápidos (acima/abaixo) o Concorrente 1 e o Concorrente
								2 registrarão.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Concorrente 1/Concorrente 2 total 1º downs</strong>: Você tem que prever
								quantos 1º downs (over/under) o Concorrente 1 e o Concorrente 2 registrarão.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Concorrente 1/Concorrente 2 total de 3ª conversões para baixo</strong>: Você
								tem que prever quantas conversões de 3ª para baixo (acima/abaixo) o Concorrente 1 e
								o Concorrente 2 registrarão.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro Resultado da unidade do Concorrente 1/Concorrente 2</strong>: Você
								tem que prever qual será o resultado do resultado da primeira unidade do Concorrente
								1/Concorrente 2.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º Jogo de Pontuação Concorrente 1/Concorrente 2</strong>: Você tem que
								prever qual será a primeira jogada de pontuação do Concorrente 1/Concorrente 2.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Concorrente 1/Concorrente 2 metades ganhas</strong>: Você tem que prever
								quais metades o Concorrente 1/Concorrente 2 vencerá.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Concorrente 1/Concorrente 2 quartos ganhos</strong>: Você tem que prever
								quais quartos o Concorrente 1/Concorrente 2 vencerá.
							</strong>
						</p>

						<p>
							<strong>
								<strong>O Concorrente 1/Concorrente 2 marcará mais pontos em</strong>: Você tem que
								prever em qual dos períodos de tempo determinados o Concorrente 1/Concorrente 2
								marcará mais pontos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo -Concorrente 1/Concorrente 2 touchdowns totais</strong>: Você tem
								que prever quantos touchdowns (acima/abaixo) o Concorrente 1 e o Concorrente 2
								registrarão no primeiro tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - Concorrente 1/Concorrente 2 touchdowns totais</strong>: Você tem
								que prever quantos touchdowns (acima/abaixo) o Concorrente 1 e o Concorrente 2
								registrarão no segundo tempo.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Concorrente 1/Concorrente 2 field goals</strong>: Você tem que
								prever quantos field goals (mais/menos) o Concorrente 1 e o Concorrente 2
								registrarão no primeiro tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - Concorrente 1/Concorrente 2 field goals</strong>: Você tem que
								prever quantos field goals (acima/menos) o Concorrente 1 e o Concorrente 2
								registrarão no segundo tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Competidor 1/Concorrente 2 para marcar primeiro e ganhar o jogo</strong>:
								Você tem que prever se o Concorrente 1/Concorrente 2 marcará primeiro e vencerá a
								partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Competidor 1/Concorrente 2 para marcar primeiro e perder o jogo</strong>:
								Você tem que prever se o Concorrente 1/Concorrente 2 vai marcar primeiro e perder a
								partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Concorrente 1/Concorrente 2 para pontuar em cada quarto</strong>: Você tem
								que prever se o Concorrente 1/Concorrente 2 pontuará em cada quarto.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Concorrente 1/Concorrente 2 para pontuar em ambas as metades</strong>: Você
								tem que prever se o Concorrente 1/Concorrente 2 pontuará em ambas as metades.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Concorrente 1/Concorrente 2 para ganhar todos os quartos</strong>: Você tem
								que prever se o Concorrente 1/Concorrente 2 ganhará todos os quartos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Concorrente 1/Concorrente 2 para ganhar as duas metades</strong>: Você tem
								que prever se o Concorrente 1/Concorrente 2 ganhará as duas metades.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Concorrente 1/Concorrente 2 para obter 1º para baixo</strong>: Você tem que
								prever se o Concorrente 1/Concorrente 2 ficará 1º para baixo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time para marcar maior field goal</strong>: Você tem que prever qual time
								marcará o field goal mais longo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time com maior retorno de KickOff no jogo</strong>: Você tem que prever qual
								time registrará o retorno de kick off mais longo na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time com jogada mais longa de Scrimmage</strong>: Você tem que prever qual
								time registrará a jogada mais longa de scrimmage na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time com mais conversão de 3º para baixo no jogo</strong>: Você tem que
								prever qual equipe registrará mais conversões de 3º para baixo na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time com mais jogadas ofensivas no jogo</strong>: Você tem que prever qual
								time registrará as jogadas mais ofensivas na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe com mais jardas de penalidade aceitas no jogo</strong>: Você tem que
								prever qual equipe registrará as jardas de penalidade mais aceitas na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time com mais punts</strong>: Você tem que prever qual time registrará mais
								punts na partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time com maior pontuação Quarto</strong>: Você tem que prever qual equipe
								registrará o quarto de maior pontuação na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Uma equipe marca 3 vezes seguidas</strong>: Você tem que prever se pelo
								menos uma equipe marcará 3 vezes seguidas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro time a entrar na zona vermelha</strong>: Você tem que prever qual
								time entrará primeiro na zona vermelha.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro time a marcar dentro da zona vermelha</strong>: Você tem que prever
								qual time marcará primeiro de dentro da zona vermelha.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time com mais tempo de posse de bola</strong>: Você tem que prever qual time
								registrará mais tempo de posse de bola na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time para marcar touchdown mais longo</strong>: Você tem que prever qual
								time marcará o touchdown mais longo na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time para marcar primeiro touchdown</strong>: Você tem que prever qual
								equipe marcará o primeiro touchdown na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time para marcar último touchdown</strong>: Você tem que prever qual equipe
								marcará o último touchdown na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time para cometer primeiro turnover</strong>: Você tem que prever qual time
								cometerá o primeiro turnover na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time não comete turnovers</strong>: Você tem que prever qual time não
								cometerá turnovers na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe para ganhar o lançamento da moeda</strong>: Você tem que prever qual
								equipe ganhará o lançamento da moeda.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º time a punt</strong>: Você tem que prever qual time vai punt primeiro.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro time a punt 3 vezes</strong>: Você tem que prever qual time vai
								primeiro punt 3 vezes.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qual time terá o punt bruto mais longo</strong>: Você tem que prever qual
								time registrará o punt bruto mais longo na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time com maior retorno de Punt no jogo</strong>: Você tem que prever qual
								time registrará o maior retorno de punt na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time para marcar touchdown mais curto</strong>: Você tem que prever qual
								time registrará o touchdown mais curto na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time para ter drive mais longo (jardas) resultando em um touchdown</strong>:
								Você tem que prever qual equipe registrará o drive mais longo (em jardas) resultando
								em um touchdown.
							</strong>
						</p>

						<p>
							<strong>
								<strong>
									Time para ter maior drive (jardas) resultando em um field goal feito
								</strong>
								: Você tem que prever qual time registrará o drive mais longo (em jardas) resultando
								em um field goal feito.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time para marcar o último Field Goal</strong>: Você tem que prever qual
								equipe marcará o último field goal.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro time a conseguir um primeiro down</strong>: Você tem que prever
								qual time vai conseguir um primeiro down.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe para cometer primeiro turnover do jogo</strong>: Você tem que prever
								qual equipe vai cometer o primeiro turnover do jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time para ter o field goal mais longo</strong>: Você tem que prever qual
								time terá o field goal mais longo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe para cometer a primeira penalidade aceita</strong>: Você tem que
								prever qual equipe cometerá a primeira penalidade aceita.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time para ter o field goal mais longo</strong>: Você tem que prever qual
								time terá o field goal mais longo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time para ganhar mais jardas de passe</strong>: Você tem que prever qual
								time ganhará mais jardas de passe.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time para ganhar mais jardas corridas</strong>: Você tem que prever qual
								equipe ganhará mais jardas corridas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe com mais turnovers comprometidos</strong>: Você tem que prever qual
								equipe cometerá mais turnovers.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Último time a marcar no 1º tempo</strong>: Você tem que prever qual time vai
								marcar por último no 1º tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time para marcar o Xº touchdown</strong>: Você tem que prever qual equipe
								marcará o Xº touchdown.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vai Competidor 1/Concorrente 2 pontuação em seu primeiro drive</strong>:
								Você tem que prever se o Concorrente 1/Competitor 2 vai pontuar em seu primeiro
								drive.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Xº quarto - Touchdowns totais do Concorrente 1/Concorrente 2</strong>: Você
								tem que prever quantos touchdowns (acima/abaixo) o Concorrente 1 e o Concorrente 2
								registrarão no X quarto.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Xº quarto -Competidor 1/Concorrente 2 field goals</strong>: Você tem que
								prever quantos field goals (acima/menos) o Concorrente 1 e o Concorrente 2
								registrarão no X quarto.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro ataque do time a cruzar a linha de 50 jardas</strong>: Você tem que
								prever qual ataque do time primeiro cruzará a linha de 50 jardas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time para ter o field goal mais curto</strong>: Você tem que prever qual
								time terá o field goal mais curto.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time com maior pontuação quarto</strong>: Você tem que prever qual equipe
								terá o quarto de maior pontuação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time com menor pontuação quarto</strong>: Você tem que prever qual time terá
								o quarto de menor pontuação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe para ter um primeiro desafio de treinadores</strong>: Você tem que
								prever qual equipe terá primeiro um desafio de treinador.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe para chamar primeiro timeout</strong>: Você tem que prever qual
								equipe chamará primeiro um timeout.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time para registrar 1º Sack</strong>: Você tem que prever qual equipe vai
								registrar o 1º sack.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe para chamar 1º timeout</strong>: Você tem que prever qual equipe
								chamará o primeiro timeout.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Maior vantagem (qualquer equipe) O/U</strong>: Você tem que prever qual será
								a maior vantagem no jogo (acima / abaixo) por qualquer equipe.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Será que o time que ganhar o lançamento da moeda ganhará o jogo</strong>:
								Você tem que prever se o time que ganhar o lançamento da moeda, também ganhará o
								jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>
									Será que o Concorrente 1/Competidor 2 ganhará o lance da moeda e ganhará o jogo
								</strong>
								: Você tem que prever se o Competidor 1/Competidor 2 ganhará o lance da moeda e
								vencerá a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Será que ambas as equipes terão a vantagem no 1º tempo</strong>: É preciso
								prever se ambas as equipes terão a vantagem no 1º tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Será que ambas as equipes terão a vantagem no 2º tempo</strong>: É preciso
								prever se ambas as equipes terão a vantagem no 2º tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Será que ambas as equipes terão a liderança no 4º quarto</strong>: Você tem
								que prever se ambas as equipes terão a liderança no 4º quarto.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time para marcar as primeiras vitórias</strong>: Você tem que prever se o
								time que marcar primeiro, também vai ganhar o jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Time para marcar últimas vitórias</strong>: Você tem que prever se o time
								que marcar por último, também vai ganhar o jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qualquer time para marcar 4 vezes seguidas</strong>: Você tem que prever se
								qualquer um dos times marcará 4 vezes seguidas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Cada equipe marcará um touchdown em cada metade</strong>: Você tem que
								prever se cada equipe marcará pelo menos um touchdown em cada metade.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Cada equipe marcará dois touchdowns em cada metade</strong>: Você tem que
								prever se cada equipe marcará pelo menos dois touchdowns em cada metade.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qualquer equipe para marcar 40+ pontos</strong>: Você tem que prever se
								alguma equipe vai marcar 40+ pontos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>3 Pontuações Diretas por Qualquer Equipe (incl. OT)</strong>: Você tem que
								prever se qualquer uma das equipes marcará 3 vezes seguidas na partida (OT
								incluído).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Será concorrente 1/concorrente 2 Score First Drive</strong>: Você tem que
								prever se o concorrente 1 ou o concorrente 2 marcará seu primeiro drive.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ambas as equipes para marcar 19.5 / 24.5 / 29.5 (incl. OT)</strong>: Você
								tem que prever se ambas as equipes marcarão 19.5 ou 24.5 ou 29.5 pontos na partida
								(OT incluído).
							</strong>
						</p>

						<p className="pH2">
							<strong>Outros Mercados Estatísticos</strong>
						</p>

						<p>
							<strong>
								<strong>Field goal mais longo marcado</strong>: Você tem que prever qual será o
								field goal mais longo (over/under) marcado na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Field goal mais curto marcado</strong>: Você tem que prever qual será o
								field goal mais curto (over/under) marcado na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Resultado da primeira unidade (incl. OT)</strong>: Você tem que prever o
								resultado da primeira unidade.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeira jogada ofensiva do jogo (incl. OT)</strong>: Você tem que prever
								qual será a primeira jogada ofensiva do jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de penalidades aceitas</strong>: Você tem que prever qual será o
								número total de penalidades aceitas (acima/menos) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de tentativas de passe</strong>: Você tem que prever qual será o
								número total de tentativas de passe (acima/abaixo) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de finalizações de passes</strong>: Você tem que prever qual será o
								número total de finalizações de passes (acima/abaixo) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de jardas de passe</strong>: Você tem que prever qual será o número
								total de jardas de passe (acima/abaixo) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de 1º downs</strong>: Você tem que prever qual será o número total de
								1º downs (over/under) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de punts</strong>: Você tem que prever qual será o número total de
								punts (over/under) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>TD total de 2 vias</strong>: Você tem que prever qual será o número total de
								touchdowns (over/under) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de interceptações</strong>: Você tem que prever qual será o número
								total de interceptações (acima/abaixo) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de tackles defensivos</strong>: Você tem que prever qual será o número
								total de tackles defensivos (over/under) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Touchdown mais longo marcado</strong>: Você tem que prever qual será o
								touchdown mais longo (over/under) marcado na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Touchdown mais curto marcado</strong>: Você tem que prever qual será o
								touchdown mais curto (over/under) marcado na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Xº quarto - total de touchdowns</strong>: Você tem que prever qual será o
								número total de touchdowns (acima/abaixo) no X quarto.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º Tempo - field goals</strong>: Você tem que prever qual será o número
								total de field goals (over/under) no 1º tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Xº quarto - field goals</strong>: Você tem que prever qual será o número
								total de field goals (over/under) no X quarto.
							</strong>
						</p>

						<p>
							<strong>
								<strong>
									Total de números de camisa para marcadores de touchdown (conversões de 2 pontos
									não contam)
								</strong>
								: Você tem que prever qual será o número total de números de camisa para marcadores
								de touchdown (acima/abaixo) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Haverá um ponto extra perdido após um touchdown? (Somente chute)</strong>:
								Você tem que prever se haverá um ponto extra perdido após um touchdown (somente
								chute).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Será que o jogo será decidido exatamente por 3 pontos</strong>: Você tem que
								prever se o jogo será decidido exatamente por 3 pontos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Haverá uma conversão de 2 pt</strong>: Você tem que prever se haverá uma
								conversão de 2 pts.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogo a ser empatado após 0 a 0</strong>: É preciso prever se o jogo ficará
								empatado após 0 a 0.
							</strong>
						</p>

						<p>
							<strong>
								<strong>TD total de 3 vias</strong>: Você tem que prever qual será o número total de
								touchdowns (over/under) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro método de pontuação 3-way</strong>: Você tem que prever qual será o
								primeiro método de pontuação (3way).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro método de pontuação 6-way</strong>: Você tem que prever qual será o
								primeiro método de pontuação (6way).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro tipo de turnover 3way</strong>: Você tem que prever qual será o
								primeiro tipo de turnover (3way).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeira jogada ofensiva do jogo</strong>: Você tem que prever qual será a
								primeira jogada ofensiva do jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Último método de pontuação</strong>: Você tem que prever qual será o último
								método de pontuação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Resultado do 1º desafio de treinadores</strong>: Você tem que prever qual
								será o resultado do 1º desafio de treinadores.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quantos jogadores terão uma tentativa de passe</strong>: Você tem que prever
								quantos jogadores (acima/abaixo) terão uma tentativa de passe.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quem terá mais primeiros downs</strong>: Você tem que prever quem terá mais
								1º downs.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Segurança a ser pontuada</strong>: Você tem que prever se uma segurança será
								pontuada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Conversão bem-sucedida de 2 pontos</strong>: Você tem que prever se haverá
								uma conversão bem-sucedida de 2 pontos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Half Time - Total de músicas</strong>: Você tem que prever quantas músicas
								serão tocadas no intervalo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Número da camisa do 1º marcador de touchdown</strong>: Você tem que prever o
								número da camisa do 1º marcador de touchdown.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de jardas brutas de punt do jogo</strong>: Você tem que prever qual
								será a jarda bruta total de punt (over/under) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Comprimento (jardas) da unidade mais longa</strong>: Você tem que prever
								qual será a duração da unidade mais longa (mais/menos jardas) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jardas líquidas ganhas no drive de abertura do jogo</strong>: Você tem que
								prever quantas jardas líquidas serão ganhas no drive de abertura do jogo
								(over/under).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeira pontuação de jardas</strong>: Você tem que prever quais serão as
								primeiras jardas de pontuação (acima/abaixo).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiras jardas para touchdown</strong>: Você tem que prever quais serão as
								primeiras jardas para touchdown (acima/abaixo).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Distância do 1º field goal bem-sucedido</strong>: Você tem que prever qual
								será a distância do 1º field goal bem-sucedido (over/under yards) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de jardas de field goal</strong>: Você tem que prever qual será o
								número total de jardas de field goal (acima/abaixo) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de conversões de 3º para baixo</strong>: Você tem que prever qual será
								o número total de conversões de 3º para baixo (acima/abaixo) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de conversões 4th down</strong>: Você tem que prever qual será o
								número total de 4th down conversions (over/under) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de kickoffs</strong>: Você tem que prever qual será o número total de
								kickoffs (over/under) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de jardas ofensivas líquidas</strong>: Você tem que prever qual será o
								número total de jardas ofensivas líquidas (acima/abaixo) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de jogadores para ter uma tentativa de passe</strong>: Você tem que
								prever qual será o número total de jogadores para ter uma tentativa de passe
								(acima/abaixo) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de jogadores com recepções</strong>: Você tem que prever qual será o
								número total de jogadores com recepções (acima/menos) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de jogadores com tentativas de rush</strong>: Você tem que prever qual
								será o número total de jogadores com tentativas de rush (over/under) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de tentativas de rushing</strong>: Você tem que prever qual será o
								número total de tentativas de rushing (over/under) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de jardas TD</strong>: Você tem que prever qual será a jarda total de
								touchdown (over/under) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de passes para touchdown</strong>: Você tem que prever qual será o
								número total de passes para touchdown (acima/abaixo) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Maior vantagem do jogo</strong>: Você tem que prever qual será a maior
								vantagem (over/under) na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Maior número de finalizações consecutivas por QB inicial</strong>: Você tem
								que prever quais serão as finalizações mais consecutivas por qualquer QB inicial.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Conversão bem-sucedida de dois pontos</strong>: Você tem que prever se
								haverá uma conversão bem-sucedida de 2 pontos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Lançamento de moeda corretamente chamado</strong>: Você tem que prever se o
								lançamento de moeda será chamado corretamente.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Kickoff de abertura para ser um touchback</strong>: Você tem que prever se o
								kickoff de abertura será um touchback.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qualquer chute para acertar verticalmente</strong>: Você tem que prever se
								algum chute vai bater na vertical.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Haverá um octapus</strong>: Você tem que prever se haverá um octapus.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qualquer punt resultará em um touchback</strong>: Você tem que prever se
								qualquer punt resultará em um touchback.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Haverá um punt bloqueado</strong>: Você tem que prever se haverá um punt
								bloqueado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Haverá um punt falso ou FG</strong>: Você tem que prever se haverá um punt
								falso ou FG.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Haverá um punt devolvido para um touchdown</strong>: Você tem que prever se
								haverá um punt devolvido para um touchdown.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º Drive - Field goal feito</strong>: Você tem que prever se haverá um field
								goal no 1º drive.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qualquer equipe para marcar um touchdown em seu drive de abertura</strong>:
								Você tem que prever se qualquer uma das equipes marcará um touchdown em seu drive de
								abertura.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Placar ofensivo no 1º drive do jogo</strong>: Você tem que prever se haverá
								um placar ofensivo no 1º drive do jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º field goal - a partir das 14</strong>:00 ou após as 14:00 decorridos:
								Você tem que prever se o 1º field goal será marcado em ou após as 14:00 minutos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1ª pontuação - a partir das 7</strong>:00 ou após o término: Você tem que
								prever se a 1ª pontuação será marcada em ou após 07:00 minutos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º touchdown - em ou após 10</strong>:00 decorrido: Você tem que prever se o
								1º touchdown será marcado em ou após 10:00 minutos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Haverá um field goal bem-sucedido nos quatro quartos</strong>: Você tem que
								prever se haverá um field goal bem-sucedido nos quatro quartos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeira pontuação do jogo é touchdown</strong>: Você tem que prever se a
								primeira pontuação do jogo é um touchdown.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Haverá um quarto sem gols</strong>: você tem que prever se haverá um quarto
								sem gols.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Kickoff de abertura para ser um touchback</strong>: Você tem que prever se o
								kickoff de abertura será um touchback.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Haverá um FG/XP perdido</strong>: Você tem que prever se haverá um FG/XP
								perdido.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Haverá uma escolha 6</strong>: Você tem que prever se haverá uma escolha 6.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe especial ou touchdown defensivo marcado</strong>: Você tem que prever
								se haverá um touchdown de equipe especial ou touchdown defensivo marcado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qualquer snapper longo registrará um tackle ou assistência</strong>: Você
								tem que prever se qualquer snapper longo registrará um tackle ou assistência.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Haverá uma ejeção</strong>: Você tem que prever se haverá uma ejeção.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Haverá uma tentativa de flea-flicker</strong>: Você tem que prever se haverá
								uma tentativa de flea-flicker.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Haverá um kick-off devolvido para um touchdown</strong>: Você tem que prever
								se haverá um kick-off devolvido para um touchdown.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Placar nos 2 minutos finais do 1º tempo?</strong>: É preciso prever se
								haverá placar nos 2 minutos finais do 1º tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Haverá um retorno no 4º quarto</strong>: Você tem que prever se haverá um
								retorno no 4º quarto.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Última jogada do jogo para ser um QB ajoelhado</strong>: Você tem que prever
								se a última jogada do jogo será um QB ajoelhado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Haverá uma pontuação na última jogada do jogo</strong>: Você tem que prever
								se haverá uma pontuação na última jogada do jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Será a última jogada do jogo um Quarterback Rush</strong>: Você tem que
								prever se a última jogada do jogo será um quarterback rush.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mais 1º downs</strong>: Você tem que prever quem fará mais 1º downs.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Duração do Hino Nacional</strong>: Você tem que prever qual será a duração
								do Hino Nacional.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Resultado do lançamento da moeda</strong>: Você tem que prever qual será o
								resultado do lançamento da moeda.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Cor do Gatorade derramado sobre treinador principal vencedor</strong>: Você
								tem que prever qual será a cor do Gatorade que será derramado sobre o treinador
								principal vencedor.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quem o MVP do Super Bowl agradecerá primeiro</strong>: Você tem que prever
								quem será o MVP do Super Bowl agradecendo primeiro.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Posição do MVP</strong>: Você tem que prever qual será a posição do MVP.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1ª jogada de pontuação</strong>: Você tem que prever qual será a 1ª jogada
								de pontuação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Kickoff de abertura retornado para um touchdown</strong>: Você tem que
								prever se o kickoff de abertura será devolvido para um touchdown.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quarto do primeiro touchdown</strong>: Você tem que prever qual será o
								quarto do primeiro touchdown.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º Turnover do Jogo será</strong>: Você tem que prever qual será o 1º
								turnover do jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de touchdowns - Exato</strong>: Você tem que prever exatamente qual
								será o número total de touchdowns na partida.
							</strong>
						</p>

						<p className="pH2">
							<strong>Outrights de Futebol Americano:</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor</strong>: Você deve prever o vencedor de um determinado torneio de
								acordo com o ranking oficial da competição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor da Divisão/Conferência</strong>: Você deve prever o vencedor de uma
								determinada divisão ou conferência de acordo com o ranking oficial da competição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vitórias na Temporada Regular - Equipe</strong>: Você deve prever quantas
								vitórias (mais/menos) a referida equipe irá acumular na temporada regular da
								competição em questão, de acordo com o ranking oficial da competição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Eles vão para os playoffs? - Equipe</strong>: Você tem que prever se a
								equipe mencionada chegará ao playoff do torneio em questão de acordo com o ranking
								oficial da competição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Top4, Top6, Top8, Top10</strong>: Você deve prever se a equipe selecionada
								terminará na posição superior respectiva quando a competição terminar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Draft X° Pick</strong>: Você tem que prever quem será o X° pick no draft
								mencionado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Posição do Draft - Jogador</strong>: Você deve prever qual posição o jogador
								mencionado ficará no draft mencionado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>H2H - Pontuação Correta da Série</strong>: Você tem que prever o resultado
								final da série de partidas entre as 2 equipes indicadas. Para efeitos de divulgação
								serão considerados válidos apenas os sites oficiais de cada competição. (A saber:
								H2H significa head to head, o que pode ser traduzido como "cabeça a cabeça", o que
								indica comparação entre dois adversários)
							</strong>
						</p>

						<p>
							<strong>
								<strong>H2H - Quando terminará a série?</strong>: Você deve prever em quantos jogos
								terminará a série de partidas entre as 2 equipes indicadas. Para efeitos de
								divulgação serão considerados válidos apenas os sites oficiais de cada competição.
								(A saber: H2H significa head to head, o que pode ser traduzido como "cabeça a
								cabeça", o que indica comparação entre dois adversários)
							</strong>
						</p>

						<p>
							<strong>
								<strong>H2H - Vencedor</strong>: Você deve prever qual das duas equipes indicadas se
								qualificará na fase de qualificação ou no play-off. (A saber: H2H significa head to
								head, o que pode ser traduzido como "cabeça a cabeça", o que indica comparação entre
								dois adversários)
							</strong>
						</p>

						<p>
							<strong>
								<strong>Para chegar aos Playoffs</strong>: Você deve prever se a equipe selecionada
								chegará ao playoff (Sim) ou não (Não) durante o torneio de acordo com o ranking
								oficial da competição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Prêmios - Jogador Mais Valioso</strong>: Você tem que prever quem ganhará o
								Prêmio de Jogador Mais Valioso de uma determinada temporada (somente temporada
								regular).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Prêmios - Novato Ofensivo do Ano</strong>: Você tem que prever quem ganhará
								o Prêmio de Jogador Novato do Ano da temporada específica (somente temporada
								regular).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Prêmios - Novato Defensivo do Ano</strong>: Você tem que prever quem ganhará
								o Prêmio de Jogador Defensivo do Ano da temporada específica (somente temporada
								regular).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Para chegar ao Super Bowl</strong>: Você deve prever se a equipe selecionada
								chegará ao Superbowl (Sim) ou não (Não) durante o torneio de acordo com o ranking
								oficial da competição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe - Posição no Draft</strong>: Você tem que prever qual será a posição
								da equipe no draft mencionado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Super Bowl - Conferência Vencedora</strong>: Você tem que prever de qual
								conferência virá o vencedor do superbowl.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Super Bowl - Divisão Vencedora</strong>: Você tem que prever de qual divisão
								virá o vencedor do superbowl.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Super Bowl - Time para ganhar o sorteio</strong>: Você tem que prever qual
								time vai ganhar o sorteio no superbowl.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Super Bowl - MVP</strong>: Você tem que prever qual jogador será o MVP do
								Super Bowl.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Momento do primeiro ponto (minutos)</strong>: Você deve prever quando
								será(ão) marcado(s) o(s) primeiro(s) ponto(s) (minuto).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de First Downs (incluindo OT)</strong>: você deve prever quantos First
								Downs serão marcados (incluindo OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Safety (incluindo o tempo extra)</strong>: você deve prever onde haverá
								safety na partida (incluindo o tempo extra).
							</strong>
						</p>

						<p>
							<strong>
								<strong>
									TD da equipe defensiva ou especial marcado (incluindo o tempo de descanso)
								</strong>
								: você deve prever se haverá TDs da equipe defensiva ou especial marcados (incluindo
								o tempo de descanso).{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Maior número de First Downs (incluindo o tempo extra)</strong>: você deve
								prever qual equipe marcará mais first downs (incluindo o tempo extra).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Grande vitória, pequena vitória</strong>: Você deve prever se o time da casa
								ou o time visitante vencerá por mais de 14 pontos (grande vitória) ou por 1-13
								pontos (pequena vitória).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mercados H2H do Jogador</strong>: Se o jogador listado não participar da
								partida, as apostas serão consideradas nulas. Em caso de empate entre os jogadores,
								as apostas serão anuladas.
							</strong>
						</p>

						<p>
							<strong>
								Todos os mercados especiais de jogadores de futebol americano são liquidados de
								acordo com a fonte oficial relevante. As prorrogações potenciais são incluídas na
								liquidação de todos os mercados disponíveis.
							</strong>
						</p>
					</div>
				</details>
				{/* Futebol Australiano  */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<g clip-path="url(#clip0_471_299)">
								{' '}
								<path
									d="M8.66 19.08C8.27 18.69 8.27 18.06 8.66 17.67C9.05 17.28 9.68 17.28 10.07 17.67L11.49 19.09L13.09 17.49L11.67 16.07C11.28 15.68 11.28 15.05 11.67 14.66C12.06 14.27 12.69 14.27 13.08 14.66L14.5 16.08L16.07 14.51L14.65 13.09C14.26 12.7 14.26 12.07 14.65 11.68C15.04 11.29 15.67 11.29 16.06 11.68L17.48 13.1L19.08 11.5L17.66 10.08C17.27 9.69 17.27 9.06 17.66 8.67C18.05 8.28 18.68 8.28 19.07 8.67L20.49 10.09L29.86 0.72C27.99 0.25 26.02 0 24 0C10.75 0 0 10.75 0 24C0 26.02 0.25 27.99 0.72 29.86L10.08 20.5L8.66 19.08Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M31.28 2.14L21.92 11.5L23.34 12.92C23.73 13.31 23.73 13.94 23.34 14.33C22.95 14.72 22.32 14.72 21.93 14.33L20.51 12.91L18.91 14.51L20.33 15.93C20.72 16.32 20.72 16.95 20.33 17.34C19.94 17.73 19.31 17.73 18.92 17.34L17.5 15.92L15.93 17.49L17.35 18.91C17.74 19.3 17.74 19.93 17.35 20.32C16.96 20.71 16.33 20.71 15.94 20.32L14.52 18.9L12.92 20.5L14.34 21.92C14.73 22.31 14.73 22.94 14.34 23.33C13.95 23.72 13.32 23.72 12.93 23.33L11.51 21.91L2.14 31.28C4.02 31.75 5.98 32 8 32C21.25 32 32 21.25 32 8C32 5.98 31.75 4.01 31.28 2.14Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
							</g>{' '}
							<defs>
								{' '}
								<clipPath id="clip0_471_299">
									{' '}
									<rect
										data-darkreader-inline-fill=""
										fill="white"
										height="28"
										style={{ fill: '#FFFFFF' }}
										width="28"
									></rect>{' '}
								</clipPath>{' '}
							</defs>{' '}
						</svg>
						Futebol Australiano
					</summary>
					<div className="textItem">
						<p>
							<strong>
								Todos os mercados excluem tempo extra, salvo indicação em contrário. Os mercados são
								baseados no resultado no final de um jogo programado de 80 minutos, salvo indicação
								em contrário. Isso inclui qualquer lesão adicional ou tempo de paralisação, mas não
								inclui tempo extra.
							</strong>
						</p>

						<p className="pH2">
							<strong>Principais Mercados</strong>
						</p>

						<p>
							<strong>
								<strong>Mercado 1X2</strong>: Você tem que prever o resultado do tempo regulamentar
								da partida inteira.. Existem 3 resultados possíveis: 1 (o time da casa ganha), X (os
								times vão empatar), 2 (o time visitante ganha).
							</strong>
						</p>

						<p>
							<strong>
								<strong>empate anula aposta (DNB)</strong>: este mercado de apostas consiste no
								seguinte, para definir uma aposta como vencedora, deve necessariamente haver uma
								equipe vencedora, o que significa que, se a partida terminar empatada, a aposta em
								dinheiro será ser reembolsado. Por exemplo, se uma pontuação final resultar em
								empate, a aposta será considerada nula.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap</strong>: Você tem que prever o vencedor da partida inteira no
								tempo regulamentar adicionando ou subtraindo o spread indicado ao resultado da
								partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total (mais/menos)</strong>: Você deve prever se o número total de gols
								marcados durante todo o tempo regulamentar da partida será acima ou abaixo da linha
								indicada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total equipe da casa</strong>: Você tem que prever se o número total de gols
								marcados, do Hometeam, durante o tempo regulamentar de toda a partida será superior
								ou inferior ao spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total da equipe visitante</strong>: Você tem que prever se o número total de
								gols marcados, da equipe visitante, durante o tempo regulamentar de toda a partida
								será superior ou inferior ao spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ímpar/Par</strong>: Você tem que prever se o resultado da partida é um
								número par ou ímpar, se o resultado da partida for "0:0", as apostas são contadas
								como "par".
							</strong>
						</p>

						<p>
							<strong>
								<strong>Casa Ímpar/Par</strong>: Você deve prever se o número de gols marcados pela
								equipe da casa durante o tempo regulamentar de toda a partida será par ou ímpar. Se
								o time da casa não marcar nenhum gol, a seleção vencedora é par.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ímpar/Par Fora</strong>: Você deve prever se o número de gols marcados pela
								equipe visitante durante o tempo regulamentar de toda a partida será par ou ímpar.
								Se o time da casa não marcar nenhum gol, a seleção vencedora é par.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mercado 1X2 e Total</strong>: Você deve prever o resultado da partida
								juntamente com o número de gols marcados durante a partida, considerando o spread
								indicado. Seis resultados são possíveis: 1&amp;A cima de "X", X&amp;A cima de "X",
								2&amp;A cima de "X", 1&amp;Abaixo "X", X&amp;Sob "X", 2&amp;Sob "X"
							</strong>
						</p>

						<p className="pH2">
							<strong>Mercados de tempo</strong>
						</p>

						<p>
							<strong>
								<strong>Quarto 1x2</strong>: Você tem que prever o resultado de um determinado
								quarto, as seleções são 1-o time da casa, 2-o time visitante e X-draw. Se o quarto
								estiver incompleto, este mercado será anulado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quarto Empate anula aposta</strong>: Você tem que prever o vencedor de um
								determinado quarto, se o quarto terminar empatado, todas as apostas serão anuladas
								para este mercado, se o quarto não for concluído, este mercado será anulado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap do Quarto</strong>: Você tem que prever o vencedor de um
								determinado quarto adicionando ou subtraindo o spread indicado ao resultado do
								quarto, se o quarto estiver incompleto este mercado será anulado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total do quarto</strong>: Você tem que prever se o número total de gols
								marcados durante o quarto será acima ou abaixo da linha indicada, se o quarto
								estiver incompleto, este mercado será anulado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total do quarto em casa/visitante</strong>: Você tem que prever se o número
								total de gols marcados pela equipe nomeada (casa ou visitante) durante o quarto será
								acima ou abaixo da linha indicada, se o quarto estiver incompleto, este mercado será
								ser anulado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Margem de Vitória do Quarto</strong>: Mercado de apostas que prevê a
								diferença que um time terá em relação ao seu oponente no final do quarto
								selecionado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quarto Ímpar/Par</strong>: Você tem que prever se o resultado do quarto é um
								número par ou ímpar, se o resultado da partida for "0:0, as apostas são contadas
								como "par".
							</strong>
						</p>

						<p className="pH2">
							<strong>Outrights</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor</strong>: Você deve prever o vencedor de um determinado torneio de
								acordo com o ranking oficial da competição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Top4, Top8</strong>: Você tem que prever se a equipe selecionada terminará
								na respectiva primeira posição quando a competição terminar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Para chegar à final</strong>: Você deve prever se a equipe selecionada
								chegará à final da competição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Temporada Regular Mais Vitórias/Derrotas</strong>: Você deve prever qual
								time registrará mais vitórias/derrotas durante o torneio em questão de acordo com o
								ranking oficial da competição.
							</strong>
						</p>
					</div>
				</details>
				{/* Futebol de Praia  */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 28 28"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<g clip-path="url(#clip0_414_716)">
								{' '}
								<path
									d="M4.45018 27.0857C5.81505 28.5029 7.44373 29.6571 9.25591 30.4914L7.6043 27.6457L4.45018 27.0743V27.0857Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M29.7978 7.86286L29.4308 11.3943L31.8853 13.76C31.5871 11.6229 30.8645 9.63429 29.8093 7.86286H29.7978Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M23.5814 30.0914C25.0495 29.3029 26.3799 28.2857 27.5384 27.0971L25.3591 27.6343L23.5928 30.0914H23.5814Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M27.9857 13.1886L22.6753 15.5543L21.1039 20.3657L20.8516 21.1429L25.0265 25.3714L29.7634 24.2057C31.0366 22.0914 31.828 19.6686 32 17.0857L27.9857 13.2V13.1886Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M13.0179 22.5943H13.0065L9.72616 26.7314L12.5591 31.6229C13.6717 31.8629 14.8186 32 16 32C17.2846 32 18.5233 31.8286 19.7161 31.5543L23.1799 26.7429L19.0738 22.5829H13.0179V22.5943Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M2.30538 7.68C1.02079 9.78286 0.194982 12.1943 0 14.7886L2.58065 11.4743L2.30538 7.68Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M17.147 9.96571L17.9498 10.5486L21.8839 13.3943L27.1599 11.0514L27.7792 5.15429C26.529 3.80571 25.0495 2.66286 23.3979 1.80571L17.147 4.58286V9.96571Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M10.1161 13.4057L14.853 9.97714V4.58286L8.60215 1.81714C7.03082 2.62857 5.62007 3.69143 4.41577 4.96L4.86308 11.0743L10.1161 13.4057Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M20.4158 0.628572C19.005 0.228571 17.5254 0 16 0C14.4746 0 12.9835 0.228571 11.5728 0.628572L16 2.59429L20.4158 0.628572Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M7.8681 25.3829L11.1713 21.2343V21.2229L9.32473 15.5657L4.11756 13.2457L0.126165 18.3429C0.447312 20.5371 1.21577 22.5829 2.33978 24.3886L7.85663 25.3829H7.8681Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M13.2817 20.3086H18.7183L20.4043 15.1543L16 11.9657L11.6072 15.1543L13.2817 20.3086Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
							</g>{' '}
							<defs>
								{' '}
								<clipPath id="clip0_414_716">
									{' '}
									<rect
										data-darkreader-inline-fill=""
										fill="white"
										height="28"
										style={{ fill: '#FFFFFF' }}
										width="28"
									></rect>{' '}
								</clipPath>{' '}
							</defs>{' '}
						</svg>
						Futebol de Praia
					</summary>
					<div className="textItem">
						<p className="pH2">{`Mercados Principais
`}</p>
						<p>{`1X2: Você tem que prever o resultado do tempo regulamentar de toda a partida (3 períodos de 12 minutos). Existem 3 resultados possíveis: 1 (o time da casa ganha), X (os times vão empatar), 2 (o time visitante ganha).

`}</p>
						<p className="pH2">{`Outrights
`}</p>
						<p>{`Vencedor: Você deve prever o vencedor de um determinado torneio de acordo com o ranking oficial da competição.

`}</p>
						<p>{`Vencedor do Grupo: Você aposta na equipe que terminar com a maior quantidade de pontos em seu grupo.

`}</p>
					</div>
				</details>
				{/* Futsal */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<g clip-path="url(#clip0_511_268)">
								{' '}
								<path
									d="M0 27C0 26.45 0.450563 26 1.00125 26H5.00626C5.55695 26 6.00751 26.45 6.00751 27C6.00751 27.55 5.55695 28 5.00626 28H1.00125C0.450563 28 0 27.55 0 27Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M1.00125 30C0.450563 30 0 30.45 0 31C0 31.55 0.450563 32 1.00125 32H9.01126C9.56195 32 10.0125 31.55 10.0125 31C10.0125 30.45 9.56195 30 9.01126 30H1.00125Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M22.3579 25.99H31.4393C31.3592 25.85 31.2791 25.7 31.169 25.56L26.0125 18.85C25.8423 18.62 25.7121 18.36 25.6521 18.08L25.3317 16.69L20.836 17.89C20.7459 17.91 20.6658 17.92 20.5757 17.92C20.1352 17.92 19.7347 17.63 19.6145 17.18C19.4743 16.65 19.7847 16.1 20.3254 15.96L24.8911 14.74L24.4105 12.67L18.5932 14.23C18.5031 14.25 18.423 14.26 18.3329 14.26C17.8924 14.26 17.4919 13.97 17.3717 13.52C17.2315 12.99 17.5419 12.44 18.0826 12.3L23.97 10.72L23.169 7.26C22.5482 4.54 19.174 3.57 17.1915 5.55C16.9011 5.84 16.5106 6 16.1001 6H14.6984C13.7171 6 12.8861 5.29 12.7259 4.33L12.3755 2.24C12.1552 0.95 11.0438 0 9.73217 0C9.16145 0 8.61076 0.18 8.15019 0.52L1.7622 5.18L21.1164 25.49C21.3867 25.75 21.9174 26 22.3579 25.98V25.99Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M22.1777 27.99C21.4268 27.93 20.4255 27.65 19.5645 26.78L0.490613 6.76C0.260325 7.27 0.130163 7.83 0.130163 8.41V11.28C0.130163 12.31 0.530663 13.3 1.24155 14.05L17.2916 30.77C18.0426 31.56 19.0939 32 20.1852 32H28.005C28.9161 32 29.7972 31.69 30.5181 31.12C31.4994 30.33 32 29.17 32 28H22.1977L22.1777 27.99Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
							</g>{' '}
							<defs>
								{' '}
								<clipPath id="clip0_511_268">
									{' '}
									<rect
										data-darkreader-inline-fill=""
										fill="white"
										height="28"
										style={{ fill: '#FFFFFF' }}
										width="28"
									></rect>{' '}
								</clipPath>{' '}
							</defs>{' '}
						</svg>
						Futsal
					</summary>
					<div className="textItem">
						<p>
							<strong>
								Considera-se uma partida de Futsal com 40 minutos de jogo como oficial. Todas as
								partidas serão determinadas com a pontuação final do tempo regulamentar, salvo
								indicação em contrário. O tempo regular deve ser concluído para que as apostas sejam
								válidas, salvo indicação em contrário.
							</strong>
						</p>

						<p>
							<strong>
								As apostas serão válidas dentro do tempo regulamentar; mais o tempo adicionado pelo
								árbitro devido ao tempo perdido devido a lesões e substituições. A prorrogação, o
								gol de ouro e a definição da partida por pênaltis não são válidos para liquidar as
								apostas neste esporte.
							</strong>
						</p>

						<p className="pH2">
							<strong>Mercados de Futsal:</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor - 1X2</strong>: Para isso, pode haver três possibilidades: que o
								time da casa vença (1), que o placar final seja um empate (x) ou que o visitante
								seja o vencedor (2).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Dupla chance (1X-12-X2)</strong>: mercado de apostas em que o jogador pode
								maximizar suas chances de ganhar cobrindo-se com dois resultados: 1X (vitória ou
								empate em casa), 12 (vitória em casa ou vitória fora) e X2 (empate ou vitória fora).
								*Se uma partida for disputada em campo neutro, a equipe nomeada primeiro é
								considerada em casa.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Próximo Gol</strong>: Aposte em prever qual das duas equipes marcará o
								próximo gol. Você também pode apostar em "nenhum gol" (nenhum gol será marcado).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ambas as equipes marcam</strong>: Existem duas possibilidades (sim-não) de
								que ambas as equipes marquem pelo menos um gol cada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>
									Gols Ímpar/Par para a equipe da casa, para a equipe visitante e total de gols
								</strong>
								: A aposta consiste em prever se o total de gols de um jogo será par ou ímpar. Se a
								partida terminar empatada em 0 a 0, será considerado um número par de gols. Se a
								partida for suspensa, todas as apostas na partida serão anuladas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total (Total da equipe da casa - Total da equipe visitante)</strong>:
								Consiste em apostar no número de gols em uma partida marcados por ambas as equipes
								ou por cada equipe individualmente. Por exemplo, você decide apostar em um "Over",
								isso significa que você apostou em mais de um certo número de gols. Pelo contrário,
								se você apostar em um "Under", você aposta em menos de um certo número de gols.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quem vencerá o resto da partida? (Apostas ao vivo se aplicam)</strong>: Este
								é um mercado de apostas ao vivo, você aposta em quem vai ganhar o resto da partida.
								A partir do momento em que a aposta é feita, a pontuação é contada como 0:0,
								independentemente da pontuação real da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Empate anula aposta</strong>: este mercado de apostas consiste no seguinte,
								para definir uma aposta como vencedora, deve necessariamente haver uma equipe
								vencedora, o que significa que, se o jogo terminar empatado, o dinheiro apostado
								será devolvido. Por exemplo, se uma pontuação final resultar em empate, a aposta
								será considerada nula.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap</strong>: aposta em que o vencedor do jogo deve ser decidido com a
								respectiva margem de gols. A pontuação correta é somada ou subtraída dos gols
								propostos no handicap, e após a referida operação, será determinado quem vence:
								equipe da casa, empate ou equipe visitante.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Resultado ou resultado exato</strong>: Aposte no resultado exato de uma
								partida, ou seja, no placar exato ao final de 40 minutos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Margem de ganho</strong>: Neste tipo de aposta, você prevê qual time vencerá
								e qual a diferença que vencerá.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Alcance de gols do time da casa</strong>: Preveja em um intervalo
								selecionado, quantos gols no total serão marcados pelo time da casa.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Alcance de gols do time visitante</strong>: Preveja em um intervalo
								selecionado, quantos gols no total serão marcados pelo time visitante.
							</strong>
						</p>

						<p className="pH2">
							<strong>Mercados do primeiro tempo</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - 1x2</strong>: Você tem que prever o resultado do primeiro tempo.
								Existem 3 resultados possíveis: 1 (o time da casa ganha), X (os times vão empatar),
								2 (o time visitante ganha).
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - qual equipe ganha o resto</strong>: Independentemente do placar
								real do primeiro tempo, no momento de fazer a aposta o placar do evento será
								considerado 0-0.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - xº gol</strong>: Você tem que prever qual Time vai marcar o
								próximo gol no primeiro tempo. Existem 3 resultados possíveis: 1 (pontuação da
								equipe da casa), nenhum, 2 (pontuação da equipe visitante).
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - handicap</strong>: Você deve prever o resultado final do primeiro
								tempo levando em consideração o handicap entre parênteses.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - total</strong>: Você tem que prever se o número total de gols
								marcados durante o primeiro tempo será acima ou abaixo da linha indicada.
							</strong>
						</p>

						<p className="pH2">
							<strong>Outros Mercados</strong>
						</p>

						<p>
							<strong>
								<strong>Prorrogação - 1x2</strong>: Você tem que prever o resultado da prorrogação.
								Existem 3 resultados possíveis: 1 (o time da casa ganha), X (os times vão empatar),
								2 (o time visitante ganha).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Prorrogação - qual equipe ganha o resto</strong>: Independentemente do
								placar real da prorrogação, no momento de fazer a aposta o placar do evento será
								considerado 0-0.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Prorrogação - xº gol</strong>: Você tem que prever qual Equipe marcará o
								próximo gol na prorrogação. Existem 3 resultados possíveis: 1 (pontuação da equipe
								da casa), nenhum, 2 (pontuação da equipe visitante).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Prorrogação - total</strong>: Você deve prever se o número total de gols
								marcados durante a prorrogação será acima ou abaixo da linha indicada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pênaltis - vencedor</strong>: Você tem que prever o vencedor da disputa de
								pênaltis.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Cobrança de pênaltis - xº gol</strong>: Você tem que prever qual time
								marcará o xº gol na disputa de pênaltis.
							</strong>
						</p>
					</div>
				</details>
				{/* Golfe */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<path
								d="M16 0C9.92 0 5 4.92 5 11C5 17.08 9.92 22 16 22C22.08 22 27 17.08 27 11C27 4.92 22.08 0 16 0ZM18 13C17.45 13 17 12.55 17 12C17 11.45 17.45 11 18 11C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13ZM20 17C19.45 17 19 16.55 19 16C19 15.45 19.45 15 20 15C20.55 15 21 15.45 21 16C21 16.55 20.55 17 20 17ZM22 13C21.45 13 21 12.55 21 12C21 11.45 21.45 11 22 11C22.55 11 23 11.45 23 12C23 12.55 22.55 13 22 13Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M21 24H11C10.45 24 10 24.45 10 25C10 25.55 10.45 26 11 26H15V31C15 31.55 15.45 32 16 32C16.55 32 17 31.55 17 31V26H21C21.55 26 22 25.55 22 25C22 24.45 21.55 24 21 24Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
						</svg>
						Golfe
					</summary>
					<div className="textItem">
						<p>
							<strong>
								A regra de empate (dead heat) se aplica a mercados onde uma seleção de empate não é
								explicitamente oferecida, como mercados de 2 bolas e 3 bolas. Um dead heat é
								definido como um evento em que há dois ou mais contratos vencedores conjuntos. As
								regras do dead heat estabelecem que a aposta deve ser dividida pelo número de
								competidores envolvidos no dead heat e depois liquidada com as probabilidades
								normais. Com a regra do empate, os ganhos potenciais são recalculados com base no
								número de competidores com o mesmo desempenho.
							</strong>
						</p>

						<p>
							<strong>
								Considera-se que um jogador jogou assim que deu a tacada. No caso de um jogador
								desistir depois de ter dado a tacada, as apostas serão perdidas em apostas diretas,
								de grupo, partida ou 18 buracos.{' '}
							</strong>
						</p>

						<p>
							<strong>
								Quando um torneio for reduzido do número programado de buracos por qualquer motivo
								(ou seja, condições climáticas adversas), as apostas definitivas feitas antes da
								rodada final completada serão pagas ao jogador premiado com o troféu se 36 buracos
								do torneio tiverem sido concluídos. Se menos de 36 buracos foram concluídos ou
								apostas definitivas foram feitas após a rodada final concluída, as apostas serão
								anuladas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Outrights/Antepost</strong>: apostas em qualquer jogador que participe de um
								torneio de qualificação, mas não se qualifique para o torneio principal, serão
								classificadas como perdedoras.{' '}
							</strong>
						</p>

						<p>
							<strong>
								Os Torneios de Skins estarão sujeitos às regras do Dead-Heat caso os jogadores
								ganhem quantias iguais de prêmios em dinheiro no final da competição especificada.
								Se forem jogados buracos adicionais para declarar um único vencedor, isso será usado
								para fins de liquidação.
							</strong>
						</p>

						<p className="pH2">
							<strong>Mercados de golfe:</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor do Torneio</strong>: Você deve prever o vencedor do torneio.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor do grupo</strong>: Você tem que prever qual dos jogadores nomeados
								incluídos na aposta irá alcançar a melhor posição final no torneio.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pódio</strong>: Você deve prever se o jogador selecionado terminará entre os
								3 primeiros do torneio, incluindo empates.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Top 6</strong>: Você deve prever se o jogador selecionado terminará entre os
								6 primeiros no torneio, incluindo empates.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Top 10</strong>: Você deve prever se o jogador selecionado terminará entre
								os 10 primeiros do torneio, incluindo empates.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Top 20</strong>: Você deve prever se o jogador selecionado terminará entre
								os 20 primeiros do torneio, incluindo empates.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor da melhor nacionalidade</strong>: Você deve prever qual dos
								jogadores nomeados, da nacionalidade selecionada, incluídos na aposta, alcançará a
								melhor posição final no torneio.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Top Continental</strong>: Você deve prever qual dos jogadores nomeados, do
								continente selecionado, incluídos na aposta, alcançará a melhor posição final no
								torneio.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Margem Vencedora</strong>: Com base no número de tacadas entre o jogador
								vencedor e o(s) indivíduo(s) que terminarem em segundo (inclui um preço para o
								torneio ir para o play-off). No caso de condições meteorológicas adversas que afetem
								o torneio, a liquidação será válida desde que sejam jogados um mínimo de 36 buracos
								de um torneio.
							</strong>
						</p>

						<p>
							<strong>
								Haverá um Playoff? Você deve prever se haverá um playoff (buraco extra) ou não no
								circuito mencionado.
							</strong>
						</p>

						<p>
							<strong>
								Haverá um buraco em um? Refere-se a um buraco em um (um jogador está alcançando um
								buraco com um acerto) sendo registrado nas rodadas designadas de um torneio
								específico. No caso de condições meteorológicas adversas que afetem o torneio, as
								apostas serão válidas desde que sejam jogados um mínimo de 36 buracos de um torneio.
								No caso de um buraco em um ser registrado, mas 36 buracos não serem jogados, a opção
								'sim' - 'fazer um buraco em um' - será considerada a vencedora.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Melhor jogador canhoto</strong>: Você deve prever qual dos jogadores
								canhotos nomeados incluídos na aposta alcançará a melhor posição final no torneio.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Top Ex-Vencedor</strong>: Você tem que prever quais dos jogadores nomeados
								que ganharam o título mencionado no passado, incluídos na aposta, alcançarão a
								melhor posição final no torneio.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador para fazer o corte</strong>: Para Fazer/Perder Corte - Um corte de
								torneio deve ser aplicado para que as apostas sejam válidas. No caso de um Torneio
								em que exista um sistema de corte múltiplo, a liquidação será definida por um
								jogador que jogue ou não jogue na próxima rodada após o 1º corte oficial.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Líder da 1ª rodada</strong>: Você deve prever qual dos jogadores nomeados
								incluídos na aposta alcançará a melhor posição final na 1ª rodada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1ª Rodada Top X (5,10,20)</strong>: Você deve prever se os jogadores
								nomeados incluídos na aposta alcançarão a posição X na 1ª rodada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Apostas futuras incluindo 'Field'</strong>: Non-Runner - nenhuma aposta além
								de 'The Field'. O preço do 'The Field' inclui todos os jogadores não cotados neste
								mercado. As apostas são aceitas apenas para ganhar. Aplicam-se as regras de apostas
								definitivas acima.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Apostas sem jogador(es) nomeado(s)</strong>: As regras Dead-Heat aplicam-se
								a apostas vencedoras, a menos que o(s) jogador(es) excluído(s) não ganhem o torneio.
								As regras do Dead-Heat também se aplicam à parte do lugar das apostas Each-Way.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Apostas em grupo</strong>: O vencedor será o jogador que obtiver a melhor
								colocação no final do torneio. Qualquer jogador que perder o corte será considerado
								um perdedor. Se todos os jogadores perderem o corte, a pontuação mais baixa após o
								corte determinará a liquidação. Não-corredor - não serão aplicadas deduções de
								apostas de acordo com a Regra 4(c) de Tattersalls. As regras do Dead-Heat se
								aplicam, exceto quando o vencedor é determinado por um play-off.
							</strong>
						</p>

						<p>
							<strong>
								Se um torneio for afetado por condições climáticas adversas, as apostas serão
								liquidadas desde que haja um vencedor do torneio considerado e um mínimo de 36
								buracos sejam concluídos. O vencedor será o jogador na liderança no final da última
								rodada completada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Posição final de um jogador nomeado</strong>: Em caso de empate na posição
								final, a posição empatada contará. Por exemplo, um empate com 5 outros jogadores
								pelo 8º lugar contará como uma posição final de 8º.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Apostas em partidas de 54, 72 e 90 buracos</strong>: Se um torneio for
								afetado por condições meteorológicas adversas, as apostas serão liquidadas desde que
								haja um vencedor do torneio considerado e um mínimo de 36 buracos sejam concluídos.
								O vencedor será o jogador na liderança no final da última rodada completada.
							</strong>
						</p>

						<p>
							<strong>
								Se um jogador perder o corte, o outro jogador será considerado o vencedor. Se ambos
								os jogadores perderem o corte, a pontuação mais baixa após o corte determinará a
								liquidação.
							</strong>
						</p>

						<p>
							<strong>
								Se um jogador for desqualificado ou desistir após o início, antes da conclusão de
								duas rodadas ou após ambos os jogadores terem feito o corte, o outro jogador é
								considerado o vencedor.
							</strong>
						</p>

						<p>
							<strong>
								Se um jogador for desqualificado durante a 3ª ou 4ª rodada, quando o outro jogador
								na aposta da partida já tiver perdido o corte, o jogador desqualificado será
								considerado o vencedor.
							</strong>
						</p>

						<p>
							<strong>
								Será oferecido um preço pelo empate e, em caso de empate, as apostas na vitória de
								qualquer um dos jogadores serão perdidas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Partidas do torneio</strong>: Como acima, mas as apostas são anuladas em
								caso de empate.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Seis atiradores</strong>: Aplicam-se as regras do Dead-Heat. A regra 4 pode
								ser aplicada no caso de um não-corredor. Os jogadores que começarem, mas não
								completarem sua rodada serão considerados perdedores.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Cinco atiradores</strong>: Como acima, mas com cinco jogadores agrupados.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Apostas em 18 buracos</strong>: O vencedor será o jogador com a pontuação
								mais baixa em 18 buracos. Os jogadores estão emparelhados, eles podem ou não estar
								jogando juntos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>18 buracos - Apostas em duas e três bolas</strong>: As apostas são válidas
								quando os jogadores terminarem o primeiro buraco. Se uma rodada for abandonada, as
								apostas nessa rodada serão anuladas.
							</strong>
						</p>

						<p>
							<strong>
								As apostas em 2 ou 3 bolas serão válidas independentemente de os pares/grupos reais
								serem diferentes. Para torneios usando o sistema de pontuação Stableford, o maior
								pontuador durante a rodada é considerado o vencedor. Não-competidores- apostas de 2
								e 3 bolas anuladas. Nas apostas de 2 bolas em que não é oferecido um preço para o
								empate, as apostas serão anuladas em caso de empate. Se um preço for oferecido para
								um empate, isso regerá a liquidação. Nas apostas de 3 bolas, aplicam-se as regras do
								Dead-Heat.
							</strong>
						</p>

						<p>
							<strong>
								Para todas as outras apostas envolvendo grupos de mais de 3 jogadores juntos em 18
								buracos (por exemplo, 7 bolas, 9 bolas, etc.) aplicam-se as regras de Dead-Heat.
								Não-corredor sem aposta. Serão aplicadas deduções de acordo com a Regra 4(c) de
								Tattersalls.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Fourballs</strong>: As apostas são válidas assim que ambos os pares derem a
								tacada no primeiro buraco.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Apostas de handicap</strong>: Deduzir o handicap do total final para
								determinar o vencedor. O torneio deve ser concluído, caso contrário as apostas serão
								anuladas. Qualquer jogador que perder o corte será considerado um perdedor. Qualquer
								não-corredor, Regra 4 e termos de colocação SP serão aplicados. Aplicam-se as regras
								de empate.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Confrontos míticos</strong>: O vencedor será o jogador com a pontuação mais
								baixa em 18 buracos. Se as pontuações estiverem empatadas após 18 buracos, as
								apostas serão anuladas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador para atirar na rodada mais baixa</strong>: Aplicam-se as regras do
								Dead-Heat.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pontuação individual da rodada do jogador</strong>: A linha pode ser
								ajustada Ao Vivo. Todas as apostas serão anuladas se o jogador não completar a
								rodada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap do próximo buraco - 3 bolas</strong>: As regras de Dead-Heat
								aplicam-se quando aplicáveis. Todas as apostas serão anuladas se todos os 3
								jogadores não derem a tacada inicial no buraco indicado. A liquidação das apostas é
								determinada quando os jogadores saem do green.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor do próximo buraco - 2 bolas</strong>: Todas as apostas serão
								anuladas se ambos os jogadores não derem a tacada inicial no buraco indicado. A
								liquidação das apostas é determinada quando os jogadores saem do green.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total do próximo buraco</strong>: As apostas são determinadas com base na
								pontuação combinada dos jogadores nomeados no buraco indicado. Todas as apostas
								serão anuladas se todos os jogadores não completarem o buraco indicado. A liquidação
								das apostas é determinada quando os jogadores saem do green.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pontuação do jogador selecionado no buraco seguinte</strong>: Todas as
								apostas serão anuladas se o jogador não completar o buraco indicado. A liquidação
								das apostas é determinada quando o jogador sai do green.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Líder de final de rodada</strong>: Você deve prever quem liderará no final
								da rodada mencionada. Aplicam-se as regras do Dead-Heat.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mercados de partidas</strong>: Se uma partida não começar (por exemplo,
								jogador lesionado ou desqualificado antes do início de uma partida), todas as
								apostas nessa partida serão anuladas.
							</strong>
						</p>

						<p>
							<strong>
								As apostas em mercados que podem ser liquidadas usando o torneio oficial e os
								resultados das partidas (incluindo a pontuação correta da partida final e apostas em
								partidas individuais) serão liquidadas usando esses resultados. Isso inclui quando
								uma partida termina cedo, seja por acordo dos jogadores ou por lesão.
							</strong>
						</p>

						<p>
							<strong>
								Todos os outros mercados onde uma partida termina antes da conclusão de 18 buracos
								(por exemplo, por acordo), como pontuação da partida, serão resolvidos como se os
								buracos incompletos restantes fossem empates. Por exemplo, um jogador com 2 pontos
								no buraco 13 quando a partida terminar será considerado como tendo vencido 2 e 1 (no
								buraco 17). Apostas de buraco único não concluídas serão anuladas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Greensomes</strong>: Apostas liquidadas no resultado oficial do tour.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Foursomes</strong>: As apostas são válidas assim que ambos os pares derem a
								tacada no primeiro buraco.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Apostas em partidas de 36 buracos</strong>: A liquidação será no jogador que
								alcançar a melhor colocação no final de 36 buracos. Se o número de rodadas jogadas
								for reduzido, por exemplo, em caso de mau tempo, as apostas serão liquidadas desde
								que um jogador tenha ganho o troféu (as apostas serão válidas enquanto houver um
								vencedor declarado e um mínimo de 18 buracos concluídos).{' '}
							</strong>
						</p>

						<p>
							<strong>
								Se um jogador for desqualificado ou desistir após começar antes da conclusão de duas
								rodadas, o outro jogador será considerado o vencedor.
							</strong>
						</p>

						<p>
							<strong>
								Será oferecido um preço pelo empate e, em caso de empate, as apostas na vitória de
								qualquer um dos jogadores serão perdidas.
							</strong>
						</p>

						<p>
							<strong>
								Ryder Cup/Solheim Cup/Walker Cup/Warburg Cup/Presidents Cup e quaisquer outros
								'jogos internacionais'. Todos os mercados, incluindo Outright, empate anula aposta,
								Handicap, placar máximo de pontos, mercados de pontuação correta, serão liquidados
								em resultado salvo indicação em contrário. Na Presidents Cup, 'To Lift Trophy' (sem
								a opção Tie), aplicam-se as regras de empate.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Partidas simples</strong>: Se uma partida individual terminar empatada, as
								apostas serão anuladas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mercados de pontuação correta</strong>: Todas as partidas programadas devem
								ser completadas na íntegra para que as apostas sejam válidas, independentemente se
								as correspondências são transportadas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mercados líderes (dia)</strong>: A liquidação será baseada na pontuação após
								o número programado de partidas, independentemente de as partidas serem transitadas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mercados líderes (formato do dia)</strong>: A liquidação será baseada na
								pontuação após o número programado de partidas no formato especificado,
								independentemente de as partidas serem transitadas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Maior número de partidas de pontos</strong>: Os mercados serão liquidados em
								todo o torneio. Se um confronto individual terminar empatado, as apostas serão
								anuladas. As apostas serão válidas assim que o jogador começar a jogar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pontuação vencedora</strong>: A liquidação será após a conclusão de 72
								buracos (ou 90 para torneios quando aplicável), caso contrário as apostas serão
								anuladas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ganhar/Não Ganhar um Major</strong>: Os 4 majors são US Open, US Masters,
								USPGA e British Open. Vitória Aprimorada - Refere-se a apostas definitivas em
								torneios.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Partidas para o buraco 18</strong>: O número programado de partidas deve
								começar para que as apostas tenham efeito. O número de partidas em que ambas as
								equipes dão a primeira tacada no buraco 18 será usado para fins de liquidação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pontuação da equipe que marca o 1º ponto completo</strong>: Para fins de
								liquidação, o vencedor será o primeiro time a vencer uma partida programada e, como
								resultado, adquirir um ponto completo. No caso de todas as partidas programadas
								terminarem em empate, as apostas serão anuladas.{' '}
							</strong>
						</p>
					</div>
				</details>
				{/* Hóquei no Gelo / Hóquei em Campo */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 33 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<g clip-path="url(#clip0_514_315)">
								{' '}
								<path
									clip-rule="evenodd"
									d="M19.5651 19.09C19.6052 19.02 19.6553 18.92 19.7155 18.79C19.9061 18.39 20.1469 17.83 20.4278 17.12C20.9795 15.71 21.6416 13.85 22.3037 11.89C23.6279 7.98 24.9421 3.75 25.4437 2.12C25.8349 0.85 27.0086 0 28.3228 0H28.9848C30.9912 0 32.3856 1.91 31.8941 3.78C29.1554 14.15 27.45 20.12 26.0656 23.66C25.3734 25.43 24.7113 26.73 23.9489 27.7C23.1364 28.73 22.2636 29.31 21.3306 29.71C19.3945 30.55 16.7863 31.12 14.0777 31.47C11.329 31.83 8.32953 32 5.55074 32C3.91557 32 2.40078 31.62 1.31735 30.51C0.243957 29.41 -0.00683594 27.99 -0.00683594 26.77V25.07C-0.00683594 22.36 2.17005 20.12 5.20966 20.12C5.37017 20.12 5.65106 20.12 6.02223 20.14C7.32636 20.17 9.80419 20.24 12.4726 20.14C14.178 20.08 15.8634 19.95 17.2578 19.72C17.95 19.61 18.5318 19.47 18.9732 19.33C19.2741 19.23 19.4547 19.15 19.5651 19.09ZM19.4948 19.2L19.4748 19.22C19.4748 19.22 19.4748 19.22 19.4948 19.2Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									fill-rule="evenodd"
									style={{ fill: '#FFFFFF' }}
								></path>{' '}
								<path
									d="M2.01957 10.65V12.16C2.0296 12.52 2.09983 13.01 2.41081 13.45C3.09297 14.41 4.90871 16.03 9.08191 15.99C13.2551 15.95 15.0408 14.31 15.7129 13.34C16.0138 12.9 16.074 12.41 16.074 12.05V10.37C14.3084 11.38 11.7905 12.01 8.90134 12.03C6.17271 12.05 3.77512 11.53 2.01957 10.65Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M16.0439 7.92C16.0239 6.93 15.5122 6.18 15.0107 5.72C14.5091 5.25 13.8871 4.93 13.2952 4.69C12.0914 4.22 10.5766 3.98 9.00165 3.99C7.42667 4 5.91188 4.27 4.71811 4.75C4.12624 4.99 3.5143 5.33 3.02275 5.8C2.52116 6.28 2.00954 7.04 2.01957 8.04V8.28C3.3237 9.26 5.85169 10.04 8.90134 10.02C12.2118 9.99 14.8903 9.03 16.064 7.91L16.0439 7.92Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
							</g>{' '}
							<defs>
								{' '}
								<clipPath id="clip0_514_315">
									{' '}
									<rect
										data-darkreader-inline-fill=""
										fill="white"
										height="28"
										style={{ fill: '#FFFFFF' }}
										transform="translate(0.00317383)"
										width="28"
									>
										{' '}
									</rect>{' '}
								</clipPath>{' '}
							</defs>{' '}
						</svg>
						Hóquei no Gelo / Hóquei em Campo
					</summary>
					<div className="textItem">
						<p>
							<strong>
								O resultado de uma aposta em um evento de hóquei no gelo/hóquei em campo é baseado
								apenas nos tempos regulares. Salvo indicação em contrário, as prorrogações e os
								pênaltis não afetarão o resultado da aposta.
							</strong>
						</p>

						<p className="pH2">
							<strong>Principais Mercados</strong>
						</p>

						<p>
							<strong>
								*Alguns dos mercados listados abaixo podem aparecer em E-Ice Hockey (as mesmas
								regras se aplicam).{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Money Line (incl.OT e penalidades)</strong>: Você deve prever o resultado da
								partida, incluindo qualquer período de prorrogação e penalidades.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1X2</strong>: Prevê se o vencedor do jogo será a equipe da casa - equipe
								visitante ou se em vez disso o resultado final será um empate, as apostas são
								aceites apenas no tempo regulamentar, excluindo prolongamentos e o resultado dos
								pontapés de grande penalidade da série.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap (incl.OT e penalidades) (2-Way)</strong>: Você tem que prever o
								vencedor de toda a partida inteira adicionando ou subtraindo o spread indicado ao
								resultado da partida, incluindo qualquer período de prorrogação e penalidades
								(contagem de pênaltis como ' 1 ' ).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total (incl.OT e pênaltis)</strong>: Você tem que prever se o número total
								de gols marcados durante a partida será acima ou abaixo do spread indicado,
								incluindo qualquer período de prorrogação e pênaltis (os pênaltis contam como ' 1 '
								).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ambas as equipes marcarão (GG/NG)</strong>: Prevê se ambas as equipes
								marcarão ao final da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ímpar/par (incluindo prorrogação e penalidades)</strong>: Você deve prever
								se o resultado da partida é um número par ou ímpar, se o resultado da partida for "
								0:0 ", as apostas são contadas como " par ", incluindo possíveis tempo extra e
								penalidades (o resultado das penalidades conta como ' 1 ' ).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro Gol</strong>: Você tem que prever qual time vai marcar o primeiro
								gol do regulamento.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Último Gol</strong>: Você tem que prever qual time vai marcar o último gol
								do regulamento.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Dupla chance</strong>:
							</strong>
						</p>

						<p>
							<strong>
								<strong>1X</strong>: Se o resultado for uma vitória em casa ou um empate
							</strong>
						</p>

						<p>
							<strong>
								<strong>2X</strong>: Se o resultado for uma vitória fora ou um empate
							</strong>
						</p>

						<p>
							<strong>
								<strong>1.2</strong>: Se o resultado for uma vitória em casa ou uma vitória fora
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total (mais/menos)</strong>: Prevê se a pontuação ao final do tempo
								regulamentar será mais ou menos de acordo com o número escolhido no mercado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap (2-Way)</strong>: Você tem que prever o vencedor do tempo
								regulamentar de toda a partida adicionando ou subtraindo o spread indicado ao
								resultado da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Empate anula aposta</strong>: este mercado de apostas consiste no seguinte,
								para definir uma aposta como vencedora, deve necessariamente haver uma equipe
								vencedora, o que significa que, se a partida terminar empatada, o dinheiro apostado
								será devolvido. Por exemplo, se uma pontuação final resultar em empate, a aposta
								será considerada nula.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total da equipe da casa / equipe visitante</strong>: Você deve prever se o
								número total de gols marcados pela equipe da casa ou da equipe visitante durante a
								partida será superior ou inferior ao spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Margem Vencedora</strong>: Mercado de apostas que prevê a diferença que uma
								equipe terá em relação ao adversário ao final da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pontuação Correta</strong>: Prever a pontuação final do evento ao final do
								tempo regulamentar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Haverá prorrogação</strong>: Você deve prever se haverá prorrogação na
								partida ou não.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap (3-Way)</strong>: Você tem que prever o vencedor do tempo
								regulamentar de toda a partida adicionando ou subtraindo o spread indicado ao
								resultado da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Período de maior pontuação</strong>: Preveja qual dos períodos terá o maior
								número de gols.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Período de maior pontuação da casa</strong>: Preveja qual dos períodos a
								equipe da casa terá o maior número de gols.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Período de maior pontuação fora</strong>: Preveja em qual dos períodos a
								equipe visitante terá o maior número de gols.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ímpar/Par</strong>: Prever se o número de gols ao final do evento
								representará um número par ou ímpar.
							</strong>
						</p>

						<p>
							<strong>
								Apostas mais/menos, incluindo as 3 opções (mais/menos/empate… gols), são sugeridas
								para o tempo regulamentar apenas em todos os jogos de hóquei, independentemente do
								campeonato.
							</strong>
						</p>

						<p>
							<strong>
								Se, como resultado do jogo, o número total de gols marcados for igual ao total da
								aposta e apenas duas opções forem fornecidas (maior ou menor, sem a opção de "empate
								… gols"), o dinheiro apostado será reembolsado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>
									Quem vai ganhar o resto da partida - Quem vai ganhar o resto do primeiro tempo
									(inclui apostas ao vivo)
								</strong>
								: Este é um mercado ao vivo, você aposta em quem vai ganhar o resto da partida, (ao
								selecionar o mercado, o evento terá uma pontuação de 0-0 independente da pontuação
								real no momento da aposta).{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>
									Quem vai ganhar o resto da partida incluindo prorrogação e pênaltis (Inclui aposta
									ao vivo)
								</strong>
								: Esse é um mercado ao vivo, você aposta em quem vencerá o restante da partida, (ao
								selecionar o mercado, o evento terá uma pontuação de 0-0 independente da pontuação
								real no momento da aposta). A prorrogação e a disputa de pênaltis estão incluídas na
								aposta.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mercado 1X2 e Total</strong>: Este mercado de apostas combina dois mercados
								de apostas principais onde você deve prever quem vencerá a partida e quantos gols
								totais (mais/menos) serão marcados na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Casa sem aposta</strong>: Você deve prever se o time visitante vencerá a
								partida ou se a partida terminará empatada. Se o time da casa vencer a partida, a
								aposta será considerada nula.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Fora sem aposta</strong>: Você deve prever se o time da casa vencerá a
								partida ou se a partida terminará empatada. Se o time visitante vencer a partida, a
								aposta será considerada nula.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Gols exatos</strong>: Você deve prever o número exato de gols que serão
								marcados durante o tempo regulamentar de toda a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Gols exatos da casa</strong>: Você deve prever o número exato de gols que
								serão marcados pela equipe da casa durante o tempo regulamentar de toda a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Gols exatos fora</strong>: Você deve prever o número exato de gols que serão
								marcados pelo time visitante durante o tempo regulamentar de toda a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qual time marcará</strong>: Você deve prever qual time irá marcar durante a
								partida. 4 são os resultados possíveis: Apenas equipe 1, Apenas equipe 2, Ambas as
								equipes, Nenhuma.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Folha limpa em casa</strong>: Folha limpa é um termo usado para descrever
								uma equipe que não sofreu nenhum gol. Você tem que prever se o time da casa não
								sofrerá gols durante toda a partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Folha limpa fora de casa</strong>: Folha limpa é um termo usado para
								descrever uma equipe que não sofreu nenhum gol. Você tem que prever se o time
								visitante não sofrerá gols durante toda a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1x2 &amp; ambas as equipes marcam</strong>: Você tem que prever o resultado
								da partida e se ambas as equipes marcarão ou não apenas no 1º tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Tempo extra - 1x2</strong>: Você tem que prever o resultado 1X2 apenas do
								período de tempo extra.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Tempo extra - chance dupla</strong>: Você tem que prever o resultado para
								chance dupla apenas do período de tempo extra:
							</strong>
						</p>

						<p>
							<strong>
								<strong>1X</strong>: Se o resultado for uma vitória em casa ou um empate
							</strong>
						</p>

						<p>
							<strong>
								<strong>2X</strong>: Se o resultado for uma vitória fora ou um empate
							</strong>
						</p>

						<p>
							<strong>
								<strong>1.2</strong>: Se o resultado for uma vitória em casa ou uma vitória fora
							</strong>
						</p>

						<p>
							<strong>
								<strong>Prorrogação - xº gol</strong>: Você deve prever qual Time durante o período
								de prorrogação marcará o próximo gol. Existem 3 resultados possíveis: 1 (o resultado
								da equipe da casa), X (o empate da equipe), 2 (o resultado da equipe visitante).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Prorrogação - total</strong>: Você deve prever se o número total de gols
								marcados apenas durante a prorrogação será superior ou inferior ao spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Prorrogação - empate anula aposta</strong>: este mercado de apostas consiste
								no seguinte, para definir uma aposta como vencedora, deve necessariamente haver uma
								equipe vencedora, o que significa que, se o período de prolongamento terminar
								empatado, a aposta a dinheiro será ser reembolsado. Por exemplo, se uma pontuação
								final resultar em empate, a aposta será considerada nula.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Prorrogação - competidor1 devolve aposta</strong>: Você deve prever se o
								time da casa vencerá a prorrogação ou se a partida terminará empatada. Se o time da
								casa vencer a partida, a aposta será considerada nula.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Prorrogação - competidor2 devolve aposta</strong>: Você tem que prever se o
								time visitante vencerá a prorrogação ou se a partida terminará empatada. Se o time
								da casa vencer a partida, a aposta será considerada nula.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Cobrança de pênaltis - vencedor</strong>: Você tem que prever qual time
								vencerá a disputa de pênaltis (1-2).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Cobrança de pênaltis - xº gol</strong>: Você deve prever qual time marcará o
								gol "x" durante a cobrança de pênaltis. 3 Resultados possíveis: 1, X, 2.
							</strong>
						</p>

						<p>
							<strong>
								<strong>x gol &amp; 1x2</strong>: Vocês têm que prever juntos se o resultado final
								da partida será 1, X ou 2 e qual equipe fará o gol x da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>x período 1x2 e 1x2</strong>: Você tem que prever juntos se o resultado
								final do período selecionado e o resultado final da partida. Os resultados possíveis
								são:
							</strong>
						</p>

						<p>
							<strong>Equipe da casa e equipe da casa</strong>
						</p>

						<p>
							<strong>sorteio e time da casa</strong>
						</p>

						<p>
							<strong>Time visitante e time da casa</strong>
						</p>

						<p>
							<strong>Seleção da casa e sorteio</strong>
						</p>

						<p>
							<strong>empate &amp; empate</strong>
						</p>

						<p>
							<strong>Equipe visitante e empate</strong>
						</p>

						<p>
							<strong>Time da casa e time visitante</strong>
						</p>

						<p>
							<strong>Empate e equipe visitante</strong>
						</p>

						<p>
							<strong>Equipe visitante e equipe visitante</strong>
						</p>

						<p>
							<strong>
								<strong>Casa para vencer todos os períodos</strong>: Você deve prever se a equipe da
								casa vencerá todos os períodos durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Fora para vencer todos os períodos</strong>: Você deve prever se o time
								visitante vencerá todos os períodos durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Casa para vencer em qualquer período</strong>: Você deve prever se a equipe
								da casa vencerá em qualquer período durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Fora para vencer qualquer período</strong>: Você deve prever se o time
								visitante vencerá qualquer período durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Casa para marcar em todos os períodos</strong>: Você deve prever se a equipe
								da casa marcará em todos os períodos durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Fora de casa para marcar em todos os períodos</strong>: Você tem que prever
								se a equipe visitante vai marcar em todos os períodos durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Todos os períodos acima de x.5</strong>: Você deve prever se todos os
								períodos terminarão acima de x.5 (0.5,1.5,2.5..) durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Todos os períodos abaixo de x.5</strong>: Você deve prever se todos os
								períodos terminarão abaixo de x.5 (0.5,1.5,2.5..) durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Tipo de gol</strong>: Você tem que prever o tipo de gol do gol x: 6 são os
								resultados possíveis:
							</strong>
						</p>

						<p>
							<strong>mesma força</strong>
						</p>

						<p>
							<strong>jogo de poder</strong>
						</p>

						<p>
							<strong>de mão curta</strong>
						</p>

						<p>
							<strong>pênalti</strong>
						</p>

						<p>
							<strong>rede vazia</strong>
						</p>

						<p>
							<strong>nenhuma meta</strong>
						</p>

						<p>
							<strong>
								<strong>Tipo de gol em casa x</strong>: Tem de prever o tipo de gol x.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Fora xº tipo de gol</strong>: Tem de prever o tipo de gol x.
							</strong>
						</p>

						<p>
							<strong>
								<strong>A partida vai para a disputa de pênaltis</strong>: Você precisa prever se a
								partida irá para a disputa de pênaltis
							</strong>
						</p>

						<p>
							<strong>
								<strong>
									Ambas as equipes marcarão duas vezes (excluindo tempo extra e pênaltis)
								</strong>
								: Você deve prever se ambas as equipes marcarão duas vezes na partida (excluindo o
								tempo regulamentar e os pênaltis).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de minutos de pênalti (acima/abaixo)</strong>: Você deve prever se o
								total de minutos de pênalti será superior ou inferior à linha determinada.
							</strong>
						</p>

						<p>
							<strong>Mercados do Período</strong>
						</p>

						<p>
							<strong>
								<strong>1º-2º-3º Período</strong>: Os mercados de apostas de período permitem ao
								jogador apostar no resultado final de cada um dos períodos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Período 1X2</strong>: Prever se o vencedor no período mencionado será o time
								da casa - time visitante ou se o resultado final será um empate, as apostas são
								aceitas apenas no tempo regulamentar, excluindo tempo extra e o resultado da
								penalidade da série chutes.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Período empate sem aposta</strong>: este mercado de apostas consiste no
								seguinte, para definir uma aposta como vencedora, deve necessariamente haver uma
								equipe vencedora no referido período, o que significa que, se o jogo terminar
								empatado, o dinheiro aposta será reembolsada. Por exemplo, se uma pontuação final
								resultar em empate, a aposta será considerada nula.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Período Dupla Chance</strong>:
							</strong>
						</p>

						<p>
							<strong>
								<strong>1X</strong>: Se o resultado for uma vitória em casa ou um empate no período
								mencionado
							</strong>
						</p>

						<p>
							<strong>
								<strong>2X</strong>: Se o resultado for uma vitória fora ou um empate no período
								mencionado
							</strong>
						</p>

						<p>
							<strong>
								<strong>1.2</strong>: Se o resultado for uma vitória em casa ou uma vitória fora no
								período mencionado
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap do Período (2 vias)</strong>: Você deve prever o vencedor do
								período mencionado adicionando ou subtraindo o spread indicado ao resultado do
								período.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total do Período</strong>: Você deve prever se o número total de gols
								marcados durante o período mencionado será superior ou inferior ao spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro Gol do Período</strong>: Você tem que prever qual time vai marcar o
								primeiro gol do período mencionado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Período Última Equipe a Marcar</strong>: Você deve prever qual equipe irá
								marcar o último gol do período mencionado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Período Ambas as equipes marcam</strong>: Prevê se ambas as equipes
								pontuarão ou não no período mencionado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Período - competidor1 total</strong>: Você deve prever se o número total de
								gols marcados pela equipe da casa durante o período mencionado será superior ou
								inferior ao spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Período - total competidor2</strong>: Você deve prever se o número total de
								gols marcados pela equipe visitante durante o período mencionado será superior ou
								inferior ao spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Período - gols exatos</strong>: Você deve prever o número exato de gols que
								serão marcados no período mencionado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Período - gols exatos do competidor1</strong>: Você deve prever o número
								exato de gols que serão marcados pela equipe da casa durante o período mencionado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Período - gols exatos do competidor2</strong>: Você deve prever o número
								exato de gols que serão marcados pela equipe visitante durante o período mencionado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Período - qual time pontuar</strong>: Você deve prever qual time irá pontuar
								durante o período mencionado. 4 são os resultados possíveis: Apenas equipe 1, Apenas
								equipe 2, Ambas as equipes, Nenhuma.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Período - folha limpa competidor1</strong>: Folha limpa é um termo usado
								para descrever uma equipe que não sofreu nenhum gol. Você tem que prever se o time
								da casa não sofrerá gols durante o período mencionado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Período - folha limpa competidor2</strong>: Folha limpa é um termo usado
								para descrever uma equipe que não sofreu nenhum gol. Você tem que prever se a equipe
								visitante manterá uma folha limpa durante o período mencionado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Período - pontuação correta</strong>: Preveja a pontuação final no final do
								período mencionado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Período - qual time ganha o resto</strong>: Este é um mercado ao vivo, você
								aposta em quem vai ganhar o resto do período mencionado, (ao selecionar o mercado, o
								evento terá uma pontuação de 0-0 independente da pontuação real no momento da
								aposta).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Período - par/ímpar</strong>: Prever se o número de gols ao final do período
								mencionado representará um número par ou ímpar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Xº período - qualquer uma das equipes marcará</strong>: você deve prever se
								uma das equipes marcará no Xº período
							</strong>
						</p>

						<p>
							<strong>Especiais de Jogador</strong>
						</p>

						<p>
							<strong>
								<strong>Objetivos do jogador (no mínimo)</strong>: Consiste em prever pelo menos
								quantos gols o jogador específico fará, apenas em tempo padrão, a menos que o
								mercado especifique (Inc OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Assistências do jogador (pelo menos)</strong>: Consiste em prever pelo menos
								quantas assistências o jogador específico fará, apenas o tempo padrão, a menos que o
								mercado especifique (Inc OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Tiros à gol do jogador (pelo menos)</strong>: Consiste em prever pelo menos
								quantos chutes à baliza o jogador específico fará, apenas o tempo padrão a menos que
								o mercado especifique (Inc OT). Chutes que não estão no gol não contam.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Defesas do jogador (pelo menos)</strong>: Consiste em prever pelo menos
								quantas defesas o jogador específico fará, apenas em tempo padrão, a menos que o
								mercado especifique (Inc OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pontos do jogador (pelo menos)</strong>: Consiste em prever pelo menos
								quantos pontos (gols e assistências combinados) o jogador específico fará, apenas o
								tempo padrão, a menos que o mercado especifique (Inc OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Finalizações do jogador a gol (mais/menos)</strong>: Consiste em prever a
								quantidade de chutes a gol que o jogador específico fará, apenas o tempo padrão, a
								menos que o mercado especifique (Inc OT). Chutes que não estão no gol não contam.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Defesas do jogador (mais/menos)</strong>: Consiste em prever a quantidade de
								defesas que o jogador específico fará, apenas em tempo padrão, a menos que o mercado
								especifique (Inc OT).
							</strong>
						</p>

						<p>
							<strong>
								<strong>
									10 minutos - total de {`{de}`} a {`{até}`}:
								</strong>
								Você deve prever o número total de gols marcados dentro de um segmento específico de
								10 minutos do jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>
									5 minutos - total de {`{de}`} a {`{até}`}:
								</strong>
								Você deve prever o número total de gols marcados dentro de um segmento específico de
								5 minutos do jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Gols em Powerplay:</strong>
								Você deve prever o número total de gols marcados durante os power plays na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Gol em gol vazio:</strong>
								Você deve prever se uma equipe marcará um gol quando a equipe adversária remover seu
								goleiro em favor de um jogador extra, tipicamente nos minutos finais da partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Gol em desvantagem numérica:</strong>
								Você deve prever se uma equipe marcará um gol enquanto está em desvantagem numérica,
								geralmente devido a um de seus jogadores estar na caixa de penalidades.{' '}
							</strong>
						</p>

						<p className="pH2">
							<strong>Hóquei no Gelo/Hóquei em Campo Outrights</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor</strong>: Você deve prever o vencedor de um determinado torneio de
								acordo com o ranking oficial da competição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor da divisão/conferência</strong>: Você deve prever o vencedor de
								determinada divisão ou conferência de acordo com o ranking oficial da competição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pontos da Temporada Regular - Equipe</strong>: Você deve prever quantos
								pontos (mais/menos) a equipe mencionada irá acumular de acordo com o ranking oficial
								da competição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Eles vão para os playoffs? - Equipe</strong>: Você tem que prever se a
								equipe mencionada chegará ao playoff do torneio em questão de acordo com o ranking
								oficial da competição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Top4, Top6, Top8, Top10</strong>: Você deve prever se a equipe selecionada
								terminará na posição superior respectiva quando a competição terminar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Draft X° Pick</strong>: Você tem que prever quem será o X° pick no draft
								mencionado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Posição do Draft - Jogador</strong>: Você deve prever qual posição o jogador
								mencionado ficará no draft mencionado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>H2H - Pontuação Correta da Série</strong>: Você tem que prever o resultado
								final da série de partidas entre as 2 equipes indicadas. Para efeitos de divulgação
								serão considerados válidos apenas os sites oficiais de cada competição. (A saber:
								H2H significa head to head, o que pode ser traduzido como "cabeça a cabeça", o que
								indica comparação o entre dois adversários)
							</strong>
						</p>

						<p>
							<strong>
								<strong>H2H - Quando terminará a série?</strong>: Você deve prever quantos jogos
								terminará a série de partidas entre as 2 equipes indicadas. Para efeitos de
								divulgação serão considerados válidos apenas os sites oficiais de cada competição.
								(A saber: H2H significa head to head, o que pode ser traduzido como "cabeça a
								cabeça", o que indica comparação entre dois adversários)
							</strong>
						</p>

						<p>
							<strong>
								<strong>H2H - Vencedor</strong>: Você deve prever qual das duas equipes indicadas se
								qualificará na fase de qualificação ou no play-off. (A saber: H2H significa head to
								head, o que pode ser traduzido como "cabeça a cabeça", o que indica comparação entre
								dois adversários).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Marcador a qualquer momento/Xº(AO VIVO)</strong>: as apostas aplicam-se
								apenas ao tempo regulamentar. Todos os jogadores oferecidos são considerados como
								elegíveis. Se um jogador não listado marcar um gol, todas as apostas nos jogadores
								listados serão válidas. Para efeitos de liquidação, apenas os gols e assistências
								marcados durante o tempo regulamentar são considerados. Observe que se o placar após
								o tempo regulamentar for 0-0, todas as apostas serão consideradas perdidas. Todas as
								apostas em jogadores listados, mas que deixaram o jogo antes do final da partida
								(como lesões ou expulsões) serão válidas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador para marcar um gol (AO VIVO)</strong>: as apostas aplicam-se apenas
								ao tempo regulamentar. Todos os jogadores oferecidos são considerados como
								elegíveis. Se um jogador não listado marcar um gol, todas as apostas nos jogadores
								listados serão válidas. Para efeitos de liquidação, apenas os gols e assistências
								marcados durante o tempo regulamentar são considerados. Observe que se o placar após
								o tempo regulamentar for 0-0, todas as apostas serão consideradas perdidas. Todas as
								apostas em jogadores listados, mas que deixaram o jogo antes do final da partida
								(como lesões ou expulsões) serão válidas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mercados H2H do Jogador</strong>: Para os seguintes mercados especiais de
								jogadores, as apostas aplicam-se ao tempo regulamentar mais prorrogação (se houver),
								salvo indicação em contrário. Potencial disputa de pênaltis não contará para
								liquidação:
							</strong>
						</p>

						<p>
							<strong>
								*Se um jogador não participar da partida, todas as apostas serão consideradas
								anuladas.*{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pontos do jogador (acima/abaixo):</strong>
								Consiste em prever a quantidade de pontos (gols e assistências combinados) que um
								jogador específico fará, apenas no tempo regulamentar, a menos que o mercado
								especifique (incluindo tempo extra).{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Gols do jogador (acima/abaixo):</strong>
								Consiste em prever a quantidade de gols que um jogador específico fará, apenas no
								tempo regulamentar, a menos que o mercado especifique (incluindo tempo extra).{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Assistências do jogador (acima/abaixo):</strong>
								Consiste em prever a quantidade de assistências que um jogador específico fará,
								apenas no tempo regulamentar, a menos que o mercado especifique (incluindo tempo
								extra).{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pontos de powerplay do jogador:</strong>
								Consiste em prever a quantidade de pontos conquistados por um jogador durante a
								vantagem numérica (powerplay), apenas no tempo regulamentar, a menos que o mercado
								especifique (incluindo tempo extra).{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Plus/Minus do jogador:</strong>
								Consiste em prever os pontos ganhos por um jogador na avaliação plus/minus.
								Considerando que um "plus" é dado ao jogador que está no gelo quando sua equipe
								marca um gol em igualdade numérica ou com um jogador a menos, enquanto um "minus" é
								dado aos jogadores que estão no gelo quando os adversários marcam nessas situações.
								Apenas no tempo regulamentar, a menos que o mercado especifique (incluindo tempo
								extra).{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Shootout do jogador:</strong>
								Consiste em prever se um goleiro registrará um shootout ou não. Um shootout (SO) é
								creditado a um goleiro que impede com sucesso que a outra equipe marque durante toda
								a partida. Em jogos da temporada regular, se o placar terminar 0-0 e a partida for
								para a disputa de pênaltis, ambos os goleiros recebem o shootout. Apenas no tempo
								regulamentar, a menos que o mercado especifique (incluindo tempo extra).{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Chutes bloqueados do jogador:</strong>
								Consiste em prever a quantidade de chutes bloqueados registrados por um defensor. Um
								chute que é desviado ou bloqueado por um oponente não conta como chute a gol; é
								registrado como um chute bloqueado. O jogador que bloqueia o chute é creditado com
								um “chute bloqueado”. Apenas no tempo regulamentar, a menos que o mercado
								especifique (incluindo tempo extra).{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro gol do jogador:</strong>
								Você deve prever qual jogador marcará o primeiro gol durante a partida. Apenas no
								tempo regulamentar, a menos que o mercado especifique (incluindo tempo extra).{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Último gol do jogador:</strong>
								Você deve prever qual jogador marcará o último gol durante a partida. Apenas no
								tempo regulamentar, a menos que o mercado especifique (incluindo tempo extra).{' '}
							</strong>
						</p>

						<ul>
							<li>
								<strong>-Marcador a qualquer momento/Xº(AO VIVO)</strong>
							</li>
							<li>
								<strong>-Jogador para marcar um gol (AO VIVO)</strong>
							</li>
							<li>
								<strong>-Total de assistências do jogador (ou mais/menos) (PRÉ-JOGO)</strong>
							</li>
							<li>
								<strong>-Total de Gols do Jogador (ou mais/menos) (PRÉ-JOGO)</strong>
							</li>
							<li>
								<strong>-Total de defesas do jogador (ou mais/menos) (PRÉ-JOGO)</strong>
							</li>
							<li>
								<strong>-Total de Pontos do jogador (ou mais/menos) (PRÉ-JOGO)</strong>
							</li>
							<li>
								<strong>-Total de tiros do Jogador (ou mais/menos) (PRÉ-JOGO)</strong>
							</li>
							<li>
								<strong>-Total de tiros a gol do jogador (ou mais/menos) (PRÉ-JOGO)</strong>
							</li>
						</ul>
					</div>
				</details>
				{/* Hurling */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 33 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<path
								d="M31.1131 23.3326C30.8331 23.0497 30.4931 22.8376 30.1431 22.6962C29.8831 22.5952 29.6031 22.5245 29.3331 22.5042C29.3031 22.5042 29.2831 22.5042 29.2531 22.5042C29.0031 22.484 28.7531 22.4941 28.5031 22.5346C28.4431 22.5447 28.3831 22.575 28.3231 22.5952C28.1131 22.6457 27.9031 22.6962 27.7131 22.7871C27.6431 22.8174 27.5831 22.878 27.5131 22.9184C27.3431 23.0194 27.1731 23.1104 27.0231 23.2417L22.1431 28.1714L25.6331 31.6969C25.7331 31.798 25.8431 31.8687 25.9631 31.9192C26.0431 31.9495 26.1331 31.9596 26.2131 31.9697C26.2531 31.9697 26.2931 32 26.3431 32C26.6031 32 26.8531 31.899 27.0531 31.707L31.1331 27.5855C31.6931 27.0198 32.0031 26.2621 32.0031 25.454C32.0031 24.6458 31.6931 23.8983 31.1331 23.3326H31.1131Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M25.4831 21.9183L20.5631 16.9482L22.5831 14.9076L17.9731 10.2507C17.7931 10.4628 15.9831 12.3115 15.9831 12.3115C15.9831 12.3115 14.1731 10.4729 13.9931 10.2507L9.38313 14.9076L11.4031 16.9482L6.67314 21.7264V21.7365L11.2531 26.3632H11.2631V26.3733L15.9931 21.5951L20.9031 26.5551L25.4831 21.9284V21.9183Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M5.66315 12.1296C6.05315 12.3822 6.45314 12.6448 6.85314 12.8974C7.18314 13.1095 7.51314 13.3318 7.84314 13.554C7.85314 13.554 7.86314 13.5641 7.87314 13.5742L12.9031 8.49296C12.4631 7.5939 12.1332 6.64432 11.8032 5.70485C11.0332 3.51274 10.2432 1.23982 8.05315 0.371064C5.91315 -0.477493 3.41314 0.158925 1.68314 1.97726C0.0431409 3.69458 -0.436848 5.9877 0.413152 7.94746C0.853152 8.96775 2.52315 10.079 5.67315 12.1195L5.66315 12.1296Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M23.8631 13.3419L24.1031 13.5843C24.8331 13.0994 25.5731 12.6145 26.3031 12.1397C29.4631 10.0992 31.1231 8.98795 31.5731 7.96767C32.4331 6.0079 31.9431 3.71478 30.3131 1.99746C29.8831 1.54288 29.3931 1.15901 28.8831 0.855953C27.3431 -0.0532144 25.5431 -0.24515 23.9331 0.391268C21.7431 1.26003 20.9531 3.52285 20.1831 5.72505C19.8531 6.66453 19.5231 7.6141 19.0831 8.51317L23.8731 13.352L23.8631 13.3419Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M9.77315 27.7168L4.94315 22.8376C4.83315 22.7366 4.72314 22.6457 4.60314 22.575C4.58314 22.5649 4.56314 22.5447 4.54314 22.5346C4.40314 22.4436 4.25314 22.3628 4.10314 22.3022C3.98314 22.2517 3.86314 22.2214 3.74314 22.1911C3.68314 22.1709 3.62315 22.1507 3.55315 22.1305C2.61315 21.9486 1.60314 22.2214 0.873143 22.9487C-0.286857 24.1205 -0.286857 26.0298 0.873143 27.2016L4.95315 31.3232C5.05314 31.4242 5.16315 31.4949 5.28315 31.5454C5.36315 31.5757 5.45315 31.5858 5.53315 31.5959C5.57315 31.5959 5.61315 31.6262 5.66315 31.6262C5.92315 31.6262 6.17314 31.5252 6.37314 31.3333L9.17315 28.5149L9.86315 27.8178L9.78315 27.737L9.77315 27.7168Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
						</svg>
						Hurling
					</summary>
					<div className="textItem">
						<p className="pH2">
							<strong>Mercado Principal</strong>
						</p>

						<p>
							<strong>
								<strong>1X2</strong>: Você tem que prever o resultado de toda a partida. Existem 3
								resultados possíveis: 1 (o time da casa ganha), X (os times vão empatar), 2 (o time
								visitante ganha).
							</strong>
						</p>

						<p className="pH2">
							<strong>Outrights</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor</strong>: Você deve prever o vencedor de um determinado torneio de
								acordo com o ranking oficial da competição.
							</strong>
						</p>
					</div>
				</details>
				{/* Handebol */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 28 28"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<g clip-path="url(#clip0_516_603)">
								{' '}
								<path
									d="M16.5822 7.46315C17.0322 7.46315 17.4822 7.38217 17.9222 7.21009C19.8122 6.46103 20.7522 4.28471 20.0122 2.37157C19.2722 0.458427 17.1322 -0.493081 15.2322 0.255979C14.3122 0.620386 13.5922 1.31883 13.1922 2.23997C12.7922 3.15099 12.7722 4.17336 13.1322 5.0945C13.7022 6.57237 15.0922 7.47327 16.5722 7.47327L16.5822 7.46315Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M28.5622 19.0737C28.3222 18.7194 22.5022 10.5101 16.6722 9.6598C16.6422 9.6598 16.6022 9.6598 16.5722 9.6598C16.5622 9.6598 16.5422 9.64968 16.5322 9.64968L10.0022 9.05245C9.05217 8.24266 8.07217 7.34176 7.22217 6.5016C7.28217 6.48136 7.34217 6.47123 7.40217 6.45099C9.06217 5.79303 9.89217 3.89002 9.24217 2.20969C8.59217 0.519247 6.71217 -0.310792 5.04217 0.347166C3.46217 0.974757 2.65217 2.72594 3.14217 4.34552C3.14217 4.4265 3.14217 4.51761 3.17217 4.59859C3.77217 6.34977 7.74217 9.79139 8.95217 10.8138C9.11217 10.9453 9.30217 11.0263 9.50217 11.0466L12.8322 11.3502C12.8922 13.3849 12.9022 14.6805 12.9022 15.8345C12.9022 16.9986 12.9022 18.1019 12.9722 19.7215C12.9822 19.9847 13.0622 20.2377 13.1922 20.4604L4.06217 30.2994C3.68217 30.7043 3.70217 31.3522 4.10217 31.7267C4.29217 31.9089 4.54217 32 4.78217 32C5.05217 32 5.31217 31.8886 5.51217 31.6761L14.9022 21.5638L18.1222 21.584L21.4622 24.307L18.6822 26.8983C15.6522 29.7225 14.9822 30.3197 15.0222 30.6841C15.0022 30.7549 14.9822 30.8258 14.9822 30.8967C14.9822 31.4534 15.4322 31.9089 15.9822 31.9089C16.2722 31.9089 16.5322 31.7773 16.7222 31.5647C16.9122 31.3825 20.8622 27.617 23.6722 25.0054C23.8822 24.8029 24.0022 24.5195 23.9922 24.226C23.9922 23.9324 23.8422 23.6591 23.6222 23.4668L19.7022 20.2782C19.7122 20.2074 19.7422 20.1466 19.7422 20.0758L19.5722 12.9496C23.4522 15.3587 26.8722 20.177 26.9222 20.2377C27.1222 20.5212 27.4222 20.6629 27.7422 20.6629C27.9422 20.6629 28.1422 20.6021 28.3222 20.4807C28.7722 20.1568 28.8822 19.5292 28.5622 19.0737Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
							</g>{' '}
							<defs>
								{' '}
								<clipPath id="clip0_516_603">
									{' '}
									<rect
										data-darkreader-inline-fill=""
										fill="white"
										height="28"
										style={{ fill: '#FFFFFF' }}
										width="28"
									></rect>{' '}
								</clipPath>{' '}
							</defs>{' '}
						</svg>
						Handebol
					</summary>
					<div className="textItem">
						<p>
							<strong>
								Todas as apostas de handebol serão feitas com base em 60 minutos de jogo, a menos
								que especificado de outra forma. As tempo extra não contam, nem afetam o resultado
								do segundo tempo e não serão levadas em consideração para a contagem das apostas do
								segundo tempo. Se os 60 minutos de jogo não forem concluídos por qualquer motivo,
								todas as apostas serão anuladas e a aposta será reembolsada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>
									A partida deve ser concluída para que as apostas sejam válidas (a menos que o
									mercado já tenha sido liquidado). Todos os mercados ao vivo não incluem tempo
									extra, mercados como
								</strong>
								: 1x2, Handicap, Ímpar/Par, Margem de Vitória de Handebol, Chance Dupla, exceto para
								mercados de apostas como: Qualificar/Ganhar a copa/Vencer após a prorrogação etc.
							</strong>
						</p>

						<p className="pH2">
							<strong>Principais Mercados</strong>
						</p>

						<p>
							<strong>
								<strong>Mercado 1X2</strong>: Preveja o resultado da partida. As apostas são aceitas
								apenas para o tempo normal, excluindo tempo extra.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total</strong>: Você aposta se haverá mais ou menos gols do que a linha
								dada, durante o tempo regulamentar de uma partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap</strong>: Você deve prever o vencedor o tempo regulamentar de toda
								a partida adicionando ou subtraindo o spread indicado ao resultado da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Chance Dupla</strong>: Você tem que prever o resultado do tempo regulamentar
								de toda a partida. Existem 3 resultados possíveis: 1X (no final do jogo o time da
								casa vence ou empata), X2 (no final do jogo o time visitante vence ou empata), 12
								(no final do jogo o time da casa vence ou o time visitante vence).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Empate anula aposta</strong>: Preveja o resultado da partida. Se o resultado
								final for um empate, a aposta será considerada nula.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ímpar/Par</strong>: Preveja se o número total de gols marcados é um número
								par ou ímpar, caso contrário, se a pontuação final for 0:0, as apostas serão
								determinadas como par.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Intervalo/Fim do jogo</strong>: Preveja qual time será o vencedor no
								primeiro tempo e no final da partida no tempo regulamentar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Margem Vencedora</strong>: Este mercado de apostas consiste em prever qual
								equipe vencerá e por quanto de diferença vencerá.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Corrida para X Gols</strong>: Preveja qual time chegará primeiro em X gols.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap (3 vias)</strong>: Você deve prever o resultado final da partida
								levando em consideração o handicap entre parênteses.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Totais da equipe</strong>: Você aposta se haverá mais ou menos gols do que a
								linha dada para o time da casa ou visitante, durante o tempo regulamentar de uma
								partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mercados do 1º/2º tempo</strong>: Nesta seção você encontrará os principais
								mercados de apostas relacionados ao primeiro ou ao segundo tempo da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1X2 &amp; totais</strong>: Preveja quem será o vencedor da partida e quantos
								gols (mais/menos) serão marcados na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Metade com pontuação mais alta</strong>: Preveja qual das duas metades terá
								a pontuação mais alta.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Metade com pontuação mais alta da equipe</strong>: Preveja qual das duas
								metades terá uma pontuação mais alta em comparação com a outra, mas apenas para a
								equipe da casa ou da equipe visitante.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe com maior pontuação no tempo</strong>: Preveja qual das duas equipes
								terá uma pontuação mais alta em um tempo em comparação com a outra equipe.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Faixa de Gols</strong>: Preveja em uma faixa selecionada, quantos gols no
								total serão marcados por ambas as equipes.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Intervalo de Gols da Equipe</strong>: Preveja em um intervalo selecionado,
								quantos gols o time da casa ou visitante irá marcar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>xº gol</strong>: Preveja qual time marcará o xº gol.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Prorrogação - total</strong>: Você tem que prever se o número total de gols
								marcados durante a Prorrogação será acima ou abaixo da linha indicada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Prorrogação - handicap</strong>: Você deve prever o resultado final da
								Prorrogação levando em consideração o handicap entre parênteses.
							</strong>
						</p>

						<p className="pH2">
							<strong>Mercados do 1º tempo</strong>
						</p>

						<p>
							<strong>
								<strong>8.3.1 1º tempo - 1x2</strong>: Preveja o resultado do primeiro tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - chance dupla</strong>: Você tem que prever o resultado do
								primeiro tempo. Existem 3 resultados possíveis: 1X (no final da 1ª parte a equipe da
								casa ganha ou empata), X2 (no final da 1ª parte a equipe visitante ganha ou empata),
								12 (no final da 1ª parte a equipe vitória do time da casa ou vitória do time
								visitante).
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - empate anula aposta</strong>: Preveja o resultado do primeiro
								tempo. Se o resultado final for um empate, a aposta será considerada nula.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - handicap x</strong>:y: Você deve prever o resultado final da
								partida levando em consideração o handicap entre parênteses.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - handicap</strong>: Você tem que prever o vencedor do primeiro
								tempo somando ou subtraindo o spread indicado ao resultado da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - total</strong>: Em um determinado valor dado no mercado, você
								aposta se haverá mais ou menos gols durante o 1º tempo da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Total da casa</strong>: Você aposta se haverá mais ou menos gols
								do que a linha dada para o time da casa, durante o primeiro tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Total visitante</strong>: Você aposta se haverá mais ou menos
								gols do que a linha dada para o time visitante, durante o primeiro tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>8.3.8 1ª parte - ímpar/par</strong>: Preveja se o número total de gols
								marcados durante a 1ª parte é um número ímpar ou par, caso contrário, se o resultado
								final for 0:0, as apostas serão consideradas pares.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - 1x2 &amp; total</strong>: Preveja quem será o vencedor do
								primeiro tempo e quantos gols (mais/menos) serão marcados no primeiro tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Margem de vitórias</strong>: Este mercado de apostas consiste em
								prever qual time vencerá o 1º tempo e por quanto de diferença vencerá.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - intervalo de gols</strong>: Preveja em um intervalo selecionado,
								quantos gols no total serão marcados por ambas as equipes durante o 1º tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Faixa de gols da casa</strong>: Preveja em um intervalo
								selecionado, quantos gols no total serão marcados pela equipe da casa durante o 1º
								tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Intervalo de gols fora</strong>: Preveja em um intervalo
								selecionado, quantos gols no total serão marcados pelo time visitante durante o 1º
								tempo.
							</strong>
						</p>

						<p className="pH2">
							<strong>Mercados do 2º tempo</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - 1x2</strong>: Preveja o resultado do segundo tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - chance dupla</strong>: Você tem que prever o resultado do segundo
								tempo. Existem 3 resultados possíveis: 1X (no final da 2ª parte a equipe da casa
								ganha ou empata), X2 (no final da 2ª parte a equipe visitante ganha ou empata), 12
								(no final da 2ª parte ou vitória do time da casa ou vitória do time visitante).
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - empate anula aposta</strong>: Prever o resultado do segundo
								tempo. Se o resultado final for um empate, a aposta será considerada nula.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - par/ímpar</strong>: Preveja se o número total de gols marcados
								durante a 2ª parte é um número par ou ímpar, caso contrário, se o resultado final
								for 0:0, as apostas serão consideradas pares.
							</strong>
						</p>

						<p className="pH2">
							<strong>Handebol - Outrights</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor</strong>: Você deve prever o vencedor de um determinado torneio de
								acordo com o ranking oficial da competição.
							</strong>
						</p>

						<p className="pH2">Especiais do jogador</p>

						<p>
							Mínimo de gols do jogador (formação inicial) (incluindo prorrogação): Você deve prever
							o número de gols que um jogador marcará pelo menos durante a partida, incluindo a
							prorrogação. Para que a aposta seja válida, o jogador deve começar a partida na
							titular. Se o jogador for listado como substituto e não começar, as apostas nesse
							jogador poderão ser anuladas.
						</p>

						<p>
							Gols do jogador (incl. prorrogação): prevê se o número total de gols marcados por um
							jogador específico durante a partida inclui a prorrogação.
						</p>
					</div>
				</details>
				{/* Kabaddi */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<path
								d="M22.6961 9.40018C24.7368 9.40018 26.3971 7.73987 26.3971 5.70009C26.3971 3.66031 24.7368 2 22.6961 2C20.6563 2 18.996 3.66031 18.996 5.70009C18.996 7.73987 20.6563 9.40018 22.6961 9.40018Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M14.0092 12.315C16.05 12.315 17.7103 10.6547 17.7103 8.61392C17.7103 6.57414 16.05 4.91383 14.0092 4.91383C11.9694 4.91383 10.3091 6.57414 10.3091 8.61392C10.3091 10.6547 11.9694 12.315 14.0092 12.315Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M17.006 19.6791C13.7939 19.2134 13.0378 18.9737 13.1661 15.5931C13.231 15.2048 13.0644 14.7984 12.7089 14.5782L12.5469 14.4787C9.76966 12.7598 8.82244 12.1999 8.23422 12.1374C7.09483 12.0097 5.50963 12.7686 3.58106 14.3821C3.44059 14.4991 0.138501 17.2803 0.0272937 18.8411C-0.0483079 19.9 0.727218 20.9274 1.79393 21.9561L1.89051 22.8017C2.0183 23.9098 2.0183 23.9098 2.03001 24.4503C2.03586 24.7049 2.04366 25.0687 2.0661 25.6804C2.08756 26.2881 1.13547 27.8489 0.233125 28.9269C-0.120983 29.3502 -0.0653794 29.9794 0.357014 30.3345C0.544311 30.4906 0.772579 30.5677 0.998896 30.5677C1.28374 30.5677 1.56664 30.4467 1.76369 30.2106C2.15877 29.7404 4.12246 27.3104 4.06198 25.6092C4.04052 25.0112 4.03272 24.6561 4.02784 24.4064C4.01747 23.9254 4.01126 23.7813 3.95053 23.2342C4.05064 23.1881 4.07483 23.1673 4.11475 23.1475C4.44022 22.9856 5.26466 22.2864 5.26466 22.2864C5.28234 22.3076 5.28904 22.3339 5.30868 22.3539C5.85789 22.9119 6.18663 23.2406 6.39734 23.4504C6.70853 23.7625 6.71048 23.7606 6.85485 23.945C6.97679 24.101 7.18457 24.3654 7.66452 24.9409C7.95327 25.3653 7.80499 27.4597 7.35333 29.3346C7.22359 29.8711 7.55331 30.4106 8.08984 30.5394C8.16886 30.5589 8.2469 30.5677 8.32494 30.5677C8.77562 30.5677 9.18436 30.2604 9.29459 29.8029C9.63407 28.3981 10.3042 24.9887 9.20387 23.6669C8.74148 23.1129 8.54248 22.8602 8.42542 22.7109C8.23031 22.4612 8.23129 22.4602 7.80987 22.0378C7.61404 21.842 7.30554 21.534 6.81705 21.0383L11.2493 17.4744C11.6751 20.6551 13.6831 21.2163 16.7192 21.6554C16.7679 21.6632 16.8157 21.6662 16.8635 21.6662C17.3523 21.6662 17.7795 21.3082 17.8507 20.8107C17.9307 20.2644 17.5522 19.7581 17.006 19.6791Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M29.1793 13.7422C29.6456 14.5089 30.0748 15.7166 29.9919 16.5418C29.9372 17.0911 30.3372 17.5808 30.8864 17.6354C30.9206 17.6383 30.9537 17.6403 30.9869 17.6403C31.4942 17.6403 31.9283 17.2559 31.98 16.7409C32.1224 15.3215 31.4795 13.6787 30.8864 12.7042C29.7178 10.7815 25.8089 10.4947 25.7572 10.4947C25.747 10.495 25.7387 10.5007 25.7287 10.5013C25.7189 10.502 25.7103 10.4976 25.7006 10.4986C23.5613 10.7298 21.5811 11.04 20.8533 12.2808L20.8516 12.2847L20.8416 12.2789C20.2076 13.3246 18.798 15.1459 16.4919 15.5927C15.9495 15.6971 15.5954 16.2209 15.7007 16.7623C15.7924 17.2403 16.2109 17.572 16.6801 17.572C16.7426 17.572 16.807 17.5661 16.8704 17.5534C18.5065 17.2373 19.7747 16.4267 20.7365 15.5352C20.9307 16.7794 21.2345 17.882 21.2592 17.971C21.5738 19.0971 21.9305 20.0169 22.3237 20.744C22.2521 20.7868 22.1769 20.8224 22.1157 20.8848C21.5752 21.434 21.2494 21.7598 21.0416 21.9676C20.6182 22.392 20.6192 22.3929 20.4241 22.6417C20.3071 22.7909 20.109 23.0436 19.6457 23.5987C18.5512 24.9127 19.1667 28.3776 19.4828 29.8068C19.5862 30.2731 19.9988 30.5901 20.4573 30.5901C20.5285 30.5901 20.6007 30.5823 20.6739 30.5667C21.2123 30.4477 21.5528 29.915 21.4338 29.3756C21.0085 27.447 20.8904 25.3009 21.1811 24.8785C21.6659 24.2961 21.8737 24.0318 21.9957 23.8757C22.14 23.6913 22.142 23.6933 22.4551 23.3801C22.6649 23.1704 22.9936 22.8407 23.5399 22.2856C23.5445 22.281 23.5457 22.2746 23.5501 22.2699C23.6411 22.3364 23.7321 22.4037 23.8257 22.4544C24.3142 22.7178 25.3382 22.8001 28.1594 22.9372C29.8497 29.3919 29.988 29.8994 29.988 29.8994C30.1089 30.3433 30.5118 30.635 30.9508 30.635C31.0376 30.635 31.1264 30.6233 31.2142 30.5998C31.7468 30.4545 32.0599 29.9053 31.9156 29.3736C31.9107 29.3544 31.733 28.6997 29.8634 21.5559L29.8699 21.554L29.8152 21.3717C29.8013 21.3187 29.7895 21.2732 29.7753 21.2194C29.7723 21.2078 29.7636 21.1999 29.7602 21.1885L27.2292 12.7632C28.0496 12.9834 28.9246 13.3228 29.1793 13.7422Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
						</svg>
						Kabaddi
					</summary>
					<div className="textItem">
						<p className="pH2">
							<strong>Principais Mercados</strong>
						</p>

						<p>
							<strong>
								<strong>1X2</strong>: Você tem que prever o resultado do tempo regulamentar de toda
								a partida. São 3 resultados possíveis: 1 (vitórias do time da casa), X (times vão
								empatar), 2 (vitórias do time fora).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total (Over/Under)</strong>: Você tem que prever se o número total de pontos
								marcados durante o tempo regulamentar de toda a partida estará acima ou abaixo da
								linha indicada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Dupla chance</strong>: Você tem que prever o resultado do tempo regulamentar
								de toda a partida. Existem 3 resultados possíveis: 1X (no final do jogo o time da
								casa vence ou empata), X2 (no final da partida o time visitante vence ou empata), 12
								(no final da partida o time da casa vence ou o time visitante vence).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Draw no bet (DNB)</strong>: este mercado de apostas consiste no seguinte,
								para definir uma aposta como vencedora, deve necessariamente haver uma equipe
								vencedora, o que significa que, se a partida terminar em um empate, a aposta em
								dinheiro será reembolsada. Por exemplo, se uma pontuação final resultar em um
								empate, a aposta será liquidada como nula.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap</strong>: Você tem que prever o vencedor do tempo regulamentar de
								toda a partida adicionando ou subtraindo o handicap indicado para o resultado da
								partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Margem de vitória</strong>: Mercado de apostas que prevê a quantidade de
								diferença que uma equipe terá de seu adversário no final da partida, por exemplo,
								time da casa por 1-5 pontos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Intervalo/Tempo integral</strong>: Você tem que prever o resultado do 1º
								tempo da partida junto com o resultado do tempo regular de toda a partida. Os
								desfechos possíveis são: (1/1, 1/X, 1/2, X/1, X/X, X/2, 2/1, 2/X e 2/2).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total Equipe da casa</strong>: Você tem que prever se o número total de
								pontos marcados, do Equipe da casa, durante o tempo regulamentar de toda a partida,
								será acima ou abaixo da linha indicada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total Equipe Visitante</strong>: Você tem que prever se o número total de
								pontos marcados, da Equipe Visitante, durante o tempo regulamentar de toda a
								partida, estará acima ou abaixo da linha indicada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Metade de maior pontuação</strong>: Você tem que prever qual metade terá
								mais pontos marcados.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ímpar/Par</strong>: Você tem que prever se o resultado da partida é um
								número ímpar ou par, se o resultado da partida é "0:0", as apostas são contadas como
								"pares".
							</strong>
						</p>

						<p>
							<strong>Mercados do Primeiro Tempo</strong>
						</p>

						<p>
							<strong>
								<strong>1º Tempo - Sorteio sem Aposta</strong>: Você tem que prever o vencedor do 1º
								tempo, se a metade terminar como um empate todas as apostas serão anuladas, se a
								metade estiver incompleta este mercado será anulado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - dupla chance</strong>: É preciso prever o resultado do 1º tempo.
								São 3 resultados possíveis: 1X (no final do 1º Tempo o time da casa vence ou
								empata), X2 (no final do 1º Tempo o time visitante vence ou empata), 12 (no final do
								1º Tempo o time da casa vence ou o time visitante vence).
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Handicap</strong>: Você tem que prever o vencedor do 1º tempo
								adicionando ou subtraindo o spread indicado ao resultado da metade, se a metade
								estiver incompleta este mercado será anulado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Total (Under/Over)</strong>: Você tem que prever se o número
								total de pontos marcados durante o 1º semestre será acima ou abaixo da linha dada,
								se a metade estiver incompleta este mercado será nulo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Total em casa/fora (Abaixo/Acima)</strong>: Você tem que prever
								se o número total de pontos marcados pela equipe nomeada (Casa ou Fora) durante o 1º
								tempo será acima ou abaixo da linha dada, se a metade estiver incompleta este
								mercado será anulado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo ímpar/par</strong>: Você tem que prever se o número total de pontos
								marcados no 1º tempo será ímpar ou par, se a metade estiver incompleta este mercado
								será nulo.
							</strong>
						</p>
					</div>
				</details>
				{/* Motocicletas */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 33 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<g clip-path="url(#clip0_515_371)">
								{' '}
								<path
									d="M31.2417 14.5675C30.8717 13.2575 30.3517 11.9575 29.7017 10.7275C27.6617 6.8475 24.2717 3.5575 19.6617 2.1275C14.4017 0.4975 10.1817 0.6875 6.94173 2.3575C3.70173 4.0275 1.82173 6.9775 0.871734 10.0775C-0.0882661 13.1675 -0.178266 16.5575 0.241734 19.4675C0.641734 22.2775 1.59173 25.0575 3.13173 26.6175C3.42173 26.9175 3.81173 27.1175 4.22173 27.1875L26.4417 30.9675C27.1117 31.0775 27.7917 30.8475 28.2517 30.3475C30.1317 28.3075 31.2517 25.7775 31.7317 23.0875C32.2317 20.2875 32.0317 17.3275 31.2417 14.5675ZM7.21173 11.1575L6.98173 12.2075C6.86173 12.7475 6.33173 13.0875 5.79173 12.9775C5.25173 12.8575 4.91173 12.3275 5.02173 11.7875L5.25173 10.7375C6.08173 6.8875 9.78173 4.3675 13.6717 5.0175C14.2117 5.1075 14.5817 5.6275 14.4917 6.1675C14.4017 6.7075 13.8817 7.0775 13.3417 6.9875C10.5117 6.5175 7.81173 8.3575 7.21173 11.1575ZM28.7017 22.6075L19.4117 21.1275C17.0217 20.7375 15.0517 19.0575 14.2817 16.7675L13.2717 13.7775C13.2717 13.7775 13.2717 13.7475 13.2717 13.7375C13.2017 13.4875 13.2517 13.2175 13.4117 13.0175C13.5417 12.8575 13.7317 12.7575 13.9317 12.7275L26.8717 11.0875L27.5617 10.9975C29.6517 14.5875 30.4517 18.9175 29.7517 22.7775L28.6917 22.6075H28.7017Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
							</g>{' '}
							<defs>
								{' '}
								<clipPath id="clip0_515_371">
									{' '}
									<rect
										data-darkreader-inline-fill=""
										fill="white"
										height="28"
										style={{ fill: '#FFFFFF' }}
										transform="translate(0.00317383)"
										width="28"
									>
										{' '}
									</rect>{' '}
								</clipPath>{' '}
							</defs>{' '}
						</svg>
						Motocicletas
					</summary>
					<div className="textItem">
						<p>
							<strong>
								O resultado de uma aposta em um evento de MotoGP, Moto2, Moto3, Superbike, Speedway
								é baseado nos primeiros resultados oficiais publicados. As decisões tomadas pela
								federação oficial (incluindo mas não se limitando à FIM) e que afetem ou alterem o
								resultado alcançado no campo de corrida não serão levadas em consideração.
							</strong>
						</p>

						<p>
							<strong>
								Sempre que uma corrida for oficialmente adiada ou suspensa, todas as apostas
								relacionadas permanecerão válidas se o evento ocorrer antes da meia-noite do dia
								seguinte à data originalmente definida para a partida. Se não for retomado ou se não
								for concluído dentro do prazo mencionado, todas as apostas relacionadas a esse
								evento serão consideradas nulas.
							</strong>
						</p>

						<p className="pH2">
							<strong>Mercados de Motos:</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor (Corrida)</strong>: Você prevê que o piloto selecionado será o
								vencedor da corrida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pódio (Corrida)</strong>: Você prevê que o piloto selecionado alcançará o
								pódio (primeira, segunda ou terceira posição).
							</strong>
						</p>

						<p>
							<strong>
								<strong>H2H (Corrida)</strong>: Você deve prever qual dos dois pilotos especificados
								na aposta alcançará a melhor posição na corrida. No caso de ambos os pilotos
								desistirem ou serem desqualificados na mesma volta, esta tipologia de aposta será
								considerada nula. (A saber: H2H significa head to head, o que pode ser traduzido
								como "cabeça a cabeça", o que indica comparação entre dois adversários)
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor (Pole)</strong>: Você prevê que o piloto selecionado alcançará a
								melhor posição durante a sessão de qualificação.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pódio (Pódio)</strong>: Você prevê que o piloto selecionado concluirá a
								sessão de qualificação na primeira, segunda ou terceira posição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>H2H (Pole)</strong>: Você tem que prever qual dos dois pilotos especificados
								na aposta alcançará a melhor posição na sessão de qualificação. (A saber: H2H
								significa head to head, o que pode ser traduzido como "cabeça a cabeça", o que
								indica comparação entre dois adversários)
							</strong>
						</p>

						<p>
							<strong>
								<strong>Melhor do grupo (Corrida e Pole)</strong>: Você deve prever qual piloto
								alcançará a posição mais alta no grupo selecionado. Caso um dos pilotos do grupo não
								participe na competição selecionada, a aposta será considerada nula.
							</strong>
						</p>
					</div>
				</details>
				{/* Mercados de FIFA */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Mercados de FIFA
					</summary>
					<div className="textItem">
						<p>
							<strong>
								1x2
								<strong>
									Você tem que prever o resultado do tempo regulamentar de toda a partida. Existem 3
									resultados possíveis
								</strong>
								: 1 (o time da casa vence), X (os times vão empatar), 2 (o time visitante vence).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Empate anula aposta (DNB)</strong>: este mercado de apostas consiste no
								seguinte, para definir uma aposta como vencedora, deve necessariamente haver uma
								equipe vencedora, o que significa que, se a partida terminar empatada, a aposta em
								dinheiro será ser reembolsado. Por exemplo, se uma pontuação final resultar em
								empate, a aposta será considerada nula.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total (mais/menos)</strong>: Você deve prever se o número total de gols
								marcados durante toda a partida será acima ou abaixo da linha indicada.
							</strong>
						</p>
					</div>
				</details>
				{/* Mercados de NBA 2K */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<g clip-path="url(#clip0_461_385)">
								{' '}
								<path
									d="M17.6568 19.2741C18.0761 18.6731 18.5751 18.1321 19.1241 17.6513C15.8702 15.6277 14.7723 10.9694 13.814 6.98237C13.2152 4.27758 12.5165 1.47262 11.4185 0.671201C9.02303 1.47262 6.62752 2.77492 4.73108 4.77847C4.1322 5.37953 3.63314 5.9806 3.13407 6.68184C6.77724 10.9594 11.688 15.788 17.6568 19.2741Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M16.0698 23.4014C16.1696 22.59 16.3693 21.8086 16.6687 21.0673C10.62 17.531 5.6793 12.7726 1.93632 8.48503C0.13969 11.6907 -0.359375 15.4974 0.239502 19.0036C2.43538 20.7067 4.63127 21.5081 8.0249 21.9088C11.2988 22.2193 13.9638 22.7202 16.0698 23.4014Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M21.0405 16.379C21.1902 16.3089 21.33 16.2287 21.4797 16.1686C22.5077 12.3118 22.8771 7.51331 22.1983 1.27227C19.5034 0.0701376 16.509 -0.230394 13.6144 0.170315C14.6126 1.67297 15.2114 3.97705 15.7105 6.48148C16.7685 10.8292 17.8365 15.257 21.0405 16.379Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M24.9931 15.4474C25.7517 15.4474 26.4903 15.5575 27.1989 15.7278C28.5963 14.7361 29.814 12.9229 30.5826 9.68716C29.7841 7.88397 28.6862 6.28113 27.2888 4.77847C26.3905 3.87687 25.3923 3.07546 24.3942 2.47439C24.8434 7.66358 24.5639 11.9612 23.7953 15.5375C24.1946 15.4874 24.5938 15.4474 25.0031 15.4474H24.9931Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M31.7604 18.5428C32.0499 16.6795 32.0299 14.7561 31.6805 12.8928C31.0617 14.4155 30.2632 15.6277 29.295 16.5493C30.2333 17.0602 31.0617 17.7414 31.7604 18.5428Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M12.1172 31.5258C14.3431 32.1269 16.7186 32.1369 18.9844 31.6861C17.9164 30.7244 17.0879 29.5122 16.5789 28.1498C15.1116 29.5022 13.6144 30.5942 12.1172 31.5258Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M16.0199 25.4751C14.1434 24.834 11.5683 24.273 7.92509 23.8021C5.13033 23.5016 3.03426 22.9005 1.13782 21.7986C1.93632 23.8021 3.13407 25.7055 4.73108 27.3083C6.22827 28.811 7.92509 29.913 9.72172 30.7144C11.708 29.4822 13.9538 27.9595 16.0499 25.9359C16.0299 25.7856 16.0299 25.6254 16.0199 25.4751Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M31.1416 21.1074C30.3331 19.6247 28.9956 18.4727 27.3986 17.8817C26.65 17.6112 25.8415 17.4509 25.0031 17.4509C23.3062 17.4509 21.7592 18.052 20.5514 19.0537C20.1322 19.4044 19.7629 19.8051 19.4335 20.2358C19.0243 20.7868 18.6849 21.3879 18.4454 22.039C18.2757 22.5098 18.1459 23.0007 18.0761 23.5116C18.0361 23.8222 18.0062 24.1427 18.0062 24.4633V24.9642C18.0062 25.5052 18.0761 26.0261 18.1859 26.537C18.5252 28.0396 19.3437 29.352 20.4716 30.3137C21.6893 31.3555 23.2763 31.9966 25.0031 31.9966C28.8658 31.9966 32 28.8511 32 24.9642V24.4633C32 23.2411 31.6905 22.0991 31.1416 21.0974V21.1074ZM26.9694 28.5706H23.2863C22.7972 28.5706 22.4978 28.3903 22.348 28.0597C22.3281 28.0196 22.3081 27.9795 22.2981 27.9294C22.2682 27.8092 22.2383 27.689 22.2383 27.5387V21.9188C22.2383 21.7986 22.2582 21.6984 22.2882 21.5982C22.388 21.1274 22.7074 20.877 23.2863 20.877H26.9694C27.4884 20.877 27.7479 21.1274 27.7479 21.6383C27.7479 21.9689 27.6281 22.1893 27.4086 22.3095C27.2888 22.3796 27.149 22.4197 26.9594 22.4197H24.1447V23.8823H26.7198C27.2389 23.8823 27.4984 24.1427 27.4984 24.6536C27.4984 25.0043 27.3686 25.2347 27.1191 25.3449C27.0093 25.395 26.8796 25.425 26.7198 25.425H24.1447V27.0078H26.9594C27.2289 27.0078 27.4185 27.0779 27.5583 27.2082C27.6781 27.3384 27.7479 27.5287 27.7479 27.7792C27.7479 28.3001 27.4884 28.5505 26.9694 28.5505V28.5706Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
							</g>{' '}
							<defs>
								{' '}
								<clipPath id="clip0_461_385">
									{' '}
									<rect
										data-darkreader-inline-fill=""
										fill="white"
										height="28"
										style={{ fill: '#FFFFFF' }}
										width="28"
									></rect>{' '}
								</clipPath>{' '}
							</defs>{' '}
						</svg>
						Mercados de NBA 2K
					</summary>
					<div className="textItem">
						<p>
							<strong>
								<strong>Vencedor da partida 1X2</strong>: Preveja se o vencedor será o time da casa
								ou visitante com a opção de selecionar também o empate.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Money Line (Vencedor 1,2) (inclui tempo extra)</strong>: Preveja o vencedor
								da partida, independentemente da margem de pontos. Este mercado incluirá tempo
								extra.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total (mais/menos) (inclui tempo extra)</strong>: Consiste em prever se o
								total de pontos marcados por ambas as equipes será maior ou menor que a linha dada
								no mercado de apostas escolhido. Por exemplo: Acima de 215,5 - Abaixo de 215,5. Este
								mercado incluirá tempo extra.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap (spread) (inclui tempo extra)</strong>: Você tem que prever o
								vencedor de toda a partida adicionando ou subtraindo o spread indicado ao resultado
								da partida. Este mercado incluirá tempo extra.
							</strong>
						</p>
					</div>
				</details>
				{/* Pesapallo */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Pesapallo
					</summary>
					<div className="textItem">
						<h2>
							<strong>Mercado Principal</strong>
						</h2>

						<p>
							<strong>
								<strong>Mercado 1X2</strong>: Você tem que prever o resultado do tempo regulamentar
								de toda a partida. Existem 3 resultados possíveis: 1 (o time da casa vence), X (os
								times vão empatar), 2 (o time visitante vence).
							</strong>
						</p>

						<h2>
							<strong>Mercado Outright:</strong>
						</h2>

						<p>
							<strong>
								<strong>Vencedor</strong>: Você deve prever o vencedor de um determinado torneio de
								acordo com o ranking oficial da competição.
							</strong>
						</p>
					</div>
				</details>
				{/* Polo Aquático */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<g clip-path="url(#clip0_414_474)">
								{' '}
								<path
									d="M8.84868 17.82C9.3086 17.68 9.75853 17.5 10.1985 17.29C7.00896 12.15 6.749 6.79999 7.13894 3.44999C6.99896 3.56999 6.85899 3.68999 6.72901 3.81999C2.98959 7.55999 1.99975 13 3.72948 17.65C5.28923 18.27 7.06895 18.34 8.84868 17.81V17.82Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M14.6078 13.36L14.8077 13.05C13.388 10.56 12.8281 7.74999 13.248 5.06999C13.5579 3.09999 14.3678 1.36999 15.5776 -0.0100098C13.448 0.0599902 11.3483 0.63999 9.44858 1.73999C8.96866 3.62999 8.14878 10.18 11.9182 16.26C12.958 15.49 13.8779 14.51 14.6178 13.36H14.6078Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M15.1977 5.67999C18.0972 5.58999 23.7763 6.34999 28.8056 10.36C28.2956 7.95999 27.1258 5.67999 25.2661 3.81999C23.3064 1.85999 20.8768 0.65999 18.3372 0.19999C16.6775 1.35999 15.5676 3.17999 15.2277 5.37999C15.2077 5.47999 15.2077 5.57999 15.1977 5.67999Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M16.5575 12.09C16.5575 12.09 16.6175 12.09 16.6475 12.09C21.7667 12.09 26.116 15.01 27.6557 19.04C28.5756 17.24 29.0455 15.27 29.0755 13.29C24.0663 8.33999 17.6473 7.61999 15.1477 7.65999C15.2777 9.17999 15.7476 10.69 16.5475 12.09H16.5575Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M1.70979 27.62L4.2094 25.17C5.19925 24.2 6.80899 24.2 7.79884 25.17C9.27861 26.62 11.5083 26.84 13.238 25.87C13.5779 25.68 13.9179 25.46 14.2078 25.17C15.1977 24.2 16.8074 24.2 17.7973 25.17C18.0972 25.46 18.4272 25.68 18.7771 25.88C20.5069 26.84 22.7365 26.62 24.2063 25.17C25.1961 24.2 26.8059 24.2 27.7957 25.17L30.2953 27.62C30.6853 28 31.3152 28 31.7051 27.62C32.095 27.24 32.095 26.62 31.7051 26.23L29.2055 23.78C28.0557 22.66 26.4559 22.27 24.9862 22.6C25.0761 22.51 25.1761 22.43 25.2661 22.34C25.6061 22 25.916 21.65 26.206 21.29C25.906 19.16 24.6462 17.27 22.7965 15.97C21.9366 17.64 20.0669 20.32 17.0774 22.63C15.9276 22.35 14.6978 22.52 13.6579 23.13C13.348 23.31 13.058 23.52 12.7881 23.78C11.9782 24.58 10.7484 24.71 9.78853 24.19C16.3475 22.14 20.0069 17 21.0868 15C19.757 14.41 18.2572 14.07 16.6575 14.07C16.6175 14.07 16.5675 14.07 16.5275 14.07C16.5175 14.09 16.5075 14.1 16.4975 14.12L16.2975 14.42C14.6378 17.01 12.1982 18.89 9.41859 19.71C8.41874 20.01 7.4189 20.15 6.43905 20.15C5.91913 20.15 5.40921 20.1 4.90929 20.01C5.41921 20.83 6.02912 21.61 6.739 22.32C6.83899 22.42 6.94897 22.5 7.04896 22.59C5.56919 22.25 3.94944 22.63 2.79962 23.76L0.290013 26.24C-0.0999262 26.62 -0.0999262 27.24 0.290013 27.63C0.679952 28.01 1.30985 28.01 1.69979 27.63L1.70979 27.62Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M29.2055 27.88C27.4358 26.15 24.5662 26.15 22.7965 27.88C21.8067 28.85 20.1969 28.85 19.2071 27.88C18.9471 27.62 18.6571 27.42 18.3472 27.24C16.9074 26.38 15.0977 26.38 13.6579 27.24C13.348 27.42 13.058 27.63 12.7881 27.89C11.7982 28.86 10.1885 28.86 9.19862 27.89C7.4289 26.16 4.55935 26.16 2.78962 27.89L0.290013 30.32C-0.0999262 30.7 -0.0999262 31.32 0.290013 31.71C0.679952 32.09 1.30985 32.09 1.69979 31.71L4.1994 29.26C5.18925 28.29 6.799 28.29 7.78884 29.26C9.55856 30.99 12.4281 30.99 14.1978 29.26C15.1877 28.29 16.7974 28.29 17.7873 29.26C19.557 30.99 22.4266 30.99 24.1963 29.26C25.1861 28.29 26.7959 28.29 27.7857 29.26L30.2853 31.71C30.6753 32.09 31.3052 32.09 31.6951 31.71C32.085 31.33 32.085 30.71 31.6951 30.32L29.1955 27.87L29.2055 27.88Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
							</g>{' '}
							<defs>
								{' '}
								<clipPath id="clip0_414_474">
									{' '}
									<rect
										data-darkreader-inline-fill=""
										fill="white"
										height="28"
										style={{ fill: '#FFFFFF' }}
										width="28"
									></rect>{' '}
								</clipPath>{' '}
							</defs>{' '}
						</svg>
						Polo Aquático
					</summary>
					<div className="textItem">
						<h2>
							<strong>Principais Mercados</strong>
						</h2>

						<p>
							<strong>
								<strong>1X2</strong>: Você tem que prever o resultado do tempo regulamentar da
								partida inteira. Existem 3 resultados possíveis: 1 (o time da casa vence), X (os
								times vão empatar), 2 (o time visitante vence).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total (mais/menos)</strong>: Você deve prever se o número total de gols
								marcados durante o tempo regulamentar de toda a partida será acima ou abaixo da
								linha indicada.
							</strong>
						</p>

						<h2>
							<strong>Outrights</strong>
						</h2>

						<p>
							<strong>
								<strong>Vencedor</strong>: Você deve prever o vencedor de um determinado torneio de
								acordo com o ranking oficial da competição.
							</strong>
						</p>
					</div>
				</details>
				{/* Rugby / Liga de Rugby */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 33 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<g clip-path="url(#clip0_515_468)">
								{' '}
								<path
									d="M32.0032 11.16V8C32.0032 6.05 31.7632 4.16 31.3232 2.34L25.2932 8.37C27.1032 10.04 29.3832 10.96 31.7732 11.14C31.8532 11.14 31.9232 11.16 32.0032 11.16Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M24.0032 0C23.3032 0 22.6132 0.05 21.9232 0.11C21.8532 2.54 22.5332 4.91 23.9632 6.88L30.0532 0.78C30.0532 0.78 29.9832 0.75 29.9432 0.74C28.0432 0.26 26.0532 0 24.0032 0Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M31.4432 13.11C28.6532 12.87 25.9932 11.76 23.8732 9.78L22.0432 11.61L23.3632 12.93C23.7532 13.32 23.7532 13.95 23.3632 14.34C22.9732 14.73 22.3432 14.73 21.9532 14.34L20.6332 13.02L19.0332 14.62L20.3632 15.95C20.7532 16.34 20.7532 16.97 20.3632 17.36C19.9732 17.75 19.3432 17.75 18.9532 17.36L17.6232 16.03L16.0532 17.6L17.3832 18.93C17.7732 19.32 17.7732 19.95 17.3832 20.34C16.9932 20.73 16.3632 20.73 15.9732 20.34L14.6432 19.01L13.0432 20.61L14.3732 21.94C14.7632 22.33 14.7632 22.96 14.3732 23.35C13.9832 23.74 13.3532 23.74 12.9632 23.35L11.6332 22.02L9.75317 23.9C11.6732 26.03 12.7332 28.69 12.9332 31.47C22.1732 29.54 29.4532 22.3 31.4532 13.09L31.4432 13.11Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M2.34317 31.32C4.16317 31.76 6.05317 32 8.00317 32C9.00317 32 9.98317 31.92 10.9432 31.8C10.8032 29.43 9.93317 27.16 8.32317 25.34L2.34317 31.32Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M0.00317383 24C0.00317383 26.05 0.263174 28.04 0.743174 29.94C0.743174 29.98 0.773174 30.01 0.783174 30.05L6.86317 23.97C4.92317 22.48 2.54317 21.76 0.113174 21.78C0.0431738 22.51 0.00317383 23.25 0.00317383 24Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M0.393174 19.79C3.24317 19.82 6.03317 20.72 8.29317 22.54L10.1932 20.64L8.70317 19.15C8.31317 18.76 8.31317 18.13 8.70317 17.74C9.09317 17.35 9.72317 17.35 10.1132 17.74L11.6032 19.23L13.2032 17.63L11.7132 16.14C11.3232 15.75 11.3232 15.12 11.7132 14.73C12.1032 14.34 12.7332 14.34 13.1232 14.73L14.6132 16.22L16.1832 14.65L14.6932 13.16C14.3032 12.77 14.3032 12.14 14.6932 11.75C15.0832 11.36 15.7132 11.36 16.1032 11.75L17.5932 13.24L19.1932 11.64L17.6932 10.14C17.3032 9.75 17.3032 9.12 17.6932 8.73C18.0832 8.34 18.7132 8.34 19.1032 8.73L20.6032 10.23L22.5032 8.33C20.7432 6.04 19.8832 3.25 19.9032 0.4C9.99317 2.08 2.15317 9.87 0.393174 19.79Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
							</g>{' '}
							<defs>
								{' '}
								<clipPath id="clip0_515_468">
									{' '}
									<rect
										data-darkreader-inline-fill=""
										fill="white"
										height="28"
										style={{ fill: '#FFFFFF' }}
										transform="translate(0.00317383)"
										width="28"
									>
										{' '}
									</rect>{' '}
								</clipPath>{' '}
							</defs>{' '}
						</svg>
						Rugby / Liga de Rugby
					</summary>
					<div className="textItem">
						<p>
							<strong>
								A menos que especificado de outra forma, todas as apostas em partidas de Rugby/Rugby
								League são calculadas para 80 minutos de jogo, o que inclui qualquer acréscimo
								adicionado pelo árbitro, se uma partida for suspensa antes do final do tempo
								regulamentar, todas as apostas nessa partida serão anuladas, exceto para os mercados
								que já foram liquidados.
							</strong>
						</p>

						<h2>
							<strong>Principais Mercados</strong>
						</h2>

						<p>
							<strong>
								<strong>1X2</strong>: Você tem que prever o resultado do tempo regulamentar de toda
								a partida. Existem 3 resultados possíveis: 1 (o time da casa ganha), X (os times vão
								empatar), 2 (o time visitante ganha).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Chance Dupla</strong>: Você tem que prever o resultado de toda a partida.
								Existem 3 resultados possíveis: 1X (no final do jogo o time da casa vence ou
								empata), X2 (no final do jogo o time visitante vence ou empata), 12 (no final do
								jogo o time da casa vence ou o time visitante vence).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Empate anula aposta</strong>: este mercado de apostas consiste no seguinte,
								para definir uma aposta como vencedora, deve necessariamente haver uma equipe
								vencedora, o que significa que, se a partida terminar empatada, o dinheiro apostado
								será devolvido. Por exemplo, se uma pontuação final resultar em empate, a aposta
								será considerada nula.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap</strong>: aposta em que o vencedor do jogo deve ser decidido com a
								respectiva margem de gols. A pontuação correta é somada ou subtraída dos pontos
								propostos no handicap, e após a referida operação, será determinado quem vence:
								equipe da casa, empate ou equipe visitante.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap (3-Way)</strong>: Você deve prever o resultado final da partida
								levando em consideração o handicap entre parênteses. Por exemplo, (0:1) indica que o
								time FORA tem um gol de vantagem, já para (1:0) indica que o time da CASA tem um gol
								de vantagem.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total</strong>: Você deve prever se o número total de pontos marcados
								durante toda a partida será superior ou inferior ao spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total da equipe</strong>: Você deve prever se o número total de pontos
								marcados pela equipe da casa ou visitante durante toda a partida será superior ou
								inferior ao spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Margem de Vitória</strong>: Você deve prever a margem de vitória na partida
								para o time da casa ou visitante, ou se a partida termina empatada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Intervalo/Tempo integral</strong>: Você deve prever o resultado do 1º tempo
								da partida junto com o resultado de toda a partida. Os resultados possíveis são:
								(1/1, 1/X, 1/2, X/1, X/X, X/2, 2/1, 2/X e 2/2).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Metade com pontuação mais alta</strong>: prevê qual das duas metades da
								partida terá a maior quantidade de pontos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ímpar/Par</strong>: Você tem que prever se o resultado da partida é um
								número par ou ímpar, se o resultado da partida for "0:0"", as apostas são contadas
								como "par".
							</strong>
						</p>

						<p>
							<strong>
								<strong>Intervalo de Pontos</strong>: Você deve prever o intervalo de pontos durante
								a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Para se classificar</strong>: Você deve prever se a equipe indicada se
								classificará para a fase seguinte do torneio.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qual equipe vencerá a final</strong>: Você deve prever qual equipe vencerá a
								final do torneio selecionado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qual equipe ganhará o 3º lugar final</strong>: Você deve prever qual equipe
								será classificada na terceira posição no torneio selecionado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qual equipe vence o resto da partida</strong>: Você aposta em quem vencerá o
								resto da partida. A partir do momento em que a aposta é feita, a pontuação é contada
								como 0:0, independentemente da pontuação real da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Prorrogação - 1x2</strong>: Você tem que prever qual time vencerá a
								prorrogação no jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeira jogada de pontuação (Pré-live)</strong>: Você tem que prever como
								serão os primeiros pontos da partida. 6 são os resultados possíveis:
							</strong>
						</p>

						<ul>
							<li>
								<strong>competidor1 com tentativa</strong>
							</li>
							<li>
								<strong>competidor1 com penalidade</strong>
							</li>
							<li>
								<strong>competidor1 com drop goal</strong>
							</li>
							<li>
								<strong>concorrente2 com tentativa</strong>
							</li>
							<li>
								<strong>concorrente2 com penalidade</strong>
							</li>
							<li>
								<strong>concorrente2 com drop goal</strong>
							</li>
						</ul>

						<p>
							<strong>
								<strong>Corrida para x pontos</strong>: Você deve prever qual time chegará primeiro
								em X pontos durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Próxima jogada de pontuação (Ao vivo)</strong>: Você tem que prever como os
								X pontos da partida serão marcados. são 6 resultados possíveis:
							</strong>
						</p>

						<ul>
							<li>
								<strong>concorrente1 com tentativa</strong>
							</li>
							<li>
								<strong>concorrente1 com penalidade</strong>
							</li>
							<li>
								<strong>concorrente1 com drop goal</strong>
							</li>
							<li>
								<strong>concorrente2 com tentativa</strong>
							</li>
							<li>
								<strong>concorrente2 com penalidade</strong>
							</li>
							<li>
								<strong>concorrente2 com drop goal</strong>
							</li>
						</ul>

						<p>
							<strong>
								<strong>Tipo de primeira pontuação</strong>: Você tem que prever como serão marcados
								os primeiros pontos durante a partida. 3 são os resultados possíveis: com try com
								pênalti com drop goal
								<br />
								<strong>Tipo de último placar do jogo</strong>: Você tem que prever como serão
								marcados os últimos pontos da partida. 4 são os resultados possíveis: com try com
								penalidade com drop goal com conversão.
								<br />
								<strong>Última pontuação</strong>: Você deve prever como serão marcados os últimos
								pontos durante a partida. 10 são os resultados possíveis: concorrente1 com
								tentativa.{' '}
							</strong>
						</p>

						<ul>
							<li>
								<strong>concorrente1 com meta de queda</strong>
							</li>

							<li>
								<strong>concorrente1 com conversão</strong>
							</li>

							<li>
								<strong>concorrente1 com conversão perdida</strong>
							</li>

							<li>
								<strong>concorrente2 com tentativa</strong>
							</li>

							<li>
								<strong>concorrente2 com penalidade</strong>
							</li>

							<li>
								<strong>concorrente2 com meta de queda</strong>
							</li>

							<li>
								<strong>concorrente2 com conversão</strong>
							</li>

							<li>
								<strong>concorrente2 com conversão perdida</strong>
							</li>
						</ul>

						<p>
							<strong>
								<strong>Equipe a marcar primeiro</strong>: você deve prever qual time marcará
								primeiro durante a partida.
								<br />
								<strong>Equipe que marcará por último</strong>: Você deve prever qual time marcará
								por último durante a partida.
								<br />
								<strong>Intervalo/Final&nbsp;do jogo com qualquer empate</strong>: Você deve prever
								o resultado do primeiro tempo e do segundo tempo.
								<br />
								<strong>Ambos os tempos - Primeira pontuação</strong>: Você deve prever como serão
								marcados os primeiros pontos durante o primeiro e o segundo tempo. 6 são os
								resultados possíveis: concorrente1 com tentativa.{' '}
							</strong>
						</p>

						<ul>
							<li>
								<strong>concorrente1 com penalidade</strong>
							</li>

							<li>
								<strong>concorrente1 com drop goal</strong>
							</li>

							<li>
								<strong>concorrente2 com try</strong>
							</li>

							<li>
								<strong>concorrente2 com penalidade</strong>
							</li>

							<li>
								<strong>concorrente2 com drop goal</strong>
							</li>
						</ul>

						<p>
							<strong>
								<strong>Em&nbsp;qualquer tempo - Primeira pontuação</strong>: Você deve prever como
								serão marcados os primeiros pontos durante o primeiro ou o segundo tempo. 6 são os
								resultados possíveis: concorrente1 com tentativa.{' '}
							</strong>
						</p>

						<ul>
							<li>
								<strong>concorrente1 com penalidade</strong>
							</li>

							<li>
								<strong>concorrente1 com drop goal</strong>
							</li>

							<li>
								<strong>concorrente2 com try</strong>
							</li>

							<li>
								<strong>concorrente2 com penalidade</strong>
							</li>

							<li>
								<strong>concorrente2 com drop goal</strong>
							</li>
						</ul>

						<p>
							<strong>
								<strong>Ambos&nbsp;os Tempos - Primeiro tipo de pontuação</strong>: Você tem que
								<br />
								prever como serão marcados os primeiros pontos durante o primeiro e o segundo tempo.
								<br />
								3 são os resultados possíveis: com try com pênalti com drop goal.
								<br />
								<strong>Qualquer tempo - Primeiro tipo de pontuação</strong>: Você deve prever como
								serão marcados os primeiros pontos durante o primeiro ou o segundo tempo. 3 são os
								resultados possíveis: com try com pênalti com drop goal.
								<br />
								<strong>Ambos os Tempos - Handicap</strong>: aposta em que o vencedor do primeiro e
								do segundo tempo deve ser decidido com a respectiva margem de gols. A pontuação
								correta é somada ou subtraída dos pontos propostos no handicap, e após a referida
								operação será determinado quem vence: mandante, empate ou visitante.
								<br />
								<strong>Qualquer tempo - Handicap</strong>: aposta em que o vencedor do primeiro ou
								do segundo tempo deve ser decidido com a respectiva margem de golo. A pontuação
								correta é somada ou subtraída dos pontos propostos no handicap, e após a referida
								operação será determinado quem vence: mandante, empate ou visitante.
								<br />
								<strong>Ambas as metades - Tipo de último resultado do jogo</strong>: Você deve
								prever como serão marcados os últimos pontos durante o primeiro e o segundo tempo. 4
								são os resultados possíveis: com try com penalidade com drop goal com conversão.
								<br />
								<b data-stringify-type="bold">
									<strong>Qualquer um dos Tempos - Último tipo de pontuação do jogo</strong>:&nbsp;
								</b>
								Você deve prever como os últimos pontos serão marcados durante o primeiro ou o
								segundo tempo. 4 são os resultados possíveis: com try com pênalti com drop goal com
								conversão.
								<br />
								<strong>Ambos os tempos - Último placar</strong>: Você temque prever como
								serãomarcados os últimos pontos do primeiro e do segundo tempo. 10 são os resultados
								possíveis: concorrente1 com tentativa.{' '}
							</strong>
						</p>

						<ul>
							<li>
								<strong>concorrente1 com penalidade</strong>
							</li>

							<li>
								<strong>concorrente1 com meta de queda</strong>
							</li>

							<li>
								<strong>concorrente1 com conversão</strong>
							</li>

							<li>
								<strong>concorrente1 com conversão perdida</strong>
							</li>

							<li>
								<strong>concorrente2 com tentativa</strong>
							</li>

							<li>
								<strong>concorrente2 com penalidade</strong>
							</li>

							<li>
								<strong>concorrente2 com meta de queda</strong>
							</li>

							<li>
								<strong>concorrente2 com conversão</strong>
							</li>

							<li>
								<strong>concorrente2 com conversão perdida</strong>
							</li>
						</ul>

						<p>
							<strong>
								<b data-stringify-type="bold">Pontuação do meio-último:&nbsp;</b>Você deve prever
								como serão marcados os últimos pontos do primeiro ou do segundo tempo. 10 são os
								resultados possíveis: concorrente1 com tentativa.{' '}
							</strong>
						</p>

						<ul>
							<li>
								<strong>concorrente1 com penalidade</strong>
							</li>

							<li>
								<strong>concorrente1 com meta de queda</strong>
							</li>

							<li>
								<strong>concorrente1 com conversão</strong>
							</li>

							<li>
								<strong>concorrente1 com conversão perdida</strong>
							</li>

							<li>
								<strong>concorrente2 com tentativa</strong>
							</li>

							<li>
								<strong>concorrente2 com penalidade</strong>
							</li>

							<li>
								<strong>concorrente2 com meta de queda</strong>
							</li>

							<li>
								<strong>concorrente2 com conversão</strong>
							</li>

							<li>
								<strong>concorrente2 com conversão perdida</strong>
							</li>
						</ul>

						<p>
							<strong>
								<b data-stringify-type="bold">Ambas as</b>
								<b data-stringify-type="bold">partes - Resultado da partida:&nbsp;</b>Você tem que
								prever o resultado do primeiro tempo e do segundo tempo.
								<br />
								<b data-stringify-type="bold">
									Qualquer um dos Tempos - Resultado da Partida:&nbsp;
								</b>
								Você deve prever o resultado do primeiro tempo ou do segundo tempo.
								<br />
								<b data-stringify-type="bold">Ambas as partes - corrida para x pontos:&nbsp;</b>Você
								deve prever qual time alcançará primeiro os X pontos durante a primeira e a segunda
								metade da partida.
								<br />
								<b data-stringify-type="bold">Ambas as metades - corrida para x pontos:&nbsp;</b>
								Você deve prever qual time alcançará primeiro os X pontos durante a primeira ou a
								segunda metade da partida.
								<br />
								<b data-stringify-type="bold">Ambas as partes - Equipe a marcar primeiro:&nbsp;</b>
								Você deve prever qual equipe marcará primeiro durante o primeiro e o segundo tempo.
								<br />
								<b data-stringify-type="bold">Qualquer parte - Equipe a marcar primeiro:&nbsp;</b>
								Você deve prever qual equipe marcará primeiro durante o primeiro ou o segundo tempo.
								<br />
								<b data-stringify-type="bold">Ambos Partes - Equipe a marcar primeiro:&nbsp;</b>Você
								deve prever qual equipe marcará por último durante o primeiro e o segundo tempo.
								<br />
								<b data-stringify-type="bold">Qualquer parte - Equipe a marcar primeiro:&nbsp;</b>
								Você deve prever qual equipe marcará por último durante o primeiro ou no segundo
								tempo.
								<br />
								<b data-stringify-type="bold">Queda total gols - Equipe da casa/visitante:&nbsp;</b>
								Você deve prever quantos drop goals serão marcados pela equipe da casa/visitante
								durante a partida.
								<br />
								<b data-stringify-type="bold">
									Ambos os tempos - Total da equipe da casa/visitante:&nbsp;
								</b>
								Você deve prever se o número total de pontos marcados pela equipe da casa /A equipe
								visitante durante o primeiro tempo e o segundo tempo estará acima ou abaixo do
								spread indicado.
								<br />
								<b data-stringify-type="bold">Qualquer parte - Total:&nbsp;</b>Você deve prever se o
								número total de pontos marcados durante o primeiro ou o segundo tempo será superior
								ou inferior ao spread indicado.
								<br />
								<b data-stringify-type="bold">
									Qualquer parte - Total da equipe da casa/visitante:&nbsp;
								</b>
								Você deve prever se o número total de pontos marcados pela equipe da casa/visitante
								durante o primeiro ou o segundo tempo será superior ou inferior ao spread indicado.
								<br />
								<b data-stringify-type="bold">Ambas as partes - Ímpar/Par:&nbsp;</b>Tem de prever se
								o número total de pontos marcados por ambas as equipas durante a primeira e a
								segunda parte é um número ímpar ou par, se o resultado for "0:0ÿ, as apostas são
								contadas como " até".
								<br />
								<b data-stringify-type="bold">Ambas as partes - Total:&nbsp;</b>Você deve prever se
								o número total de pontos marcados durante a primeira e a segunda parte será superior
								ou inferior ao spread indicado.
								<br />
								<b data-stringify-type="bold">Qualquer parte - Ímpar/Par:&nbsp;</b>Você deve prever
								se o número total de pontos marcados por ambas as equipes durante o resultado do
								primeiro tempo ou do segundo tempo é um número ímpar ou par, se o resultado for
								"0:0ÿ, apostas são contados como "pares".
								<br />
								<b data-stringify-type="bold">
									Ambos os Tempos - Time da Casa/Visitante - Total de drop goals:&nbsp;
								</b>
								Você deve prever quantos drop goals serão marcados pelo Time da Casa/Visitante
								durante o primeiro e o segundo tempo.
								<br />
								<strong>Ambos os Tempos - Equipe da Casa/Visitante - Ímpar/Par</strong>: Você deve
								prever se o número total de pontos marcados pela equipe da casa/visitante durante o
								resultado do primeiro tempo e o resultado do segundo tempo será um número ímpar ou
								par. Se o resultado for "0:0", as apostas serão contadas como "pares".
								<br />
								<strong>Qualquer um dos Tempos - Equipe da Casa/Visitante - Par/Ímpar</strong>: Você
								deve prever se o número total de pontos marcados pela equipe da casa/visitante
								durante o resultado do primeiro tempo ou do segundo tempo é um número ímpar ou par.
								Se o resultado for "0:0", as apostas serão contadas como "par".
								<br />
								<strong>Ambas as Metades - Vitória</strong>: Você deve prever se o time da casa ou o
								visitante vencerá nas duas partes.
								<br />
								<strong>1º Tempo - Marcador de Ensaio a Qualquer Momento</strong>: Você tem que
								prever qual jogador marcará durante o primeiro tempo.
								<br />
								<strong>2º Tempo - Marcador de Ensaio a Qualquer Momento</strong>: Você tem que
								prever qual jogador marcará durante o segundo tempo.
								<br />
								<strong>Ambas as Partes - Marcador de Ensaio a Qualquer Momento</strong>: Você tem
								que prever qual jogador marcará durante as duas metades.{' '}
							</strong>
						</p>

						<h2>
							<strong>Mercados do primeiro tempo</strong>
						</h2>

						<p>
							<strong>
								<strong>1º tempo - 1X2</strong>: Você tem que prever o resultado do primeiro tempo.
								Existem 3 resultados possíveis: 1 (o time da casa ganha), X (os times vão empatar),
								2 (o time visitante ganha).
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Chance Dupla</strong>: Você tem que prever o resultado do
								primeiro tempo. Existem 3 resultados possíveis: 1X (no final do jogo o time da casa
								vence ou empata), X2 (no final do jogo o time visitante vence ou empata), 12 (no
								final do jogo o time da casa vence ou o time visitante vence).
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - empate anula aposta</strong>: Este mercado de apostas consiste no
								seguinte, para definir uma aposta como vencedora, deve necessariamente haver uma
								equipe vencedora, o que significa que, se o primeiro tempo terminar empatado, a
								aposta em dinheiro será reembolsada. Por exemplo, se o primeiro tempo resultar em
								empate, a aposta será considerada nula.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Handicap</strong>: aposta em que o vencedor da primeira parte
								deve ser decidido com a respectiva margem de gols. A pontuação correta é somada ou
								subtraída dos pontos propostos no handicap, e após a referida operação, será
								determinado quem vence: equipe da casa, empate ou equipe visitante.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Handicap (3-Way)</strong>: Você deve prever o resultado do 1º
								tempo levando em consideração o handicap entre parênteses. Por exemplo, (0:1) indica
								que o time FORA tem um gol de vantagem, já para (1:0) indica que o time da CASA tem
								um gol de vantagem.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Total</strong>: Você tem que prever se o número total de pontos
								marcados durante o primeiro tempo será superior ou inferior ao spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Total da equipe</strong>: Você deve prever se o número total de
								pontos marcados pela equipe da casa ou visitante durante o primeiro tempo será
								superior ou inferior ao spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Total de tentativas</strong>: Você deve prever se o número total
								de tentativas marcadas durante o primeiro tempo será superior ou inferior ao spread
								indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Total de tentativas da equipe</strong>: Você tem que prever se o
								número total de tentativas marcadas pela equipe da casa ou visitante durante o
								primeiro tempo será superior ou inferior ao spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Ímpar/Par</strong>: Você tem que prever se o resultado do
								primeiro tempo é um número par ou ímpar, se o resultado for "0:0", as apostas são
								contadas como "par".
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - qual time ganha o resto</strong>: Você aposta em quem vai ganhar
								o resto do 1º tempo. A partir do momento em que a aposta é feita, o placar conta
								como 0:0, independentemente do placar real da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - margem de vitória</strong>: Tem de prever a margem de vitória na
								1ª parte do jogo para a equipe da casa ou visitante, ou se o jogo termina empatado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - intervalo de pontos</strong>: Você tem que prever o intervalo de
								pontos durante o primeiro tempo da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - corrida para x pontos</strong>: Você tem que prever qual time
								chegará primeiro em X pontos durante o 1º tempo da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Try - 1X2</strong>: Você tem que prever o resultado do primeiro
								tempo em tentativas alcançadas. Existem 3 resultados possíveis: 1 (o time da casa
								ganha), X (os times vão empatar), 2 (o time visitante ganha).
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Tentativa - Dupla Chance</strong>: Você tem que prever o
								resultado do primeiro tempo em tentativas alcançadas. Existem 3 resultados
								possíveis: 1X (no final do jogo o time da casa vence ou empata), X2 (no final do
								jogo o time visitante vence ou empata), 12 (no final do jogo o time da casa vence ou
								o time visitante vence).
							</strong>
						</p>

						<p>
							<strong>
								<strong>1ª parte - Try - Empate anula aposta</strong>: este mercado de apostas
								consiste no seguinte, para definir uma aposta como vencedora, deve necessariamente
								haver uma equipe vencedora nas tentativas realizadas, o que significa que, se a
								primeira parte terminar em empate, a aposta em dinheiro será reembolsada. Por
								exemplo, se a primeira metade das tentativas resultar em empate, a aposta será
								considerada nula.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Try - Handicap</strong>: aposta em que o vencedor do primeiro
								tempo em tentativa realizada deve ser decidido com a respectiva margem de gol. A
								pontuação correta é somada ou subtraída das tentativas propostas no handicap, e após
								a referida operação, será determinado quem vence: equipe da casa, empate ou equipe
								visitante.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Try - Handicap (3-Way)</strong>: aposta em que o vencedor do
								primeiro tempo em try realizado deve ser decidido com a respectiva margem de gol. A
								pontuação correta é somada ou subtraída das tentativas propostas no handicap, e após
								a referida operação, será determinado quem vence: equipe da casa, empate ou equipe
								visitante.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º Tempo - Tentativa - Ímpar/Par</strong>: Você tem que prever se o
								resultado do primeiro tempo em tentativas alcançadas é um número ímpar ou par, se o
								resultado da partida for "0:0", as apostas são contadas como "par".
								<strong>1º tempo - Primeiro placar</strong>: Você tem que prever como serão marcados
								os primeiros pontos durante o primeiro tempo. 6 são os resultados possíveis:{' '}
							</strong>
						</p>

						<ul>
							<li>
								<strong>concorrente1 com tentativa</strong>
							</li>

							<li>
								<strong>concorrente1 com penalidade</strong>
							</li>

							<li>
								<strong>concorrente1 com drop goal</strong>
							</li>

							<li>
								<strong>concorrente2 com try</strong>
							</li>

							<li>
								<strong>concorrente2 com penalidade</strong>
							</li>

							<li>
								<strong>concorrente2 com drop goal</strong>
							</li>
						</ul>

						<p>
							<strong>
								<strong>1º tempo - Tipo de primeiro placar</strong>: Você tem que prever como serão
								marcados os primeiros pontos durante o primeiro tempo. 3 são os resultados
								possíveis: com try com pênalti com drop goal
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Tipo de último placar do jogo</strong>: Você tem que prever como
								serão marcados os últimos pontos durante o primeiro tempo. 4 são os resultados
								possíveis: com try com penalidade com drop goal com conversão
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Último placa</strong>r: Você tem que prever como serão marcados
								os últimos pontos do primeiro tempo. 10 são os resultados possíveis:
							</strong>
						</p>

						<ul>
							<li>
								<strong>concorrente1 com tentativa</strong>
							</li>

							<li>
								<strong>concorrente1 com penalidade</strong>
							</li>

							<li>
								<strong>concorrente1 com meta de queda</strong>
							</li>

							<li>
								<strong>concorrente1 com conversão</strong>
							</li>

							<li>
								<strong>concorrente1 com conversão perdida</strong>
							</li>

							<li>
								<strong>concorrente2 com tentativa</strong>
							</li>

							<li>
								<strong>concorrente2 com penalidade</strong>
							</li>

							<li>
								<strong>concorrente2 com meta de queda</strong>
							</li>

							<li>
								<strong>concorrente2 com conversão</strong>
							</li>

							<li>
								<strong>concorrente2 com conversão perdida</strong>
							</li>
						</ul>

						<p>
							<strong>
								<strong>1º tempo - Corrida para x tentativa</strong>s: Você tem que prever qual time
								chegará primeiro em X tentativas durante o 1º tempo da partida.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º Tempo - Equipe a marcar primeiro</strong>: Você tem que prever qual time
								marcará primeiro durante o primeiro tempo
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º Tempo - Equipe a marcar no primeiro try</strong>: Você tem que prever
								qual time marcará o primeiro try durante o primeiro tempo
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º Tempo - Equipe a marcar por último</strong>: Você tem que prever qual
								time marcará por último durante o primeiro tempo
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Equipe que marcará o último try</strong>: Você tem que prever
								qual time marcará o último try durante o primeiro tempo
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Equipe da casa/visitante - Ímpar/Par</strong>: Você deve prever
								se o resultado do 1º tempo nas tentativas alcançadas pela equipe da casa/visitante é
								um número ímpar ou par, se o resultado da partida for "0:0", as apostas serão
								contadas como "pares".
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º Tempo - Mais tentativas:</strong> Você tem que prever se o time da casa
								ou visitante marcará mais tentativas durante o primeiro tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Primeiro marcador do ensaio</strong>: Tem que prever qual jogador
								marcará o primeiro ensaio durante a primeira parte
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º Tempo - Equipe da casa/visitante - Primeiro marcador do ensaio</strong>:
								Tem que prever qual jogador da equipe da casa/visitante marcará o primeiro ensaio
								durante a primeira parte
							</strong>
						</p>

						<p>
							<strong>
								<strong>1ª parte - Último marcador do ensaio</strong>: Tem que prever qual jogador
								marcará o último ensaio durante a primeira parte
							</strong>
						</p>

						<p>
							<strong>
								<strong>1ª parte - Equipe da casa/visitante - último marcador do ensaio</strong>:
								Tem que prever qual jogador da equipe da casa/visitante marcará o último ensaio
								durante a primeira parte
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º tempo - Equipe da casa/visitante - Total de drop goals:</strong> Você
								deve prever quantos drop goals serão marcados pela equipe da casa/visitante durante
								o primeiro tempo &nbsp;
							</strong>
						</p>

						<p>
							Para se classificar: Você deve prever qual equipe se classificará para a próxima
							rodada, para a etapa do torneio ou para vencer uma determinada fase da competição.
						</p>

						<p>
							Qual equipe vencerá a final: Você deve prever qual equipe vencerá a partida final da
							competição.
						</p>

						<p>
							Qual equipe vencerá a final do 3º lugar: Você deve prever qual das duas equipes
							terminará em terceiro lugar geral no torneio.
						</p>

						<p>
							Qual equipe vence o restante da partida: Você deve prever o vencedor de um jogo após
							um evento específico acontecer.
						</p>

						<p>
							Margem de vitória: É preciso prever o número exato de pontos pelos quais uma equipe
							vencerá uma partida durante o tempo regulamentar.
						</p>

						<p>
							Intervalo de pontos: Prever o intervalo de pontos pelo qual uma equipe vencerá a
							partida durante o tempo regulamentar.
						</p>

						<p>
							Prorrogação - 1x2: Você deve prever o resultado de uma partida após o tempo
							regulamentar, incluindo qualquer tempo extra (prorrogação) que possa ser jogado se o
							placar estiver empatado no final do tempo regulamentar.
						</p>

						<h2>
							<strong>Mercados do segundo tempo</strong>
						</h2>

						<p>
							<strong>
								<strong>2º tempo - Primeiro placar</strong>: Você tem que prever como serão marcados
								os primeiros pontos durante o segundo tempo. 6 são os resultados possíveis:
								concorrente1 com tentativa concorrente1 com penalidade concorrente1 com drop goal
								concorrente2 com try concorrente2 com penalidade concorrente2 com drop goal
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - Tipo de primeiro placar</strong>: Você tem que prever como serão
								marcados os primeiros pontos durante o segundo tempo. 3 são os resultados possíveis:
								com try com pênalti com drop goal
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - Handicap</strong>: aposta em que o vencedor do segundo tempo deve
								ser decidido com a respectiva margem de gol. A pontuação correta é somada ou
								subtraída dos pontos propostos no handicap, e após a referida operação será
								determinado quem vence: mandante, empate ou visitante equipe.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - Tipo de último placar do jogo</strong>: Você deve prever como
								serão marcados os últimos pontos no segundo tempo. 4 são os resultados possíveis:
								com try com penalidade com drop goal com conversão
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - Último placar</strong>: Você tem que prever como serão marcados
								os últimos pontos do segundo tempo. 10 são os resultados possíveis:
							</strong>
						</p>

						<ul>
							<li>
								<strong>concorrente1 com tentativa</strong>
							</li>
							<li>
								<strong>concorrente1 com penalidade</strong>
							</li>
							<li>
								<strong>concorrente1 com meta de queda</strong>
							</li>
							<li>
								<strong>concorrente1 com conversão</strong>
							</li>
							<li>
								<strong>concorrente1 com conversão perdida</strong>
							</li>
							<li>
								<strong>concorrente2 com tentativa</strong>
							</li>
							<li>
								<strong>concorrente2 com penalidade</strong>
							</li>
							<li>
								<strong>concorrente2 com meta de queda</strong>
							</li>
							<li>
								<strong>concorrente2 com conversão</strong>
							</li>
							<li>
								<strong>concorrente2 com conversão perdida</strong>
							</li>
						</ul>

						<p>
							<strong>
								<strong>2º tempo - Corrida para x pontos</strong>: Você deve prever qual time
								alcançará primeiro os X pontos durante o segundo tempo da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - Corrida para x tentativas</strong>: Você tem que prever qual time
								chegará primeiro em X tentativas durante o segundo tempo da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º Tempo - Equipe a marcar primeiro</strong>: Você tem que prever qual time
								marcará primeiro durante o segundo tempo
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º Tempo - Equipe a marcar no primeiro try</strong>: Você tem que prever
								qual time marcará o primeiro try durante o segundo tempo
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º Tempo - Equipe a marcar por último</strong>: Você tem que prever qual
								time marcará por último durante o segundo tempo
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - Equipe que marcará o último try</strong>: Você tem que prever
								qual time marcará o último try durante o segundo tempo
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - Total de tentativas</strong>: Você tem que prever se o número
								total de tentativas marcadas durante o segundo tempo será superior ou inferior ao
								spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - Mais tentativas</strong>: Você tem que prever se o time da casa
								ou visitante marcará mais tentativas durante o segundo tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º Tempo - Primeiro marcador do ensaio</strong>: Você tem que prever qual
								jogador marcará o primeiro ensaio durante o segundo tempo
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º Tempo - Último marcador do ensaio</strong>: Você tem que prever qual
								jogador marcará o último ensaio durante o segundo tempo
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º Tempo - Equipe da casa/visitante - Total de gols perdidos</strong>: Você
								deve prever quantos gols perdidos serão marcados pela equipe da casa/visitante
								durante o segundo tempo
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - Total de tentativas - Equipe da casa/visitante</strong>: Você
								deve prever se o número total de tentativas marcadas pela equipe da casa/visitante
								durante o segundo tempo estará acima ou abaixo do spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º Tempo - Tentativa - Ímpar/Par</strong>: Você deve prever se o resultado
								do segundo tempo nas tentativas alcançadas é um número ímpar ou par, se o resultado
								da partida for "0:0", as apostas serão contadas como "pares".
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - Equipe da casa/visitante - Tentativas pares/ímpares</strong>:
								Você deve prever se o resultado do segundo tempo nas tentativas alcançadas pela
								equipe da casa/visitante é um número par ou ímpar, se o resultado da partida for
								"0:0", as apostas são contados como "pares".
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º tempo - Time da casa/visitante - Primeiro marcador do ensaio</strong>:
								Você tem que prever qual jogador do time da casa/Visitante marcará o primeiro ensaio
								durante o segundo tempo
							</strong>
						</p>

						<p>
							<strong>
								<strong>2º Tempo - Time da casa/visitante - Último marcador do ensaio</strong>: Você
								tem que prever qual jogador da equipe da casa/visitante marcará o último try durante
								o segundo tempo
							</strong>
						</p>

						<h2>
							<strong>Mercados Combinados</strong>
						</h2>

						<p>
							<strong>
								<strong>11.4.1. 1X2 &amp; Total</strong>: Este mercado de apostas combina dois
								mercados de apostas principais onde você deve prever quem vencerá a partida (ou
								empate) e quantos pontos totais (mais/menos) serão marcados na partida.
							</strong>
						</p>

						<p>
							Marcar primeiro / Tempo integral: Você deve prever o time que marcar primeiro e o
							vencedor geral da partida.
						</p>

						<p>
							Placar primeiro / Meio tempo / Tempo integral: essa aposta exige que você preveja: o
							time que marcará primeiro. O resultado no intervalo (qual equipe está liderando ou se
							é um empate). O resultado final no tempo integral (qual equipe venceu). Você deve
							acertar todos os três resultados para ganhar a aposta.
						</p>

						<h2>
							<strong>Mercados de Try:</strong>
						</h2>

						<p>
							<strong>
								<strong>Try - 1X2</strong>: Você tem que prever o resultado do tempo regulamentar de
								toda a partida em tentativas alcançadas. Existem 3 resultados possíveis: 1 (o time
								da casa ganha), X (os times vão empatar), 2 (o time visitante ganha).
							</strong>
						</p>

						<p>
							<strong>
								<strong>1Try - Dupla Chance</strong>: Você tem que prever o resultado do tempo
								regulamentar de toda a partida em tentativas alcançadas. Existem 3 resultados
								possíveis: 1X (no final do jogo o time da casa vence ou empata), X2 (no final do
								jogo o time visitante vence ou empata), 12 (no final do jogo o time da casa vence ou
								o time visitante vence).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Try - empate anula aposta</strong>: Este mercado de apostas consiste no
								seguinte, para definir uma aposta como vencedora, deve necessariamente haver uma
								equipe vencedora nas tentativas alcançadas, o que significa que, se o jogo terminar
								empatado, o dinheiro da aposta será reembolsada. Por exemplo, se uma pontuação final
								em tentativas resultar em empate, a aposta será considerada nula.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Try - Handicap</strong>: Aposta em que o vencedor do jogo em try realizado
								deve ser decidido com a respectiva margem de gol. A pontuação correta é somada ou
								subtraída das tentativas propostas no handicap, e após a referida operação, será
								determinado quem vence: equipe da casa, empate ou equipe visitante.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Try - Handicap (3-Way)</strong>: aposta em que o vencedor do jogo em try
								realizado deve ser decidido com a respectiva margem de gols. A pontuação correta é
								somada ou subtraída das tentativas propostas no handicap, e após a referida
								operação, será determinado quem vence: equipe da casa, empate ou equipe visitante.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Try - Total de tentativas</strong>: Você deve prever se o número total de
								tentativas marcadas durante a partida será superior ou inferior ao spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Try - Total de tentativas da equipe</strong>: Você deve prever se o número
								total de tentativas marcadas durante a partida pela equipe da casa ou visitante será
								superior ou inferior ao spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Try - Ímpar/Par</strong>: Você tem que prever se o resultado da partida em
								tentativas alcançadas é um número par ou ímpar, se o resultado da partida for "0:0",
								as apostas são contadas como "par".
								<strong>Equipe marcará o primeiro try</strong>: Você deve prever qual time marcará o
								primeiro try durante a partida{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe que marcará o último try</strong>: Você deve prever qual time marcará
								o último try durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mais tentativas (inc. ET)</strong>: Você deve prever se o time da casa ou
								visitante marcará mais tentativas durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro marcador de ensaio</strong>: Você deve prever qual jogador marcará
								o primeiro ensaio do jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Último marcador de ensaio</strong>: Você tem que prever qual jogador marcará
								o último ensaio do jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>A qualquer momento marcador de ensaio</strong>: Você tem que prever qual
								jogador marcará durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ambas as metades - Equipe a marcar no primeiro ensaio</strong>: Você tem que
								prever qual time marcará o primeiro try durante o primeiro e o segundo tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qualquer um dos Tempos - Equipe que marcará o primeiro ensaio</strong>: Você
								tem que prever qual time marcará o primeiro ensaio durante o primeiro ou o segundo
								tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ambos os Tempos - Equipe que marcará o último ensaio:</strong> Você tem que
								prever qual a equipe marcará o último try durante o primeiro e o segundo tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qualquer um dos Tempos - Equipe que marcará o último try</strong>: Você deve
								prever qual time marcará o último try durante o primeiro ou o segundo tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ambos os Tempos - Total de tentativas - Casa/Fora Equipe</strong>: Você deve
								prever se o número total de tentativas marcadas pela equipe da casa/visitante
								durante o primeiro e o segundo tempo estará acima ou abaixo do spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qualquer parte - Total de tentativas - Equipe da casa/visitante</strong>:
								Você deve prever se o número total de tentativas marcadas pela equipe da
								casa/visitante durante o primeiro ou o segundo tempo será superior ou inferior ao
								spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe da casa/visitante - Tries - Ímpar/Par</strong>: Você deve prever se o
								resultado da partida nas tentativas alcançadas pela equipe da casa/visitante é um
								número ímpar ou par, se o resultado da partida for "0:0", as apostas serão contadas
								como "até".
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ambas as metades - Mais tentativas</strong>: Você deve prever se o time da
								casa ou visitante marcará mais tentativas durante o primeiro e o segundo tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qualquer parte - Mais tentativas:</strong> Você deve prever se o time da
								casa ou o visitante marcarão mais tentativas durante o primeiro ou o segundo tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ambas as metades - corrida para x tentativas</strong>: Você deve prever qual
								time chegará primeiro em X tentativas durante a primeira e a segunda metade da
								partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qualquer meia corrida até x tentativas</strong>: Você deve prever qual
								equipe chegará primeiro em X tentativas durante a primeira ou a segunda metade da
								partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe da casa/visitante - Primeiro marcador do ensaio</strong>: Você deve
								prever qual jogador da equipe da casa/visitante marcará o primeiro ensaio durante a
								partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ambos os tempos - Primeiro marcador do ensaio</strong>: Você deve prever
								qual jogador marcará o primeiro ensaio durante o primeiro e o segundo tempo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe da casa/visitante - último marcador do ensaio</strong>: Você tem que
								prever qual jogador da equipe da casa/visitante marcará o último ensaio durante a
								partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ambas as partes - Último marcador do ensaio</strong>: Você tem que prever
								qual jogador marcará o último ensaio durante a primeira e a segunda metade.
							</strong>
						</p>

						<p>
							Marcar o 1º try / Resultado da partida: Você precisa prever: Quem marcará o primeiro
							try da partida. O resultado final da partida (qual equipe vence). Você deve prever
							corretamente a equipe que marcará o primeiro try e o vencedor geral.
						</p>

						<p>
							Resultado do 1º try / 1º tempo: Você tem que prever: Quem marca o primeiro try. O
							resultado no intervalo (qual equipe está vencendo no intervalo). Tanto o primeiro
							marcador de try quanto o vencedor do intervalo precisam ser previstos corretamente
							para que a aposta seja vencedora.
						</p>

						<p>
							Equipe que marcará o primeiro try: Você deve prever qual equipe marcará o primeiro try
							da partida, independentemente de quem vencer a partida.
						</p>

						<p>
							Equipe que marcará o último try (incluindo prorrogação): você deve prever qual equipe
							marcará o último try da partida, incluindo qualquer período de prorrogação, se
							aplicável.
						</p>

						<p>
							Primeiro ensaio convertido: Você deve prever se o primeiro try da partida será
							convertido em um try bem-sucedido. Gol do chutador.
						</p>

						<h2>
							<strong>Mercados Outright Rugby/Liga de Rugby:</strong>
						</h2>

						<p>
							<strong>
								<strong>Vencedor</strong>: Você deve prever o vencedor de um determinado torneio de
								acordo com a classificação oficial da competição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vitórias da Temporada Regular - Equipe</strong>: Você deve prever quantas
								vitórias (mais/menos) a equipe mencionada irá acumular de acordo com o ranking
								oficial da competição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mais Derrotas da Temporada Regular - Equipe</strong>: Você deve prever
								quantas derrotas (mais/menos) a equipe mencionada irá reunir de acordo com o ranking
								oficial da competição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>H2H - Vencedor</strong>: Você deve prever qual das duas equipes indicadas se
								classificará na fase de qualificação ou no play-off. (A saber: H2H significa head to
								head, o que pode ser traduzido como "cabeça a cabeça", o que indica comparação entre
								dois adversários)
							</strong>
						</p>

						<p>
							<strong>
								<strong>Para Fazer a Grande Final</strong>: Você deve prever se a equipe selecionada
								fará a Grande Final (Sim) ou não (Não) durante o torneio de acordo com o ranking
								oficial da competição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Para chegar aos Playoffs</strong>: Você deve prever se a equipe selecionada
								chegará aos playoffs (Sim) ou não (Não) durante o torneio de acordo com o ranking
								oficial da competição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Top4, Top6, Top8</strong>: Você deve prever se a equipe selecionada
								terminará na respectiva primeira posição quando a competição terminar.
							</strong>
						</p>
					</div>
				</details>
				{/* Salto de Esqui */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Salto de Esqui
					</summary>
					<div className="textItem">
						<p>{`Vencedor: Você tem que prever o vencedor do torneio.

`}</p>
						<p>{`Top 3: Você deve prever se o jogador selecionado terminará entre os 3 primeiros do torneio, incluindo empates.

`}</p>
						<p>{`H2H: Você deve prever qual dos dois jogadores especificados na aposta alcançará a melhor posição no torneio. No caso de ambos os jogadores se retirarem ou serem desqualificados na mesma fase, esta tipologia de aposta será considerada nula.

`}</p>
					</div>
				</details>
				{/* Snooker */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<path
								d="M11.79 11.7804C9.46 14.1104 9.46 17.8904 11.79 20.2204C14.12 22.5504 17.9 22.5504 20.23 20.2204C22.56 17.8904 22.56 14.1104 20.23 11.7804C17.9 9.45043 14.12 9.45043 11.79 11.7804ZM16.6 12.1904C16.99 12.2504 17.38 12.3804 17.77 12.5904C18.17 12.8004 18.52 13.0604 18.84 13.3804C19.22 13.7604 19.5 14.1604 19.66 14.5804C19.83 15.0004 19.88 15.4004 19.81 15.7904C19.74 16.1804 19.56 16.5204 19.26 16.8204C18.97 17.1104 18.65 17.2804 18.28 17.3504C17.92 17.4204 17.56 17.3704 17.2 17.2004C17.42 17.5904 17.5 17.9904 17.43 18.4004C17.37 18.8104 17.18 19.1804 16.85 19.5104C16.53 19.8304 16.17 20.0204 15.77 20.0804C15.37 20.1404 14.94 20.0804 14.49 19.8904C14.05 19.7004 13.63 19.4004 13.21 18.9804C12.87 18.6404 12.59 18.2704 12.37 17.8804C12.15 17.4804 12.01 17.0704 11.96 16.6704C11.94 16.5104 11.95 16.3804 11.98 16.2704C12.02 16.1604 12.09 16.0504 12.2 15.9404C12.36 15.7804 12.54 15.6904 12.74 15.6704C12.94 15.6404 13.11 15.7004 13.24 15.8304C13.31 15.9004 13.36 15.9804 13.4 16.0604C13.44 16.1404 13.48 16.2504 13.52 16.4004C13.53 16.4304 13.54 16.4704 13.55 16.5104C13.57 16.5504 13.59 16.6004 13.61 16.6504C13.69 16.9004 13.78 17.1104 13.86 17.2904C13.95 17.4704 14.08 17.6404 14.25 17.8004C14.54 18.0904 14.79 18.2504 15.01 18.2804C15.23 18.3204 15.45 18.2304 15.67 18.0104C15.87 17.8104 15.95 17.6004 15.91 17.3804C15.87 17.1604 15.7 16.9104 15.4 16.6104L14.92 16.1304C14.76 15.9704 14.7 15.8004 14.72 15.6004C14.74 15.4004 14.83 15.2304 14.98 15.0804C15.13 14.9304 15.3 14.8404 15.5 14.8204C15.7 14.8004 15.87 14.8704 16.03 15.0204L16.37 15.3604C16.66 15.6504 16.9 15.8104 17.12 15.8604C17.33 15.9104 17.53 15.8404 17.71 15.6604C17.9 15.4704 17.99 15.2604 17.98 15.0504C17.98 14.8304 17.87 14.6104 17.67 14.4104C17.52 14.2604 17.36 14.1504 17.19 14.0704C17.02 13.9904 16.82 13.9104 16.58 13.8404L16.34 13.7504C16.19 13.7004 16.07 13.6604 15.99 13.6304C15.91 13.5904 15.84 13.5404 15.76 13.4704C15.63 13.3404 15.58 13.1804 15.6 12.9804C15.63 12.7804 15.72 12.6004 15.88 12.4404C15.99 12.3304 16.1 12.2604 16.21 12.2204C16.32 12.1804 16.45 12.1804 16.61 12.2004L16.6 12.1904Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M10.38 10.3704C12.07 8.68043 14.34 7.91043 16.56 8.07043L11.31 2.82043C9.41 3.49043 7.62 4.58043 6.1 6.10043C4.58 7.62043 3.5 9.41044 2.82 11.3104L8.07 16.5604C7.92 14.3404 8.68 12.0704 10.37 10.3804L10.38 10.3704Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M31 27.9904H23.22C24.18 27.4104 25.08 26.7104 25.9 25.8904C27.42 24.3704 28.5 22.5804 29.18 20.6804L23.95 15.4504C24.1 17.6704 23.34 19.9404 21.65 21.6304C19.96 23.3204 17.69 24.0904 15.47 23.9304L19.52 27.9604H16.67L2.23 13.5304C1.46 17.8804 2.74 22.5304 6.11 25.8904C6.93 26.7104 7.84 27.4104 8.79 27.9904H1C0.45 27.9904 0 28.4404 0 28.9904C0 29.5404 0.45 29.9904 1 29.9904H31C31.55 29.9904 32 29.5404 32 28.9904C32 28.4404 31.55 27.9904 31 27.9904Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M25.9 6.09044C22.54 2.73044 17.89 1.44043 13.54 2.22043L29.78 18.4604C30.55 14.1104 29.27 9.46043 25.91 6.10043L25.9 6.09044Z"
								data-darkreader-inline-fill=""
								fill="#FFFFFF"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
						</svg>
						Snooker
					</summary>
					<div className="textItem">
						<p>
							<strong>
								Se uma partida começar, mas não terminar por qualquer motivo, todas as apostas
								oferecidas no resultado final da partida são nulas.
							</strong>
						</p>

						<p>
							<strong>
								Para efeitos de apostas, apenas as bolas que tenham entrado "legalmente" serão
								contadas, por ex. quando houver uma "bola suja" envolvida, as bolas inseridas não
								serão consideradas. As apostas serão resolvidas de acordo.
							</strong>
						</p>

						<h2>
							<strong>Mercados de snooker</strong>
						</h2>

						<p>
							<strong>
								<strong>
									No caso de reinstalação em qualquer um dos quadros, serão aplicadas as seguintes
									regras
								</strong>
								:{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor do quadro</strong>: todas as apostas são válidas e serão liquidadas
								de acordo com o vencedor oficial do quadro.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Apostas decididas</strong>: serão válidas todas as apostas cujo resultado
								tenha sido determinado antes do re-rack. Qualquer evento após o re-rack será
								irrelevante para as apostas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Apostas não decididas</strong>: todas as apostas cujo resultado não tenha
								sido determinado antes do re-rack serão liquidadas apenas de acordo com os eventos
								ocorridos após o re-rack. Qualquer evento anterior ao re-rack será irrelevante para
								as apostas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>
									Todas as apostas referentes ao resultado final do frame (por exemplo
								</strong>
								: total de apostas, apostas par/ímpar) serão as liquidadas com o resultado oficial
								do frame.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Aposta de Frame (Resultado Exato)</strong>: A aposta refere-se ao resultado
								final exato no total de frames jogados.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor do Frame</strong>: Esta aposta refere-se ao vencedor de um
								determinado frame. Este quadro deve ser preenchido para que as apostas sejam
								válidas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total</strong>: Preveja o total de pontos que serão ganhos na partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Primeiro a atingir 3 Frames</strong>: Preveja quem será o primeiro a atingir
								3 frames, Alguns dos jogadores devem atingir 3 frames para que as apostas sejam
								válidas.
							</strong>
						</p>

						<h2>
							<strong>Mercado Outright:</strong>
						</h2>

						<p>
							<strong>
								<strong>Vencedor</strong>: Você deve prever o vencedor de um determinado torneio de
								acordo com a classificação oficial da competição.
							</strong>
						</p>
					</div>
				</details>
				{/* Squash */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Squash
					</summary>
					<div className="textItem">
						<p>
							<strong>
								Se um jogador se retirar, perder a partida ou for desqualificado, todos os mercados
								indecisos serão considerados nulos. Se os pontos de penalização forem atribuídos
								pelo árbitro, todas as apostas nesse jogo serão válidas.
							</strong>
						</p>

						<h2>
							<strong>Principais Mercados</strong>
						</h2>

						<p>
							<strong>
								<strong>Vencedor (1,2)</strong>: Mercado de apostas que consiste em prever o
								vencedor da partida independentemente da margem de pontos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Resultado Correto</strong>: Você deve prever o resultado correto da partida
								em termos de sets ganhos por cada jogador. Se um jogador se retirar durante a
								partida, todas as apostas não decididas serão consideradas nulas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Xº jogo - Vencedor</strong>: Adivinhe o vencedor no jogo mencionado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° jogo - Total de Pontos</strong>: Prever se o total de pontos acumulados
								por ambas as equipes em um determinado jogo será superior ou inferior a um
								determinado número no mercado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° jogo - Handicap de Pontos</strong>: Você tem que prever o vencedor do
								jogo mencionado (em pontos ganhos) somando ou subtraindo o spread indicado ao
								resultado da partida (em pontos).
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° jogo - par/ímpar</strong>: Prever se o total de pontos acumulados por
								ambas as equipes no jogo em questão será um número par ou ímpar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° jogo - corrida para X pontos</strong>: Você tem que prever qual time
								alcançará X pontos primeiro para o jogo mencionado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° jogo - N° ponto</strong>: Você tem que prever qual time ganhará o N°
								ponto para o jogo mencionado.
							</strong>
						</p>

						<h2>
							<strong>Outrights</strong>
						</h2>

						<p>
							<strong>
								<strong>Vencedor</strong>: Você deve prever o vencedor de um determinado torneio de
								acordo com o ranking oficial da competição.
							</strong>
						</p>
					</div>
				</details>
				{/* Tênis */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 33 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<g clip-path="url(#clip0_515_519)">
								{' '}
								<path
									d="M31.9132 17.7655C24.1407 17.8256 17.8388 24.1275 17.7787 31.9C21.2698 31.5098 24.6509 29.9894 27.3317 27.3185C30.0126 24.6377 31.533 21.2566 31.9132 17.7655Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M32.0032 15.7649C32.0032 15.7649 32.0032 15.6749 32.0032 15.6249V15.5749C31.8931 11.6236 30.3327 7.7124 27.3217 4.69146C24.2808 1.6405 20.3095 0.0900195 16.3183 0.00999451C16.3183 0.0300008 16.3183 0.050007 16.3183 0.0600101C16.3183 9.02281 9.036 16.3151 0.0732023 16.3151C0.0531961 16.3151 0.0331898 16.3151 0.0131836 16.3151C0.0131836 16.3551 0.0131836 16.4051 0.0131836 16.4451C0.123218 20.3964 1.68371 24.3076 4.69465 27.3285C7.70559 30.3395 11.6268 31.9 15.578 32.01C15.6481 32.01 15.7081 32.01 15.7781 32.01C15.7781 23.0572 23.0604 15.7749 32.0132 15.7649H32.0032Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M14.3177 0.0900195C10.7966 0.460135 7.38549 1.99061 4.68464 4.68145C1.9938 7.3823 0.473327 10.7934 0.0932086 14.3145C7.92566 14.3045 14.2976 7.93247 14.3177 0.0900195Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
							</g>{' '}
							<defs>
								{' '}
								<clipPath id="clip0_515_519">
									{' '}
									<rect
										data-darkreader-inline-fill=""
										fill="white"
										height="28"
										style={{ fill: '#FFFFFF' }}
										transform="translate(0.00317383)"
										width="28"
									>
										{' '}
									</rect>{' '}
								</clipPath>{' '}
							</defs>{' '}
						</svg>
						Tênis
					</summary>
					<div className="textItem">
						<h2>
							<strong>Regras Gerais</strong>
						</h2>

						<p>
							<strong>
								Os jogos de tênis serão mantidos abertos com todas as apostas válidas até que os
								oficiais ou o órgão organizador declarem um vencedor. Nesses casos, a regra das 48
								horas não é válida. ou incumprimento (lesão, doença ou circunstância pessoal),
								decisão de adulto, vitória fácil, desqualificação ou abandono, todos os mercados
								determinados no campo são liquidados em conformidade e todos os restantes indecisos
								são declarados nulos. Para evitar dúvidas, se um jogador de tênis se retirou antes
								do último ponto concluído, o mercado do vencedor da partida é anulado, mas todos os
								mercados relacionados a sets ou jogos específicos que são determinados são
								liquidados de acordo.
							</strong>
						</p>

						<p>
							<strong>
								Os mercados que foram matematicamente alcançados serão resolvidos após a confirmação
								do ponto decisivo. <strong>Exemplo</strong>: no placar do set de 3-3, o número
								mínimo de jogos para que o set seja concluído é 9 (6-3 ou 3-6). Isso significa que
								as linhas totais de 6,5, 7,5 e 8,5 já podem ser liquidadas como vitória para o Over.
								As linhas inteiras em que nenhuma seleção vence serão anuladas.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Tie Break</strong>: É uma disputa que se joga quando dois competidores
								chegam a um empate de 6 a 6 em qualquer Set, e consiste em um dos dois jogadores
								atingir 7 pontos com diferença de 2 em relação ao seu rival, é importante mencionar
								que para os mercados de tênis mais/menos, o desempate contará como um único jogo,
								independentemente da duração do evento.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Super Tie Break</strong>: Possui especificações semelhantes ao Tie Break,
								com a diferença de que um dos dois jogadores atinge 10 pontos com diferença de 2 em
								relação ao seu rival, é importante mencionar que para over/under mercados de tênis,
								o Super Tie Break ou Match Tie Break contarão como um único jogo, independentemente
								da duração do evento.
							</strong>
						</p>

						<p>
							<strong>
								Um Tie Break ou Super Tie Break será válido desde que a decisão seja anunciada antes
								do início do evento.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mercados de ganhadores de pontos</strong>: Os mercados de ganhadores de
								pontos são liquidados após a confirmação do ponto. Se o ponto não for jogado, o
								mercado será anulado.
								<br />
								<br />
								Como os torneios principais lidam com os desempates
								<br />
								<br />
								Se o placar chegar a seis games no set final (2-2 ou 1-1 nos sets e 6-6 nos games),
								o(s) vencedor(es) da partida será(ão) o(s) primeiro(s) jogador(es) a ganhar 10
								pontos com vantagem de dois ou mais pontos (10-8, 10-7, 10-6, 11-9, 15-13 etc). A
								regra acima se aplica a todos os Grand Slams (Aberto da Austrália, Aberto da França,
								Aberto dos EUA, Wimbledon) nas eliminatórias,&nbsp;simples e duplas masculinas,
								simples e duplas femininas, eventos para cadeiras de rodas e juniores em simples.{' '}
							</strong>
						</p>

						<h2>
							<strong>Principais Mercados</strong>
						</h2>

						<p>
							<strong>
								*Alguns dos mercados listados abaixo podem aparecer no E-Tennis (aplicam-se as
								mesmas regras)
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor (1,2)</strong>: Mercado de apostas que consiste em prever o
								vencedor da partida independentemente da margem de pontos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogos de Handicap (spread)</strong>: Você tem que prever o vencedor a toda a
								partida adicionando ou subtraindo o spread indicado ao resultado da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Sets de Handicap</strong>: Você deve prever o resultado em termos de sets
								ganhos por cada jogador adicionando ou subtraindo ao resultado final o spread
								especificado na aposta.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Resultado Correto</strong>: Você deve prever o resultado correto da partida
								em termos de sets ganhos por cada jogador. Se um jogador se retirar durante a
								partida, todas as apostas não decididas serão consideradas nulas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de jogos (mais/menos)</strong>: Você deve prever se o número total de
								jogos disputados na partida será superior ou inferior ao spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogos Ímpar/Par</strong>: Preveja no final da partida que o total de jogos é
								um número par ou ímpar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de jogos (mais/menos) Jogador 1</strong>: Você deve prever se o número
								total de jogos do Jogador 1 será superior ou inferior ao spread indicado. Um
								tiebreak é considerado um jogo. A quantidade de jogos jogados será indicada na
								liquidação da aposta pelo segundo número entre parênteses. Se a partida não for
								concluída, todas as apostas não decididas serão consideradas nulas.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de jogos (mais/menos) Jogador 2</strong>: Você deve prever se o número
								total de jogos do Jogador 2 será superior ou inferior ao spread indicado. Um
								tiebreak é considerado um jogo. A quantidade de jogos jogados será indicada na
								liquidação da aposta pelo segundo número entre parênteses. Se a partida não for
								concluída, todas as apostas não decididas serão consideradas nulas.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor e Total</strong>: Você deve prever o vencedor da partida e se o
								número de jogos disputados está acima ou abaixo do spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Haverá um tiebreak</strong>: Você deve prever se haverá um tie-break na
								partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Deuce in the game (Sim/Não)</strong>: "Deuce in the game" significa que a
								pontuação do jogo chegará a 40-40.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de pontos do próximo jogo ("Set "N", Jogo "X") (Acima/Abaixo)</strong>
								: Você deve prever se o número total de pontos do próximo jogo "X" do set "N" será
								superior ou inferior ao spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor do ponto do jogo ("Set "N", Game "X", Point "Y")</strong>: Você
								deve prever o vencedor do Ponto "Y" do jogo "X" do set "N".
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pontuação correta do jogo ("set" "N", jogo "X")</strong>: Você deve prever a
								pontuação correta do game "X" da partida do set "N" em termos de sets vencidos por
								cada joga
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor do jogo ("Set "N", Game "X")</strong>: Você deve prever o vencedor
								do Jogo "X" do set "N".
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap do Jogo do Set "N"</strong>: Você deve prever o vencedor do Set "N"
								adicionando ou subtraindo o spread indicado ao resultado desse set.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Set "N" atual Total de jogos ímpares/pares</strong>: Você deve prever se, no
								final do set atual "N", o total de jogos será um número par ou ímpar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de jogos ímpares/pares ("Set "N")</strong>: Você precisa prever se, no
								final do Set "N", o total de jogos será um número par ou ímpar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de Jogos Acima/Abaixo do Set Atual "N" (Jogadores)</strong>: Você deve
								prever se o número total de jogos do set atual "N" para o jogador mencionado será
								superior ou inferior ao spread indicado. Um tiebreak é considerado como um jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de jogos do próximo set "N" acima/abaixo (jogadores)</strong>: Você
								deve prever se o número total de jogos do próximo set "N" para o jogador mencionado
								será maior ou menor que o spread indicado. Um tiebreak é considerado um jogo.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de jogos ímpares/pares do próximo set "N"</strong>: Você deve prever
								se, ao final do próximo set "N", o total de jogos será um número par ou ímpar.
								<br />
								<br />
								<strong>Ambos os jogadores vencerão um set</strong>: Preveja se os dois jogadores
								vencerão um set durante a partida.
								<br />
								<br />
								<strong>xº set - pontuação correta após 4 jogos</strong>: Você deve prever a
								pontuação exata e correta do set "X" após 4 jogos. Se os jogos mencionados não forem
								concluídos, todas as apostas indecisas serão consideradas nulas.
								<br />
								<br />
								<strong>xº set - pontuação correta após 6 jogos</strong>: Você deve prever a
								pontuação exata e correta do set "X" após 6 jogos. Se os jogos mencionados não forem
								concluídos, todas as apostas indecisas serão consideradas nulas.
								<br />
								<br />
								<strong>Set "N"- x-ésimo intervalo</strong>: Consiste em prever qual jogador fará o
								x-ésimo intervalo durante o Set "N". Os mini-breaks dentro dos tiebreaks ou
								match-tiebreaks não são considerados. Existem três resultados possíveis: jogador1,
								nenhum, jogador2.
								<br />
								<br />
								<strong>Set "N" jogo x - break point</strong>: Consiste em prever se haverá break
								point durante o set "N" do jogo x.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quantidade de Aces Totais</strong>
								<br />
								Você deve prever o número de aces servidos durante uma partida, com marcos
								específicos definidos pela casa de apostas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quantidade de Aces do Jogador X</strong>
								<br />
								Você deve prever o número de aces que um jogador específico fará durante uma
								partida, com marcos específicos definidos pela casa de apostas.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quantidade de Duplas Falhas Totais</strong>
								<br />
								Você deve prever o número de duplas falhas que um jogador cometerá durante uma
								partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quantidade de Duplas Falhas do Jogador</strong>
								<br />
								Você deve prever o número de duplas falhas que o Jogador X cometerá durante uma
								partida, com marcos específicos definidos pela casa de apostas.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quantidade de Aces e Duplas Falhas Totais</strong>
								<br />
								Você deve prever o número total de aces e duplas falhas que serão cometidos durante
								uma partida, com marcos específicos definidos pela casa de apostas.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quantidade de Aces e Duplas Falhas do Jogador X</strong>
								<br />
								Você deve prever o número de aces e duplas falhas que o Jogador X fará durante uma
								partida, com marcos específicos definidos pela casa de apostas.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Aces 1x2</strong>
								<br />
								Você deve prever qual jogador fará mais aces em uma partida específica.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Aces Handicap</strong>
								<br />
								Você deve prever qual jogador fará mais aces, aplicando um handicap a um dos
								jogadores.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Duplas Falhas 1x2</strong>
								<br />
								Você deve prever qual jogador cometerá mais duplas falhas em uma partida específica.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Duplas Falhas Handicap</strong>
								<br />
								Você deve prever qual jogador cometerá mais duplas falhas, aplicando um handicap a
								um dos jogadores.
							</strong>
						</p>

						<p>
							<strong>Mercados por Set</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor do 1º Set</strong>: Você deve prever o vencedor do primeiro Set. A
								aposta será considerada "anulada" se o primeiro set não for concluído.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor do 2º Set</strong>: Você deve prever o vencedor do segundo Set. A
								aposta será considerada "anulada" se este conjunto não for concluído.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor do Set " X " </strong>: Você deve prever o vencedor do Set " X ". A
								aposta será considerada "anulada" se este conjunto não for concluído.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Resultado duplo (Primeiro set/jogo)</strong>: Prever o vencedor do primeiro
								set e no final do jogo num único mercado de apostas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador 1 para ganhar exatamente 1 set</strong>: Preveja se o jogador da
								casa terá uma vitória de 1 set durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador 2 para ganhar exatamente 1 set</strong>: Prever que o jogador
								visitante terá uma vitória de 1 set durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Sets exatos</strong>: Você deve prever o número exato de sets durante a
								partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de sets</strong>: Você deve prever se o número total de sets jogados
								na partida será superior ou inferior ao spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qualquer set a zero</strong>: Preveja se pelo menos um dos sets da partida
								terminará com pontuação exata de 6-0 / 0-6. Defina " X ".
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogos de Handicap</strong>: Você deve prever o vencedor do Set " X " somando
								ou subtraindo o spread indicado ao resultado da partida. Se a partida não for
								concluída, todas as apostas não decididas serão consideradas nulas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de jogos do Set " X "</strong>: Você deve prever se o número total de
								jogos disputados no Set " X " durante a partida será superior ou inferior ao spread
								indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pontuação Correta do Set " X "</strong>: Você deve prever a pontuação exata
								exata do Set " X ". Se o set mencionado não for concluído, todas as apostas não
								decididas serão consideradas nulas.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador 1 para ganhar um set</strong>: Você tem que prever se o jogador 1
								vai ganhar, ou não, pelo menos um set na partida. Há dois resultados possíveis: SIM
								e NÃO.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador 2 para ganhar um set</strong>: Você tem que prever se o jogador 2
								vai ganhar, ou não, pelo menos um set na partida. Há dois resultados possíveis: SIM
								e NÃO.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Set "X" Ímpar /Par</strong>: Você deve prever se o número total de jogos
								disputados no Set "X" durante a partida será par ou ímpar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Set "X" haverá tie-break</strong>: Você tem que prever se no set " X "
								haverá tie-break.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Set "N" - corrida para X° jogos</strong>: Você tem que prever qual jogador
								chegará a " X " jogos primeiro no set específico.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pontuação correta do jogo ("set" "N", jogo "X")</strong>: Você deve prever a
								pontuação correta do game "X" da partida do set "N" em termos de sets vencidos por
								cada jogador.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Set "N" Grupo do placar exato</strong>: Você tem que prever o grupo de
								pontuações exatas, onde está incluída a pontuação exata do Set, entre as seleções
								oferecidas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Xth Set – Vencedor &amp; Total</strong>: Você tem que prever o vencedor do
								set e se o número de jogos disputados está acima ou abaixo da linha indicada.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quem vai ganhar Jogo (X e Y) do set n_</strong>: Mercado de apostas que
								consiste em prever o jogador que vai ganhar os jogos x e Y do set n, Por exemplo: 1
								(jogos 6 e 7) 2º set (Onde a aposta é para o jogador da casa) - X (jogo 6 e 7) 2º
								set (onde aposta no empate) - 2 (jogo 6 e 7) 2º set (onde aposta no jogador
								visitante).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quem ganhará o ponto X no jogo Y no set n? (Inclui apostas ao vivo)</strong>
								: Preveja o jogador que ganhará o ponto x do jogo y do set n. Por exemplo, o jogador
								Wawrinka terá uma vitória no 1º ponto no jogo 10 do 3º set da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>
									Quem vencerá o jogo x do set (1, 2, 3, 4,5)? (Inclui apostas em jogos ao vivo)
								</strong>
								: Preveja o jogador que ganhará o jogo x do set especificado no mercado de apostas.
								Por exemplo: 1 (jogo 10) 2º set - 2 (jogo 10) 2º set.
							</strong>
						</p>

						<p>
							<strong>
								<strong>
									Número exato de pontos no jogo X (1º set) (Inclui apostas em jogos ao vivo)
								</strong>
								: Prevê o número exato de pontos jogados no jogo escolhido no mercado de apostas do
								primeiro set.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Empate no jogo sim-não (Inclui apostas ao vivo)</strong>: "Duas no jogo"
								significa que a pontuação do jogo chegará a 40-40 pontos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Resultado do jogo X (Set N) Jogador 1 ou 2 (0-15-30-40)</strong>: Consiste
								em prever o vencedor de um jogo, e quantos pontos o adversário fará (0-15-30 -40),
								ou seja, se você escolher o jogador 1 a 30 significa que o jogo é ganho pelo jogador
								1 mas o jogador 2 marca 30 pontos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Set "N" jogo x - pontos pares/ímpares</strong>: Consiste em prever se o
								número de pontos jogados em um jogo de um set, será par ou ímpar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Set "N" jogo x - placar correto ou intervalo</strong>: Consiste em prever o
								vencedor de um jogo, e quantos pontos o adversário fará (0-15-30-40), ou se haverá
								quebra de saque no jogo mencionado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Definir "N" do jogo Y - corrida para x pontos</strong>: Prever o jogador que
								chegará primeiro a X pontos no jogo específico.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Definir "N" jogo Y - primeiro vencedor de x pontos</strong>: Preveja o
								jogador que ganhará os primeiros X pontos no jogo específico.
							</strong>
						</p>

						<p>
							<strong>
								<strong>O set "N" irá para o tie break?</strong>: Você deve prever se o Set "N" irá
								para um tie-break.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor do set "N" e total de jogos do set "N"</strong>: Você deve prever o
								vencedor do set "N" e se o número de jogos disputados nesse set está acima ou abaixo
								do spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor do set atual "N" e total de jogos do set "N"</strong>: Você deve
								prever o vencedor do set atual "N" e se o número de jogos disputados nesse set está
								acima ou abaixo do spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor do próximo set "N" e total de jogos do set</strong>: Você deve
								prever o vencedor do próximo set "N" e se o número de jogos disputados nesse set
								está acima ou abaixo do spread indicado.
								<br />
								<br />
								<strong>Partida até o final x:y</strong>: Você deve prever o placar exato da partida
								em termos de jogos vencidos por cada jogador. Se um jogador se retirar durante o
								jogo, todas as apostas indecisas serão consideradas nulas.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Próximo xº break</strong>: Você deve prever qual jogador fará o xº break de
								saque na partida. Se não houver quebra de saque na partida, as apostas serão
								consideradas nulas.
							</strong>
						</p>

						<p>Total de desempates: Você deve prever o número total de tie-breaks na partida.</p>

						<p>
							Jogador Y - Total de pontos acima/abaixo: Você deve prever se o jogador Y marcará mais
							ou menos de um total de pontos especificado durante a partida.
						</p>

						<p>
							Jogador Y - Total de quebras: Você deve prever quantas quebras de saque o jogador Y
							conseguirá durante a partida.
						</p>

						<p>Jogador Y - Ases: Você deve prever quantos ases o Jogador Y acertará na partida.</p>

						<p>
							Aces Matchbet: Você precisa prever qual jogador acertará mais ases na partida. Se
							ambos os jogadores acertarem o mesmo número, a aposta pode ser considerada um empate.
						</p>

						<p>
							Jogador Y - Falhas duplas: Você deve prever quantas faltas duplas o jogador Y cometerá
							durante a partida ou o set. Uma dupla falta ocorre quando o sacador falha em ambas as
							tentativas de saque.
						</p>

						<p>
							X set - jogo N - ás: Você deve prever se o jogador acertará um ás no jogo N durante o
							set X.
						</p>

						<p>
							X set - Z: Você deve prever se um jogador acertará exatamente Z ases durante o set X.
						</p>

						<p>
							Conjunto X - Jogador Y - total de pontos: Você deve prever o número total de pontos
							que o jogador Y marcará no set X.
						</p>

						<p>
							X set - Jogador Y - total de quebras: Você deve prever quantas quebras de saque o
							jogador Y conseguirá no X set. Uma quebra ocorre quando o jogador que recebe ganha o
							game enquanto o adversário está sacando.
						</p>

						<p>
							X set - Jogador Y - total de ases: Você deve prever o número de ases que o jogador Y
							acertará durante o set X.
						</p>

						<p>
							X set - maior número de ases: Você deve prever qual jogador acertará o maior número de
							ases no conjunto X. Se ambos os jogadores acertarem o mesmo número de ases, a aposta
							poderá ser considerada um empate.
						</p>

						<p>
							X set - Jogador Y - total de quebras: Você deve prever quantas quebras de saque o
							jogador X conseguirá no set X.
						</p>

						<p>
							X set - Z break: Você deve prever se exatamente Z breaks ocorrerão durante o set X.
						</p>

						<p>
							X set - game N - break point: Você deve prever se um break point ocorrerá durante um
							game específico no X set do game N. Um break point ocorre quando o jogador recebedor
							tem a chance de quebrar o saque do sacador.
						</p>

						<p>
							X set - jogo N - ponto Z - total de chutes: Você deve prever o número total de chutes
							realizados durante um ponto Z específico (rally) em um jogo N específico do conjunto
							X.
						</p>

						<p>
							X set - game N - ponto Z - resultado do saque: Você deve prever o resultado do saque
							em um ponto Z específico em um game N específico do set X. Os possíveis resultados
							podem incluir a vitória ou a derrota do sacador no ponto.
						</p>

						<p>
							Conjunto X - jogo N - ponto Z - resultado: Você deve prever o resultado geral do ponto
							Z em um jogo N específico conjunto X. Os possíveis resultados podem incluir um
							vencedor ou uma falha.
						</p>

						<p>
							X set - jogo N - ponto Z - último golpe: Você deve prever o último golpe de um ponto Z
							específico em um jogo N específico durante o set X.
						</p>

						<h2>
							<br />
							<br />
							<strong>Tênis - Outrights </strong>
						</h2>

						<p>
							<strong>
								<strong>Vencedor</strong>: Você deve prever o vencedor de um determinado torneio de
								acordo com o ranking oficial da competição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Fase de Eliminação</strong>: Preveja em qual rodada o jogador selecionado
								será eliminado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Chegar à final</strong>: Preveja se o jogador selecionado chegará à final do
								torneio nomeado.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Nome dos Finalistas</strong>: Você deve prever os dois jogadores que
								chegarão à final do torneio nomeado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quarto Vencedor</strong>: Você deve prever que o vencedor do torneio virá do
								1º/2º/3º/4º quarto.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Metade Vencedora</strong>: Você deve prever que o vencedor do torneio virá
								da metade superior ou da metade inferior.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quarto 1/2/3/4/ Vencedor</strong>: Você tem que prever o vencedor do quarto
								(1º/2º/3º/4º).{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quem vai mais longe</strong>: Você deve prever qual dos dois jogadores
								indicados alcançará a melhor posição no torneio mencionado.
							</strong>
						</p>
					</div>
				</details>
				{/* Tênis de Mesa */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<g clip-path="url(#clip0_515_510)">
								{' '}
								<path
									d="M15.1212 22.6L7.05725 14.48L5.20634 12.62C4.81614 15.18 5.23635 17.76 5.96671 20.35C5.96671 20.37 5.96671 20.39 5.96671 20.41L1.18436 25.16C-0.386413 26.72 -0.396418 29.25 1.16435 30.82C2.72512 32.39 5.25636 32.4 6.82713 30.84L7.52748 30.15L11.6595 26.05C11.6595 26.05 11.6895 26.05 11.7195 26.05C14.2708 26.78 16.802 27.19 19.3233 26.82L17.4824 24.96L15.1312 22.6H15.1212Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M28.7979 3.29C26.5868 1.07 23.7054 0.05 20.6939 0.06H20.4838C16.5719 0.13 12.4599 1.9 9.34837 5C7.61752 6.72 6.46696 8.49 5.78662 10.36L21.5944 26.26C23.4653 25.6 25.2462 24.45 26.977 22.74C32.5598 17.2 33.9405 8.47 28.8079 3.3L28.7979 3.29Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M3.03527 6C4.69608 6 6.03674 4.67 6.04675 3.01C6.05675 1.35 4.71609 0 3.05528 0C1.40447 0 0.0538034 1.33 0.0437985 2.99C0.0437985 4.65 1.37445 5.99 3.03527 6Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
							</g>{' '}
							<defs>
								{' '}
								<clipPath id="clip0_515_510">
									{' '}
									<rect
										data-darkreader-inline-fill=""
										fill="white"
										height="28"
										style={{ fill: '#FFFFFF' }}
										width="28"
									></rect>{' '}
								</clipPath>{' '}
							</defs>{' '}
						</svg>
						Tênis de Mesa
					</summary>
					<div className="textItem">
						<h2>
							<strong>Principais Mercados</strong>
						</h2>

						<p>
							<strong>
								*Alguns dos mercados listados abaixo podem aparecer no E-Tenis de Mesa (aplicam-se
								as mesmas regras){' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor (1x2)</strong>: Mercado de apostas que consiste em prever o
								vencedor da partida independentemente da margem de pontos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogos de Handicap (spread)</strong>: Você tem que prever o vencedor da
								partida adicionando ou subtraindo o spread indicado ao resultado da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de jogos (mais/menos)</strong>: Você deve prever se o número total de
								jogos disputados na partida será superior ou inferior ao spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Resultado Correto</strong>: Você deve prever o resultado correto da partida
								em termos de jogos vencidos por cada jogador. Se um jogador se retirar durante a
								partida, todas as apostas não decididas serão consideradas nulas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ponto Handicap</strong>: Você tem que prever o vencedor de toda a partida
								(em pontos ganhos) somando ou subtraindo o spread indicado ao resultado da partida
								(em pontos).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de Pontos</strong>: Consiste em prever se o total de pontos marcados
								por ambas as equipes será maior ou menor que o número dado no mercado de apostas
								escolhido.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quantos jogos serão decididos por pontos extras?</strong>: Preveja quantos
								jogos alcançarão pontos extras (o vencedor do set tem mais de 11 pontos).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogos Exatos</strong>: Você deve prever o número exato de jogos durante a
								partida.
							</strong>
						</p>

						<h2>
							<strong>Mercados de jogos</strong>
						</h2>

						<p>
							<strong>
								<strong>X° jogo - Vencedor</strong>: Preveja se o vencedor do jogo mencionado será o
								time da casa (1) ou o time visitante (2).
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° jogo - Total de Pontos</strong>: Prever se o total de pontos acumulados
								por ambas as equipes em um determinado jogo será superior ou inferior a um
								determinado número no mercado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° jogo - Handicap de Pontos</strong>: Você tem que prever o vencedor do
								jogo mencionado (em pontos ganhos) somando ou subtraindo o spread indicado ao
								resultado do jogo (em pontos).
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° jogo - par/ímpar</strong>: Prever se o total de pontos acumulados por
								ambas as equipes no jogo em questão será um número par ou ímpar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>X° jogo - corrida para X pontos</strong>: Você tem que prever qual time
								alcançará X pontos primeiro para o jogo mencionado.
							</strong>
						</p>

						<p>
							<strong>
								No entanto, e em caso de abandono de um jogador, todos os mercados determinados no
								campo são liquidados em conformidade e todos os restantes são declarados nulos. Para
								evitar dúvidas, se um jogador de tênis de mesa se retirar antes da conclusão do
								último ponto, o mercado do vencedor da partida será anulado, mas todos os mercados
								relacionados a jogos específicos ou pontos determinados serão liquidados de acordo.
							</strong>
						</p>

						<p>
							Handicap do jogo: você deve prever o vencedor do jogo adicionando ou subtraindo o
							spread indicado ao resultado do jogo.
						</p>
					</div>
				</details>
				{/* Tênis de Padel */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Tênis de Padel
					</summary>
					<div className="textItem">
						<h2>
							<strong>Principais Mercados</strong>
						</h2>

						<p>
							<strong>
								<strong>Vencedor (1,2)</strong>: Mercado de apostas que consiste em prever o
								vencedor da partida independentemente da margem de pontos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap Games (spread)</strong>: Você tem que prever o vencedor da partida
								adicionando ou subtraindo o spread indicado para o resultado da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Handicap Sets</strong>: Você tem que prever o resultado em termos de
								conjuntos ganhos por cada jogador adicionando ou subtraindo ao resultado final o
								spread especificado na aposta.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Pontuação correta</strong>: Você tem que prever a pontuação correta da
								partida em termos de sets ganhos por cada jogador. Se um jogador se retirar durante
								a partida, todas as apostas indecisas serão consideradas nulas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de jogos (Over/Under)</strong>: Você tem que prever se o número total
								de jogos jogados na partida será maior ou abaixo do spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogos ímpares/pares</strong>: Prever no final da partida que o total de
								jogos é um número ímpar ou par.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de jogos (Acima/Menos) Jogador 1</strong>: Você tem que prever se o
								número total de jogos para o Jogador 1 será maior ou abaixo do spread indicado. Um
								tiebreak é considerado um jogo. A quantidade de jogos jogados será indicada na
								liquidação da aposta pelo segundo número entre parênteses. Se a partida não for
								concluída, todas as apostas indecisas serão consideradas nulas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de jogos (Mais/Menos) Jogador 2</strong>: Você tem que prever se o
								número total de jogos para o Jogador 2 será maior ou abaixo do spread indicado. Um
								tiebreak é considerado um jogo. A quantidade de jogos jogados será indicada na
								liquidação da aposta pelo segundo número entre parênteses. Se a partida não for
								concluída, todas as apostas indecisas serão consideradas nulas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor &amp; Total</strong>: Você tem que prever o vencedor da partida e
								se o número de jogos jogados está acima ou abaixo do spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Tiebreak (sim/não)</strong>: É preciso prever se haverá tie-break na
								partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Deuce no jogo (Sim/Não)</strong>: "Deuce no jogo" significa que o placar do
								jogo chegará a 40-40.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor do 1º Set</strong>: Você tem que prever o vencedor do primeiro Set.
								A aposta será considerada "nula" se o primeiro set não for concluído.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor do 2º set</strong>: Você tem que prever o vencedor do segundo set.
								A aposta será considerada "nula" se este conjunto não for concluído.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Conjunto "X" Vencedor</strong>: Você tem que prever o vencedor do Conjunto
								"X". A aposta será considerada "nula" se este conjunto não for concluído.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Resultado duplo (Primeiro set/partida)</strong>: Prever o vencedor do
								primeiro set, e no final da partida em um único mercado de apostas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador 1 para ganhar exatamente 1 set</strong>: Prever se o jogador da casa
								terá uma vitória de 1 set durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador 2 para ganhar exatamente 1 set</strong>: Preveja que o jogador
								visitante terá uma vitória de 1 set durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Conjuntos exatos</strong>: Você tem que prever o número exato de sets
								durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de sets</strong>: Você tem que prever se o número total de sets
								jogados na partida será acima ou abaixo do spread indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Qualquer conjunto para zero</strong>: Prever se pelo menos um dos sets da
								partida terminará com placar exato de 6-0 / 0-6.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Definir jogos de Handicap "X"</strong>: Você tem que prever o vencedor do
								Conjunto "X" adicionando ou subtraindo o spread indicado ao resultado da partida. Se
								a partida não for concluída, todas as apostas indecisas serão consideradas nulas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Definir "X" Total de jogos</strong>: Você tem que prever se o número total
								de jogos jogados no Conjunto "X" durante a partida será maior ou inferior ao spread
								indicado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Definir "X" Pontuação Correta</strong>: Você tem que prever a pontuação
								correta exata do Conjunto "X". Se o conjunto mencionado não for concluído, todas as
								apostas indecisas serão consideradas nulas.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador 1 para ganhar um set</strong>: Você tem que prever se o jogador 1
								vai ganhar, ou não, pelo menos um set na partida. Há dois resultados possíveis: SIM
								e NÃO.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador 2 para ganhar um set</strong>: Você tem que prever se o jogador 2
								vai ganhar, ou não, pelo menos um set na partida. Há dois resultados possíveis: SIM
								e NÃO.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Definir "X" ímpar/par</strong>: Você tem que prever se o número total de
								jogos jogados no Conjunto "X" durante a partida será ímpar ou par.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Conjunto "X" haverá um tiebreak</strong>: Você tem que prever se no Set "X"
								haverá um tie-break.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Definir "N" - corrida para x jogos</strong>: Você tem que prever qual
								jogador vai chegar "X" jogos primeiro no conjunto específico.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quem vai ganhar Jogo (X e Y) do set n_</strong>: Mercado de apostas que
								consiste em prever o jogador que vai ganhar jogos x e Y para o set n, Por exemplo: 1
								(jogos 6 e 7) 2º set (Onde a aposta é para jogador da casa) - X (jogos 6 e 7) 2º set
								(Onde você aposta no empate) - 2 (Jogo 6 e 7) 2º set (Onde você aposta no jogador
								visitante).
							</strong>
						</p>

						<p>
							<strong>
								<strong>
									Quem vai ganhar o ponto X no jogo Y no set n? (Inclui apostas de jogo ao vivo)
								</strong>
								: Preveja o jogador que ganhará o ponto x do jogo y do conjunto n. Por exemplo, o
								jogador Wawrinka terá uma vitória no 1º ponto no jogo 10 do 3º set da partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>
									Quem vai ganhar o jogo x do set (1, 2, 3, 4,5)? (Inclui apostas de jogo ao vivo)
								</strong>
								: Prever o jogador que ganhará o jogo x do conjunto especificado no mercado de
								apostas. Por exemplo: 1 (jogo 10) 2º set - 2 (jogo 10) 2º set.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Número exato de pontos no jogo X (1º set)</strong>: (Inclui apostas de jogo
								ao vivo): Prevê o número exato de pontos jogados no jogo escolhido no mercado de
								apostas do primeiro conjunto.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Deuce no jogo sim-não (Inclui apostas ao vivo)</strong>: "Deuce no jogo"
								significa que o placar do jogo chegará a 40-40.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Resultado do jogo X (Set N) Jogador 1 ou 2 (0-15-30-40)</strong>: Consiste
								em prever o vencedor de um jogo, e quantos pontos o jogador adversário fará
								(0-15-30-40), ou seja, se você escolher o jogador 1 a 30 significa que o jogo é
								vencido pelo jogador 1 mas o jogador 2 marca 30 pontos.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Conjunto "N" jogo x - pontos ímpares/pares</strong>: Consiste em prever se o
								número de pontos jogados em um jogo de um set, será ímpar ou par.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Definir "N" jogo x - pontuação correta ou quebra</strong>: Consiste em
								prever o vencedor de um jogo, e quantos pontos o jogador adversário fará
								(0-15-30-40), ou se haverá uma quebra de saque no jogo mencionado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Definir "N" jogo Y - corrida para x pontos</strong>: Prever o jogador que
								vai chegar primeiro a X pontos no jogo específico.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Definir "N" jogo Y - primeiro x vencedor de pontos</strong>: Prever o
								jogador que ganhará os primeiros X pontos no jogo específico.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Jogador X Aces (Acima/Abaixo):</strong> Você deve prever quantos aces serão
								marcados pelo comp1 durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de Aces (Acima/Abaixo):</strong> Você deve prever quantos aces serão
								marcados por ambos os competidores combinados durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Faltas Duplas do Jogador X (Acima/Menos):</strong> Você tem que prever
								quantas faltas duplas o comp1 cometerá durante a partida (o/u 1.5)
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de faltas duplas (acima/abaixo):</strong> Você deve prever quantas
								faltas duplas serão cometidas por ambos os competidores combinados durante a
								partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Aces e Duplas Faltas (Over/Under):</strong> Você deve prever quantos aces e
								duplas faltas serão cometidas por ambos os competidores combinados durante a
								partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Duração da partida (minutos) (acima/abaixo):</strong> você deve prever
								quantos minutos a partida durará
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de quebras (acima/abaixo):</strong> Você deve prever quantas quebras
								serão feitas por ambos os competidores combinados durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de quebras do jogador X (acima/abaixo):</strong> você deve prever
								quantas quebras o jogador X fará durante a partida
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mais quebras de saque (2-way):</strong> Você tem que prever qual competidor
								fará mais quebras (1/2 em caso de empate o mercado é anulado).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Mais quebras de saque (3-way):</strong> você tem que prever qual competidor
								fará mais quebras (inclui a opção de empate)
							</strong>
						</p>
					</div>
				</details>
				{/* Vôlei */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 33 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<g clip-path="url(#clip0_414_454)">
								{' '}
								<path
									d="M22.4828 18.2257C20.7929 17.4454 18.8529 16.9953 16.8029 16.9953C16.7129 16.9953 16.6129 17.0053 16.5229 17.0053C16.4829 17.0553 16.4529 17.1153 16.4129 17.1654L16.1729 17.5355C13.353 21.9369 8.75303 24.4276 4.32309 24.4276C3.6431 24.4276 2.97311 24.3576 2.30312 24.2476C2.96311 25.3379 3.7431 26.3782 4.68309 27.3185C5.73307 28.3689 6.90306 29.2291 8.14304 29.9294C17.0129 27.3385 21.3328 20.3964 22.4928 18.2357L22.4828 18.2257Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M24.2228 19.206C22.7528 22.1069 18.3529 28.1188 10.783 31.1097C12.473 31.6899 14.2329 32 16.0029 32C20.0929 32 24.1928 30.4395 27.3128 27.3085C27.7927 26.8184 28.2327 26.3082 28.6427 25.7781C28.2027 23.1272 26.5728 20.7965 24.2228 19.206Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M14.4829 16.4551L14.7429 16.065C14.7429 16.065 14.7829 15.995 14.8029 15.965C11.633 10.4933 12.153 3.98124 15.7929 0C13.003 0.0300094 10.233 0.80025 7.76304 2.29072C7.23305 4.75148 6.10307 12.6139 10.933 20.1963C12.283 19.236 13.503 17.9856 14.4829 16.4651V16.4551Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M14.7429 9.18287C14.8729 11.1335 15.4729 13.1341 16.5629 15.0047C16.6429 15.0047 16.7229 14.9947 16.8029 14.9947C23.0328 14.9947 28.3227 18.5858 30.1227 23.5274C31.3827 21.1566 32.0127 18.5358 32.0027 15.915C25.4928 9.57299 17.5129 9.13285 14.7529 9.19287L14.7429 9.18287Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M9.23302 21.2266C5.22308 14.8746 4.95308 8.06252 5.45308 3.98124C5.19308 4.21132 4.93308 4.43138 4.68309 4.67146C0.0431546 9.32291 -1.14683 16.105 1.11314 21.8468C3.6831 22.8071 6.60306 22.527 9.23302 21.2166V21.2266Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M31.7127 12.9941C31.1327 9.95311 29.6727 7.0322 27.3128 4.68146C24.8328 2.20069 21.7528 0.720225 18.5329 0.210066C16.3329 1.83057 15.0529 4.37137 14.7729 7.18224C18.2029 7.06221 25.4828 7.95248 31.7127 12.9941Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
							</g>{' '}
							<defs>
								{' '}
								<clipPath id="clip0_414_454">
									{' '}
									<rect
										data-darkreader-inline-fill=""
										fill="white"
										height="28"
										style={{ fill: '#FFFFFF' }}
										transform="translate(0.00317383)"
										width="28"
									>
										{' '}
									</rect>{' '}
								</clipPath>{' '}
							</defs>{' '}
						</svg>
						Vôlei
					</summary>
					<div className="textItem">
						<p>
							<strong>
								Uma partida de vôlei não tem duração específica, a partida depende dos sets vencidos
								por cada equipe, uma vez que uma equipe ganhe 3 sets com um máximo de 5 sets, a
								partida termina.
							</strong>
						</p>

						<p>
							<strong>
								Se uma partida não for concluída, as apostas no final das partidas serão anuladas e
								a aposta será reembolsada, mas se os mercados de apostas forem determinados, isso
								não acontecerá, pois é o saldo do jogo ao vivo.
							</strong>
						</p>

						<h2>
							<strong>Principais Mercados:</strong>
						</h2>

						<p>
							<strong>
								*Alguns dos mercados listados abaixo podem aparecer no E-Voleibol (aplicam-se as
								mesmas regras)
							</strong>
						</p>

						<p>
							<strong>
								<strong>Vencedor</strong>: Preveja se o vencedor da partida será o time da casa (1)
								ou o time visitante (2).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ponto Handicap</strong>: Você tem que prever o vencedor de toda a partida
								(em pontos ganhos) somando ou subtraindo o spread indicado ao resultado da partida
								(em pontos).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de Pontos</strong>: Consiste em prever se o total de pontos marcados
								por ambas as equipes será maior ou menor que o número dado no mercado de apostas
								escolhido.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Sets Exatos</strong>: Consiste em prever se o número total de sets jogados
								na partida será maior ou menor que o número informado no mercado de apostas
								escolhido.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Haverá um 4º set?</strong>: (Sim - Não) o 4º set da partida deverá ser
								disputado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Haverá um 5º set?</strong>: (Sim - Não) o 5º set da partida terá que ser
								jogado para definir a equipe vencedora.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Resultado Correto</strong>: Você deve prever o resultado correto da partida
								em termos de sets ganhos por cada equipe.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe da casa vence um set</strong>: Você deve prever se a equipe da casa
								vencerá pelo menos um set.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe visitante vence um set</strong>: Você deve prever se a equipe
								visitante vencerá pelo menos um set.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe da casa vence exatamente um set</strong>: Você deve prever se a
								equipe da casa vencerá exatamente um set.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe visitante vence exatamente um set</strong>: Você deve prever se a
								equipe visitante vencerá exatamente um set.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe da casa vence exatamente dois sets</strong>: Você deve prever se a
								equipe da casa vencerá exatamente dois sets.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Equipe visitante vence exatamente dois sets</strong>: Você deve prever se a
								equipe visitante vencerá exatamente dois sets.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Quantos sets serão decididos por pontos extras?</strong>: Preveja quantos
								sets alcançarão pontos extras (o vencedor do set tem mais de 25 pontos).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Xº Set - Nth Point</strong>: Você tem que prever qual equipe ganhará o ponto
								N do set X.
							</strong>
						</p>

						<h2>
							<strong>Mercados de set:</strong>
						</h2>

						<p>
							<strong>
								<strong>1º/2º/3º/4º/5º set - Vencedor</strong>: Prever se o vencedor do set
								mencionado será o time da casa (1) ou o time visitante (2).
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º/2º/3º/4º/5º set - Total de Pontos</strong>: Prever se o total de pontos
								acumulados por ambas as equipes em um determinado set será superior ou inferior a um
								determinado número no mercado.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º/2º/3º/4º/5º set - Ponto Handicap</strong>: Você tem que prever o vencedor
								do set mencionado (em pontos ganhos), somando ou subtraindo o spread indicado ao
								resultado da partida (em pontos).
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º/2º/3º/4º/5º set - ímpar/par</strong>: Preveja se o total de pontos
								acumulados por ambas as equipes na partida ou set relevante será um número par ou
								ímpar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º/2º/3º/4º/5º set - corrida para X pontos</strong>: Você deve prever qual
								equipe alcançará X pontos primeiro no set mencionado.
							</strong>
						</p>

						<h2>
							<strong>Mercados de Outright:</strong>
						</h2>

						<p>
							<strong>
								<strong>Vencedor</strong>: Você deve prever o vencedor de um determinado torneio de
								acordo com o ranking oficial da competição.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Top4, Top6, Top8, Top10</strong>: Você tem que prever se a equipe
								selecionada terminará na posição superior respectiva quando a competição terminar.
							</strong>
						</p>
					</div>
				</details>
				{/* Vôlei de Praia */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 33 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<g clip-path="url(#clip0_414_454)">
								{' '}
								<path
									d="M22.4828 18.2257C20.7929 17.4454 18.8529 16.9953 16.8029 16.9953C16.7129 16.9953 16.6129 17.0053 16.5229 17.0053C16.4829 17.0553 16.4529 17.1153 16.4129 17.1654L16.1729 17.5355C13.353 21.9369 8.75303 24.4276 4.32309 24.4276C3.6431 24.4276 2.97311 24.3576 2.30312 24.2476C2.96311 25.3379 3.7431 26.3782 4.68309 27.3185C5.73307 28.3689 6.90306 29.2291 8.14304 29.9294C17.0129 27.3385 21.3328 20.3964 22.4928 18.2357L22.4828 18.2257Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M24.2228 19.206C22.7528 22.1069 18.3529 28.1188 10.783 31.1097C12.473 31.6899 14.2329 32 16.0029 32C20.0929 32 24.1928 30.4395 27.3128 27.3085C27.7927 26.8184 28.2327 26.3082 28.6427 25.7781C28.2027 23.1272 26.5728 20.7965 24.2228 19.206Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M14.4829 16.4551L14.7429 16.065C14.7429 16.065 14.7829 15.995 14.8029 15.965C11.633 10.4933 12.153 3.98124 15.7929 0C13.003 0.0300094 10.233 0.80025 7.76304 2.29072C7.23305 4.75148 6.10307 12.6139 10.933 20.1963C12.283 19.236 13.503 17.9856 14.4829 16.4651V16.4551Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M14.7429 9.18287C14.8729 11.1335 15.4729 13.1341 16.5629 15.0047C16.6429 15.0047 16.7229 14.9947 16.8029 14.9947C23.0328 14.9947 28.3227 18.5858 30.1227 23.5274C31.3827 21.1566 32.0127 18.5358 32.0027 15.915C25.4928 9.57299 17.5129 9.13285 14.7529 9.19287L14.7429 9.18287Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M9.23302 21.2266C5.22308 14.8746 4.95308 8.06252 5.45308 3.98124C5.19308 4.21132 4.93308 4.43138 4.68309 4.67146C0.0431546 9.32291 -1.14683 16.105 1.11314 21.8468C3.6831 22.8071 6.60306 22.527 9.23302 21.2166V21.2266Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
								<path
									d="M31.7127 12.9941C31.1327 9.95311 29.6727 7.0322 27.3128 4.68146C24.8328 2.20069 21.7528 0.720225 18.5329 0.210066C16.3329 1.83057 15.0529 4.37137 14.7729 7.18224C18.2029 7.06221 25.4828 7.95248 31.7127 12.9941Z"
									data-darkreader-inline-fill=""
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								>
									{' '}
								</path>{' '}
							</g>{' '}
							<defs>
								{' '}
								<clipPath id="clip0_414_454">
									{' '}
									<rect
										data-darkreader-inline-fill=""
										fill="white"
										height="28"
										style={{ fill: '#FFFFFF' }}
										transform="translate(0.00317383)"
										width="28"
									>
										{' '}
									</rect>{' '}
								</clipPath>{' '}
							</defs>{' '}
						</svg>
						Vôlei de Praia
					</summary>
					<div className="textItem">
						<p>
							<strong>
								A partida de vôlei de praia não tem duração específica, a partida depende dos sets
								vencidos por cada equipe. Se qualquer jogador for substituído por outro jogador
								antes do início da partida, todas as apostas serão anuladas. Se uma partida começar,
								mas não for concluída, todas as apostas baseadas no resultado final serão
								consideradas nulas, com exceção dos mercados onde o resultado já foi determinado.
							</strong>
						</p>

						<h2>
							<strong>Principais Mercados</strong>
						</h2>

						<p>
							<strong>
								<strong>Vencedor</strong>: Preveja se o vencedor da partida será o time da casa (1)
								ou o time visitante (2)
							</strong>
						</p>

						<p>
							<strong>
								<strong>Sets Exatos</strong>: Consiste em prever se o número total de sets jogados
								na partida será maior ou menor que o número dado no mercado de apostas escolhido.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Resultado Correto</strong>: Você deve prever o resultado correto da partida
								em termos de sets ganhos por cada equipe.
							</strong>
						</p>

						<p>
							<strong>
								<strong>Ponto Handicap</strong>: Você tem que prever o vencedor de toda a partida
								(em pontos ganhos) somando ou subtraindo o spread indicado ao resultado da partida
								(em pontos).
							</strong>
						</p>

						<p>
							<strong>
								<strong>Total de Pontos</strong>: Consiste em prever se o total de pontos marcados
								por ambas as equipes será maior ou menor que o número dado no mercado de apostas
								escolhido.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1Quantos sets serão decididos por pontos extras?</strong>: Preveja quantos
								sets alcançarão pontos extras.
							</strong>
						</p>

						<h2>
							<strong>Mercados de set:</strong>
						</h2>

						<p>
							<strong>
								<strong>1º/2º/3º/4º/5º set - Vencedor</strong>: Preveja se o vencedor do set
								mencionado será o time da casa (1) ou o time visitante (2).
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º/2º/3º/4º/5º set - Total de Pontos</strong>: Prever se o total de pontos
								acumulados por ambas as equipes num determinado set será superior ou inferior a um
								determinado número no mercado.{' '}
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º/2º/3º/4º/5º set - Ponto Handicap</strong>: Você tem que prever o vencedor
								do set mencionado (em pontos ganhos) somando ou subtraindo o spread indicado ao
								resultado da partida (em pontos).
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º/2º/3º/4º/5º set - ímpar/par</strong>: Preveja se o total de pontos
								acumulados por ambas as equipes na partida ou set relevante será um número par ou
								ímpar.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º/2º/3º/4º/5º set - corrida para X pontos</strong>: Você deve prever qual
								equipe alcançará X pontos primeiro no set mencionado.
							</strong>
						</p>

						<p>
							<strong>
								<strong>1º/2º/3º/4º/5º set - X ponto</strong>: Você tem que prever qual time marcará
								os X pontos primeiro para o set mencionado.
							</strong>
						</p>

						<h2>
							<strong>Mercado Outright:</strong>
						</h2>

						<p>
							<strong>
								<strong>Vencedor</strong>: Você deve prever o vencedor de um determinado torneio de
								acordo com a classificação oficial da competição.
							</strong>
						</p>
					</div>
				</details>
				{/* Construtor de Apostas */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Construtor de Apostas
					</summary>
					<div className="textItem">
						<p>{`O recurso Construtor de Apostas dá ao jogador a oportunidade de combinar seleções do mesmo evento em um boletim de apostas. Se uma seleção que participa de um boletim de apostas do Construtor de Apostas for anulada/empurrada, então todo o boletim de apostas também será anulado/empurrado, INDEPENDENTEMENTE do resultado das outras seleções que participam do Construtor de Apostas.

`}</p>
						<p>{`Por exemplo, no jogo LA Lakers x Toronto Raptors, criamos um boletim de apostas com LA Lakers para vencer, por mais de 220,5 pontos na partida e Jogador X - Mais de 29,5 pontos. Caso o Jogador X não participe da partida, a seleção para seus pontos (acima de 29,5) é considerada nula. Portanto, todo o boletim de apostas é resolvido como nulo como a seleção participa de um Construtor de Apostas.

`}</p>
					</div>
				</details>
				{/* Pagamento Antecipado */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Pagamento Antecipado
					</summary>
					<div className="textItem">
						<p>
							<strong>PAGAMENTO ANTECIPADO DO FUTEBOL</strong>
						</p>

						<p>
							<strong>
								Com a oferta Soccer Early Payout, você pode fazer uma aposta antes do início da
								partida no mercado 1X2 (vitória em casa ou fora) e se seu time estiver 2 gols à
								frente em qualquer ponto da partida, você ganha automaticamente sem ter que esperar
								a partida terminar!
							</strong>
						</p>

						<p>
							<strong>
								A oferta é válida para apostas simples, múltiplas, de sistema e Construtor de
								Apostas feitas no mercado 1X2 (Vitória em Casa ou Fora) APENAS antes do início da
								partida e não durante a partida. A oferta não se aplica às apostas feitas na seleção
								do Sorteio em cada jogo.
							</strong>
						</p>

						<p>
							<strong>
								Sua aposta é paga integralmente se seu time estiver dois gols acima em qualquer
								momento da partida, independentemente do resultado final.
							</strong>
						</p>

						<p>
							<strong>
								Esta oferta não se aplica a apostas em que o Cash Out tenha sido utilizado. Em
								múltiplos, a concessão da oferta para uma determinada seleção da aposta não será
								afetada retrospectivamente se o cliente sacar as apostas das seleções restantes.
							</strong>
						</p>

						<p>
							<strong>
								Todos os ganhos serão creditados o mais rápido possível quando a equipe estiver com
								dois gols de vantagem. Esta oferta não se aplicará quando uma aposta tiver sido
								totalmente sacada. Quando uma aposta tiver sido parcialmente sacada e a sua equipe
								estiver dois gols à frente, a aposta será liquidada na aposta ativa restante.
							</strong>
						</p>

						<p>
							<strong>
								Se a sua aposta for paga antecipadamente de acordo com esta oferta, ela não será
								paga novamente se sua seleção ganhar a partida.
							</strong>
						</p>

						<p>
							<strong>PAGAMENTO ANTECIPADO DE BEISEBOL</strong>
						</p>

						<p>
							<strong>
								Com a oferta de Pagamento Antecipado de Beisebol, você pode fazer uma aposta antes
								do início da partida no mercado Money Line (vitória em casa ou fora) e se sua equipe
								ficar 5 corridas à frente em qualquer ponto da partida, você ganha automaticamente
								sem ter que esperar a partida terminar!
							</strong>
						</p>

						<p>
							<strong>
								A oferta é válida para apostas simples, múltiplas, de sistema e do Construtor de
								Apostas feitas no mercado Money Line (Vencedor) (vitória em casa ou fora) APENAS
								antes do início da partida e não durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								Sua aposta é paga integralmente se seu time tiver cinco corridas a qualquer momento
								da partida, independentemente do resultado final.
							</strong>
						</p>

						<p>
							<strong>
								Esta oferta não se aplica a apostas em que o Cash Out tenha sido utilizado. Em
								múltiplos, a concessão da oferta para uma determinada seleção da aposta não será
								afetada retrospectivamente se o cliente sacar as apostas das seleções restantes.
							</strong>
						</p>

						<p>
							<strong>
								Todos os ganhos serão creditados o mais rápido possível quando a equipe tiver cinco
								corridas à frente. Esta oferta não se aplicará quando uma aposta tiver sido
								totalmente sacada. Quando uma aposta for parcialmente sacada e sua equipe avançar
								cinco corridas, a aposta será liquidada com base na aposta ativa restante.
							</strong>
						</p>

						<p>
							<strong>
								Se a sua aposta for paga antecipadamente de acordo com esta oferta, ela não será
								paga novamente se sua seleção ganhar a partida.
							</strong>
						</p>

						<p>
							<strong>
								A oferta não é válida para as Linhas de Arremesso relevantes (Money Line PL).
							</strong>
						</p>

						<p>
							<strong>PAGAMENTO ANTECIPADO DO FUTEBOL AMERICANO</strong>
						</p>

						<p>
							<strong>
								Com a oferta de Pagamento Antecipado de Futebol Americano, você pode fazer uma
								aposta antes do início da partida no mercado Money Line (vitória em casa ou fora) e
								se sua equipe estiver 17 pontos à frente em qualquer ponto da partida, você ganha
								automaticamente sem ter que esperar a partida terminar!
							</strong>
						</p>

						<p>
							<strong>
								A oferta é válida para apostas simples, múltiplas, de sistema e do Construtor de
								Apostas feitas no mercado Money Line (Home or Away Win) APENAS antes do início da
								partida e não durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								Sua aposta é paga integralmente se sua equipe estiver dezessete pontos acima em
								qualquer ponto da partida, independentemente do resultado final.
							</strong>
						</p>

						<p>
							<strong>
								Esta oferta não se aplica a apostas em que o Cash Out tenha sido utilizado. Em
								múltiplos, a concessão da oferta para uma determinada seleção da aposta não será
								afetada retrospectivamente se o cliente sacar as apostas das seleções restantes.
							</strong>
						</p>

						<p>
							<strong>
								Todos os ganhos serão creditados o mais rápido possível quando a equipe estiver com
								dezessete pontos de vantagem. Esta oferta não se aplicará quando uma aposta tiver
								sido totalmente sacada. Quando uma aposta for parcialmente encerrada e a sua equipa
								avançar dezessete pontos, a aposta será liquidada com base na aposta ativa restante.
							</strong>
						</p>

						<p>
							<strong>
								Se a sua aposta for paga antecipadamente de acordo com esta oferta, ela não será
								paga novamente se sua seleção ganhar a partida.
							</strong>
						</p>

						<p>
							<strong>PAGAMENTO ANTECIPADO DE BASQUETEBOL</strong>
						</p>

						<p>
							<strong>
								Com a oferta de Pagamento Antecipado de Basquete, você pode fazer uma aposta antes
								do início da partida no mercado Money Line (vitória em casa ou fora) e se sua equipe
								estiver 18 ou 20 pontos à frente em qualquer ponto da partida, você ganha
								automaticamente sem ter que esperar a partida terminar!
							</strong>
						</p>

						<p>
							<strong>
								A oferta é válida para apostas simples, múltiplas, de sistema e do Construtor de
								Apostas feitas no mercado Money Line (Home or Away Win) APENAS antes do início da
								partida e não durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								Sua aposta é paga integralmente se sua equipe estiver dezoito ou vinte pontos acima
								em qualquer ponto da partida, independentemente do resultado final.
							</strong>
						</p>

						<p>
							<strong>
								Esta oferta não se aplica a apostas em que o Cash Out tenha sido utilizado. Em
								múltiplos, a concessão da oferta para uma determinada seleção da aposta não será
								afetada retrospectivamente se o cliente sacar as apostas das seleções restantes.
							</strong>
						</p>

						<p>
							<strong>
								Todos os ganhos serão creditados o mais rápido possível quando a equipe estiver com
								dezoito ou vinte pontos de vantagem. Esta oferta não se aplicará quando uma aposta
								tiver sido totalmente sacada. Quando uma aposta for parcialmente encerrada e a sua
								equipe avançar dezoito ou vinte pontos, a aposta será liquidada com base na aposta
								ativa restante.
							</strong>
						</p>

						<p>
							<strong>
								Se a sua aposta for paga antecipadamente de acordo com esta oferta, ela não será
								paga novamente se sua seleção ganhar a partida.
							</strong>
						</p>

						<p>
							<strong>PAGAMENTO ANTECIPADO DE TÊNIS</strong>
						</p>

						<p>
							<strong>
								Com a oferta Tennis Early Payout, você pode fazer uma aposta antes do início da
								partida no mercado Match Winner (vitória em casa ou fora) e se o seu jogador estiver
								2 sets à frente em qualquer ponto da partida, você ganha automaticamente sem ter que
								esperar que a partida termine!
							</strong>
						</p>

						<p>
							<strong>
								A oferta é válida para apostas simples, múltiplas, de sistema e do Construtor de
								Apostas feitas no mercado do Vencedor da Partida (Vitória em Casa ou Fora) APENAS
								antes do início da partida e não durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								Sua aposta é paga integralmente se seu jogador tiver dois sets a qualquer momento da
								partida, independentemente do resultado final.
							</strong>
						</p>

						<p>
							<strong>
								Esta oferta não se aplica a apostas em que o Cash Out tenha sido utilizado. Em
								múltiplos, a concessão da oferta para uma determinada seleção da aposta não será
								afetada retrospectivamente se o cliente sacar as apostas das seleções restantes.
							</strong>
						</p>

						<p>
							<strong>
								Todos os ganhos serão creditados assim que possível, uma vez que o jogador estiver
								dois sets à frente. Esta oferta não se aplicará quando uma aposta tiver sido
								totalmente sacada. Quando uma aposta tiver sido parcialmente sacada e o seu jogador
								avançar dois sets, a aposta será liquidada na aposta ativa restante.
							</strong>
						</p>

						<p>
							<strong>
								Se a sua aposta for paga antecipadamente de acordo com esta oferta, ela não será
								paga novamente se sua seleção ganhar a partida.
							</strong>
						</p>

						<p>
							<strong>PAGAMENTO ANTECIPADO DE HÓQUEI NO GELO</strong>
						</p>

						<p>
							<strong>
								Com a oferta de Pagamento Antecipado de Hóquei no Gelo, você pode fazer uma aposta
								antes do início da partida no mercado Money Line (vitória em casa ou fora) e se sua
								equipe estiver 3 gols à frente em qualquer ponto da partida, você ganha
								automaticamente sem ter que esperar a partida terminar!
							</strong>
						</p>

						<p>
							<strong>
								A oferta é válida para apostas simples, múltiplas, de sistema e do Construtor de
								Apostas feitas no mercado Money Line (Home or Away Win) APENAS antes do início da
								partida e não durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								Sua aposta é paga integralmente se seu time estiver três gols a mais em qualquer
								momento da partida, independentemente do resultado final.
							</strong>
						</p>

						<p>
							<strong>
								Esta oferta não se aplica a apostas em que o Cash Out tenha sido utilizado. Em
								múltiplos, a concessão da oferta para uma determinada seleção da aposta não será
								afetada retrospectivamente se o cliente sacar as apostas das seleções restantes.
							</strong>
						</p>

						<p>
							<strong>
								Todos os ganhos serão creditados o mais rápido possível, uma vez que sua equipe
								estiver a três gols à frente. Esta oferta não se aplicará quando uma aposta tiver
								sido totalmente sacada. Quando uma aposta tiver sido parcialmente sacada e a sua
								equipe avançar três gols, a aposta será liquidada na aposta ativa restante.
							</strong>
						</p>

						<p>
							<strong>
								Se a sua aposta for paga antecipadamente de acordo com esta oferta, ela não será
								paga novamente se sua seleção ganhar a partida.
							</strong>
						</p>
					</div>
				</details>
				{/* 0% de margem */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						0% de margem
					</summary>
					<div className="textItem">
						<p>
							<strong>0% DE MARGEM NO FUTEBOL 1X2</strong>
						</p>

						<p>
							<strong>
								Este recurso lhe dá a oportunidade de fazer uma aposta no mercado 1X2 com margem de
								0% (isso significa que o operador recebe 0% de comissão, o que torna as
								probabilidades oferecidas tão competitivas quanto possível).
							</strong>
						</p>

						<p>
							<strong>
								O recurso de margem de 0% é válido para apostas simples, múltiplas e de sistema
								feitas no mercado 1X2 com a indicação de 0%, SOMENTE antes do início da partida e
								não durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								Os mercados de margem de 0% não estão incluídos no modelo de bônus acumulador e na
								oferta de pagamento antecipado.
							</strong>
						</p>

						<p>
							<strong>0% DE MARGEM NO VENCEDOR DO BASQUETE</strong>
						</p>

						<p>
							<strong>
								Este recurso lhe dá a oportunidade de fazer uma aposta no mercado Money Line com
								margem de 0% (isso significa que o operador recebe 0% de comissão, o que torna as
								probabilidades oferecidas tão competitivas quanto possível).
							</strong>
						</p>

						<p>
							<strong>
								O recurso de margem de 0% é válido para apostas simples, múltiplas e de sistema
								feitas no mercado Money Line com a indicação de 0%, SOMENTE antes do início da
								partida e não durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								Os mercados de margem de 0% não estão incluídos no modelo de bônus acumulador e na
								oferta de pagamento antecipado.
							</strong>
						</p>

						<p>
							<strong>MARGEM DE 0% NO VENCEDOR DO FUTEBOL AMERICANO</strong>
						</p>

						<p>
							<strong>
								Este recurso lhe dá a oportunidade de fazer uma aposta no mercado Money Line com
								margem de 0% (isso significa que o operador recebe 0% de comissão, o que torna as
								probabilidades oferecidas tão competitivas quanto possível).
							</strong>
						</p>

						<p>
							<strong>
								O recurso de margem de 0% é válido para apostas simples, múltiplas e de sistema
								feitas no mercado Money Line com a indicação de 0%, SOMENTE antes do início da
								partida e não durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								Os mercados de margem de 0% não estão incluídos no modelo de bônus acumulador e na
								oferta de pagamento antecipado.
							</strong>
						</p>

						<p>
							<strong>MARGEM DE 0% NO VENCEDOR DA PARTIDA DE TÊNIS</strong>
						</p>

						<p>
							<strong>
								Este recurso lhe dá a oportunidade de fazer uma aposta no mercado Match Winner com
								margem de 0% (isso significa que o operador recebe 0% de comissão, o que torna as
								probabilidades oferecidas tão competitivas quanto possível).
							</strong>
						</p>

						<p>
							<strong>
								O recurso de margem de 0% é válido para apostas simples, múltiplas e de sistema
								feitas no mercado Vencedor da partida com a indicação de 0%, SOMENTE antes do início
								da partida e não durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								Os mercados de margem de 0% não estão incluídos no modelo de bônus acumulador e na
								oferta de pagamento antecipado.
							</strong>
						</p>

						<p>
							<strong>MARGEM DE 0% NO VENCEDOR DO BEISEBOL</strong>
						</p>

						<p>
							<strong>
								Este recurso lhe dá a oportunidade de fazer uma aposta no mercado Money Line com
								margem de 0% (isso significa que o operador recebe 0% de comissão, o que torna as
								probabilidades oferecidas tão competitivas quanto possível).
							</strong>
						</p>

						<p>
							<strong>
								O recurso de margem de 0% é válido para apostas simples, múltiplas e de sistema
								feitas no mercado Money Line com a indicação de 0%, SOMENTE antes do início da
								partida e não durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								Os mercados de margem de 0% não estão incluídos no modelo de bônus acumulador e na
								oferta de pagamento antecipado.
							</strong>
						</p>

						<p>
							<strong>
								A oferta não é válida para as Linhas de Arremesso relevantes (Money Line PL).
							</strong>
						</p>

						<p>
							<strong>MARGEM DE 0% NO VENCEDOR DO HÓQUEI NO GELO</strong>
						</p>

						<p>
							<strong>
								Este recurso lhe dá a oportunidade de fazer uma aposta no mercado Money Line com
								margem de 0% (isso significa que o operador recebe 0% de comissão, o que torna as
								probabilidades oferecidas tão competitivas quanto possível).
							</strong>
						</p>

						<p>
							<strong>
								O recurso de margem de 0% é válido para apostas simples, múltiplas e de sistema
								feitas no mercado Money Line com a indicação de 0%, SOMENTE antes do início da
								partida e não durante a partida.
							</strong>
						</p>

						<p>
							<strong>
								Os mercados de margem de 0% não estão incluídos no modelo de bônus acumulador e na
								oferta de pagamento antecipado.
							</strong>
						</p>
					</div>
				</details>
				{/* Empate Anula */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Empate Anula
					</summary>
					<div className="textItem">
						<p>{`Faça uma aposta antes do início da partida, no PLACAR CORRETO ou no mercado HALFTIME/FULLTIME e, se a partida terminar em um empate 0-0, sua aposta será totalmente reembolsada.

`}</p>
						<p>{`A oferta é válida para apostas simples, múltiplas, de sistema e do Construtor de Apostas feitas no Score Correto ou nos mercados Halftime/Fulltime SOMENTE antes do início da partida e não durante a partida.

`}</p>
						<p>{`Os reembolsos serão creditados assim que a partida terminar. Se, entretanto, o jogador interferir na aposta de alguma forma (por exemplo, levantamento/levantamento parcial), a aposta deixará de se aplicar à oferta de Empate.

`}</p>
					</div>
				</details>
				{/* Apostas Teaser */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Empate
					</summary>
					<div className="textItem">
						<p>{`Nas apostas esportivas, uma aposta teaser é um tipo de aposta parlay. Em uma aposta teaser, o apostador pode alterar o spread de pontos de um jogo, tornando a aposta mais fácil de ganhar. Em troca, o apostador percebe um retorno menor sobre as apostas em caso de vitória. Se uma seleção perder, o teaser é considerado perdido. Se uma seleção for anulada e o resto for ganho, o teaser é considerado nulo.

`}</p>
					</div>
				</details>
				{/* Regra Dead Heat */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Regra Dead Heat
					</summary>
					<div className="textItem">
						<p>{`Quando não houver vencedor óbvio ou houver empate entre dois, três ou mais competidores, será aplicada a regra do "Dead Heat". Isso significa que as probabilidades serão divididas pelo número de participantes empatados nessa posição.

`}</p>
						<p>{`Por exemplo: empate em Corridas de Cavalos, ou empate no mercado para o artilheiro de um campeonato. Dois jogadores estão empatados pelo número de gols em um campeonato. Jogador 1 pagou 3,00 e Jogador 2 pagou 1,5. As odds serão divididas por 2 e a aposta será paga normalmente.

`}</p>
						<p>{`O jogador 1 será pago com odds de 3,00 / 2 = 1,5.

`}</p>
						<p>{`O jogador 2 será pago com odds de 1,5 / 2 = 0,75.

`}</p>
					</div>
				</details>
				{/* Mercados de Classificação */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Mercados de Classificação
					</summary>
					<div className="textItem">
						<p>{`Para classificar: este mercado consiste em prever qual das equipes irá para a próxima rodada do torneio. Para esta opção, serão considerados os resultados da primeira mão e da segunda mão, incluindo prolongamento e pontapés de grande penalidade, se atribuídos.

`}</p>
						<p>{`Método da vitória: Neste mercado devemos prever como o time que se classifica para a próxima fase o fará.

`}</p>
						<p>{`Por exemplo, se minha seleção for:

`}</p>
						<p>{`Prorrogação em Casa (Prorrogação Juventus Turim): Estou indicando que a definição desse mercado será dada na prorrogação.

`}</p>
						<p>{`Tempo regulamentar da equipe da casa (Tempo normal da Juventus Turim): Prevejo que este mercado será definido durante o tempo regulamentar + acréscimos do jogo.

`}</p>
						<p>{`Penalidades do visitante (penalidades do Ajax): Estou prevendo que o mercado será definido na disputa de pênaltis.

`}</p>
					</div>
				</details>
				{/* Cash Out */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Cash Out
					</summary>
					<div className="textItem">
						<h2>
							<strong>O que é o "Cash Out"?</strong>
						</h2>

						<p>
							<strong>
								O "Cash Out" é uma opção oferecida pela Estrelabet que permite receber seus ganhos
								antecipadamente. Com o "Cash Out", você tem controle total sobre suas apostas.
								Sempre que o botão "Cash Out" estiver disponível, você pode optar por receber seus
								ganhos antes do término dos eventos.
							</strong>
						</p>

						<p>
							<strong>
								O "Cash Out" está disponível em uma variedade de esportes e mercados na Estrelabet.
								Você verá o ícone "Cash Out" e o valor atualizado em suas apostas em "Minhas
								Apostas".
							</strong>
						</p>

						<h3>
							<strong>Termos e Condições do "Cash Out":</strong>
						</h3>

						<ul>
							<li>
								<strong>
									O "Cash Out" pode ser utilizado em apostas simples, múltiplas e sistemas.
								</strong>
							</li>
							<li>
								<strong>Você pode utilizá-lo antes ou durante os eventos esportivos.</strong>
							</li>
							<li>
								<strong>
									Ao clicar no botão "Cash Out", sua aposta será paga imediatamente pelo valor
									indicado.
								</strong>
							</li>
						</ul>

						<p>
							<strong>
								<strong>Importante:</strong> uma vez acionado, o "Cash Out" não pode ser desfeito.
							</strong>
						</p>

						<p>
							<strong>A Estrelabet pode recusar o "Cash Out" se:</strong>
						</p>

						<ul>
							<li>
								<strong>O valor exibido estiver incorreto.</strong>
							</li>
							<li>
								<strong>Houver um erro evidente no mercado.</strong>
							</li>
							<li>
								<strong>
									O mercado apostado esteja suspenso ou a seleção/linha não se ache disponível nesse
									momento (situação comum em mercados como Totais e Handicaps)
								</strong>
							</li>
							<li>
								<strong>
									Suspeitarmos que você tenha realizado o "Cash Out" após conhecer o resultado de um
									evento.
								</strong>
							</li>
						</ul>

						<p>
							<strong>
								A Estrelabet não garante que o "Cash Out" estará disponível o tempo todo, mesmo que
								anunciado para um evento específico. Estrelabet não se responsabiliza se o "Cash
								Out" não estiver disponível devido a problemas técnicos.
							</strong>
						</p>

						<p>
							<strong>
								Após o processamento do "Cash Out", as informações serão registradas em seu
								histórico de apostas.
							</strong>
						</p>
					</div>
				</details>
				{/* Regras Especiais */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Regras Especiais
					</summary>
					<div className="textItem">
						<h2>
							<strong>FUTEBOL:</strong>
						</h2>

						<h2>
							<strong>FUTEBINGO ESTRELABET</strong>
						</h2>

						<p>
							<strong>
								Mostre o seu conhecimento em futebol e teste a sua sorte em uma aposta no Futebingo
								EstrelaBet. Você pode dar seus palpites, a partir de R$2,00, em uma sequência de
								jogos e ganhar lucros enormes.
							</strong>
						</p>

						<h2>
							<strong>O que é o Futebingo?</strong>
						</h2>

						<p>
							<strong>
								O Futebingo é uma modalidade de aposta bastante popular ao redor do mundo, e no
								Brasil a EstrelaBet oferece aos seus apostadores. Além do prêmio, ao acertar o
								Futebingo você ganha reconhecimento por mostrar o quanto entende de futebol. Alguns
								jogos são selecionados pela casa e sua tarefa é fazer palpites em cada um desses
								jogos. Se acertar todos os resultados, você será um dos ganhadores do Futebingo.
							</strong>
						</p>

						<h2>
							<strong>Prêmios do Futebingo</strong>
						</h2>

						<p>
							<strong>
								O prêmio do Futebingo é dividido entre todos os apostadores que acertaram seus
								palpites. Apostas ganhas com palpites em partidas em que os favoritos venceram
								tendem a pagar menos, pois serão mais apostadores dividindo o prêmio. No Futebingo
								em que o apostador acerta o palpite em uma zebra, é provável que seu prêmio seja
								maior, pois será dividido com menos pessoas.
							</strong>
						</p>

						<h2>
							<strong>Resultado Final do Futebingo</strong>
						</h2>

						<p>
							<strong>
								O Futebingo 1x2 é muito simples: aqui você simplesmente palpita em quem acredita que
								ganhará os confrontos, ou se preferir, palpita em um empate. Você deve fazer um
								palpite em cada um dos jogos pré-selecionados e acertar todos para ser um dos
								vencedores do Futebingo.
							</strong>
						</p>

						<h2>
							<strong>Futebingo Score</strong>
						</h2>

						<p>
							<strong>
								No Futebingo Score, é essencial que você seja preciso em seus palpites. Para vencer
								nesta modalidade, é necessário acertar o placar exato das partidas pré-selecionadas.
								Em caso de acerto, o prêmio será dividido entre os demais vencedores.
							</strong>
						</p>

						<h2>
							<strong>Como Apostar no Futebingo</strong>
						</h2>

						<p>
							<strong>
								Apostar no Futebingo da EstrelaBet é muito simples, mas vamos te dar mais um
								empurrãozinho com um passo a passo.
							</strong>
						</p>

						<ul>
							<li>
								<strong>Conecte-se à sua conta. Caso ainda não tenha uma, REGISTRE-SE AQUI</strong>
							</li>
							<li>
								<strong>Acesse o nosso lobby no menu lateral.</strong>
							</li>
							<li>
								<strong>
									Faça seus palpites nos jogos pré-selecionados e confirme sua aposta.
								</strong>
							</li>
						</ul>

						<p>
							<strong>Pronto, agora é só cruzar os dedos e torcer!</strong>
						</p>

						<h2>
							<strong>FUTEBOL 1X1(UM CONTRA UM)</strong>
						</h2>

						<h2>
							<strong>Como funciona o futebol 1X1 (um contra um)</strong>
						</h2>

						<p>
							<strong>
								Um goleiro e um jogador de linha de cada lado. Ganha quem fizer mais gols. Em caso
								de empate no número de gols, a decisão vai para o shoot-out.
							</strong>
						</p>

						<p>
							<strong>
								Cada atleta pode pedir um minuto de parada técnica por período, estando com a posse
								de bola, e até dois minutos antes do fim da partida.
							</strong>
						</p>

						<h2>
							<strong>Quais as regras do 1X1 no futebol?</strong>
						</h2>

						<p>
							<strong>
								As regras do 1X1 são divididas em tópicos. São eles: tempo, início e reinício,
								atletas e comissão técnica, contagem de gols e desempate, arbitragem, shoot-out ou
								tiros livres e pênalti. Veja abaixo as principais informações sobre cada um deles.
							</strong>
						</p>

						<p>
							<strong>
								<b>TEMPO - </b> Dois tempos de 15 minutos nas competições. Os jogos apostados chegam
								a dois tempos de 20 minutos. Cada jogador tem direito a um minuto de parada técnica
								por período.
							</strong>
						</p>

						<p>
							<strong>
								Em caso de lesão, a partida é paralisada, e o atendimento médico precisa ser
								acionado. Se o jogador ou goleiro não tiver condição de jogo, vence a outra dupla.
							</strong>
						</p>

						<p>
							<strong>
								<b>GOLS E DESEMPATE - </b> A bola precisa ultrapassar completamente a linha do gol.
								Não vale gol de goleiro no 1X1. Em caso de empate, desempate nas cobranças
								alternadas de shoot-out no campo e tiro livre de dez metros na quadra.
							</strong>
						</p>

						<p>
							<strong>
								<b>ARBITRAGEM - </b> Deve ser aplicada a punição com shoot-out/tiro livre: mais de
								cinco faltas (não acumula entre os tempos), dois cartões amarelos e contato do
								goleiro fora da área com a bola. Em caso de cartão vermelho, o jogador expulso será
								decretado como o derrotado.
							</strong>
						</p>

						<p>
							<strong>
								<b>SHOOT-OUT/TIRO LIVRE - </b> Shoot-out: a bola precisa ser colocada na linha do
								shoot-out, o jogador tem cinco segundos para finalizar, o goleiro precisa estar na
								linha do gol até o primeiro toque do jogador, e a defesa não pode ser realizada fora
								da área. Tiro livre: A bola precisa ser colocada na marca dos 10 metros e não pode
								existir mais nenhum jogador entre a bola e o goleiro, que tem que ficar posicionado
								na distância mínima de cinco metros da bola até que ela seja chutada pelo cobrador.
							</strong>
						</p>

						<p>
							<strong>
								<b>PÊNALTI - </b> O pênalti é concedido quando o jogador sofre uma falta dentro da
								área adversária. A bola tem que ser colocada na marca do pênalti, e o goleiro
								precisa ficar em cima da linha do gol.{' '}
							</strong>
						</p>

						<h2>
							<strong>ENTRETERIMENTO:</strong>
						</h2>

						<h2>
							<strong>BIG BROTHER BRASIL</strong>
						</h2>

						<p>
							<strong>
								Big Brother Brasil
								<br />
								As apostas serão resolvidas com base nos resultados oficiais da competição. No caso
								de qualquer informação que possa afetar o resultado das apostas, estas serão
								devolvidas.{' '}
							</strong>
						</p>

						<p>
							<strong>
								As apostas em Big Brother Brasil serão resolvidas com base no resultado oficial
								anunciado durante a transmissão ao vivo. No caso de um jogador voltar posteriormente
								ao jogo, as apostas já liquidadas não serão reembolsadas.
							</strong>
						</p>
					</div>
				</details>
				{/* Loterias */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="32"
							viewBox="0 0 32 32"
							width="32"
							xmlns="http://www.w3.org/2000/svg"
						>
							{' '}
							<path
								d="M31 29.9906H25.78L24.16 26.9116C23.6 27.2715 23.01 27.5914 22.41 27.8813L23.52 30.0006H8.43L9.57 27.8813C8.96 27.5914 8.38 27.2815 7.82 26.9216L6.16 30.0006H1C0.45 30.0006 0 30.4505 0 31.0003C0 31.5501 0.45 32 1 32H31C31.55 32 32 31.5501 32 31.0003C32 30.4505 31.55 30.0006 31 30.0006V29.9906Z"
								data-darkreader-inline-fill=""
								fill="white"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M8.77 25.1522L13.41 16.555L13.84 15.7652C13.65 15.4154 13.54 15.0155 13.54 14.5856C13.54 13.1861 14.68 12.0464 16.08 12.0464C17.48 12.0464 18.62 13.1861 18.62 14.5856C18.62 15.0155 18.5 15.4153 18.31 15.7752L18.67 16.455L23.23 25.1422C26.8 22.783 29.15 18.7543 29.15 14.1558C29.16 6.8881 23.27 1 16 1C8.73 1 2.83 6.8881 2.83 14.1658C2.83 18.7643 5.19 22.813 8.77 25.1622V25.1522ZM24.04 15.1354C25.14 15.1354 26.04 16.0351 26.04 17.1348C26.04 18.2344 25.14 19.1341 24.04 19.1341C22.94 19.1341 22.04 18.2344 22.04 17.1348C22.04 16.0351 22.94 15.1354 24.04 15.1354ZM20.54 4.17897C21.64 4.17897 22.54 5.07868 22.54 6.17833C22.54 7.27797 21.64 8.17768 20.54 8.17768C19.44 8.17768 18.54 7.27797 18.54 6.17833C18.54 5.07868 19.44 4.17897 20.54 4.17897ZM13.94 5.40858C15.04 5.40858 15.94 6.30829 15.94 7.40793C15.94 8.50758 15.04 9.40729 13.94 9.40729C12.84 9.40729 11.94 8.50758 11.94 7.40793C11.94 6.30829 12.84 5.40858 13.94 5.40858ZM7.94 12.1764C9.04 12.1764 9.94 13.0761 9.94 14.1758C9.94 15.2754 9.04 16.1751 7.94 16.1751C6.84 16.1751 5.94 15.2754 5.94 14.1758C5.94 13.0761 6.84 12.1764 7.94 12.1764Z"
								data-darkreader-inline-fill=""
								fill="white"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
							<path
								d="M16.72 17.0348C16.51 17.0848 16.3 17.1248 16.08 17.1248C15.86 17.1248 15.64 17.0848 15.43 17.0248L15.13 17.5747L10.52 26.1119C12.19 26.8717 14.04 27.3115 15.99 27.3115C17.94 27.3115 19.81 26.8717 21.48 26.1019L16.98 17.5347L16.71 17.0248L16.72 17.0348Z"
								data-darkreader-inline-fill=""
								fill="white"
								style={{ fill: '#FFFFFF' }}
							></path>{' '}
						</svg>
						Loterias
					</summary>
					<div className="textItem">
						<h2>
							<strong>Regras Gerais</strong>
						</h2>

						<p>
							<strong>
								Quando você faz uma aposta na loteria, é importante notar que você não está
								comprando um bilhete ou entrando no sorteio oficial da loteria. As apostas paralelas
								da loteria são baseadas nos números sorteados nos sorteios oficiais.
							</strong>
						</p>

						<p>
							<strong>
								As apostas paralelas da loteria não podem ser combinadas com outras apostas.
							</strong>
						</p>

						<p>
							<strong>
								Se um horário de sorteio for remarcado, o sorteio será cancelado e todas as apostas
								serão reembolsadas.
							</strong>
						</p>

						<p>
							<strong>Pagamento máximo é de R$200.000,00 (duzentos mil reais).</strong>
						</p>

						<h3>
							<strong>Loterias</strong>
						</h3>

						<h4>
							<strong>Lotto irlandês (Principal, Plus 1, Plus 2)</strong>
						</h4>

						<p>
							<strong>
								Os sorteios da Irish Lotto ocorrem todas as quartas-feiras e sábados às 19:55,
								horário irlandês local. É possível fazer apostas até 10 minutos antes do sorteio.
								Irish Lotto contém 47 bolas (1-47) com 7 bolas sorteadas (6 + 1 Bola Bônus).
							</strong>
						</p>

						<h4>
							<strong>Lotto austríaco</strong>
						</h4>

						<p>
							<strong>
								Os sorteios da loteria austríaca ocorrem todas as quartas-feiras às 18:48 e domingos
								às 19:15, horário local austríaco. É possível fazer apostas até 10 minutos antes do
								sorteio. Austrian Lotto contém 45 bolas (1-45) com 7 bolas sorteadas (6 + 1 bola
								bônus).
							</strong>
						</p>

						<h4>
							<strong>Lotto alemão</strong>
						</h4>

						<p>
							<strong>
								Os sorteios da Loteria Alemã ocorrem todas as quartas-feiras às 18:25 e sábados às
								19:25, horário local alemão. É possível fazer apostas até 10 minutos antes do
								sorteio. German Lotto contém 49 bolas (1-49) com 6 bolas tiradas do tambor
								principal. Um tambor de superbola separado contém 10 bolas (0-9) com 1 número
								desenhado.
							</strong>
						</p>

						<h4>
							<strong>EuroJackpot</strong>
						</h4>

						<p>
							<strong>
								Os sorteios do EuroJackpot realizam-se todas as terças e sextas-feiras às 21:00,
								hora local finlandesa.
							</strong>
						</p>

						<p>
							<strong>
								É possível fazer apostas até 10 minutos antes do sorteio. EuroJackpot contém 50
								bolas (1-50) com 5 bolas tiradas do tambor principal. Um tambor EuroNumbers separado
								contém 12 bolas (1-12) com 2 números sorteados.
							</strong>
						</p>

						<h3>
							<strong>Mercados</strong>
						</h3>

						<h4>
							<strong>Mercados ímpares/pares:</strong>
						</h4>

						<p>
							<strong>
								Você tem que prever se a bola/soma de bolas sorteadas é um número ímpar ou par, por
								exemplo, se a bola/soma de bolas é 42, as apostas são contadas como "pares".
							</strong>
						</p>

						<p>
							<strong>Os mercados que contêm as opções ímpares/pares são os seguintes:</strong>
						</p>

						<ul>
							<li>
								<strong>Soma de todos os números ímpares/pares sorteados</strong>
							</li>
							<li>
								<strong>Soma dos números ímpares sorteados ímpares/pares</strong>
							</li>
							<li>
								<strong>Bola de bônus ímpar/par</strong>
							</li>
							<li>
								<strong>Soma das Bolas Extras ímpar/par</strong>
							</li>
							<li>
								<strong>Maior número sorteado ímpar/par</strong>
							</li>
							<li>
								<strong>Menor número sorteado ímpar/par</strong>
							</li>
						</ul>

						<h4>
							<strong>Mercados sobre/ inferiores:</strong>
						</h4>

						<p>
							<strong>
								Você tem que prever se a soma total de bolas sorteadas durante o sorteio estará
								acima ou abaixo da linha indicada. Os mercados que contêm as opções over/under são
								os seguintes:
							</strong>
						</p>

						<ul>
							<li>
								<strong>Soma de todos os números sorteados O/U</strong>
							</li>
							<li>
								<strong>Soma dos números pares sorteados O/U</strong>
							</li>
							<li>
								<strong>Soma das Bolas Extras O/U</strong>
							</li>
							<li>
								<strong>Soma dos números ímpares sorteados O/U</strong>
							</li>
						</ul>

						<h4>
							<strong>Escolha N:</strong>
						</h4>

						<p>
							<strong>
								Você tem que prever as bolas tiradas do tambor. Você pode optar por apostar em
								1,2,3,4 ou 5 números no sorteio selecionado. Bolas de bônus estão excluídas.
							</strong>
						</p>

						<p>
							<strong>
								Se mais de uma bola for selecionada, então, todas elas devem ser sorteadas para que
								o boletim de apostas seja bem-sucedido.
							</strong>
						</p>

						<h4>
							<strong>Escolha N com bola bônus:</strong>
						</h4>

						<p>
							<strong>
								Você tem que prever as bolas tiradas do tambor. Você pode optar por apostar em
								1,2,3,4 ou 5 números no sorteio selecionado. Bolas de bônus estão incluídas.
							</strong>
						</p>

						<p>
							<strong>
								Se mais de uma bola for selecionada, então, todas elas devem ser sorteadas para que
								o boletim de apostas seja bem-sucedido.
							</strong>
						</p>

						<h4>
							<strong>Número da bola bônus:</strong>
						</h4>

						<p>
							<strong>Você tem que prever o número da Bola Bônus.</strong>
						</p>

						<h2>
							<strong>Sites oficiais para conferência dos resultados</strong>
						</h2>

						<p>
							<strong>
								<strong>EuroJackpot</strong>:
							</strong>
						</p>
						<strong>Clique aqui</strong>

						<p>
							<strong>
								<strong>EuroMillions</strong>:
							</strong>
						</p>
						<strong> Clique aqui</strong>

						<p>
							<strong>
								<strong>Irish Lotto (Main + Plus)</strong>:
							</strong>
						</p>
						<strong> Clique aqui</strong>

						<p>
							<strong>
								<strong>German Lotto</strong>:
							</strong>
						</p>
						<strong> Clique aqui</strong>

						<p>
							<strong>
								<strong>Austrian Lotto</strong>:
							</strong>
						</p>
						<strong> Clique aqui</strong>
					</div>
				</details>
				{/* Odds Brilhantes */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Odds Brilhantes
					</summary>
					<div className="textItem">
						<p>{`O valor máximo para as apostas pode variar entre R$10,00 e R$50,00.

`}</p>
					</div>
				</details>
				{/* Apostas Aumentadas */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Apostas Aumentadas
					</summary>
					<div className="textItem">
						<p>{`O valor máximo para as apostas pode variar entre R$20,00 e R$100,00.

`}</p>
					</div>
				</details>
				{/* Apostas Sistema */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Apostas Sistema
					</summary>
					<div className="textItem">
						<p>{`As Apostas Sistema permitem que o apostador cubra várias combinações de resultados em eventos esportivos. Em vez de apostar em uma única seleção, cria-se um "sistema" que combina múltiplas apostas, aumentando as chances de ganhar. Um exemplo comum é o sistema 2/3, onde é necessário acertar pelo menos 2 de 3 seleções para obter retorno. Essa abordagem é popular porque oferece maior segurança, já que nem todas as seleções precisam ser vencedoras para gerar lucro.

`}</p>
						<p>{`Nas Apostas Sistema, o cliente pode utilizar a opção Banker ("B") em um ou mais eventos. Isso fixa o evento selecionado em todas as combinações, ou seja, apenas serão realizadas as apostas que incluam o(s) evento(s) marcado(s) como Banker.

`}</p>
					</div>
				</details>
				{/* Estrelabet Odds */}
				<details>
					<summary className="detailsTitle">
						<svg
							fill="none"
							height="28"
							viewBox="0 0 32 32"
							width="28"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_515_495)">
								<path
									d="M17.67 14.23C17.43 14.06 17.24 13.83 17.11 13.56L16.01 11.35L14.92 13.57C14.79 13.83 14.6 14.06 14.37 14.24C14.14 14.41 13.86 14.53 13.57 14.57L11.13 14.93L12.9 16.64C13.11 16.85 13.26 17.1 13.35 17.38C13.44 17.66 13.46 17.95 13.42 18.24L12.99 20.69L15.17 19.54C15.43 19.4 15.72 19.33 16.01 19.33C16.3 19.33 16.59 19.4 16.85 19.54L19.03 20.68L18.61 18.25C18.56 17.96 18.58 17.66 18.67 17.39C18.76 17.11 18.92 16.86 19.13 16.65L20.91 14.91L18.47 14.56C18.18 14.52 17.9 14.4 17.67 14.23Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
								<path
									d="M27.31 4.69C24.31 1.69 20.24 0 16 0C11.76 0 7.69 1.69 4.69 4.69C1.69 7.69 0 11.76 0 16C0 20.24 1.69 24.31 4.69 27.31C7.6 30.22 11.5 31.87 15.6 31.98C15.73 31.98 15.87 32 16 32C16.13 32 16.27 31.98 16.4 31.98C20.5 31.88 24.41 30.22 27.31 27.31C30.31 24.31 32 20.24 32 16C32 11.76 30.31 7.69 27.31 4.69ZM23.09 15.21C23.01 15.54 22.84 15.84 22.6 16.07L20.6 18L21.04 20.7C21.1 21.03 21.07 21.37 20.94 21.69C20.81 22 20.6 22.27 20.33 22.47C20.06 22.67 19.73 22.79 19.39 22.81C19.05 22.83 18.71 22.76 18.41 22.61L16.01 21.33L13.58 22.61C13.32 22.75 13.03 22.82 12.73 22.82C12.35 22.82 11.98 22.7 11.67 22.48C11.4 22.28 11.19 22.01 11.06 21.7C10.93 21.39 10.9 21.05 10.95 20.72L11.41 18L9.41 16.09C9.17 15.85 8.99 15.55 8.91 15.23C8.83 14.9 8.84 14.56 8.95 14.23C9.05 13.91 9.24 13.62 9.5 13.4C9.76 13.18 10.07 13.04 10.41 13L13.14 12.6L14.37 10.14C14.52 9.84 14.75 9.58 15.03 9.41C15.31 9.23 15.64 9.14 15.98 9.14C16.32 9.14 16.65 9.23 16.93 9.41C17.22 9.59 17.45 9.84 17.6 10.14L18.82 12.61L21.55 13C21.89 13.04 22.21 13.18 22.47 13.39C22.73 13.61 22.93 13.89 23.04 14.22C23.15 14.54 23.16 14.88 23.08 15.21H23.09Z"
									fill="#FFFFFF"
									style={{ fill: '#FFFFFF' }}
								/>
							</g>
							<defs>
								<clipPath id="clip0_515_495">
									<rect fill="white" height="28" width="28" style={{ fill: 'white' }} />
								</clipPath>
							</defs>
						</svg>
						Estrelabet Odds
					</summary>
					<div className="textItem">
						<h2>Mercados Exclusivos</h2>

						<p>
							<strong>Apostas Pré-Live:</strong> Os mercados exclusivos estão disponíveis apenas
							antes do início da partida. Após o apito inicial, não será possível apostar.
						</p>

						<p data-renderer-start-pos="1">
							<strong data-renderer-mark="true">Critério de Desempate:&nbsp;</strong>Em caso de
							empate no número de gols, cartões, faltas, escanteios ou em qualquer outro mercado
							considerado nos jogos, a aposta será{' '}
							<strong data-renderer-mark="true">Devolvida</strong>.
						</p>

						<p data-renderer-start-pos="302">
							<strong data-renderer-mark="true">Regras adicionais:</strong>
						</p>

						<ul data-indent-level="1">
							<li>
								<p data-renderer-start-pos="324">
									Cartões amarelos serão válidos apenas para jogadores em campo, durante os{' '}
									<strong data-renderer-mark="true">90 minutos regulamentares</strong>.
								</p>
							</li>
							<li>
								<p data-renderer-start-pos="428">
									Cartões recebidos por jogadores no banco de reservas, comissão técnica ou
									treinadores <strong data-renderer-mark="true">não serão contabilizados</strong>.
								</p>
							</li>
							<li>
								<p data-renderer-start-pos="543">
									<strong data-renderer-mark="true">Demais mercados</strong> também serão
									contabilizados{' '}
									<strong data-renderer-mark="true">
										somente durante os 90 minutos regulamentares
									</strong>
									.
								</p>
							</li>
						</ul>

						<p>
							<strong>Validade dos Gols:</strong> Apenas os gols marcados no tempo regulamentar (90
							minutos) serão contabilizados. Gols na prorrogação ou disputa de pênaltis não entram
							na contagem.
						</p>

						<p>
							<strong>Jogos Adiados:</strong> Se qualquer um dos jogos incluídos no mercado for
							adiado, a aposta será anulada e o valor retornado ao jogador.
						</p>

						<p>
							<strong>Limites de Aposta:</strong> Alguns mercados exclusivos podem ter um limite
							máximo de R$ 50,00 ou R$ 100,00 por aposta.
						</p>

						<p>
							<strong>
								Fique atento às regras antes de apostar e aproveite os nossos mercados exclusivos!
							</strong>
						</p>
					</div>
				</details>
				<p>
					<strong>
						SE HOUVER DISCREPÂNCIA ENTRE A VERSÃO EM INGLÊS DESSAS REGRAS E A TRADUÇÃO PARA OUTRO
						IDIOMA, A VERSÃO EM INGLÊS SERÁ CONSIDERADA A CORRETA.
					</strong>
				</p>
			</div>
		</div>
	);
};
export default SportsBettingRules;
